/* tslint:disable */
/* eslint-disable */
/**
 * Pogovorim API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddCompanyPatientsRequestDto
 */
export interface AddCompanyPatientsRequestDto {
    /**
     * 
     * @type {Array<AddCompanyPatientsRequestDtoPatientsInner>}
     * @memberof AddCompanyPatientsRequestDto
     */
    'patients': Array<AddCompanyPatientsRequestDtoPatientsInner>;
}
/**
 * @type AddCompanyPatientsRequestDtoPatientsInner
 * @export
 */
export type AddCompanyPatientsRequestDtoPatientsInner = BfsCompanyPatientDto | PfsCompanyPatientDto;

/**
 * 
 * @export
 * @interface AddDiseaseGroupRequestDto
 */
export interface AddDiseaseGroupRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AddDiseaseGroupRequestDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof AddDiseaseGroupRequestDto
     */
    'isChild'?: boolean;
}
/**
 * 
 * @export
 * @interface AddDiseaseRequestDto
 */
export interface AddDiseaseRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AddDiseaseRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AddDiseaseRequestDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddDiseaseRequestDto
     */
    'diseasesGroupId': string;
    /**
     * 
     * @type {string}
     * @memberof AddDiseaseRequestDto
     */
    'tip'?: string;
}
/**
 * 
 * @export
 * @interface AddFaqGroupRequestDto
 */
export interface AddFaqGroupRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AddFaqGroupRequestDto
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface AddFaqQuestionRequestDto
 */
export interface AddFaqQuestionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AddFaqQuestionRequestDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof AddFaqQuestionRequestDto
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof AddFaqQuestionRequestDto
     */
    'groupId': string;
}
/**
 * 
 * @export
 * @interface AddPlatformFeedbackRequestDto
 */
export interface AddPlatformFeedbackRequestDto {
    /**
     * Рейтинг от 0 до 10
     * @type {number}
     * @memberof AddPlatformFeedbackRequestDto
     */
    'rating'?: number | null;
    /**
     * Текстовый отзыв о платформе
     * @type {string}
     * @memberof AddPlatformFeedbackRequestDto
     */
    'comment'?: string | null;
}
/**
 * 
 * @export
 * @interface AddPromocodeToCompanyRequestDto
 */
export interface AddPromocodeToCompanyRequestDto {
    /**
     * 
     * @type {AddPromocodesPromocodeRequestDto}
     * @memberof AddPromocodeToCompanyRequestDto
     */
    'promocode'?: AddPromocodesPromocodeRequestDto | null;
    /**
     * User ID
     * @type {string}
     * @memberof AddPromocodeToCompanyRequestDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {AdminPromocodesCompanyRequestDto}
     * @memberof AddPromocodeToCompanyRequestDto
     */
    'company'?: AdminPromocodesCompanyRequestDto | null;
}
/**
 * 
 * @export
 * @interface AddPromocodesPromocodeRequestDto
 */
export interface AddPromocodesPromocodeRequestDto {
    /**
     * 
     * @type {number}
     * @memberof AddPromocodesPromocodeRequestDto
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof AddPromocodesPromocodeRequestDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AddPromocodesPromocodeRequestDto
     */
    'percentage'?: number;
    /**
     * 
     * @type {string}
     * @memberof AddPromocodesPromocodeRequestDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddPromocodesPromocodeRequestDto
     */
    'expireDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AddPromocodesPromocodeRequestDto
     */
    'firstUseOnly'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AddPromocodesPromocodeRequestDto
     */
    'useLimitPerUser'?: number;
}
/**
 * 
 * @export
 * @interface AddPromocodesToCompany
 */
export interface AddPromocodesToCompany {
    /**
     * 
     * @type {Array<CreateCompanyPromocodeInfoRequestDto>}
     * @memberof AddPromocodesToCompany
     */
    'promocodes': Array<CreateCompanyPromocodeInfoRequestDto>;
    /**
     * 
     * @type {string}
     * @memberof AddPromocodesToCompany
     */
    'promocodeExpireDate': string;
}
/**
 * 
 * @export
 * @interface AddSessionFeedbackRequestDto
 */
export interface AddSessionFeedbackRequestDto {
    /**
     * Идентификатор сессии
     * @type {string}
     * @memberof AddSessionFeedbackRequestDto
     */
    'sessionId': string;
    /**
     * Тип специалиста
     * @type {string}
     * @memberof AddSessionFeedbackRequestDto
     */
    'specialistType': AddSessionFeedbackRequestDtoSpecialistTypeEnum;
    /**
     * Id темы сессии
     * @type {Array<string>}
     * @memberof AddSessionFeedbackRequestDto
     */
    'themeIds'?: Array<string> | null;
    /**
     * Другое
     * @type {string}
     * @memberof AddSessionFeedbackRequestDto
     */
    'customTheme'?: string | null;
}

export const AddSessionFeedbackRequestDtoSpecialistTypeEnum = {
    Unspecified: 'unspecified',
    Psychologist: 'psychologist',
    Psychoanalyst: 'psychoanalyst',
    Coach: 'coach',
    Supervisor: 'supervisor',
    ClinicalPsychologist: 'clinical_psychologist',
    Sexologist: 'sexologist'
} as const;

export type AddSessionFeedbackRequestDtoSpecialistTypeEnum = typeof AddSessionFeedbackRequestDtoSpecialistTypeEnum[keyof typeof AddSessionFeedbackRequestDtoSpecialistTypeEnum];

/**
 * 
 * @export
 * @interface AddSessionOutcomeRequestDto
 */
export interface AddSessionOutcomeRequestDto {
    /**
     * id сессии
     * @type {string}
     * @memberof AddSessionOutcomeRequestDto
     */
    'sessionId': string;
    /**
     * Рейтинг от 1 до 5
     * @type {number}
     * @memberof AddSessionOutcomeRequestDto
     */
    'rating': number;
    /**
     * Текстовый отзыв о консультации
     * @type {string}
     * @memberof AddSessionOutcomeRequestDto
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface AddTherapyMethodRequestDto
 */
export interface AddTherapyMethodRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AddTherapyMethodRequestDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AdminAddFaqGroupRequestDto
 */
export interface AdminAddFaqGroupRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AdminAddFaqGroupRequestDto
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface AdminAddFaqQuestionRequestDto
 */
export interface AdminAddFaqQuestionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AdminAddFaqQuestionRequestDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAddFaqQuestionRequestDto
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAddFaqQuestionRequestDto
     */
    'groupId': string;
}
/**
 * 
 * @export
 * @interface AdminB2BMaterialResponseDto
 */
export interface AdminB2BMaterialResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminB2BMaterialResponseDto
     */
    'id': string;
    /**
     * 
     * @type {Array<B2BMaterialFileResponseDto>}
     * @memberof AdminB2BMaterialResponseDto
     */
    'files': Array<B2BMaterialFileResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BMaterialResponseDto
     */
    'companyId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BMaterialResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BMaterialResponseDto
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BMaterialResponseDto
     */
    'status': AdminB2BMaterialResponseDtoStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminB2BMaterialResponseDto
     */
    'userIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BMaterialResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BMaterialResponseDto
     */
    'updatedAt': string | null;
}

export const AdminB2BMaterialResponseDtoStatusEnum = {
    Draft: 'draft',
    Published: 'published'
} as const;

export type AdminB2BMaterialResponseDtoStatusEnum = typeof AdminB2BMaterialResponseDtoStatusEnum[keyof typeof AdminB2BMaterialResponseDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminB2BPaginatedPatientsResponseDto
 */
export interface AdminB2BPaginatedPatientsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminB2BPaginatedPatientsResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminB2BPaginatedPatientsResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminB2BPaginatedPatientsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminB2BPaginatedPatientsResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminB2BPatientResponseDto>}
     * @memberof AdminB2BPaginatedPatientsResponseDto
     */
    'data': Array<AdminB2BPatientResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminB2BPatientResponseDto
 */
export interface AdminB2BPatientResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminB2BPatientResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BPatientResponseDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BPatientResponseDto
     */
    'lastname': string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BPatientResponseDto
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BPatientResponseDto
     */
    'avatarKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BPatientResponseDto
     */
    'companyRole': string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BPatientResponseDto
     */
    'companyGroup': string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BPatientResponseDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BPatientResponseDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BPatientResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BPatientResponseDto
     */
    'deletedAt'?: string;
}
/**
 * 
 * @export
 * @interface AdminB2BSessionResponseDto
 */
export interface AdminB2BSessionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminB2BSessionResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BSessionResponseDto
     */
    'therapistId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BSessionResponseDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BSessionResponseDto
     */
    'status': AdminB2BSessionResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BSessionResponseDto
     */
    'type': AdminB2BSessionResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BSessionResponseDto
     */
    'cancelerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminB2BSessionResponseDto
     */
    'cancelReason'?: string;
    /**
     * 
     * @type {AvailabilityResponseDto}
     * @memberof AdminB2BSessionResponseDto
     */
    'availability': AvailabilityResponseDto;
    /**
     * 
     * @type {Array<AdminPatientResponseDto>}
     * @memberof AdminB2BSessionResponseDto
     */
    'patients': Array<AdminPatientResponseDto>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminB2BSessionResponseDto
     */
    'isTherapistVisited': boolean;
}

export const AdminB2BSessionResponseDtoStatusEnum = {
    Awaiting: 'awaiting',
    Live: 'live',
    Complete: 'complete',
    Canceled: 'canceled'
} as const;

export type AdminB2BSessionResponseDtoStatusEnum = typeof AdminB2BSessionResponseDtoStatusEnum[keyof typeof AdminB2BSessionResponseDtoStatusEnum];
export const AdminB2BSessionResponseDtoTypeEnum = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type AdminB2BSessionResponseDtoTypeEnum = typeof AdminB2BSessionResponseDtoTypeEnum[keyof typeof AdminB2BSessionResponseDtoTypeEnum];

/**
 * 
 * @export
 * @interface AdminCompanyGroupsResponseDto
 */
export interface AdminCompanyGroupsResponseDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCompanyGroupsResponseDto
     */
    'groups': Array<string>;
}
/**
 * 
 * @export
 * @interface AdminCompanyResponseDto
 */
export interface AdminCompanyResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyResponseDto
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCompanyResponseDto
     */
    'isArchive': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyResponseDto
     */
    'type': AdminCompanyResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyResponseDto
     */
    'ownerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyResponseDto
     */
    'createdAt'?: string;
}

export const AdminCompanyResponseDtoTypeEnum = {
    Promocode: 'promocode',
    Balance: 'balance'
} as const;

export type AdminCompanyResponseDtoTypeEnum = typeof AdminCompanyResponseDtoTypeEnum[keyof typeof AdminCompanyResponseDtoTypeEnum];

/**
 * 
 * @export
 * @interface AdminCompanyRolesResponseDto
 */
export interface AdminCompanyRolesResponseDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCompanyRolesResponseDto
     */
    'roles': Array<string>;
}
/**
 * 
 * @export
 * @interface AdminContentCourseResponseDto
 */
export interface AdminContentCourseResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseResponseDto
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminContentCourseResponseDto
     */
    'sortOrder': number;
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseResponseDto
     */
    'audience': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseResponseDto
     */
    'status': AdminContentCourseResponseDtoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AdminContentCourseResponseDto
     */
    'isForAllCompanies': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminContentCourseResponseDto
     */
    'companyIds': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AdminContentCourseResponseDto
     */
    'foldersCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminContentCourseResponseDto
     */
    'videosCount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseResponseDto
     */
    'updatedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseResponseDto
     */
    'deletedAt': string | null;
}

export const AdminContentCourseResponseDtoStatusEnum = {
    Draft: 'draft',
    Published: 'published'
} as const;

export type AdminContentCourseResponseDtoStatusEnum = typeof AdminContentCourseResponseDtoStatusEnum[keyof typeof AdminContentCourseResponseDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminContentCourseWithFoldersResponseDto
 */
export interface AdminContentCourseWithFoldersResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseWithFoldersResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseWithFoldersResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseWithFoldersResponseDto
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminContentCourseWithFoldersResponseDto
     */
    'sortOrder': number;
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseWithFoldersResponseDto
     */
    'audience': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseWithFoldersResponseDto
     */
    'status': AdminContentCourseWithFoldersResponseDtoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AdminContentCourseWithFoldersResponseDto
     */
    'isForAllCompanies': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminContentCourseWithFoldersResponseDto
     */
    'companyIds': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AdminContentCourseWithFoldersResponseDto
     */
    'foldersCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminContentCourseWithFoldersResponseDto
     */
    'videosCount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseWithFoldersResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseWithFoldersResponseDto
     */
    'updatedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminContentCourseWithFoldersResponseDto
     */
    'deletedAt': string | null;
    /**
     * 
     * @type {Array<AdminContentFolderWithVideosResponseDto>}
     * @memberof AdminContentCourseWithFoldersResponseDto
     */
    'folders': Array<AdminContentFolderWithVideosResponseDto>;
}

export const AdminContentCourseWithFoldersResponseDtoStatusEnum = {
    Draft: 'draft',
    Published: 'published'
} as const;

export type AdminContentCourseWithFoldersResponseDtoStatusEnum = typeof AdminContentCourseWithFoldersResponseDtoStatusEnum[keyof typeof AdminContentCourseWithFoldersResponseDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminContentFileRequestDto
 */
export interface AdminContentFileRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AdminContentFileRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentFileRequestDto
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface AdminContentFileResponseDto
 */
export interface AdminContentFileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminContentFileResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentFileResponseDto
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface AdminContentFolderResponseDto
 */
export interface AdminContentFolderResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminContentFolderResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentFolderResponseDto
     */
    'courseId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentFolderResponseDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AdminContentFolderResponseDto
     */
    'sortOrder': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminContentFolderResponseDto
     */
    'isSequentialLock': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminContentFolderResponseDto
     */
    'status': AdminContentFolderResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminContentFolderResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentFolderResponseDto
     */
    'updatedAt': string | null;
}

export const AdminContentFolderResponseDtoStatusEnum = {
    Draft: 'draft',
    Published: 'published'
} as const;

export type AdminContentFolderResponseDtoStatusEnum = typeof AdminContentFolderResponseDtoStatusEnum[keyof typeof AdminContentFolderResponseDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminContentFolderWithVideosResponseDto
 */
export interface AdminContentFolderWithVideosResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminContentFolderWithVideosResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentFolderWithVideosResponseDto
     */
    'courseId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentFolderWithVideosResponseDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AdminContentFolderWithVideosResponseDto
     */
    'sortOrder': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminContentFolderWithVideosResponseDto
     */
    'isSequentialLock': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminContentFolderWithVideosResponseDto
     */
    'status': AdminContentFolderWithVideosResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminContentFolderWithVideosResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentFolderWithVideosResponseDto
     */
    'updatedAt': string | null;
    /**
     * 
     * @type {Array<AdminContentResponseDto>}
     * @memberof AdminContentFolderWithVideosResponseDto
     */
    'videos': Array<AdminContentResponseDto>;
}

export const AdminContentFolderWithVideosResponseDtoStatusEnum = {
    Draft: 'draft',
    Published: 'published'
} as const;

export type AdminContentFolderWithVideosResponseDtoStatusEnum = typeof AdminContentFolderWithVideosResponseDtoStatusEnum[keyof typeof AdminContentFolderWithVideosResponseDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminContentResponseDto
 */
export interface AdminContentResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminContentResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentResponseDto
     */
    'folderId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminContentResponseDto
     */
    'sortOrder': number;
    /**
     * 
     * @type {string}
     * @memberof AdminContentResponseDto
     */
    'src': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentResponseDto
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminContentResponseDto
     */
    'status': AdminContentResponseDtoStatusEnum;
    /**
     * 
     * @type {Array<AdminContentFileResponseDto>}
     * @memberof AdminContentResponseDto
     */
    'files'?: Array<AdminContentFileResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof AdminContentResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContentResponseDto
     */
    'updatedAt': string | null;
}

export const AdminContentResponseDtoStatusEnum = {
    Draft: 'draft',
    Published: 'published'
} as const;

export type AdminContentResponseDtoStatusEnum = typeof AdminContentResponseDtoStatusEnum[keyof typeof AdminContentResponseDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminCreateCompanyRequestResponseDto
 */
export interface AdminCreateCompanyRequestResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateCompanyRequestResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateCompanyRequestResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateCompanyRequestResponseDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateCompanyRequestResponseDto
     */
    'phone': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateCompanyRequestResponseDto
     */
    'contactByPhone': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateCompanyRequestResponseDto
     */
    'numberOfEmployee': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateCompanyRequestResponseDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateCompanyRequestResponseDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface AdminCreatePaymentLinkRequestDto
 */
export interface AdminCreatePaymentLinkRequestDto {
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePaymentLinkRequestDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCreatePaymentLinkRequestDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface AdminCreatePaymentLinkResponseDto
 */
export interface AdminCreatePaymentLinkResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCreatePaymentLinkResponseDto
     */
    'paymentLink': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePaymentLinkResponseDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCreatePaymentLinkResponseDto
     */
    'currency': string;
}
/**
 * 
 * @export
 * @interface AdminCreateSessionBalancesRequestDto
 */
export interface AdminCreateSessionBalancesRequestDto {
    /**
     * 
     * @type {number}
     * @memberof AdminCreateSessionBalancesRequestDto
     */
    'quantityPerUser': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateSessionBalancesRequestDto
     */
    'startWith': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateSessionBalancesRequestDto
     */
    'endWith': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateSessionBalancesRequestDto
     */
    'companyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateSessionBalancesRequestDto
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateSessionBalancesRequestDto
     */
    'group'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCreateSessionBalancesRequestDto
     */
    'userIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AdminDiseaseGroupResponseDto
 */
export interface AdminDiseaseGroupResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminDiseaseGroupResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDiseaseGroupResponseDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDiseaseGroupResponseDto
     */
    'isChild': boolean;
    /**
     * 
     * @type {Array<DiseaseResponseDto>}
     * @memberof AdminDiseaseGroupResponseDto
     */
    'items': Array<DiseaseResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminDiseaseGroupsResponseDto
 */
export interface AdminDiseaseGroupsResponseDto {
    /**
     * 
     * @type {Array<AdminDiseaseGroupResponseDto>}
     * @memberof AdminDiseaseGroupsResponseDto
     */
    'data': Array<AdminDiseaseGroupResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminDiseasesResponseDto
 */
export interface AdminDiseasesResponseDto {
    /**
     * 
     * @type {Array<DiseaseResponseDto>}
     * @memberof AdminDiseasesResponseDto
     */
    'data': Array<DiseaseResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminFaqGroupWithQuestionsResponseDto
 */
export interface AdminFaqGroupWithQuestionsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminFaqGroupWithQuestionsResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminFaqGroupWithQuestionsResponseDto
     */
    'title': string;
    /**
     * 
     * @type {Array<FaqQuestionResponseDto>}
     * @memberof AdminFaqGroupWithQuestionsResponseDto
     */
    'questions': Array<FaqQuestionResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminFaqGroupsWithQuestionsResponseDto
 */
export interface AdminFaqGroupsWithQuestionsResponseDto {
    /**
     * 
     * @type {Array<AdminFaqGroupWithQuestionsResponseDto>}
     * @memberof AdminFaqGroupsWithQuestionsResponseDto
     */
    'data': Array<AdminFaqGroupWithQuestionsResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminFaqQuestionResponseDto
 */
export interface AdminFaqQuestionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminFaqQuestionResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminFaqQuestionResponseDto
     */
    'groupId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminFaqQuestionResponseDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof AdminFaqQuestionResponseDto
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface AdminFaqQuestionsResponseDto
 */
export interface AdminFaqQuestionsResponseDto {
    /**
     * 
     * @type {Array<AdminFaqQuestionResponseDto>}
     * @memberof AdminFaqQuestionsResponseDto
     */
    'data': Array<AdminFaqQuestionResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminGetCurrenciesResponseDto
 */
export interface AdminGetCurrenciesResponseDto {
    /**
     * 
     * @type {Array<CurrencyResponseDto>}
     * @memberof AdminGetCurrenciesResponseDto
     */
    'data': Array<CurrencyResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminGroupCallLinkResponseDto
 */
export interface AdminGroupCallLinkResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminGroupCallLinkResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupCallLinkResponseDto
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupCallLinkResponseDto
     */
    'startsAt': string;
    /**
     *
     * @type {string}
     * @memberof AdminGroupCallLinkResponseDto
     */
    'name': string | null;
    /**
     *
     * @type {string}
     * @memberof AdminGroupCallLinkResponseDto
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupCallLinkResponseDto
     */
    'companyId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupCallLinkResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupCallLinkResponseDto
     */
    'updatedAt': string | null;
}
/**
 * 
 * @export
 * @interface AdminPaginatedB2BMaterialsResponseDto
 */
export interface AdminPaginatedB2BMaterialsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedB2BMaterialsResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedB2BMaterialsResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedB2BMaterialsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedB2BMaterialsResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminB2BMaterialResponseDto>}
     * @memberof AdminPaginatedB2BMaterialsResponseDto
     */
    'data': Array<AdminB2BMaterialResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminPaginatedB2BSessionsResponseDto
 */
export interface AdminPaginatedB2BSessionsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedB2BSessionsResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedB2BSessionsResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedB2BSessionsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedB2BSessionsResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminB2BSessionResponseDto>}
     * @memberof AdminPaginatedB2BSessionsResponseDto
     */
    'data': Array<AdminB2BSessionResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminPaginatedCompaniesResponseDto
 */
export interface AdminPaginatedCompaniesResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedCompaniesResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedCompaniesResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedCompaniesResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedCompaniesResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminCompanyResponseDto>}
     * @memberof AdminPaginatedCompaniesResponseDto
     */
    'data': Array<AdminCompanyResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminPaginatedCompanyCreateRequestResponseDto
 */
export interface AdminPaginatedCompanyCreateRequestResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedCompanyCreateRequestResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedCompanyCreateRequestResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedCompanyCreateRequestResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedCompanyCreateRequestResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminCreateCompanyRequestResponseDto>}
     * @memberof AdminPaginatedCompanyCreateRequestResponseDto
     */
    'data': Array<AdminCreateCompanyRequestResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminPaginatedContentCoursesResponseDto
 */
export interface AdminPaginatedContentCoursesResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedContentCoursesResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedContentCoursesResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedContentCoursesResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedContentCoursesResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminContentCourseResponseDto>}
     * @memberof AdminPaginatedContentCoursesResponseDto
     */
    'data': Array<AdminContentCourseResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminPaginatedContentFoldersResponseDto
 */
export interface AdminPaginatedContentFoldersResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedContentFoldersResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedContentFoldersResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedContentFoldersResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedContentFoldersResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminContentFolderWithVideosResponseDto>}
     * @memberof AdminPaginatedContentFoldersResponseDto
     */
    'data': Array<AdminContentFolderWithVideosResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminPaginatedContentsResponseDto
 */
export interface AdminPaginatedContentsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedContentsResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedContentsResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedContentsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedContentsResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminContentResponseDto>}
     * @memberof AdminPaginatedContentsResponseDto
     */
    'data': Array<AdminContentResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminPaginatedPatientsResponseDto
 */
export interface AdminPaginatedPatientsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedPatientsResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedPatientsResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedPatientsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaginatedPatientsResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminPatientResponseDto>}
     * @memberof AdminPaginatedPatientsResponseDto
     */
    'data': Array<AdminPatientResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminPatientResponseDto
 */
export interface AdminPatientResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminPatientResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPatientResponseDto
     */
    'firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPatientResponseDto
     */
    'lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPatientResponseDto
     */
    'avatarKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPatientResponseDto
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {SessionOutcomeResponseDto}
     * @memberof AdminPatientResponseDto
     */
    'outcome': SessionOutcomeResponseDto;
    /**
     * 
     * @type {SessionOutcomeResponseDto}
     * @memberof AdminPatientResponseDto
     */
    'phone'?: SessionOutcomeResponseDto;
}
/**
 * 
 * @export
 * @interface AdminPaymentResponseDto
 */
export interface AdminPaymentResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentResponseDto
     */
    'dealId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminPaymentResponseDto
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPaymentResponseDto
     */
    'discountValue': number;
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentResponseDto
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentResponseDto
     */
    'dealStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentResponseDto
     */
    'cancellationDetails'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentResponseDto
     */
    'payoutStatus': AdminPaymentResponseDtoPayoutStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentResponseDto
     */
    'status': AdminPaymentResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentResponseDto
     */
    'paymentTerminal': AdminPaymentResponseDtoPaymentTerminalEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentResponseDto
     */
    'payoutTerminal': AdminPaymentResponseDtoPayoutTerminalEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AdminPaymentResponseDto
     */
    'isPromocodePaid': boolean;
}

export const AdminPaymentResponseDtoPayoutStatusEnum = {
    Pending: 'pending',
    Succeeded: 'succeeded',
    Canceled: 'canceled',
    Awaiting: 'awaiting',
    AwaitingPromocode: 'awaiting_promocode'
} as const;

export type AdminPaymentResponseDtoPayoutStatusEnum = typeof AdminPaymentResponseDtoPayoutStatusEnum[keyof typeof AdminPaymentResponseDtoPayoutStatusEnum];
export const AdminPaymentResponseDtoStatusEnum = {
    Pending: 'pending',
    WaitingForCapture: 'waiting_for_capture',
    Succeeded: 'succeeded',
    Canceled: 'canceled',
    Awaiting: 'awaiting',
    Retrying: 'retrying'
} as const;

export type AdminPaymentResponseDtoStatusEnum = typeof AdminPaymentResponseDtoStatusEnum[keyof typeof AdminPaymentResponseDtoStatusEnum];
export const AdminPaymentResponseDtoPaymentTerminalEnum = {
    YookassaDirect: 'yookassa_direct',
    YookassaSafeDeal: 'yookassa_safe_deal',
    StripeDirect: 'stripe_direct',
    NoTerminal: 'no_terminal',
    Manual: 'manual',
    SessionBalance: 'session_balance'
} as const;

export type AdminPaymentResponseDtoPaymentTerminalEnum = typeof AdminPaymentResponseDtoPaymentTerminalEnum[keyof typeof AdminPaymentResponseDtoPaymentTerminalEnum];
export const AdminPaymentResponseDtoPayoutTerminalEnum = {
    YookassaDirect: 'yookassa_direct',
    YookassaSafeDeal: 'yookassa_safe_deal',
    StripeDirect: 'stripe_direct',
    NoTerminal: 'no_terminal',
    Manual: 'manual',
    SessionBalance: 'session_balance'
} as const;

export type AdminPaymentResponseDtoPayoutTerminalEnum = typeof AdminPaymentResponseDtoPayoutTerminalEnum[keyof typeof AdminPaymentResponseDtoPayoutTerminalEnum];

/**
 * 
 * @export
 * @interface AdminPostCurrencyRequestDto
 */
export interface AdminPostCurrencyRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AdminPostCurrencyRequestDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPostCurrencyRequestDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AdminPostCurrencyRequestDto
     */
    'rubExchangeRate': number;
}
/**
 * 
 * @export
 * @interface AdminPromocodeResponseDto
 */
export interface AdminPromocodeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminPromocodeResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPromocodeResponseDto
     */
    'discountType': AdminPromocodeResponseDtoDiscountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminPromocodeResponseDto
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof AdminPromocodeResponseDto
     */
    'amount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminPromocodeResponseDto
     */
    'percentage': number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPromocodeResponseDto
     */
    'expireDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminPromocodeResponseDto
     */
    'firstUseOnly': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminPromocodeResponseDto
     */
    'timesUsed': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPromocodeResponseDto
     */
    'useLimitPerUser': number;
    /**
     * 
     * @type {string}
     * @memberof AdminPromocodeResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPromocodeResponseDto
     */
    'amoUserId': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPromocodeResponseDto
     */
    'adminName': string;
}

export const AdminPromocodeResponseDtoDiscountTypeEnum = {
    Amount: 'amount',
    Percentage: 'percentage'
} as const;

export type AdminPromocodeResponseDtoDiscountTypeEnum = typeof AdminPromocodeResponseDtoDiscountTypeEnum[keyof typeof AdminPromocodeResponseDtoDiscountTypeEnum];

/**
 * 
 * @export
 * @interface AdminPromocodesCompanyRequestDto
 */
export interface AdminPromocodesCompanyRequestDto {
    /**
     * Company ID
     * @type {string}
     * @memberof AdminPromocodesCompanyRequestDto
     */
    'id': string;
    /**
     * Company role
     * @type {string}
     * @memberof AdminPromocodesCompanyRequestDto
     */
    'role'?: string;
    /**
     * Company group
     * @type {string}
     * @memberof AdminPromocodesCompanyRequestDto
     */
    'group'?: string;
}
/**
 * 
 * @export
 * @interface AdminPromocodesResponseDto
 */
export interface AdminPromocodesResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminPromocodesResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPromocodesResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPromocodesResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPromocodesResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminPromocodeResponseDto>}
     * @memberof AdminPromocodesResponseDto
     */
    'data': Array<AdminPromocodeResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminRecommendationInfoResponseDto
 */
export interface AdminRecommendationInfoResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminRecommendationInfoResponseDto
     */
    'recommendationText': string | null;
    /**
     * 
     * @type {Array<UserFileResponseDto>}
     * @memberof AdminRecommendationInfoResponseDto
     */
    'recommendationFiles': Array<UserFileResponseDto> | null;
}
/**
 * 
 * @export
 * @interface AdminRejectTherapistRequestDto
 */
export interface AdminRejectTherapistRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AdminRejectTherapistRequestDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminReorderContentCoursesRequestDto
 */
export interface AdminReorderContentCoursesRequestDto {
    /**
     * 
     * @type {Array<AdminReorderItemRequestDto>}
     * @memberof AdminReorderContentCoursesRequestDto
     */
    'items': Array<AdminReorderItemRequestDto>;
}
/**
 * 
 * @export
 * @interface AdminReorderContentFoldersRequestDto
 */
export interface AdminReorderContentFoldersRequestDto {
    /**
     * 
     * @type {Array<AdminReorderItemRequestDto>}
     * @memberof AdminReorderContentFoldersRequestDto
     */
    'items': Array<AdminReorderItemRequestDto>;
}
/**
 * 
 * @export
 * @interface AdminReorderContentsRequestDto
 */
export interface AdminReorderContentsRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AdminReorderContentsRequestDto
     */
    'folderId': string;
    /**
     * 
     * @type {Array<AdminReorderItemRequestDto>}
     * @memberof AdminReorderContentsRequestDto
     */
    'items': Array<AdminReorderItemRequestDto>;
}
/**
 * 
 * @export
 * @interface AdminReorderItemRequestDto
 */
export interface AdminReorderItemRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AdminReorderItemRequestDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof AdminReorderItemRequestDto
     */
    'sortOrder': number;
}
/**
 * 
 * @export
 * @interface AdminResponseDto
 */
export interface AdminResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminResponseDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminResponseDto
     */
    'role': AdminResponseDtoRoleEnum;
}

export const AdminResponseDtoRoleEnum = {
    Admin: 'admin',
    Superadmin: 'superadmin',
    Askona: 'askona',
    Medsi: 'medsi',
    Curator: 'curator'
} as const;

export type AdminResponseDtoRoleEnum = typeof AdminResponseDtoRoleEnum[keyof typeof AdminResponseDtoRoleEnum];

/**
 * 
 * @export
 * @interface AdminSessionBalancePaginatedResponseDto
 */
export interface AdminSessionBalancePaginatedResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminSessionBalancePaginatedResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionBalancePaginatedResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionBalancePaginatedResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionBalancePaginatedResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminSessionBalanceResponseDto>}
     * @memberof AdminSessionBalancePaginatedResponseDto
     */
    'data': Array<AdminSessionBalanceResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminSessionBalanceResponseDto
 */
export interface AdminSessionBalanceResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminSessionBalanceResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionBalanceResponseDto
     */
    'status': AdminSessionBalanceResponseDtoStatusEnum;
    /**
     * 
     * @type {AdminSessionBalanceUserResponseDto}
     * @memberof AdminSessionBalanceResponseDto
     */
    'user': AdminSessionBalanceUserResponseDto;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionBalanceResponseDto
     */
    'startWith': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionBalanceResponseDto
     */
    'endWith': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionBalanceResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionBalanceResponseDto
     */
    'adminName': string;
}

export const AdminSessionBalanceResponseDtoStatusEnum = {
    NotStarted: 'not_started',
    Used: 'used',
    Unused: 'unused',
    Expired: 'expired',
    Unknown: 'unknown'
} as const;

export type AdminSessionBalanceResponseDtoStatusEnum = typeof AdminSessionBalanceResponseDtoStatusEnum[keyof typeof AdminSessionBalanceResponseDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminSessionBalanceUsageResponseDto
 */
export interface AdminSessionBalanceUsageResponseDto {
    /**
     * Доступное количество сессий
     * @type {number}
     * @memberof AdminSessionBalanceUsageResponseDto
     */
    'available': number;
    /**
     * Использовано сессий
     * @type {number}
     * @memberof AdminSessionBalanceUsageResponseDto
     */
    'used': number;
    /**
     * Просрочено сессий
     * @type {number}
     * @memberof AdminSessionBalanceUsageResponseDto
     */
    'expired': number;
}
/**
 * 
 * @export
 * @interface AdminSessionBalanceUserResponseDto
 */
export interface AdminSessionBalanceUserResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminSessionBalanceUserResponseDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionBalanceUserResponseDto
     */
    'email': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionBalanceUserResponseDto
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionBalanceUserResponseDto
     */
    'group': string;
}
/**
 * 
 * @export
 * @interface AdminSessionBalancesResponseDto
 */
export interface AdminSessionBalancesResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminSessionBalancesResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionBalancesResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionBalancesResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionBalancesResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminSessionBalanceResponseDto>}
     * @memberof AdminSessionBalancesResponseDto
     */
    'data': Array<AdminSessionBalanceResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminSessionFeedbackListResponseDto
 */
export interface AdminSessionFeedbackListResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminSessionFeedbackListResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionFeedbackListResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionFeedbackListResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionFeedbackListResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminSessionFeedbackResponseDto>}
     * @memberof AdminSessionFeedbackListResponseDto
     */
    'data': Array<AdminSessionFeedbackResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminSessionFeedbackResponseDto
 */
export interface AdminSessionFeedbackResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminSessionFeedbackResponseDto
     */
    'id': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof AdminSessionFeedbackResponseDto
     */
    'payload': Array<object>;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionFeedbackResponseDto
     */
    'session_id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionFeedbackResponseDto
     */
    'sessionStatus': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionFeedbackResponseDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionFeedbackResponseDto
     */
    'therapistEmail': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionFeedbackResponseDto
     */
    'therapistFirstname': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionFeedbackResponseDto
     */
    'therapistLastname': string;
    /**
     * 
     * @type {Array<object>}
     * @memberof AdminSessionFeedbackResponseDto
     */
    'patients': Array<object>;
}
/**
 * 
 * @export
 * @interface AdminSessionResponseDto
 */
export interface AdminSessionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminSessionResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionResponseDto
     */
    'therapistId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionResponseDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionResponseDto
     */
    'status': AdminSessionResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionResponseDto
     */
    'type': AdminSessionResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionResponseDto
     */
    'cancelerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSessionResponseDto
     */
    'cancelReason'?: string;
    /**
     * 
     * @type {AvailabilityResponseDto}
     * @memberof AdminSessionResponseDto
     */
    'availability': AvailabilityResponseDto;
    /**
     * 
     * @type {Array<AdminPatientResponseDto>}
     * @memberof AdminSessionResponseDto
     */
    'patients': Array<AdminPatientResponseDto>;
    /**
     * 
     * @type {AdminPaymentResponseDto}
     * @memberof AdminSessionResponseDto
     */
    'payment': AdminPaymentResponseDto;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSessionResponseDto
     */
    'isTherapistVisited': boolean;
}

export const AdminSessionResponseDtoStatusEnum = {
    Awaiting: 'awaiting',
    Live: 'live',
    Complete: 'complete',
    Canceled: 'canceled'
} as const;

export type AdminSessionResponseDtoStatusEnum = typeof AdminSessionResponseDtoStatusEnum[keyof typeof AdminSessionResponseDtoStatusEnum];
export const AdminSessionResponseDtoTypeEnum = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type AdminSessionResponseDtoTypeEnum = typeof AdminSessionResponseDtoTypeEnum[keyof typeof AdminSessionResponseDtoTypeEnum];

/**
 * 
 * @export
 * @interface AdminSessionsResponseDto
 */
export interface AdminSessionsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminSessionsResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionsResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSessionsResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminSessionResponseDto>}
     * @memberof AdminSessionsResponseDto
     */
    'data': Array<AdminSessionResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminSignInDto
 */
export interface AdminSignInDto {
    /**
     * 
     * @type {string}
     * @memberof AdminSignInDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSignInDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface AdminTherapisstStatisticResponseDto
 */
export interface AdminTherapisstStatisticResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminTherapisstStatisticResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapisstStatisticResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapisstStatisticResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapisstStatisticResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminTherapistStatisticResponseDto>}
     * @memberof AdminTherapisstStatisticResponseDto
     */
    'data': Array<AdminTherapistStatisticResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminTherapistProfileUpdateResponseDto
 */
export interface AdminTherapistProfileUpdateResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistProfileUpdateResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistProfileUpdateResponseDto
     */
    'therapistId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistProfileUpdateResponseDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistProfileUpdateResponseDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistProfileUpdateResponseDto
     */
    'lastname': string;
    /**
     * createdAt of profile update
     * @type {string}
     * @memberof AdminTherapistProfileUpdateResponseDto
     */
    'createdAt': string;
    /**
     * deletedAt of therapist
     * @type {string}
     * @memberof AdminTherapistProfileUpdateResponseDto
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {PublicTherapistResponseDto}
     * @memberof AdminTherapistProfileUpdateResponseDto
     */
    'update': PublicTherapistResponseDto;
}
/**
 * 
 * @export
 * @interface AdminTherapistProfileUpdatesResponseDto
 */
export interface AdminTherapistProfileUpdatesResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistProfileUpdatesResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistProfileUpdatesResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistProfileUpdatesResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistProfileUpdatesResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminTherapistProfileUpdateResponseDto>}
     * @memberof AdminTherapistProfileUpdatesResponseDto
     */
    'data': Array<AdminTherapistProfileUpdateResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminTherapistRequestResponseDto
 */
export interface AdminTherapistRequestResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistRequestResponseDto
     */
    'url': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistRequestResponseDto
     */
    'hasMedsiSessions'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistRequestResponseDto
     */
    'averageRating'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistRequestResponseDto
     */
    'isTop'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistRequestResponseDto
     */
    'isMedsi'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistRequestResponseDto
     */
    'isAdult': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistRequestResponseDto
     */
    'isChildTherapist'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistRequestResponseDto
     */
    'isSupervisor': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistRequestResponseDto
     */
    'isB2B': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistRequestResponseDto
     */
    'isCoach': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistRequestResponseDto
     */
    'isApproved': boolean;
    /**
     * 
     * @type {TherapistPersonalInfoResponseDto}
     * @memberof AdminTherapistRequestResponseDto
     */
    'personalInfo': TherapistPersonalInfoResponseDto;
    /**
     * 
     * @type {TherapistEducationInfoResponseDto}
     * @memberof AdminTherapistRequestResponseDto
     */
    'educationInfo': TherapistEducationInfoResponseDto;
    /**
     * 
     * @type {TherapistWorkingInfoResponseDto}
     * @memberof AdminTherapistRequestResponseDto
     */
    'workingInfo': TherapistWorkingInfoResponseDto;
    /**
     * 
     * @type {TherapistTherapiesInfoResponseDto}
     * @memberof AdminTherapistRequestResponseDto
     */
    'therapiesInfo': TherapistTherapiesInfoResponseDto;
    /**
     * 
     * @type {TherapistSupervisionInfoResponseDto}
     * @memberof AdminTherapistRequestResponseDto
     */
    'supervisionInfo': TherapistSupervisionInfoResponseDto;
    /**
     * 
     * @type {TherapistCollaborationInfoResponseDto}
     * @memberof AdminTherapistRequestResponseDto
     */
    'collaborationInfo': TherapistCollaborationInfoResponseDto;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistRequestResponseDto
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistRequestResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistRequestResponseDto
     */
    'id': string;
    /**
     * 
     * @type {AdminRecommendationInfoResponseDto}
     * @memberof AdminTherapistRequestResponseDto
     */
    'recommendationInfo': AdminRecommendationInfoResponseDto;
    /**
     * 
     * @type {AdminTherapistUserResponseDto}
     * @memberof AdminTherapistRequestResponseDto
     */
    'user': AdminTherapistUserResponseDto;
}
/**
 * 
 * @export
 * @interface AdminTherapistRequestsResponseDto
 */
export interface AdminTherapistRequestsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistRequestsResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistRequestsResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistRequestsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistRequestsResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminTherapistRequestResponseDto>}
     * @memberof AdminTherapistRequestsResponseDto
     */
    'data': Array<AdminTherapistRequestResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminTherapistResponseDto
 */
export interface AdminTherapistResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistResponseDto
     */
    'url': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistResponseDto
     */
    'hasMedsiSessions'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistResponseDto
     */
    'averageRating'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistResponseDto
     */
    'isTop'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistResponseDto
     */
    'isMedsi'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistResponseDto
     */
    'isAdult': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistResponseDto
     */
    'isChildTherapist'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistResponseDto
     */
    'isSupervisor': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistResponseDto
     */
    'isB2B': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistResponseDto
     */
    'isCoach': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistResponseDto
     */
    'isApproved': boolean;
    /**
     * 
     * @type {TherapistPersonalInfoResponseDto}
     * @memberof AdminTherapistResponseDto
     */
    'personalInfo': TherapistPersonalInfoResponseDto;
    /**
     * 
     * @type {TherapistEducationInfoResponseDto}
     * @memberof AdminTherapistResponseDto
     */
    'educationInfo': TherapistEducationInfoResponseDto;
    /**
     * 
     * @type {TherapistWorkingInfoResponseDto}
     * @memberof AdminTherapistResponseDto
     */
    'workingInfo': TherapistWorkingInfoResponseDto;
    /**
     * 
     * @type {TherapistTherapiesInfoResponseDto}
     * @memberof AdminTherapistResponseDto
     */
    'therapiesInfo': TherapistTherapiesInfoResponseDto;
    /**
     * 
     * @type {TherapistSupervisionInfoResponseDto}
     * @memberof AdminTherapistResponseDto
     */
    'supervisionInfo': TherapistSupervisionInfoResponseDto;
    /**
     * 
     * @type {TherapistCollaborationInfoResponseDto}
     * @memberof AdminTherapistResponseDto
     */
    'collaborationInfo': TherapistCollaborationInfoResponseDto;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistResponseDto
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {AdminTherapistUserResponseDto}
     * @memberof AdminTherapistResponseDto
     */
    'user': AdminTherapistUserResponseDto;
    /**
     * 
     * @type {AdminRecommendationInfoResponseDto}
     * @memberof AdminTherapistResponseDto
     */
    'recommendationInfo': AdminRecommendationInfoResponseDto;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistResponseDto
     */
    'totalSessions': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistResponseDto
     */
    'visitedSessions': number;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistResponseDto
     */
    'deletedAt': string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistResponseDto
     */
    'completedCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistResponseDto
     */
    'awaitingCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistResponseDto
     */
    'canceledCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistResponseDto
     */
    'rewardInPercent': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistResponseDto
     */
    'isTest': boolean;
}
/**
 * 
 * @export
 * @interface AdminTherapistStatisticResponseDto
 */
export interface AdminTherapistStatisticResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'deletedAt': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'isTest': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'url': string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'city': string;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'totalClients': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'totalSuccessfulSessions': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'awaitingCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'canceledCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'totalSessions': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'visitedSessions': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'regularClients': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'clientsWithTwoOrMoreSessions': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'firstTimeClients': number;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'therapistBronedBy': string;
    /**
     * 
     * @type {UserStatisticsDto}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'user': UserStatisticsDto;
    /**
     * 
     * @type {Array<TherapyMethodResponseDto>}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'therapyMethods': Array<TherapyMethodResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistStatisticResponseDto
     */
    'crr': number;
}
/**
 * 
 * @export
 * @interface AdminTherapistUserResponseDto
 */
export interface AdminTherapistUserResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistUserResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistUserResponseDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistUserResponseDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistUserResponseDto
     */
    'firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistUserResponseDto
     */
    'lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistUserResponseDto
     */
    'gender': AdminTherapistUserResponseDtoGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistUserResponseDto
     */
    'avatarKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistUserResponseDto
     */
    'miniAvatarKey'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTherapistUserResponseDto
     */
    'isPhoneConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistUserResponseDto
     */
    'paymentMethodId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistUserResponseDto
     */
    'utmSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistUserResponseDto
     */
    'utmMedium'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminTherapistUserResponseDto
     */
    'utmCampaign'?: string;
}

export const AdminTherapistUserResponseDtoGenderEnum = {
    Male: 'male',
    Female: 'female',
    Transgender: 'transgender',
    Unknown: 'unknown'
} as const;

export type AdminTherapistUserResponseDtoGenderEnum = typeof AdminTherapistUserResponseDtoGenderEnum[keyof typeof AdminTherapistUserResponseDtoGenderEnum];

/**
 * 
 * @export
 * @interface AdminTherapistsResponseDto
 */
export interface AdminTherapistsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistsResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistsResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminTherapistsResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<AdminTherapistResponseDto>}
     * @memberof AdminTherapistsResponseDto
     */
    'data': Array<AdminTherapistResponseDto>;
}
/**
 * 
 * @export
 * @interface AdminUpdateCurrenciesRequestDto
 */
export interface AdminUpdateCurrenciesRequestDto {
    /**
     * 
     * @type {Array<AdminPostCurrencyRequestDto>}
     * @memberof AdminUpdateCurrenciesRequestDto
     */
    'currencies': Array<AdminPostCurrencyRequestDto>;
}
/**
 * 
 * @export
 * @interface AdminUpdateFaqGroupRequestDto
 */
export interface AdminUpdateFaqGroupRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateFaqGroupRequestDto
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface AdminUpdateFaqQuestionRequestDto
 */
export interface AdminUpdateFaqQuestionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateFaqQuestionRequestDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateFaqQuestionRequestDto
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateFaqQuestionRequestDto
     */
    'groupId'?: string;
}
/**
 * 
 * @export
 * @interface AdminUpsertB2BMaterialRequestDto
 */
export interface AdminUpsertB2BMaterialRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertB2BMaterialRequestDto
     */
    'id'?: string;
    /**
     * 
     * @type {Array<B2BMaterialFileRequestDto>}
     * @memberof AdminUpsertB2BMaterialRequestDto
     */
    'files': Array<B2BMaterialFileRequestDto>;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertB2BMaterialRequestDto
     */
    'companyId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertB2BMaterialRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertB2BMaterialRequestDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertB2BMaterialRequestDto
     */
    'status': AdminUpsertB2BMaterialRequestDtoStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUpsertB2BMaterialRequestDto
     */
    'userIds'?: Array<string>;
}

export const AdminUpsertB2BMaterialRequestDtoStatusEnum = {
    Draft: 'draft',
    Published: 'published'
} as const;

export type AdminUpsertB2BMaterialRequestDtoStatusEnum = typeof AdminUpsertB2BMaterialRequestDtoStatusEnum[keyof typeof AdminUpsertB2BMaterialRequestDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminUpsertContentCourseRequestDto
 */
export interface AdminUpsertContentCourseRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertContentCourseRequestDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertContentCourseRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertContentCourseRequestDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminUpsertContentCourseRequestDto
     */
    'sortOrder'?: number;
    /**
     * Аудитория, например junior / middle / managers
     * @type {string}
     * @memberof AdminUpsertContentCourseRequestDto
     */
    'audience'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertContentCourseRequestDto
     */
    'status': AdminUpsertContentCourseRequestDtoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpsertContentCourseRequestDto
     */
    'isForAllCompanies': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUpsertContentCourseRequestDto
     */
    'companyIds'?: Array<string>;
}

export const AdminUpsertContentCourseRequestDtoStatusEnum = {
    Draft: 'draft',
    Published: 'published'
} as const;

export type AdminUpsertContentCourseRequestDtoStatusEnum = typeof AdminUpsertContentCourseRequestDtoStatusEnum[keyof typeof AdminUpsertContentCourseRequestDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminUpsertContentFolderRequestDto
 */
export interface AdminUpsertContentFolderRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertContentFolderRequestDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertContentFolderRequestDto
     */
    'courseId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertContentFolderRequestDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AdminUpsertContentFolderRequestDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpsertContentFolderRequestDto
     */
    'isSequentialLock': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertContentFolderRequestDto
     */
    'status': AdminUpsertContentFolderRequestDtoStatusEnum;
}

export const AdminUpsertContentFolderRequestDtoStatusEnum = {
    Draft: 'draft',
    Published: 'published'
} as const;

export type AdminUpsertContentFolderRequestDtoStatusEnum = typeof AdminUpsertContentFolderRequestDtoStatusEnum[keyof typeof AdminUpsertContentFolderRequestDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminUpsertContentRequestDto
 */
export interface AdminUpsertContentRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertContentRequestDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertContentRequestDto
     */
    'folderId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminUpsertContentRequestDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertContentRequestDto
     */
    'src': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertContentRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertContentRequestDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpsertContentRequestDto
     */
    'status': AdminUpsertContentRequestDtoStatusEnum;
    /**
     * 
     * @type {Array<AdminContentFileRequestDto>}
     * @memberof AdminUpsertContentRequestDto
     */
    'files'?: Array<AdminContentFileRequestDto>;
}

export const AdminUpsertContentRequestDtoStatusEnum = {
    Draft: 'draft',
    Published: 'published'
} as const;

export type AdminUpsertContentRequestDtoStatusEnum = typeof AdminUpsertContentRequestDtoStatusEnum[keyof typeof AdminUpsertContentRequestDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminWithTokenResponseDto
 */
export interface AdminWithTokenResponseDto {
    /**
     * 
     * @type {AdminResponseDto}
     * @memberof AdminWithTokenResponseDto
     */
    'admin': AdminResponseDto;
    /**
     * 
     * @type {string}
     * @memberof AdminWithTokenResponseDto
     */
    'accessToken': string;
}
/**
 * 
 * @export
 * @interface AdminsResponseDto
 */
export interface AdminsResponseDto {
    /**
     * 
     * @type {Array<AdminResponseDto>}
     * @memberof AdminsResponseDto
     */
    'admins': Array<AdminResponseDto>;
}
/**
 * 
 * @export
 * @interface AmoResponseDto
 */
export interface AmoResponseDto {
    /**
     * status
     * @type {boolean}
     * @memberof AmoResponseDto
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface AttachCardRequestDto
 */
export interface AttachCardRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AttachCardRequestDto
     */
    'returnUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof AttachCardRequestDto
     */
    'isOutsider': boolean;
}
/**
 * 
 * @export
 * @interface AttachCardResponseDto
 */
export interface AttachCardResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AttachCardResponseDto
     */
    'redirectUrl': string;
}
/**
 * 
 * @export
 * @interface AvailabilitiesCreateResponseDto
 */
export interface AvailabilitiesCreateResponseDto {
    /**
     * 
     * @type {Array<AvailabilityResponseDto>}
     * @memberof AvailabilitiesCreateResponseDto
     */
    'availabilities': Array<AvailabilityResponseDto>;
    /**
     * 
     * @type {Array<AvailabilityRecurringResponseDto>}
     * @memberof AvailabilitiesCreateResponseDto
     */
    'availabilityRecurrings': Array<AvailabilityRecurringResponseDto>;
}
/**
 * 
 * @export
 * @interface AvailabilitiesResponseDto
 */
export interface AvailabilitiesResponseDto {
    /**
     * 
     * @type {Array<AvailabilityResponseDto>}
     * @memberof AvailabilitiesResponseDto
     */
    'availabilities': Array<AvailabilityResponseDto>;
}
/**
 * 
 * @export
 * @interface AvailabilityRecurringResponseDto
 */
export interface AvailabilityRecurringResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AvailabilityRecurringResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityRecurringResponseDto
     */
    'therapistId': string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityRecurringResponseDto
     */
    'startTime': string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityRecurringResponseDto
     */
    'type': AvailabilityRecurringResponseDtoTypeEnum;
}

export const AvailabilityRecurringResponseDtoTypeEnum = {
    Day: 'every_day',
    Weekday: 'every_weekday',
    Monday: 'every_monday',
    Tuesday: 'every_tuesday',
    Wednesday: 'every_wednesday',
    Thursday: 'every_thursday',
    Friday: 'every_friday',
    Saturday: 'every_saturday',
    Sunday: 'every_sunday'
} as const;

export type AvailabilityRecurringResponseDtoTypeEnum = typeof AvailabilityRecurringResponseDtoTypeEnum[keyof typeof AvailabilityRecurringResponseDtoTypeEnum];

/**
 * 
 * @export
 * @interface AvailabilityRequestDto
 */
export interface AvailabilityRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AvailabilityRequestDto
     */
    'startPeriodDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityRequestDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityRequestDto
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityRequestDto
     */
    'type'?: AvailabilityRequestDtoTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AvailabilityRequestDto
     */
    'isRecurring': boolean;
    /**
     * 
     * @type {number}
     * @memberof AvailabilityRequestDto
     */
    'offsetHours'?: number;
}

export const AvailabilityRequestDtoTypeEnum = {
    Day: 'every_day',
    Weekday: 'every_weekday',
    Monday: 'every_monday',
    Tuesday: 'every_tuesday',
    Wednesday: 'every_wednesday',
    Thursday: 'every_thursday',
    Friday: 'every_friday',
    Saturday: 'every_saturday',
    Sunday: 'every_sunday'
} as const;

export type AvailabilityRequestDtoTypeEnum = typeof AvailabilityRequestDtoTypeEnum[keyof typeof AvailabilityRequestDtoTypeEnum];

/**
 * 
 * @export
 * @interface AvailabilityResponseDto
 */
export interface AvailabilityResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AvailabilityResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityResponseDto
     */
    'therapistId': string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityResponseDto
     */
    'availabilityRecurringId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityResponseDto
     */
    'startDate': string;
}
/**
 * 
 * @export
 * @interface B2BMaterialFileRequestDto
 */
export interface B2BMaterialFileRequestDto {
    /**
     * 
     * @type {string}
     * @memberof B2BMaterialFileRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof B2BMaterialFileRequestDto
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface B2BMaterialFileResponseDto
 */
export interface B2BMaterialFileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof B2BMaterialFileResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof B2BMaterialFileResponseDto
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface B2BMaterialResponseDto
 */
export interface B2BMaterialResponseDto {
    /**
     * 
     * @type {Array<B2BMaterialFileResponseDto>}
     * @memberof B2BMaterialResponseDto
     */
    'files': Array<B2BMaterialFileResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof B2BMaterialResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof B2BMaterialResponseDto
     */
    'description': string | null;
}
/**
 * 
 * @export
 * @interface B2BMaterialsPaginatedResponseDto
 */
export interface B2BMaterialsPaginatedResponseDto {
    /**
     * 
     * @type {number}
     * @memberof B2BMaterialsPaginatedResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof B2BMaterialsPaginatedResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof B2BMaterialsPaginatedResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof B2BMaterialsPaginatedResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<B2BMaterialResponseDto>}
     * @memberof B2BMaterialsPaginatedResponseDto
     */
    'data': Array<B2BMaterialResponseDto>;
}
/**
 * 
 * @export
 * @interface BfsCompanyPatientDto
 */
export interface BfsCompanyPatientDto {
    /**
     * 
     * @type {string}
     * @memberof BfsCompanyPatientDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof BfsCompanyPatientDto
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof BfsCompanyPatientDto
     */
    'group'?: string;
    /**
     * 
     * @type {number}
     * @memberof BfsCompanyPatientDto
     */
    'balance': number;
    /**
     * 
     * @type {string}
     * @memberof BfsCompanyPatientDto
     */
    'balanceStartWith': string;
    /**
     * 
     * @type {string}
     * @memberof BfsCompanyPatientDto
     */
    'balanceEndWith': string;
}
/**
 * 
 * @export
 * @interface BookSessionActionDataResponseDto
 */
export interface BookSessionActionDataResponseDto {
    /**
     * 
     * @type {string}
     * @memberof BookSessionActionDataResponseDto
     */
    'redirectUrl': string;
}
/**
 * 
 * @export
 * @interface BookSessionByAdminDto
 */
export interface BookSessionByAdminDto {
    /**
     * 
     * @type {string}
     * @memberof BookSessionByAdminDto
     */
    'patientId': string;
    /**
     * 
     * @type {string}
     * @memberof BookSessionByAdminDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof BookSessionByAdminDto
     */
    'type': BookSessionByAdminDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BookSessionByAdminDto
     */
    'promocode'?: string;
}

export const BookSessionByAdminDtoTypeEnum = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type BookSessionByAdminDtoTypeEnum = typeof BookSessionByAdminDtoTypeEnum[keyof typeof BookSessionByAdminDtoTypeEnum];

/**
 * 
 * @export
 * @interface BookSessionByTherapistDto
 */
export interface BookSessionByTherapistDto {
    /**
     * 
     * @type {string}
     * @memberof BookSessionByTherapistDto
     */
    'patientId': string;
    /**
     * 
     * @type {string}
     * @memberof BookSessionByTherapistDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof BookSessionByTherapistDto
     */
    'type': BookSessionByTherapistDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BookSessionByTherapistDto
     */
    'promocode'?: string;
}

export const BookSessionByTherapistDtoTypeEnum = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type BookSessionByTherapistDtoTypeEnum = typeof BookSessionByTherapistDtoTypeEnum[keyof typeof BookSessionByTherapistDtoTypeEnum];

/**
 * 
 * @export
 * @interface BookSessionDataResponseDto
 */
export interface BookSessionDataResponseDto {
    /**
     * 
     * @type {string}
     * @memberof BookSessionDataResponseDto
     */
    'action': BookSessionDataResponseDtoActionEnum;
    /**
     * 
     * @type {BookSessionActionDataResponseDto}
     * @memberof BookSessionDataResponseDto
     */
    'actionData': BookSessionActionDataResponseDto | null;
}

export const BookSessionDataResponseDtoActionEnum = {
    Redirect: 'redirect',
    Approve: 'approve',
    NoAction: 'no_action',
    WaitCallback: 'wait_callback',
    Decline: 'decline'
} as const;

export type BookSessionDataResponseDtoActionEnum = typeof BookSessionDataResponseDtoActionEnum[keyof typeof BookSessionDataResponseDtoActionEnum];

/**
 * 
 * @export
 * @interface BookSessionRequestDto
 */
export interface BookSessionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof BookSessionRequestDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof BookSessionRequestDto
     */
    'promocode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BookSessionRequestDto
     */
    'withNewCard'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BookSessionRequestDto
     */
    'saveCard'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BookSessionRequestDto
     */
    'foreigner'?: boolean;
}
/**
 * 
 * @export
 * @interface BookSessionResponseDto
 */
export interface BookSessionResponseDto {
    /**
     * 
     * @type {BookSessionDataResponseDto}
     * @memberof BookSessionResponseDto
     */
    'data': BookSessionDataResponseDto;
}
/**
 * 
 * @export
 * @interface CampaignStatisticsDto
 */
export interface CampaignStatisticsDto {
    /**
     * 
     * @type {SessionStatisticsClientsResponseDto}
     * @memberof CampaignStatisticsDto
     */
    'medsi': SessionStatisticsClientsResponseDto;
    /**
     * 
     * @type {SessionStatisticsClientsResponseDto}
     * @memberof CampaignStatisticsDto
     */
    'pogovorim': SessionStatisticsClientsResponseDto;
}
/**
 * 
 * @export
 * @interface CancelDealRequestDto
 */
export interface CancelDealRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CancelDealRequestDto
     */
    'orderId': string;
}
/**
 * 
 * @export
 * @interface CancelSessionRequestDto
 */
export interface CancelSessionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CancelSessionRequestDto
     */
    'sessionId': string;
    /**
     * 
     * @type {string}
     * @memberof CancelSessionRequestDto
     */
    'cancelReason': string;
}
/**
 * 
 * @export
 * @interface CancelSupervisionRequestDto
 */
export interface CancelSupervisionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CancelSupervisionRequestDto
     */
    'cancelReason': string;
}
/**
 * 
 * @export
 * @interface CheckAuthTermResponseDto
 */
export interface CheckAuthTermResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof CheckAuthTermResponseDto
     */
    'isAvailable': boolean;
    /**
     * 
     * @type {number}
     * @memberof CheckAuthTermResponseDto
     */
    'secondsBeforeNextAttempt': number;
    /**
     * 
     * @type {boolean}
     * @memberof CheckAuthTermResponseDto
     */
    'hasPassword': boolean;
}
/**
 * 
 * @export
 * @interface CheckEmailRequestDto
 */
export interface CheckEmailRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CheckEmailRequestDto
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckEmailRequestDto
     */
    'isNeedVerification'?: boolean;
}
/**
 * 
 * @export
 * @interface CheckPasswordRequestDto
 */
export interface CheckPasswordRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CheckPasswordRequestDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface CheckPhoneNumberVerificationDto
 */
export interface CheckPhoneNumberVerificationDto {
    /**
     * 
     * @type {string}
     * @memberof CheckPhoneNumberVerificationDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof CheckPhoneNumberVerificationDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface CheckPhoneRequestDto
 */
export interface CheckPhoneRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CheckPhoneRequestDto
     */
    'phone': string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckPhoneRequestDto
     */
    'isNeedVerification'?: boolean;
}
/**
 * 
 * @export
 * @interface CheckPromocodeByTherapistRequestDto
 */
export interface CheckPromocodeByTherapistRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CheckPromocodeByTherapistRequestDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof CheckPromocodeByTherapistRequestDto
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface CheckVerificationCodeDto
 */
export interface CheckVerificationCodeDto {
    /**
     * 
     * @type {boolean}
     * @memberof CheckVerificationCodeDto
     */
    'confirmed': boolean;
}
/**
 * 
 * @export
 * @interface ChildTherapistTicketRequestDto
 */
export interface ChildTherapistTicketRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ChildTherapistTicketRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ChildTherapistTicketRequestDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof ChildTherapistTicketRequestDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ChildTherapistTicketRequestDto
     */
    'childName': string;
    /**
     * 
     * @type {number}
     * @memberof ChildTherapistTicketRequestDto
     */
    'childOld': number;
    /**
     * 
     * @type {string}
     * @memberof ChildTherapistTicketRequestDto
     */
    'comment'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ChildTherapistTicketRequestDto
     */
    'diseases'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ChildTherapistTicketRequestDto
     */
    'priceFrom': number;
    /**
     * 
     * @type {number}
     * @memberof ChildTherapistTicketRequestDto
     */
    'priceTo': number;
    /**
     * 
     * @type {string}
     * @memberof ChildTherapistTicketRequestDto
     */
    'therapistGender': ChildTherapistTicketRequestDtoTherapistGenderEnum;
}

export const ChildTherapistTicketRequestDtoTherapistGenderEnum = {
    Man: 'man',
    Women: 'women',
    Any: 'any'
} as const;

export type ChildTherapistTicketRequestDtoTherapistGenderEnum = typeof ChildTherapistTicketRequestDtoTherapistGenderEnum[keyof typeof ChildTherapistTicketRequestDtoTherapistGenderEnum];

/**
 * 
 * @export
 * @interface CloseSessionModalRequestDto
 */
export interface CloseSessionModalRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CloseSessionModalRequestDto
     */
    'modal': CloseSessionModalRequestDtoModalEnum;
    /**
     * 
     * @type {string}
     * @memberof CloseSessionModalRequestDto
     */
    'sessionId': string;
}

export const CloseSessionModalRequestDtoModalEnum = {
    SessionOutcomes: 'session_outcomes'
} as const;

export type CloseSessionModalRequestDtoModalEnum = typeof CloseSessionModalRequestDtoModalEnum[keyof typeof CloseSessionModalRequestDtoModalEnum];

/**
 * 
 * @export
 * @interface CreateAdminRequestDto
 */
export interface CreateAdminRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAdminRequestDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdminRequestDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdminRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdminRequestDto
     */
    'role'?: CreateAdminRequestDtoRoleEnum;
}

export const CreateAdminRequestDtoRoleEnum = {
    Admin: 'admin',
    Superadmin: 'superadmin',
    Askona: 'askona',
    Medsi: 'medsi',
    Curator: 'curator'
} as const;

export type CreateAdminRequestDtoRoleEnum = typeof CreateAdminRequestDtoRoleEnum[keyof typeof CreateAdminRequestDtoRoleEnum];

/**
 * 
 * @export
 * @interface CreateAmoPromocodeDto
 */
export interface CreateAmoPromocodeDto {
    /**
     * 
     * @type {number}
     * @memberof CreateAmoPromocodeDto
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAmoPromocodeDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateAmoPromocodeDto
     */
    'percentage'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAmoPromocodeDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAmoPromocodeDto
     */
    'expireDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAmoPromocodeDto
     */
    'firstUseOnly'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateAmoPromocodeDto
     */
    'useLimitPerUser'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAmoPromocodeDto
     */
    'amoUserId'?: string;
}
/**
 * 
 * @export
 * @interface CreateAvailabilitiesRequestDto
 */
export interface CreateAvailabilitiesRequestDto {
    /**
     * 
     * @type {Array<AvailabilityRequestDto>}
     * @memberof CreateAvailabilitiesRequestDto
     */
    'availabilities': Array<AvailabilityRequestDto>;
}
/**
 * 
 * @export
 * @interface CreateCompanyCompanyInfoRequestDto
 */
export interface CreateCompanyCompanyInfoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyCompanyInfoRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyCompanyInfoRequestDto
     */
    'type': CreateCompanyCompanyInfoRequestDtoTypeEnum;
    /**
     * 
     * @type {Array<CreateCompanyCompanyInfoTherapistsFiltersRequestDto>}
     * @memberof CreateCompanyCompanyInfoRequestDto
     */
    'therapistsFilters'?: Array<CreateCompanyCompanyInfoTherapistsFiltersRequestDto>;
}

export const CreateCompanyCompanyInfoRequestDtoTypeEnum = {
    Promocode: 'promocode',
    Balance: 'balance'
} as const;

export type CreateCompanyCompanyInfoRequestDtoTypeEnum = typeof CreateCompanyCompanyInfoRequestDtoTypeEnum[keyof typeof CreateCompanyCompanyInfoRequestDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateCompanyCompanyInfoTherapistsFiltersRequestDto
 */
export interface CreateCompanyCompanyInfoTherapistsFiltersRequestDto {
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyCompanyInfoTherapistsFiltersRequestDto
     */
    'priceMin': number;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyCompanyInfoTherapistsFiltersRequestDto
     */
    'priceMax': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyCompanyInfoTherapistsFiltersRequestDto
     */
    'coaches': boolean;
}
/**
 * 
 * @export
 * @interface CreateCompanyCreateRequestRequestDto
 */
export interface CreateCompanyCreateRequestRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyCreateRequestRequestDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyCreateRequestRequestDto
     */
    'numberOfEmployee': number;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyCreateRequestRequestDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyCreateRequestRequestDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyCreateRequestRequestDto
     */
    'phone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyCreateRequestRequestDto
     */
    'contactByPhone': boolean;
}
/**
 * 
 * @export
 * @interface CreateCompanyPromocodeInfoRequestDto
 */
export interface CreateCompanyPromocodeInfoRequestDto {
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyPromocodeInfoRequestDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyPromocodeInfoRequestDto
     */
    'percentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateCompanyPromocodeInfoRequestDto
     */
    'quantity': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCompanyPromocodeInfoRequestDto
     */
    'firstUseOnly'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateCompanyRequestDto
 */
export interface CreateCompanyRequestDto {
    /**
     * 
     * @type {CreateCompanyUserInfoDto}
     * @memberof CreateCompanyRequestDto
     */
    'user': CreateCompanyUserInfoDto;
    /**
     * 
     * @type {CreateCompanyCompanyInfoRequestDto}
     * @memberof CreateCompanyRequestDto
     */
    'company': CreateCompanyCompanyInfoRequestDto;
    /**
     * 
     * @type {Array<CreateCompanyPromocodeInfoRequestDto>}
     * @memberof CreateCompanyRequestDto
     */
    'promocodes': Array<CreateCompanyPromocodeInfoRequestDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyRequestDto
     */
    'promocodeExpireDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyRequestDto
     */
    'requestId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyRequestDto
     */
    'adminId'?: string;
}
/**
 * 
 * @export
 * @interface CreateCompanyUserInfoDto
 */
export interface CreateCompanyUserInfoDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyUserInfoDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyUserInfoDto
     */
    'lastname': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyUserInfoDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyUserInfoDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompanyUserInfoDto
     */
    'avatarKey': string;
}
/**
 * 
 * @export
 * @interface CreateDealAmountRequestDto
 */
export interface CreateDealAmountRequestDto {
    /**
     * 
     * @type {number}
     * @memberof CreateDealAmountRequestDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof CreateDealAmountRequestDto
     */
    'currency': CreateDealAmountRequestDtoCurrencyEnum;
}

export const CreateDealAmountRequestDtoCurrencyEnum = {
    Rub: 'RUB',
    Usd: 'USD'
} as const;

export type CreateDealAmountRequestDtoCurrencyEnum = typeof CreateDealAmountRequestDtoCurrencyEnum[keyof typeof CreateDealAmountRequestDtoCurrencyEnum];

/**
 * 
 * @export
 * @interface CreateDealRequestDto
 */
export interface CreateDealRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateDealRequestDto
     */
    'senderUserId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDealRequestDto
     */
    'receiverUserId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDealRequestDto
     */
    'orderId': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDealRequestDto
     */
    'withCheckout': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDealRequestDto
     */
    'savingPaymentMethod': boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateDealRequestDto
     */
    'orderDate': string;
    /**
     * 
     * @type {CreateDealAmountRequestDto}
     * @memberof CreateDealRequestDto
     */
    'payin': CreateDealAmountRequestDto;
    /**
     * 
     * @type {CreateDealAmountRequestDto}
     * @memberof CreateDealRequestDto
     */
    'payout': CreateDealAmountRequestDto;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDealRequestDto
     */
    'is_outsider': boolean;
}
/**
 * 
 * @export
 * @interface CreateFileRequestDto
 */
export interface CreateFileRequestDto {
    /**
     * File name
     * @type {string}
     * @memberof CreateFileRequestDto
     */
    'fileName': string;
    /**
     * File content type
     * @type {string}
     * @memberof CreateFileRequestDto
     */
    'contentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFileRequestDto
     */
    'mediaType': CreateFileRequestDtoMediaTypeEnum;
}

export const CreateFileRequestDtoMediaTypeEnum = {
    Avatars: 'avatars',
    Videos: 'videos',
    Documents: 'documents'
} as const;

export type CreateFileRequestDtoMediaTypeEnum = typeof CreateFileRequestDtoMediaTypeEnum[keyof typeof CreateFileRequestDtoMediaTypeEnum];

/**
 * 
 * @export
 * @interface CreateMailSubscriptionRequestDto
 */
export interface CreateMailSubscriptionRequestDto {
    /**
     * email
     * @type {string}
     * @memberof CreateMailSubscriptionRequestDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface CreateMarriedCoupleConsultationTicketRequestDto
 */
export interface CreateMarriedCoupleConsultationTicketRequestDto {
    /**
     * Имя клиента
     * @type {string}
     * @memberof CreateMarriedCoupleConsultationTicketRequestDto
     */
    'name': string;
    /**
     * Номер телефона
     * @type {string}
     * @memberof CreateMarriedCoupleConsultationTicketRequestDto
     */
    'phone': string;
    /**
     * email
     * @type {string}
     * @memberof CreateMarriedCoupleConsultationTicketRequestDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface CreateRecommendedFilterRequestDto
 */
export interface CreateRecommendedFilterRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateRecommendedFilterRequestDto
     */
    'condition': CreateRecommendedFilterRequestDtoConditionEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateRecommendedFilterRequestDto
     */
    'urgency': CreateRecommendedFilterRequestDtoUrgencyEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateRecommendedFilterRequestDto
     */
    'gender'?: CreateRecommendedFilterRequestDtoGenderEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRecommendedFilterRequestDto
     */
    'diseases'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateRecommendedFilterRequestDto
     */
    'religion'?: CreateRecommendedFilterRequestDtoReligionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRecommendedFilterRequestDto
     */
    'workWithLgbt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRecommendedFilterRequestDto
     */
    'workWithEthnicGroups'?: boolean;
}

export const CreateRecommendedFilterRequestDtoConditionEnum = {
    Bad: 'bad',
    Normal: 'normal',
    Good: 'good'
} as const;

export type CreateRecommendedFilterRequestDtoConditionEnum = typeof CreateRecommendedFilterRequestDtoConditionEnum[keyof typeof CreateRecommendedFilterRequestDtoConditionEnum];
export const CreateRecommendedFilterRequestDtoUrgencyEnum = {
    Low: 'low',
    Medium: 'medium',
    High: 'high'
} as const;

export type CreateRecommendedFilterRequestDtoUrgencyEnum = typeof CreateRecommendedFilterRequestDtoUrgencyEnum[keyof typeof CreateRecommendedFilterRequestDtoUrgencyEnum];
export const CreateRecommendedFilterRequestDtoGenderEnum = {
    Male: 'male',
    Female: 'female'
} as const;

export type CreateRecommendedFilterRequestDtoGenderEnum = typeof CreateRecommendedFilterRequestDtoGenderEnum[keyof typeof CreateRecommendedFilterRequestDtoGenderEnum];
export const CreateRecommendedFilterRequestDtoReligionEnum = {
    Christianity: 'christianity',
    Islamism: 'islamism',
    Judaism: 'judaism',
    Buddhism: 'buddhism'
} as const;

export type CreateRecommendedFilterRequestDtoReligionEnum = typeof CreateRecommendedFilterRequestDtoReligionEnum[keyof typeof CreateRecommendedFilterRequestDtoReligionEnum];

/**
 * 
 * @export
 * @interface CreateSupervisionRequestDto
 */
export interface CreateSupervisionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateSupervisionRequestDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSupervisionRequestDto
     */
    'type': CreateSupervisionRequestDtoTypeEnum;
}

export const CreateSupervisionRequestDtoTypeEnum = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type CreateSupervisionRequestDtoTypeEnum = typeof CreateSupervisionRequestDtoTypeEnum[keyof typeof CreateSupervisionRequestDtoTypeEnum];

/**
 * 
 * @export
 * @interface CreateTestSessionResponse
 */
export interface CreateTestSessionResponse {
    /**
     * 
     * @type {string}
     * @memberof CreateTestSessionResponse
     */
    'accessToken': string;
    /**
     * 
     * @type {number}
     * @memberof CreateTestSessionResponse
     */
    'uid': number;
    /**
     * 
     * @type {string}
     * @memberof CreateTestSessionResponse
     */
    'channelName': string;
}
/**
 * 
 * @export
 * @interface CreateTherapistProfileRequestDto
 */
export interface CreateTherapistProfileRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTherapistProfileRequestDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTherapistProfileRequestDto
     */
    'email'?: string;
    /**
     * 
     * @type {TherapistPersonalInfoRequestDto}
     * @memberof CreateTherapistProfileRequestDto
     */
    'personalInfo': TherapistPersonalInfoRequestDto;
    /**
     * 
     * @type {TherapistEducationInfoRequestDto}
     * @memberof CreateTherapistProfileRequestDto
     */
    'educationInfo': TherapistEducationInfoRequestDto;
    /**
     * 
     * @type {TherapistWorkingInfoRequestDto}
     * @memberof CreateTherapistProfileRequestDto
     */
    'workingInfo': TherapistWorkingInfoRequestDto;
    /**
     * 
     * @type {TherapistTherapiesInfoRequestDto}
     * @memberof CreateTherapistProfileRequestDto
     */
    'therapiesInfo': TherapistTherapiesInfoRequestDto;
    /**
     * 
     * @type {TherapistCollaborationAndMediaRequestDto}
     * @memberof CreateTherapistProfileRequestDto
     */
    'collaborationInfo': TherapistCollaborationAndMediaRequestDto;
    /**
     * 
     * @type {TherapistSupervisionInfoRequestDto}
     * @memberof CreateTherapistProfileRequestDto
     */
    'supervisionInfo': TherapistSupervisionInfoRequestDto;
    /**
     * 
     * @type {TherapistRecommendationInfoRequestDto}
     * @memberof CreateTherapistProfileRequestDto
     */
    'recommendationInfo'?: TherapistRecommendationInfoRequestDto;
}
/**
 * 
 * @export
 * @interface CurrencyResponseDto
 */
export interface CurrencyResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CurrencyResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CurrencyResponseDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CurrencyResponseDto
     */
    'rubExchangeRate': number;
}
/**
 * 
 * @export
 * @interface DayLimitsSearchStatisticsResponseDto
 */
export interface DayLimitsSearchStatisticsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DayLimitsSearchStatisticsResponseDto
     */
    'dayLimit1': string;
    /**
     * 
     * @type {string}
     * @memberof DayLimitsSearchStatisticsResponseDto
     */
    'dayLimit3': string;
    /**
     * 
     * @type {string}
     * @memberof DayLimitsSearchStatisticsResponseDto
     */
    'dayLimit7': string;
    /**
     * 
     * @type {string}
     * @memberof DayLimitsSearchStatisticsResponseDto
     */
    'dayLimit30': string;
}
/**
 * 
 * @export
 * @interface DeleteAvailabilityRequestDto
 */
export interface DeleteAvailabilityRequestDto {
    /**
     * 
     * @type {string}
     * @memberof DeleteAvailabilityRequestDto
     */
    'deleteMode'?: DeleteAvailabilityRequestDtoDeleteModeEnum;
    /**
     * 
     * @type {string}
     * @memberof DeleteAvailabilityRequestDto
     */
    'deleteDate'?: string;
}

export const DeleteAvailabilityRequestDtoDeleteModeEnum = {
    All: 'all',
    OnlyThis: 'only_this',
    ThisAndNext: 'this_and_next'
} as const;

export type DeleteAvailabilityRequestDtoDeleteModeEnum = typeof DeleteAvailabilityRequestDtoDeleteModeEnum[keyof typeof DeleteAvailabilityRequestDtoDeleteModeEnum];

/**
 * 
 * @export
 * @interface DiseaseGroupResponseDto
 */
export interface DiseaseGroupResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DiseaseGroupResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseGroupResponseDto
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof DiseaseGroupResponseDto
     */
    'isChild': boolean;
    /**
     * 
     * @type {Array<DiseaseResponseDto>}
     * @memberof DiseaseGroupResponseDto
     */
    'items': Array<DiseaseResponseDto>;
}
/**
 * 
 * @export
 * @interface DiseaseResponseDto
 */
export interface DiseaseResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DiseaseResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseResponseDto
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseResponseDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseResponseDto
     */
    'tip': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseResponseDto
     */
    'diseasesGroupId': string;
}
/**
 * 
 * @export
 * @interface DiseasesSearchStatisticsResponseDto
 */
export interface DiseasesSearchStatisticsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof DiseasesSearchStatisticsResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DiseasesSearchStatisticsResponseDto
     */
    'percentage': string;
}
/**
 * 
 * @export
 * @interface FaqGroupResponseDto
 */
export interface FaqGroupResponseDto {
    /**
     * 
     * @type {string}
     * @memberof FaqGroupResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FaqGroupResponseDto
     */
    'title': string;
    /**
     * 
     * @type {Array<FaqQuestionResponseDto>}
     * @memberof FaqGroupResponseDto
     */
    'questions': Array<FaqQuestionResponseDto>;
}
/**
 * 
 * @export
 * @interface FaqQuestionResponseDto
 */
export interface FaqQuestionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof FaqQuestionResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FaqQuestionResponseDto
     */
    'groupId': string;
    /**
     * 
     * @type {string}
     * @memberof FaqQuestionResponseDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof FaqQuestionResponseDto
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface FaqResponseDto
 */
export interface FaqResponseDto {
    /**
     * 
     * @type {Array<FaqGroupResponseDto>}
     * @memberof FaqResponseDto
     */
    'groups': Array<FaqGroupResponseDto>;
}
/**
 * 
 * @export
 * @interface GendersSearchStatisticsResponseDto
 */
export interface GendersSearchStatisticsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GendersSearchStatisticsResponseDto
     */
    'male': string;
    /**
     * 
     * @type {string}
     * @memberof GendersSearchStatisticsResponseDto
     */
    'female': string;
}
/**
 * 
 * @export
 * @interface GenerateTokenRequestDto
 */
export interface GenerateTokenRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GenerateTokenRequestDto
     */
    'medsiUserId': string;
    /**
     * 
     * @type {string}
     * @memberof GenerateTokenRequestDto
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface GenerateTokenResponseDto
 */
export interface GenerateTokenResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GenerateTokenResponseDto
     */
    'medsiToken': string;
    /**
     * 
     * @type {string}
     * @memberof GenerateTokenResponseDto
     */
    'redirectUrl': string;
}
/**
 * 
 * @export
 * @interface GetApiKeyResponseDto
 */
export interface GetApiKeyResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetApiKeyResponseDto
     */
    'apiKey': string;
}
/**
 * 
 * @export
 * @interface GetPromocodesResponseDto
 */
export interface GetPromocodesResponseDto {
    /**
     * 
     * @type {Array<PromocodePackageResponseDto>}
     * @memberof GetPromocodesResponseDto
     */
    'packages': Array<PromocodePackageResponseDto>;
}
/**
 * 
 * @export
 * @interface GetSearchStatisticsRequestDto
 */
export interface GetSearchStatisticsRequestDto {
    /**
     * 
     * @type {string}
     * @memberof GetSearchStatisticsRequestDto
     */
    'dateFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSearchStatisticsRequestDto
     */
    'dateTo'?: string;
}
/**
 * 
 * @export
 * @interface GetStatisticsResponseDto
 */
export interface GetStatisticsResponseDto {
    /**
     * 
     * @type {Array<StatisticsMonth>}
     * @memberof GetStatisticsResponseDto
     */
    'months': Array<StatisticsMonth>;
}
/**
 * 
 * @export
 * @interface GroupCallLinkResponseDto
 */
export interface GroupCallLinkResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GroupCallLinkResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GroupCallLinkResponseDto
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof GroupCallLinkResponseDto
     */
    'startsAt': string;
    /**
     *
     * @type {string}
     * @memberof GroupCallLinkResponseDto
     */
    'name': string | null;
    /**
     *
     * @type {string}
     * @memberof GroupCallLinkResponseDto
     */
    'description': string | null;
}
/**
 * 
 * @export
 * @interface JoinSessionResponseDto
 */
export interface JoinSessionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof JoinSessionResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof JoinSessionResponseDto
     */
    'therapistId': string;
    /**
     * 
     * @type {string}
     * @memberof JoinSessionResponseDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof JoinSessionResponseDto
     */
    'status': JoinSessionResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JoinSessionResponseDto
     */
    'type': JoinSessionResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof JoinSessionResponseDto
     */
    'cancelerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof JoinSessionResponseDto
     */
    'cancelReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof JoinSessionResponseDto
     */
    'accessToken': string;
    /**
     * 
     * @type {number}
     * @memberof JoinSessionResponseDto
     */
    'uid': number;
    /**
     * 
     * @type {string}
     * @memberof JoinSessionResponseDto
     */
    'channelName': string;
    /**
     * 
     * @type {SessionAvailabilityResponseDto}
     * @memberof JoinSessionResponseDto
     */
    'availability': SessionAvailabilityResponseDto;
    /**
     * 
     * @type {SessionTherapistResponseDto}
     * @memberof JoinSessionResponseDto
     */
    'therapist': SessionTherapistResponseDto;
    /**
     * 
     * @type {Array<SessionPatientResponseDto>}
     * @memberof JoinSessionResponseDto
     */
    'patients': Array<SessionPatientResponseDto>;
}

export const JoinSessionResponseDtoStatusEnum = {
    Awaiting: 'awaiting',
    Live: 'live',
    Complete: 'complete',
    Canceled: 'canceled'
} as const;

export type JoinSessionResponseDtoStatusEnum = typeof JoinSessionResponseDtoStatusEnum[keyof typeof JoinSessionResponseDtoStatusEnum];
export const JoinSessionResponseDtoTypeEnum = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type JoinSessionResponseDtoTypeEnum = typeof JoinSessionResponseDtoTypeEnum[keyof typeof JoinSessionResponseDtoTypeEnum];

/**
 * 
 * @export
 * @interface JoinSupervisionResponseDto
 */
export interface JoinSupervisionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof JoinSupervisionResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof JoinSupervisionResponseDto
     */
    'supervisorId': string;
    /**
     * 
     * @type {string}
     * @memberof JoinSupervisionResponseDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof JoinSupervisionResponseDto
     */
    'status': JoinSupervisionResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JoinSupervisionResponseDto
     */
    'type': JoinSupervisionResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof JoinSupervisionResponseDto
     */
    'cancelerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof JoinSupervisionResponseDto
     */
    'cancelReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof JoinSupervisionResponseDto
     */
    'accessToken': string;
    /**
     * 
     * @type {number}
     * @memberof JoinSupervisionResponseDto
     */
    'uid': number;
    /**
     * 
     * @type {string}
     * @memberof JoinSupervisionResponseDto
     */
    'channelName': string;
}

export const JoinSupervisionResponseDtoStatusEnum = {
    Awaiting: 'awaiting',
    Live: 'live',
    Complete: 'complete',
    Canceled: 'canceled'
} as const;

export type JoinSupervisionResponseDtoStatusEnum = typeof JoinSupervisionResponseDtoStatusEnum[keyof typeof JoinSupervisionResponseDtoStatusEnum];
export const JoinSupervisionResponseDtoTypeEnum = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type JoinSupervisionResponseDtoTypeEnum = typeof JoinSupervisionResponseDtoTypeEnum[keyof typeof JoinSupervisionResponseDtoTypeEnum];

/**
 * 
 * @export
 * @interface MedsiSignUpRequestDto
 */
export interface MedsiSignUpRequestDto {
    /**
     * 
     * @type {string}
     * @memberof MedsiSignUpRequestDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof MedsiSignUpRequestDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface MessageSuccessResponseDto
 */
export interface MessageSuccessResponseDto {
    /**
     * 
     * @type {string}
     * @memberof MessageSuccessResponseDto
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof MessageSuccessResponseDto
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface NotificationResponseDto
 */
export interface NotificationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponseDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponseDto
     */
    'event': NotificationResponseDtoEventEnum;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponseDto
     */
    'popUpDate': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponseDto
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationResponseDto
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationResponseDto
     */
    'isSended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationResponseDto
     */
    'isViewed': boolean;
    /**
     * 
     * @type {object}
     * @memberof NotificationResponseDto
     */
    'metadata': object;
}

export const NotificationResponseDtoEventEnum = {
    ConsultationCreated: 'consultation-created',
    ConsultationCanceled: 'consultation-canceled',
    ConsultationAwaiting: 'consultation-awaiting',
    ConsultationShift: 'consultation-shift',
    ConsultationStart: 'consultation-start',
    ConsultationNote: 'consultation-note',
    Profile: 'profile',
    Payment: 'payment',
    PaymentByTherapistRejected: 'payment-by-therapist-rejected',
    Payout: 'payout',
    Approve: 'approve',
    NewPromocodes: 'new-promocodes',
    PromocodesRunningOut: 'promocodes-running-out',
    PromocodesExpiring: 'promocodes-expiring',
    TherapistVerify: 'therapist-verify',
    PaymentMethod: 'payment-method',
    GreetingsTherapist: 'greetings-therapist',
    GreetingsPatient: 'greetings-patient'
} as const;

export type NotificationResponseDtoEventEnum = typeof NotificationResponseDtoEventEnum[keyof typeof NotificationResponseDtoEventEnum];

/**
 * 
 * @export
 * @interface NotificationSettingsResponseDto
 */
export interface NotificationSettingsResponseDto {
    /**
     * Email уведомления включены
     * @type {boolean}
     * @memberof NotificationSettingsResponseDto
     */
    'isEmailNotificationsEnabled': boolean;
    /**
     * SMS уведомления включены
     * @type {boolean}
     * @memberof NotificationSettingsResponseDto
     */
    'isSmsNotificationsEnabled': boolean;
}
/**
 * 
 * @export
 * @interface NotificationTimeResponseDto
 */
export interface NotificationTimeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof NotificationTimeResponseDto
     */
    'timeInHours': NotificationTimeResponseDtoTimeInHoursEnum;
}

export const NotificationTimeResponseDtoTimeInHoursEnum = {
    _0: '0',
    _1: '1',
    _8: '8',
    _16: '16',
    _24: '24',
    _48: '48'
} as const;

export type NotificationTimeResponseDtoTimeInHoursEnum = typeof NotificationTimeResponseDtoTimeInHoursEnum[keyof typeof NotificationTimeResponseDtoTimeInHoursEnum];

/**
 * 
 * @export
 * @interface NotificationsResponseDto
 */
export interface NotificationsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof NotificationsResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof NotificationsResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof NotificationsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof NotificationsResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<NotificationResponseDto>}
     * @memberof NotificationsResponseDto
     */
    'data': Array<NotificationResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof NotificationsResponseDto
     */
    'notViewedCount': number;
}
/**
 * 
 * @export
 * @interface PaginatedPromocodeResponseDto
 */
export interface PaginatedPromocodeResponseDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedPromocodeResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedPromocodeResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedPromocodeResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedPromocodeResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<PromocodeResponseDto>}
     * @memberof PaginatedPromocodeResponseDto
     */
    'data': Array<PromocodeResponseDto>;
}
/**
 * 
 * @export
 * @interface PaginatedSessionResponseDto
 */
export interface PaginatedSessionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedSessionResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedSessionResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedSessionResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedSessionResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<SessionResponseDto>}
     * @memberof PaginatedSessionResponseDto
     */
    'data': Array<SessionResponseDto>;
}
/**
 * 
 * @export
 * @interface PartialPublicPatientProfileResponseDto
 */
export interface PartialPublicPatientProfileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PartialPublicPatientProfileResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PartialPublicPatientProfileResponseDto
     */
    'firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialPublicPatientProfileResponseDto
     */
    'lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialPublicPatientProfileResponseDto
     */
    'avatarKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof PartialPublicPatientProfileResponseDto
     */
    'dateOfBirth'?: string;
}
/**
 * 
 * @export
 * @interface PatientOnboardingRequestDto
 */
export interface PatientOnboardingRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PatientOnboardingRequestDto
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOnboardingRequestDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof PatientOnboardingRequestDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientOnboardingRequestDto
     */
    'phone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientOnboardingRequestDto
     */
    'hasTherapyExperience'?: boolean;
}
/**
 * 
 * @export
 * @interface PatientProfileResponseDto
 */
export interface PatientProfileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'role': PatientProfileResponseDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'gender': PatientProfileResponseDtoGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'avatarKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'miniAvatarKey'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientProfileResponseDto
     */
    'isEmailConfirmed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientProfileResponseDto
     */
    'isPhoneConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'notificationBeforeTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'paymentMethodId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'utmSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'utmMedium'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'utmCampaign'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientProfileResponseDto
     */
    'dateOfBirth'?: string;
}

export const PatientProfileResponseDtoRoleEnum = {
    Patient: 'patient',
    Therapist: 'therapist',
    Company: 'company',
    B2bPatient: 'b2b_patient',
    Hr: 'hr'
} as const;

export type PatientProfileResponseDtoRoleEnum = typeof PatientProfileResponseDtoRoleEnum[keyof typeof PatientProfileResponseDtoRoleEnum];
export const PatientProfileResponseDtoGenderEnum = {
    Male: 'male',
    Female: 'female',
    Transgender: 'transgender',
    Unknown: 'unknown'
} as const;

export type PatientProfileResponseDtoGenderEnum = typeof PatientProfileResponseDtoGenderEnum[keyof typeof PatientProfileResponseDtoGenderEnum];

/**
 * 
 * @export
 * @interface PatientTherapistShortInfoResponseDto
 */
export interface PatientTherapistShortInfoResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PatientTherapistShortInfoResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PatientTherapistShortInfoResponseDto
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof PatientTherapistShortInfoResponseDto
     */
    'avatarKey': string;
    /**
     * 
     * @type {string}
     * @memberof PatientTherapistShortInfoResponseDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof PatientTherapistShortInfoResponseDto
     */
    'lastname': string;
    /**
     * 
     * @type {string}
     * @memberof PatientTherapistShortInfoResponseDto
     */
    'totalSessions': string;
    /**
     * 
     * @type {string}
     * @memberof PatientTherapistShortInfoResponseDto
     */
    'firstSessionDate': string;
    /**
     * 
     * @type {string}
     * @memberof PatientTherapistShortInfoResponseDto
     */
    'lastSessionDate': string;
}
/**
 * 
 * @export
 * @interface PatientTherapistsShortInfosResponseDto
 */
export interface PatientTherapistsShortInfosResponseDto {
    /**
     * 
     * @type {number}
     * @memberof PatientTherapistsShortInfosResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PatientTherapistsShortInfosResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PatientTherapistsShortInfosResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PatientTherapistsShortInfosResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<PatientTherapistShortInfoResponseDto>}
     * @memberof PatientTherapistsShortInfosResponseDto
     */
    'data': Array<PatientTherapistShortInfoResponseDto>;
}
/**
 * 
 * @export
 * @interface PatientUpdateIsTestDto
 */
export interface PatientUpdateIsTestDto {
    /**
     * 
     * @type {boolean}
     * @memberof PatientUpdateIsTestDto
     */
    'isTest': boolean;
}
/**
 * 
 * @export
 * @interface PaymentListResponseDto
 */
export interface PaymentListResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentListResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentListResponseDto
     */
    'dealId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentListResponseDto
     */
    'status': PaymentListResponseDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof PaymentListResponseDto
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentListResponseDto
     */
    'discountValue': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentListResponseDto
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentListResponseDto
     */
    'dealStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentListResponseDto
     */
    'cancellationDetails'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentListResponseDto
     */
    'payoutStatus': PaymentListResponseDtoPayoutStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentListResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {ShortUserResponseDto}
     * @memberof PaymentListResponseDto
     */
    'sender': ShortUserResponseDto;
    /**
     * 
     * @type {ShortUserResponseDto}
     * @memberof PaymentListResponseDto
     */
    'receiver': ShortUserResponseDto;
    /**
     * 
     * @type {string}
     * @memberof PaymentListResponseDto
     */
    'startDate': string;
}

export const PaymentListResponseDtoStatusEnum = {
    Processing: 'processing',
    Succeeded: 'succeeded',
    Refunded: 'refunded'
} as const;

export type PaymentListResponseDtoStatusEnum = typeof PaymentListResponseDtoStatusEnum[keyof typeof PaymentListResponseDtoStatusEnum];
export const PaymentListResponseDtoPayoutStatusEnum = {
    Pending: 'pending',
    Succeeded: 'succeeded',
    Canceled: 'canceled',
    Awaiting: 'awaiting',
    AwaitingPromocode: 'awaiting_promocode'
} as const;

export type PaymentListResponseDtoPayoutStatusEnum = typeof PaymentListResponseDtoPayoutStatusEnum[keyof typeof PaymentListResponseDtoPayoutStatusEnum];

/**
 * 
 * @export
 * @interface PaymentMethodResponseDto
 */
export interface PaymentMethodResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodResponseDto
     */
    'last4': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodResponseDto
     */
    'expiryYear': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodResponseDto
     */
    'expiryMonth': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodResponseDto
     */
    'cardType': PaymentMethodResponseDtoCardTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodResponseDto
     */
    'foreign': boolean;
}

export const PaymentMethodResponseDtoCardTypeEnum = {
    MasterCard: 'MasterCard',
    Visa: 'Visa',
    Mir: 'Mir',
    UnionPay: 'UnionPay',
    Jcb: 'JCB',
    AmericanExpress: 'AmericanExpress',
    DinersClub: 'DinersClub',
    DiscoverCard: 'DiscoverCard',
    InstaPayment: 'InstaPayment',
    InstaPaymentTm: 'InstaPaymentTM',
    Laser: 'Laser',
    Dankort: 'Dankort',
    Solo: 'Solo',
    Switch: 'Switch',
    Unknown: 'Unknown'
} as const;

export type PaymentMethodResponseDtoCardTypeEnum = typeof PaymentMethodResponseDtoCardTypeEnum[keyof typeof PaymentMethodResponseDtoCardTypeEnum];

/**
 * 
 * @export
 * @interface PaymentResponseDto
 */
export interface PaymentResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'dealId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'status': PaymentResponseDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof PaymentResponseDto
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentResponseDto
     */
    'discountValue': number;
    /**
     * 
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'dealStartDate': string;
    /**
     * 
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'cancellationDetails'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'payoutStatus': PaymentResponseDtoPayoutStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {ShortUserResponseDto}
     * @memberof PaymentResponseDto
     */
    'sender': ShortUserResponseDto;
    /**
     * 
     * @type {ShortUserResponseDto}
     * @memberof PaymentResponseDto
     */
    'receiver': ShortUserResponseDto;
}

export const PaymentResponseDtoStatusEnum = {
    Processing: 'processing',
    Succeeded: 'succeeded',
    Refunded: 'refunded'
} as const;

export type PaymentResponseDtoStatusEnum = typeof PaymentResponseDtoStatusEnum[keyof typeof PaymentResponseDtoStatusEnum];
export const PaymentResponseDtoPayoutStatusEnum = {
    Pending: 'pending',
    Succeeded: 'succeeded',
    Canceled: 'canceled',
    Awaiting: 'awaiting',
    AwaitingPromocode: 'awaiting_promocode'
} as const;

export type PaymentResponseDtoPayoutStatusEnum = typeof PaymentResponseDtoPayoutStatusEnum[keyof typeof PaymentResponseDtoPayoutStatusEnum];

/**
 * 
 * @export
 * @interface PaymentStatisticsMonth
 */
export interface PaymentStatisticsMonth {
    /**
     * 
     * @type {string}
     * @memberof PaymentStatisticsMonth
     */
    'month': string;
    /**
     * 
     * @type {number}
     * @memberof PaymentStatisticsMonth
     */
    'income': number;
}
/**
 * 
 * @export
 * @interface PaymentStatisticsResponseDto
 */
export interface PaymentStatisticsResponseDto {
    /**
     * 
     * @type {Array<PaymentStatisticsMonth>}
     * @memberof PaymentStatisticsResponseDto
     */
    'months': Array<PaymentStatisticsMonth>;
}
/**
 * 
 * @export
 * @interface PaymentsListResponseDto
 */
export interface PaymentsListResponseDto {
    /**
     * 
     * @type {number}
     * @memberof PaymentsListResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsListResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsListResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentsListResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<PaymentListResponseDto>}
     * @memberof PaymentsListResponseDto
     */
    'data': Array<PaymentListResponseDto>;
}
/**
 * 
 * @export
 * @interface PfsCompanyPatientDto
 */
export interface PfsCompanyPatientDto {
    /**
     * 
     * @type {string}
     * @memberof PfsCompanyPatientDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PfsCompanyPatientDto
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof PfsCompanyPatientDto
     */
    'group'?: string;
    /**
     * 
     * @type {number}
     * @memberof PfsCompanyPatientDto
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof PfsCompanyPatientDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PfsCompanyPatientDto
     */
    'percentage'?: number;
    /**
     * 
     * @type {string}
     * @memberof PfsCompanyPatientDto
     */
    'expirationDate': string;
}
/**
 * 
 * @export
 * @interface PromocodePackageResponseDto
 */
export interface PromocodePackageResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PromocodePackageResponseDto
     */
    'discountType': PromocodePackageResponseDtoDiscountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PromocodePackageResponseDto
     */
    'amount': number | null;
    /**
     * 
     * @type {number}
     * @memberof PromocodePackageResponseDto
     */
    'percentage': number | null;
    /**
     * 
     * @type {string}
     * @memberof PromocodePackageResponseDto
     */
    'expireDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof PromocodePackageResponseDto
     */
    'firstUseOnly': boolean;
    /**
     * 
     * @type {number}
     * @memberof PromocodePackageResponseDto
     */
    'used': number;
    /**
     * 
     * @type {number}
     * @memberof PromocodePackageResponseDto
     */
    'availableForSending': number;
    /**
     * 
     * @type {number}
     * @memberof PromocodePackageResponseDto
     */
    'total': number;
}

export const PromocodePackageResponseDtoDiscountTypeEnum = {
    Amount: 'amount',
    Percentage: 'percentage'
} as const;

export type PromocodePackageResponseDtoDiscountTypeEnum = typeof PromocodePackageResponseDtoDiscountTypeEnum[keyof typeof PromocodePackageResponseDtoDiscountTypeEnum];

/**
 * 
 * @export
 * @interface PromocodeRequestRequestDto
 */
export interface PromocodeRequestRequestDto {
    /**
     * 
     * @type {Array<CreateCompanyPromocodeInfoRequestDto>}
     * @memberof PromocodeRequestRequestDto
     */
    'promocodes': Array<CreateCompanyPromocodeInfoRequestDto>;
}
/**
 * 
 * @export
 * @interface PromocodeResponseDto
 */
export interface PromocodeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PromocodeResponseDto
     */
    'discountType': PromocodeResponseDtoDiscountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PromocodeResponseDto
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof PromocodeResponseDto
     */
    'amount': number | null;
    /**
     * 
     * @type {number}
     * @memberof PromocodeResponseDto
     */
    'percentage': number | null;
    /**
     * 
     * @type {string}
     * @memberof PromocodeResponseDto
     */
    'expireDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PromocodeResponseDto
     */
    'firstUseOnly': boolean;
    /**
     * 
     * @type {string}
     * @memberof PromocodeResponseDto
     */
    'usingType': PromocodeResponseDtoUsingTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PromocodeResponseDto
     */
    'useLimitPerUser': number;
    /**
     * 
     * @type {number}
     * @memberof PromocodeResponseDto
     */
    'availableUsesPerUser': number;
}

export const PromocodeResponseDtoDiscountTypeEnum = {
    Amount: 'amount',
    Percentage: 'percentage'
} as const;

export type PromocodeResponseDtoDiscountTypeEnum = typeof PromocodeResponseDtoDiscountTypeEnum[keyof typeof PromocodeResponseDtoDiscountTypeEnum];
export const PromocodeResponseDtoUsingTypeEnum = {
    Oneuse: 'oneuse',
    Reusable: 'reusable'
} as const;

export type PromocodeResponseDtoUsingTypeEnum = typeof PromocodeResponseDtoUsingTypeEnum[keyof typeof PromocodeResponseDtoUsingTypeEnum];

/**
 * 
 * @export
 * @interface PublicContentCourseDetailResponseDto
 */
export interface PublicContentCourseDetailResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PublicContentCourseDetailResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PublicContentCourseDetailResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PublicContentCourseDetailResponseDto
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof PublicContentCourseDetailResponseDto
     */
    'sortOrder': number;
    /**
     * 
     * @type {string}
     * @memberof PublicContentCourseDetailResponseDto
     */
    'audience': string | null;
    /**
     * 
     * @type {number}
     * @memberof PublicContentCourseDetailResponseDto
     */
    'videosCount': number;
    /**
     * 
     * @type {number}
     * @memberof PublicContentCourseDetailResponseDto
     */
    'completedCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof PublicContentCourseDetailResponseDto
     */
    'isCompleted': boolean;
    /**
     * 
     * @type {Array<PublicContentFolderResponseDto>}
     * @memberof PublicContentCourseDetailResponseDto
     */
    'folders': Array<PublicContentFolderResponseDto>;
}
/**
 * 
 * @export
 * @interface PublicContentCourseResponseDto
 */
export interface PublicContentCourseResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PublicContentCourseResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PublicContentCourseResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PublicContentCourseResponseDto
     */
    'description': string | null;
    /**
     * 
     * @type {number}
     * @memberof PublicContentCourseResponseDto
     */
    'sortOrder': number;
    /**
     * 
     * @type {string}
     * @memberof PublicContentCourseResponseDto
     */
    'audience': string | null;
    /**
     * 
     * @type {number}
     * @memberof PublicContentCourseResponseDto
     */
    'videosCount': number;
    /**
     * 
     * @type {number}
     * @memberof PublicContentCourseResponseDto
     */
    'completedCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof PublicContentCourseResponseDto
     */
    'isCompleted': boolean;
}
/**
 * 
 * @export
 * @interface PublicContentCoursesPaginatedResponseDto
 */
export interface PublicContentCoursesPaginatedResponseDto {
    /**
     * 
     * @type {number}
     * @memberof PublicContentCoursesPaginatedResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof PublicContentCoursesPaginatedResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PublicContentCoursesPaginatedResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PublicContentCoursesPaginatedResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<PublicContentCourseResponseDto>}
     * @memberof PublicContentCoursesPaginatedResponseDto
     */
    'data': Array<PublicContentCourseResponseDto>;
}
/**
 * 
 * @export
 * @interface PublicContentFileResponseDto
 */
export interface PublicContentFileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PublicContentFileResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PublicContentFileResponseDto
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface PublicContentFolderResponseDto
 */
export interface PublicContentFolderResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PublicContentFolderResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PublicContentFolderResponseDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PublicContentFolderResponseDto
     */
    'sortOrder': number;
    /**
     * 
     * @type {boolean}
     * @memberof PublicContentFolderResponseDto
     */
    'isLocked': boolean;
    /**
     * 
     * @type {Array<PublicContentVideoResponseDto>}
     * @memberof PublicContentFolderResponseDto
     */
    'videos': Array<PublicContentVideoResponseDto>;
}
/**
 * 
 * @export
 * @interface PublicContentVideoResponseDto
 */
export interface PublicContentVideoResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PublicContentVideoResponseDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof PublicContentVideoResponseDto
     */
    'sortOrder': number;
    /**
     * 
     * @type {string}
     * @memberof PublicContentVideoResponseDto
     */
    'src': string;
    /**
     * 
     * @type {string}
     * @memberof PublicContentVideoResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PublicContentVideoResponseDto
     */
    'description': string | null;
    /**
     * 
     * @type {Array<PublicContentFileResponseDto>}
     * @memberof PublicContentVideoResponseDto
     */
    'files'?: Array<PublicContentFileResponseDto>;
    /**
     * 
     * @type {boolean}
     * @memberof PublicContentVideoResponseDto
     */
    'isCompleted': boolean;
}
/**
 * 
 * @export
 * @interface PublicPatientProfileResponseDto
 */
export interface PublicPatientProfileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PublicPatientProfileResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PublicPatientProfileResponseDto
     */
    'firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicPatientProfileResponseDto
     */
    'lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicPatientProfileResponseDto
     */
    'avatarKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicPatientProfileResponseDto
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicPatientProfileResponseDto
     */
    'firstSessionDate': string;
    /**
     * 
     * @type {string}
     * @memberof PublicPatientProfileResponseDto
     */
    'lastSessionDate': string;
    /**
     * 
     * @type {number}
     * @memberof PublicPatientProfileResponseDto
     */
    'sessionCount': number;
}
/**
 * 
 * @export
 * @interface PublicTherapistResponseDto
 */
export interface PublicTherapistResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PublicTherapistResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PublicTherapistResponseDto
     */
    'url': string;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTherapistResponseDto
     */
    'hasMedsiSessions'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PublicTherapistResponseDto
     */
    'averageRating'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTherapistResponseDto
     */
    'isTop'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTherapistResponseDto
     */
    'isMedsi'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTherapistResponseDto
     */
    'isAdult': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTherapistResponseDto
     */
    'isChildTherapist'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTherapistResponseDto
     */
    'isSupervisor': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTherapistResponseDto
     */
    'isB2B': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTherapistResponseDto
     */
    'isCoach': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTherapistResponseDto
     */
    'isApproved': boolean;
    /**
     * 
     * @type {TherapistPersonalInfoResponseDto}
     * @memberof PublicTherapistResponseDto
     */
    'personalInfo': TherapistPersonalInfoResponseDto;
    /**
     * 
     * @type {TherapistEducationInfoResponseDto}
     * @memberof PublicTherapistResponseDto
     */
    'educationInfo': TherapistEducationInfoResponseDto;
    /**
     * 
     * @type {TherapistWorkingInfoResponseDto}
     * @memberof PublicTherapistResponseDto
     */
    'workingInfo': TherapistWorkingInfoResponseDto;
    /**
     * 
     * @type {TherapistTherapiesInfoResponseDto}
     * @memberof PublicTherapistResponseDto
     */
    'therapiesInfo': TherapistTherapiesInfoResponseDto;
    /**
     * 
     * @type {TherapistSupervisionInfoResponseDto}
     * @memberof PublicTherapistResponseDto
     */
    'supervisionInfo': TherapistSupervisionInfoResponseDto;
    /**
     * 
     * @type {TherapistCollaborationInfoResponseDto}
     * @memberof PublicTherapistResponseDto
     */
    'collaborationInfo': TherapistCollaborationInfoResponseDto;
    /**
     * 
     * @type {boolean}
     * @memberof PublicTherapistResponseDto
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {string}
     * @memberof PublicTherapistResponseDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface PublicTherapistsResponseDto
 */
export interface PublicTherapistsResponseDto {
    /**
     * 
     * @type {Array<PublicTherapistResponseDto>}
     * @memberof PublicTherapistsResponseDto
     */
    'therapists': Array<PublicTherapistResponseDto>;
}
/**
 * 
 * @export
 * @interface PusherAuthRequestDto
 */
export interface PusherAuthRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PusherAuthRequestDto
     */
    'socket_id': string;
    /**
     * 
     * @type {string}
     * @memberof PusherAuthRequestDto
     */
    'channel_name': string;
}
/**
 * 
 * @export
 * @interface PusherAuthResponseDto
 */
export interface PusherAuthResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PusherAuthResponseDto
     */
    'auth': string;
    /**
     * 
     * @type {string}
     * @memberof PusherAuthResponseDto
     */
    'channel_data'?: string;
    /**
     * 
     * @type {string}
     * @memberof PusherAuthResponseDto
     */
    'shared_secret'?: string;
}
/**
 * 
 * @export
 * @interface RejectPatientRequestDto
 */
export interface RejectPatientRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RejectPatientRequestDto
     */
    'rejectReason': string;
}
/**
 * 
 * @export
 * @interface RejectTherapistRequestDto
 */
export interface RejectTherapistRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RejectTherapistRequestDto
     */
    'rejectReason': string;
}
/**
 * 
 * @export
 * @interface ReligionsSearchStatisticsResponseDto
 */
export interface ReligionsSearchStatisticsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ReligionsSearchStatisticsResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ReligionsSearchStatisticsResponseDto
     */
    'percentage': string;
}
/**
 * 
 * @export
 * @interface RequestSessionRequestDto
 */
export interface RequestSessionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RequestSessionRequestDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof RequestSessionRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RequestSessionRequestDto
     */
    'patientUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestSessionRequestDto
     */
    'utmSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestSessionRequestDto
     */
    'utmMedium'?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestSessionRequestDto
     */
    'utmCampaign'?: string;
}
/**
 * 
 * @export
 * @interface RequiredModalsResponseDto
 */
export interface RequiredModalsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof RequiredModalsResponseDto
     */
    'sessionIdWithRequiredOutcome': string;
    /**
     * 
     * @type {boolean}
     * @memberof RequiredModalsResponseDto
     */
    'isPlatformFeedbackRequired': boolean;
}
/**
 * 
 * @export
 * @interface RequiredSupervisionInfoRequestDto
 */
export interface RequiredSupervisionInfoRequestDto {
    /**
     * 
     * @type {number}
     * @memberof RequiredSupervisionInfoRequestDto
     */
    'supervisionFrequency': number;
    /**
     * 
     * @type {Array<SessionTypes>}
     * @memberof RequiredSupervisionInfoRequestDto
     */
    'supervisionType': Array<SessionTypes>;
    /**
     * 
     * @type {number}
     * @memberof RequiredSupervisionInfoRequestDto
     */
    'supervisionVisitsDuration': number;
    /**
     * 
     * @type {string}
     * @memberof RequiredSupervisionInfoRequestDto
     */
    'supervisionExperienceDescription': string;
}
/**
 * 
 * @export
 * @interface RequiredSupervisionInfoResponseDto
 */
export interface RequiredSupervisionInfoResponseDto {
    /**
     * 
     * @type {number}
     * @memberof RequiredSupervisionInfoResponseDto
     */
    'supervisionFrequency'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RequiredSupervisionInfoResponseDto
     */
    'supervisionType'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof RequiredSupervisionInfoResponseDto
     */
    'supervisionVisitsDuration'?: number;
    /**
     * 
     * @type {string}
     * @memberof RequiredSupervisionInfoResponseDto
     */
    'supervisionExperienceDescription'?: string;
}
/**
 * 
 * @export
 * @interface RescheduleDealRequestDto
 */
export interface RescheduleDealRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RescheduleDealRequestDto
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleDealRequestDto
     */
    'orderDate': string;
}
/**
 * 
 * @export
 * @interface RescheduleSessionRequestDto
 */
export interface RescheduleSessionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RescheduleSessionRequestDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof RescheduleSessionRequestDto
     */
    'sessionId': string;
}
/**
 * 
 * @export
 * @interface RestorePasswordByEmailRequestDto
 */
export interface RestorePasswordByEmailRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RestorePasswordByEmailRequestDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface RestorePasswordByPhoneRequestDto
 */
export interface RestorePasswordByPhoneRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RestorePasswordByPhoneRequestDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof RestorePasswordByPhoneRequestDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof RestorePasswordByPhoneRequestDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface ReviewerResponseDto
 */
export interface ReviewerResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ReviewerResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ReviewerResponseDto
     */
    'avatarKey': string | null;
}
/**
 * 
 * @export
 * @interface SearchStatisticsResponseDto
 */
export interface SearchStatisticsResponseDto {
    /**
     * 
     * @type {SessionPriceSearchStatisticsResponseDto}
     * @memberof SearchStatisticsResponseDto
     */
    'price': SessionPriceSearchStatisticsResponseDto;
    /**
     * 
     * @type {GendersSearchStatisticsResponseDto}
     * @memberof SearchStatisticsResponseDto
     */
    'genders': GendersSearchStatisticsResponseDto;
    /**
     * 
     * @type {Array<DiseasesSearchStatisticsResponseDto>}
     * @memberof SearchStatisticsResponseDto
     */
    'diseases': Array<DiseasesSearchStatisticsResponseDto>;
    /**
     * 
     * @type {Array<TherapyMethodsSearchStatisticsResponseDto>}
     * @memberof SearchStatisticsResponseDto
     */
    'therapyMethods': Array<TherapyMethodsSearchStatisticsResponseDto>;
    /**
     * 
     * @type {Array<ReligionsSearchStatisticsResponseDto>}
     * @memberof SearchStatisticsResponseDto
     */
    'religions': Array<ReligionsSearchStatisticsResponseDto>;
    /**
     * 
     * @type {DayLimitsSearchStatisticsResponseDto}
     * @memberof SearchStatisticsResponseDto
     */
    'dayLimits': DayLimitsSearchStatisticsResponseDto;
    /**
     * 
     * @type {string}
     * @memberof SearchStatisticsResponseDto
     */
    'workWithLgbt': string;
    /**
     * 
     * @type {string}
     * @memberof SearchStatisticsResponseDto
     */
    'workWithEthnicGroups': string;
}
/**
 * 
 * @export
 * @interface SendCertificateMailRequestDto
 */
export interface SendCertificateMailRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SendCertificateMailRequestDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof SendCertificateMailRequestDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SendCertificateMailRequestDto
     */
    'type': SendCertificateMailRequestDtoTypeEnum;
}

export const SendCertificateMailRequestDtoTypeEnum = {
    Newlevel: 'newlevel',
    Start: 'start',
    Happyeverafter: 'happyeverafter',
    Legend: 'legend',
    Calmdown: 'calmdown',
    Mybestyear: 'mybestyear',
    Newchapter: 'newchapter'
} as const;

export type SendCertificateMailRequestDtoTypeEnum = typeof SendCertificateMailRequestDtoTypeEnum[keyof typeof SendCertificateMailRequestDtoTypeEnum];

/**
 * 
 * @export
 * @interface SendContactRequestDto
 */
export interface SendContactRequestDto {
    /**
     * Номер телефона
     * @type {string}
     * @memberof SendContactRequestDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof SendContactRequestDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SendContactRequestDto
     */
    'pageUrl': string;
    /**
     * 
     * @type {string}
     * @memberof SendContactRequestDto
     */
    'utmCampaign'?: string;
    /**
     * 
     * @type {string}
     * @memberof SendContactRequestDto
     */
    'utmSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof SendContactRequestDto
     */
    'utmMedium'?: string;
}
/**
 * 
 * @export
 * @interface SendPhoneNumberVerificationDto
 */
export interface SendPhoneNumberVerificationDto {
    /**
     * 
     * @type {string}
     * @memberof SendPhoneNumberVerificationDto
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface SendPromocodesRequestDto
 */
export interface SendPromocodesRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SendPromocodesRequestDto
     */
    'emails': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SendPromocodesRequestDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SendPromocodesRequestDto
     */
    'percentage'?: number;
    /**
     * 
     * @type {number}
     * @memberof SendPromocodesRequestDto
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof SendPromocodesRequestDto
     */
    'expireDate': string;
}
/**
 * 
 * @export
 * @interface SendUpdateEmailConfirmationRequestDto
 */
export interface SendUpdateEmailConfirmationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SendUpdateEmailConfirmationRequestDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface SendingStatusDto
 */
export interface SendingStatusDto {
    /**
     * 
     * @type {boolean}
     * @memberof SendingStatusDto
     */
    'send': boolean;
    /**
     * 
     * @type {number}
     * @memberof SendingStatusDto
     */
    'secondsBeforeNextAttempt': number;
}
/**
 * 
 * @export
 * @interface SessionAvailabilityResponseDto
 */
export interface SessionAvailabilityResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SessionAvailabilityResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionAvailabilityResponseDto
     */
    'startDate': string;
}
/**
 * 
 * @export
 * @interface SessionBalancePaginatedResponseDto
 */
export interface SessionBalancePaginatedResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SessionBalancePaginatedResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof SessionBalancePaginatedResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof SessionBalancePaginatedResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof SessionBalancePaginatedResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<SessionBalanceResponseDto>}
     * @memberof SessionBalancePaginatedResponseDto
     */
    'data': Array<SessionBalanceResponseDto>;
}
/**
 * 
 * @export
 * @interface SessionBalanceResponseDto
 */
export interface SessionBalanceResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SessionBalanceResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionBalanceResponseDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionBalanceResponseDto
     */
    'sessionBookingId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionBalanceResponseDto
     */
    'startWith': string;
    /**
     * 
     * @type {string}
     * @memberof SessionBalanceResponseDto
     */
    'endWith': string;
}
/**
 * 
 * @export
 * @interface SessionBalanceUsageResponseDto
 */
export interface SessionBalanceUsageResponseDto {
    /**
     * Доступное количество сессий
     * @type {number}
     * @memberof SessionBalanceUsageResponseDto
     */
    'available': number;
    /**
     * Использовано сессий
     * @type {number}
     * @memberof SessionBalanceUsageResponseDto
     */
    'used': number;
    /**
     * Просрочено сессий
     * @type {number}
     * @memberof SessionBalanceUsageResponseDto
     */
    'expired': number;
    /**
     * Скоро закончится сессия
     * @type {number}
     * @memberof SessionBalanceUsageResponseDto
     */
    'expireSoon': number;
    /**
     * Ближайшая сессия
     * @type {string}
     * @memberof SessionBalanceUsageResponseDto
     */
    'nearestEndWith': string;
}
/**
 * 
 * @export
 * @interface SessionBookingUpcomingResponseDto
 */
export interface SessionBookingUpcomingResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SessionBookingUpcomingResponseDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof SessionBookingUpcomingResponseDto
     */
    'therapistId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionBookingUpcomingResponseDto
     */
    'therapistFirstname': string;
    /**
     * 
     * @type {string}
     * @memberof SessionBookingUpcomingResponseDto
     */
    'therapistLastname': string;
    /**
     * 
     * @type {string}
     * @memberof SessionBookingUpcomingResponseDto
     */
    'therapistAvatarKey': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SessionBookingUpcomingResponseDto
     */
    'therapistSpecialization': Array<SessionBookingUpcomingResponseDtoTherapistSpecializationEnum>;
    /**
     * 
     * @type {number}
     * @memberof SessionBookingUpcomingResponseDto
     */
    'therapistWorkingExperience': number;
    /**
     * 
     * @type {PaymentMethodResponseDto}
     * @memberof SessionBookingUpcomingResponseDto
     */
    'paymentMethod'?: PaymentMethodResponseDto | null;
    /**
     * 
     * @type {number}
     * @memberof SessionBookingUpcomingResponseDto
     */
    'price'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SessionBookingUpcomingResponseDto
     */
    'usdPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SessionBookingUpcomingResponseDto
     */
    'rubExchangeRate'?: number | null;
}

export const SessionBookingUpcomingResponseDtoTherapistSpecializationEnum = {
    Unspecified: 'unspecified',
    Psychologist: 'psychologist',
    Psychoanalyst: 'psychoanalyst',
    Coach: 'coach',
    Supervisor: 'supervisor',
    ClinicalPsychologist: 'clinical_psychologist',
    Sexologist: 'sexologist'
} as const;

export type SessionBookingUpcomingResponseDtoTherapistSpecializationEnum = typeof SessionBookingUpcomingResponseDtoTherapistSpecializationEnum[keyof typeof SessionBookingUpcomingResponseDtoTherapistSpecializationEnum];

/**
 * 
 * @export
 * @interface SessionCreateResponseDto
 */
export interface SessionCreateResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SessionCreateResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionCreateResponseDto
     */
    'therapistId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionCreateResponseDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionCreateResponseDto
     */
    'status': SessionCreateResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionCreateResponseDto
     */
    'type': SessionCreateResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionCreateResponseDto
     */
    'cancelerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionCreateResponseDto
     */
    'cancelReason'?: string;
}

export const SessionCreateResponseDtoStatusEnum = {
    Awaiting: 'awaiting',
    Live: 'live',
    Complete: 'complete',
    Canceled: 'canceled'
} as const;

export type SessionCreateResponseDtoStatusEnum = typeof SessionCreateResponseDtoStatusEnum[keyof typeof SessionCreateResponseDtoStatusEnum];
export const SessionCreateResponseDtoTypeEnum = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type SessionCreateResponseDtoTypeEnum = typeof SessionCreateResponseDtoTypeEnum[keyof typeof SessionCreateResponseDtoTypeEnum];

/**
 * 
 * @export
 * @interface SessionFeedbackThemeCategoryResponseDto
 */
export interface SessionFeedbackThemeCategoryResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SessionFeedbackThemeCategoryResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionFeedbackThemeCategoryResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SessionFeedbackThemeCategoryResponseDto
     */
    'description': string;
    /**
     * 
     * @type {Array<SessionFeedbackThemeResponseDto>}
     * @memberof SessionFeedbackThemeCategoryResponseDto
     */
    'themes': Array<SessionFeedbackThemeResponseDto>;
}
/**
 * 
 * @export
 * @interface SessionFeedbackThemeResponseDto
 */
export interface SessionFeedbackThemeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SessionFeedbackThemeResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionFeedbackThemeResponseDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SessionFeedbackThemesByCategoryResponseDto
 */
export interface SessionFeedbackThemesByCategoryResponseDto {
    /**
     * 
     * @type {Array<SessionFeedbackThemeCategoryResponseDto>}
     * @memberof SessionFeedbackThemesByCategoryResponseDto
     */
    'categories': Array<SessionFeedbackThemeCategoryResponseDto>;
}
/**
 * 
 * @export
 * @interface SessionNoteResponseDto
 */
export interface SessionNoteResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SessionNoteResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionNoteResponseDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionNoteResponseDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof SessionNoteResponseDto
     */
    'lastname': string;
    /**
     * 
     * @type {string}
     * @memberof SessionNoteResponseDto
     */
    'sessionId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionNoteResponseDto
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof SessionNoteResponseDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface SessionNotesResponseDto
 */
export interface SessionNotesResponseDto {
    /**
     * 
     * @type {Array<SessionNoteResponseDto>}
     * @memberof SessionNotesResponseDto
     */
    'notes': Array<SessionNoteResponseDto>;
}
/**
 * 
 * @export
 * @interface SessionOutcomeResponseDto
 */
export interface SessionOutcomeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SessionOutcomeResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionOutcomeResponseDto
     */
    'sessionParticipantId': string;
    /**
     * 
     * @type {number}
     * @memberof SessionOutcomeResponseDto
     */
    'rating': number;
    /**
     * 
     * @type {string}
     * @memberof SessionOutcomeResponseDto
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface SessionPatientResponseDto
 */
export interface SessionPatientResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SessionPatientResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionPatientResponseDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof SessionPatientResponseDto
     */
    'avatarKey': string;
}
/**
 * 
 * @export
 * @interface SessionPriceSearchStatisticsResponseDto
 */
export interface SessionPriceSearchStatisticsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SessionPriceSearchStatisticsResponseDto
     */
    'lesser30k': string;
    /**
     * 
     * @type {string}
     * @memberof SessionPriceSearchStatisticsResponseDto
     */
    'lesser25k': string;
    /**
     * 
     * @type {string}
     * @memberof SessionPriceSearchStatisticsResponseDto
     */
    'lesser20k': string;
    /**
     * 
     * @type {string}
     * @memberof SessionPriceSearchStatisticsResponseDto
     */
    'lesser15k': string;
    /**
     * 
     * @type {string}
     * @memberof SessionPriceSearchStatisticsResponseDto
     */
    'lesser10k': string;
    /**
     * 
     * @type {string}
     * @memberof SessionPriceSearchStatisticsResponseDto
     */
    'lesser5k': string;
}
/**
 * 
 * @export
 * @interface SessionRequestResponseDto
 */
export interface SessionRequestResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SessionRequestResponseDto
     */
    'therapistId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionRequestResponseDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionRequestResponseDto
     */
    'type': SessionRequestResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionRequestResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionRequestResponseDto
     */
    'status': SessionRequestResponseDtoStatusEnum;
}

export const SessionRequestResponseDtoTypeEnum = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type SessionRequestResponseDtoTypeEnum = typeof SessionRequestResponseDtoTypeEnum[keyof typeof SessionRequestResponseDtoTypeEnum];
export const SessionRequestResponseDtoStatusEnum = {
    Pending: 'pending',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Canceled: 'canceled',
    Expired: 'expired'
} as const;

export type SessionRequestResponseDtoStatusEnum = typeof SessionRequestResponseDtoStatusEnum[keyof typeof SessionRequestResponseDtoStatusEnum];

/**
 * 
 * @export
 * @interface SessionResponseDto
 */
export interface SessionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SessionResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponseDto
     */
    'therapistId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponseDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponseDto
     */
    'status': SessionResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionResponseDto
     */
    'type': SessionResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionResponseDto
     */
    'cancelerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionResponseDto
     */
    'cancelReason'?: string;
    /**
     * 
     * @type {TherapistBaseResponseDto}
     * @memberof SessionResponseDto
     */
    'therapist': TherapistBaseResponseDto;
    /**
     * 
     * @type {AvailabilityResponseDto}
     * @memberof SessionResponseDto
     */
    'availability': AvailabilityResponseDto;
    /**
     * 
     * @type {Array<SessionNoteResponseDto>}
     * @memberof SessionResponseDto
     */
    'notes': Array<SessionNoteResponseDto>;
    /**
     * 
     * @type {Array<PartialPublicPatientProfileResponseDto>}
     * @memberof SessionResponseDto
     */
    'patients': Array<PartialPublicPatientProfileResponseDto>;
    /**
     * 
     * @type {boolean}
     * @memberof SessionResponseDto
     */
    'isHasFeedback'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SessionResponseDto
     */
    'isTherapistJoined': boolean;
}

export const SessionResponseDtoStatusEnum = {
    Awaiting: 'awaiting',
    Live: 'live',
    Complete: 'complete',
    Canceled: 'canceled'
} as const;

export type SessionResponseDtoStatusEnum = typeof SessionResponseDtoStatusEnum[keyof typeof SessionResponseDtoStatusEnum];
export const SessionResponseDtoTypeEnum = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type SessionResponseDtoTypeEnum = typeof SessionResponseDtoTypeEnum[keyof typeof SessionResponseDtoTypeEnum];

/**
 * 
 * @export
 * @interface SessionStatisticsClientsResponseDto
 */
export interface SessionStatisticsClientsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'totalClients': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'totalSessions': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'firstTimeClient': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'crr': number;
    /**
     * 
     * @type {string}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'crrFormula': string;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'regularClients': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'averagePrice': number;
    /**
     * 
     * @type {string}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'averagePriceFormula': string;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'averageClientSessions': number;
    /**
     * 
     * @type {string}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'averageClientSessionsFormula': string;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'totalPrice': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'totalPromocodes': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'totalDiscountSum': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'totalDiscountedPrice': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'newClientsAssignedCard': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'newClientsBookSession': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'newClientsSuccessBookedSession': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'newClientsTotalSuccessfulSessions': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'newClients': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsClientsResponseDto
     */
    'totalSuccessPayins': number;
}
/**
 * 
 * @export
 * @interface SessionStatisticsResponseDto
 */
export interface SessionStatisticsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsResponseDto
     */
    'completed': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsResponseDto
     */
    'canceled': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsResponseDto
     */
    'booked': number;
    /**
     * 
     * @type {number}
     * @memberof SessionStatisticsResponseDto
     */
    'planned': number;
}
/**
 * 
 * @export
 * @interface SessionTherapistResponseDto
 */
export interface SessionTherapistResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SessionTherapistResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionTherapistResponseDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof SessionTherapistResponseDto
     */
    'lastname': string;
    /**
     * 
     * @type {string}
     * @memberof SessionTherapistResponseDto
     */
    'avatarKey': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SessionTypes = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type SessionTypes = typeof SessionTypes[keyof typeof SessionTypes];


/**
 * 
 * @export
 * @interface SessionWithStartDate
 */
export interface SessionWithStartDate {
    /**
     * 
     * @type {string}
     * @memberof SessionWithStartDate
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionWithStartDate
     */
    'therapistId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionWithStartDate
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionWithStartDate
     */
    'status': SessionWithStartDateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionWithStartDate
     */
    'type': SessionWithStartDateTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SessionWithStartDate
     */
    'cancelerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionWithStartDate
     */
    'cancelReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof SessionWithStartDate
     */
    'startDate': string;
    /**
     * 
     * @type {number}
     * @memberof SessionWithStartDate
     */
    'notificationBeforeTime': number;
}

export const SessionWithStartDateStatusEnum = {
    Awaiting: 'awaiting',
    Live: 'live',
    Complete: 'complete',
    Canceled: 'canceled'
} as const;

export type SessionWithStartDateStatusEnum = typeof SessionWithStartDateStatusEnum[keyof typeof SessionWithStartDateStatusEnum];
export const SessionWithStartDateTypeEnum = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type SessionWithStartDateTypeEnum = typeof SessionWithStartDateTypeEnum[keyof typeof SessionWithStartDateTypeEnum];

/**
 * 
 * @export
 * @interface SessionsResponseDto
 */
export interface SessionsResponseDto {
    /**
     * 
     * @type {Array<SessionResponseDto>}
     * @memberof SessionsResponseDto
     */
    'sessions': Array<SessionResponseDto>;
}
/**
 * 
 * @export
 * @interface SessionsWithStartDate
 */
export interface SessionsWithStartDate {
    /**
     * 
     * @type {Array<SessionWithStartDate>}
     * @memberof SessionsWithStartDate
     */
    'sessions': Array<SessionWithStartDate>;
}
/**
 * 
 * @export
 * @interface SetMiniAvatarKeyRequest
 */
export interface SetMiniAvatarKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof SetMiniAvatarKeyRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SetMiniAvatarKeyRequest
     */
    'miniAvatarKey': string;
}
/**
 * 
 * @export
 * @interface ShiftSupervisionRequestDto
 */
export interface ShiftSupervisionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ShiftSupervisionRequestDto
     */
    'availabilityId': string;
}
/**
 * 
 * @export
 * @interface ShortUserResponseDto
 */
export interface ShortUserResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ShortUserResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ShortUserResponseDto
     */
    'firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShortUserResponseDto
     */
    'lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShortUserResponseDto
     */
    'role': ShortUserResponseDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof ShortUserResponseDto
     */
    'avatarKey'?: string;
}

export const ShortUserResponseDtoRoleEnum = {
    Patient: 'patient',
    Therapist: 'therapist',
    Company: 'company',
    B2bPatient: 'b2b_patient',
    Hr: 'hr'
} as const;

export type ShortUserResponseDtoRoleEnum = typeof ShortUserResponseDtoRoleEnum[keyof typeof ShortUserResponseDtoRoleEnum];

/**
 * 
 * @export
 * @interface StatisticsMonth
 */
export interface StatisticsMonth {
    /**
     * 
     * @type {string}
     * @memberof StatisticsMonth
     */
    'month': string;
    /**
     * 
     * @type {number}
     * @memberof StatisticsMonth
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsMonth
     */
    'expire': number;
}
/**
 * 
 * @export
 * @interface SupervisionBaseResponseDto
 */
export interface SupervisionBaseResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SupervisionBaseResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionBaseResponseDto
     */
    'supervisorId': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionBaseResponseDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionBaseResponseDto
     */
    'status': SupervisionBaseResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SupervisionBaseResponseDto
     */
    'type': SupervisionBaseResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SupervisionBaseResponseDto
     */
    'cancelerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionBaseResponseDto
     */
    'cancelReason'?: string;
}

export const SupervisionBaseResponseDtoStatusEnum = {
    Awaiting: 'awaiting',
    Live: 'live',
    Complete: 'complete',
    Canceled: 'canceled'
} as const;

export type SupervisionBaseResponseDtoStatusEnum = typeof SupervisionBaseResponseDtoStatusEnum[keyof typeof SupervisionBaseResponseDtoStatusEnum];
export const SupervisionBaseResponseDtoTypeEnum = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type SupervisionBaseResponseDtoTypeEnum = typeof SupervisionBaseResponseDtoTypeEnum[keyof typeof SupervisionBaseResponseDtoTypeEnum];

/**
 * 
 * @export
 * @interface SupervisionCreateResponseDto
 */
export interface SupervisionCreateResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SupervisionCreateResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionCreateResponseDto
     */
    'supervisorId': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionCreateResponseDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionCreateResponseDto
     */
    'status': SupervisionCreateResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SupervisionCreateResponseDto
     */
    'type': SupervisionCreateResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SupervisionCreateResponseDto
     */
    'cancelerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionCreateResponseDto
     */
    'cancelReason'?: string;
}

export const SupervisionCreateResponseDtoStatusEnum = {
    Awaiting: 'awaiting',
    Live: 'live',
    Complete: 'complete',
    Canceled: 'canceled'
} as const;

export type SupervisionCreateResponseDtoStatusEnum = typeof SupervisionCreateResponseDtoStatusEnum[keyof typeof SupervisionCreateResponseDtoStatusEnum];
export const SupervisionCreateResponseDtoTypeEnum = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type SupervisionCreateResponseDtoTypeEnum = typeof SupervisionCreateResponseDtoTypeEnum[keyof typeof SupervisionCreateResponseDtoTypeEnum];

/**
 * 
 * @export
 * @interface SupervisionNoteRequestDto
 */
export interface SupervisionNoteRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SupervisionNoteRequestDto
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface SupervisionNoteResponseDto
 */
export interface SupervisionNoteResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SupervisionNoteResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionNoteResponseDto
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionNoteResponseDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionNoteResponseDto
     */
    'lastname': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionNoteResponseDto
     */
    'supervisionId': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionNoteResponseDto
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionNoteResponseDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface SupervisionNotesResponseDto
 */
export interface SupervisionNotesResponseDto {
    /**
     * 
     * @type {Array<SupervisionNoteResponseDto>}
     * @memberof SupervisionNotesResponseDto
     */
    'notes': Array<SupervisionNoteResponseDto>;
}
/**
 * 
 * @export
 * @interface SupervisionRequestResponseDto
 */
export interface SupervisionRequestResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SupervisionRequestResponseDto
     */
    'supervisorId': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionRequestResponseDto
     */
    'availabilityId': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionRequestResponseDto
     */
    'type': SupervisionRequestResponseDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SupervisionRequestResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisionRequestResponseDto
     */
    'status': SupervisionRequestResponseDtoStatusEnum;
}

export const SupervisionRequestResponseDtoTypeEnum = {
    Personal: 'personal',
    Group: 'group'
} as const;

export type SupervisionRequestResponseDtoTypeEnum = typeof SupervisionRequestResponseDtoTypeEnum[keyof typeof SupervisionRequestResponseDtoTypeEnum];
export const SupervisionRequestResponseDtoStatusEnum = {
    Pending: 'pending',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Canceled: 'canceled',
    Expired: 'expired'
} as const;

export type SupervisionRequestResponseDtoStatusEnum = typeof SupervisionRequestResponseDtoStatusEnum[keyof typeof SupervisionRequestResponseDtoStatusEnum];

/**
 * 
 * @export
 * @interface SupervisionsBaseResponseDto
 */
export interface SupervisionsBaseResponseDto {
    /**
     * 
     * @type {Array<SupervisionBaseResponseDto>}
     * @memberof SupervisionsBaseResponseDto
     */
    'supervisions': Array<SupervisionBaseResponseDto>;
}
/**
 * 
 * @export
 * @interface SupervisorTherapistResponseDto
 */
export interface SupervisorTherapistResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SupervisorTherapistResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisorTherapistResponseDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisorTherapistResponseDto
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof SupervisorTherapistResponseDto
     */
    'supervisionCount': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisorTherapistResponseDto
     */
    'firstSupervisionDate': string;
    /**
     * 
     * @type {string}
     * @memberof SupervisorTherapistResponseDto
     */
    'lastSupervisionDate': string;
}
/**
 * 
 * @export
 * @interface SupervisorTherapistsResponseDto
 */
export interface SupervisorTherapistsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SupervisorTherapistsResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof SupervisorTherapistsResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof SupervisorTherapistsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof SupervisorTherapistsResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<SupervisorTherapistResponseDto>}
     * @memberof SupervisorTherapistsResponseDto
     */
    'data': Array<SupervisorTherapistResponseDto>;
}
/**
 * 
 * @export
 * @interface TestB2bEmailRequestDto
 */
export interface TestB2bEmailRequestDto {
    /**
     * Тип письма для тестирования
     * @type {string}
     * @memberof TestB2bEmailRequestDto
     */
    'emailType': TestB2bEmailRequestDtoEmailTypeEnum;
    /**
     * Email для отправки тестового письма
     * @type {string}
     * @memberof TestB2bEmailRequestDto
     */
    'email': string;
}

export const TestB2bEmailRequestDtoEmailTypeEnum = {
    Welcome: 'welcome',
    RegistrationConfirmation: 'registration_confirmation',
    EmailVerified: 'email_verified',
    PromocodesAssigned: 'promocodes_assigned',
    ReminderUnusedOpportunities: 'reminder_unused_opportunities',
    PromocodeExpiryWarning: 'promocode_expiry_warning',
    AfterFirstSession: 'after-first-session',
    Reactivation: 'reactivation'
} as const;

export type TestB2bEmailRequestDtoEmailTypeEnum = typeof TestB2bEmailRequestDtoEmailTypeEnum[keyof typeof TestB2bEmailRequestDtoEmailTypeEnum];

/**
 * 
 * @export
 * @interface TherapistAdditionalEducationRequestDto
 */
export interface TherapistAdditionalEducationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistAdditionalEducationRequestDto
     */
    'course': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistAdditionalEducationRequestDto
     */
    'organisation': string;
    /**
     * 
     * @type {Array<UserFileRequestDto>}
     * @memberof TherapistAdditionalEducationRequestDto
     */
    'files'?: Array<UserFileRequestDto>;
}
/**
 * 
 * @export
 * @interface TherapistAdditionalEducationResponseDto
 */
export interface TherapistAdditionalEducationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistAdditionalEducationResponseDto
     */
    'course': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistAdditionalEducationResponseDto
     */
    'organisation': string;
    /**
     * 
     * @type {Array<UserFileResponseDto>}
     * @memberof TherapistAdditionalEducationResponseDto
     */
    'files'?: Array<UserFileResponseDto>;
}
/**
 * 
 * @export
 * @interface TherapistBaseResponseDto
 */
export interface TherapistBaseResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistBaseResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistBaseResponseDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistBaseResponseDto
     */
    'lastname': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistBaseResponseDto
     */
    'avatarKey': string;
}
/**
 * 
 * @export
 * @interface TherapistCollaborationAndMediaRequestDto
 */
export interface TherapistCollaborationAndMediaRequestDto {
    /**
     * Есть ли у вас опыт проведения мастер-классов, тренингов или вебинаров?*
     * @type {boolean}
     * @memberof TherapistCollaborationAndMediaRequestDto
     */
    'workshopExperience': boolean;
    /**
     * Хотите ли вы проводить мастер-классы, вебинары или тренинги совместно с платформой?*
     * @type {boolean}
     * @memberof TherapistCollaborationAndMediaRequestDto
     */
    'workshopDesire': boolean;
    /**
     * Рассматриваете ли вы возможность написания материалов для блога?*
     * @type {boolean}
     * @memberof TherapistCollaborationAndMediaRequestDto
     */
    'blogMaterials': boolean;
    /**
     * Заинтересованы ли вы в участии в специальных проектах (лекции, программы, конференции)?*
     * @type {boolean}
     * @memberof TherapistCollaborationAndMediaRequestDto
     */
    'specialProjects': boolean;
    /**
     * Интересует ли вас поддержка в продвижении социальных сетей?*
     * @type {boolean}
     * @memberof TherapistCollaborationAndMediaRequestDto
     */
    'promotionSupport': boolean;
    /**
     * Пожалуйста, поделитесь ссылками на ваши профили в социальных сетях.*
     * @type {Array<string>}
     * @memberof TherapistCollaborationAndMediaRequestDto
     */
    'socialsLinks'?: Array<string>;
    /**
     * Пожалуйста, поделитесь ссылками на ваши материалы (статьи, курсы, книги и т.д.).*
     * @type {Array<string>}
     * @memberof TherapistCollaborationAndMediaRequestDto
     */
    'materialsLinks'?: Array<string>;
}
/**
 * 
 * @export
 * @interface TherapistCollaborationInfoResponseDto
 */
export interface TherapistCollaborationInfoResponseDto {
    /**
     * Есть ли у вас опыт проведения мастер-классов, тренингов или вебинаров?*
     * @type {boolean}
     * @memberof TherapistCollaborationInfoResponseDto
     */
    'workshopExperience': boolean;
    /**
     * Хотите ли вы проводить мастер-классы, вебинары или тренинги совместно с платформой?*
     * @type {boolean}
     * @memberof TherapistCollaborationInfoResponseDto
     */
    'workshopDesire': boolean;
    /**
     * Рассматриваете ли вы возможность написания материалов для блога?*
     * @type {boolean}
     * @memberof TherapistCollaborationInfoResponseDto
     */
    'blogMaterials': boolean;
    /**
     * Заинтересованы ли вы в участии в специальных проектах (лекции, программы, конференции)?*
     * @type {boolean}
     * @memberof TherapistCollaborationInfoResponseDto
     */
    'specialProjects': boolean;
    /**
     * Интересует ли вас поддержка в продвижении социальных сетей?*
     * @type {boolean}
     * @memberof TherapistCollaborationInfoResponseDto
     */
    'promotionSupport': boolean;
    /**
     * Пожалуйста, поделитесь ссылками на ваши профили в социальных сетях.*
     * @type {Array<string>}
     * @memberof TherapistCollaborationInfoResponseDto
     */
    'socialsLinks'?: Array<string>;
    /**
     * Пожалуйста, поделитесь ссылками на ваши материалы (статьи, курсы, книги и т.д.).*
     * @type {Array<string>}
     * @memberof TherapistCollaborationInfoResponseDto
     */
    'materialsLinks'?: Array<string>;
}
/**
 * 
 * @export
 * @interface TherapistEducationInfoRequestDto
 */
export interface TherapistEducationInfoRequestDto {
    /**
     * 
     * @type {Array<TherapistMainEducationRequestDto>}
     * @memberof TherapistEducationInfoRequestDto
     */
    'education': Array<TherapistMainEducationRequestDto>;
    /**
     * 
     * @type {Array<TherapistAdditionalEducationRequestDto>}
     * @memberof TherapistEducationInfoRequestDto
     */
    'additionalEducation'?: Array<TherapistAdditionalEducationRequestDto>;
}
/**
 * 
 * @export
 * @interface TherapistEducationInfoResponseDto
 */
export interface TherapistEducationInfoResponseDto {
    /**
     * 
     * @type {Array<TherapistMainEducationResponseDto>}
     * @memberof TherapistEducationInfoResponseDto
     */
    'education': Array<TherapistMainEducationResponseDto>;
    /**
     * 
     * @type {Array<TherapistAdditionalEducationResponseDto>}
     * @memberof TherapistEducationInfoResponseDto
     */
    'additionalEducation'?: Array<TherapistAdditionalEducationResponseDto> | null;
}
/**
 * 
 * @export
 * @interface TherapistFiltersResponseDto
 */
export interface TherapistFiltersResponseDto {
    /**
     * 
     * @type {number}
     * @memberof TherapistFiltersResponseDto
     */
    'priceMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof TherapistFiltersResponseDto
     */
    'priceMax': number;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistFiltersResponseDto
     */
    'coaches': boolean;
}
/**
 * 
 * @export
 * @interface TherapistMainEducationRequestDto
 */
export interface TherapistMainEducationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistMainEducationRequestDto
     */
    'university': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistMainEducationRequestDto
     */
    'speciality': string;
    /**
     * 
     * @type {Array<UserFileRequestDto>}
     * @memberof TherapistMainEducationRequestDto
     */
    'files'?: Array<UserFileRequestDto>;
}
/**
 * 
 * @export
 * @interface TherapistMainEducationResponseDto
 */
export interface TherapistMainEducationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistMainEducationResponseDto
     */
    'university': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistMainEducationResponseDto
     */
    'speciality': string;
    /**
     * 
     * @type {Array<UserFileResponseDto>}
     * @memberof TherapistMainEducationResponseDto
     */
    'files'?: Array<UserFileResponseDto>;
}
/**
 * 
 * @export
 * @interface TherapistPaginationSearchResponseDto
 */
export interface TherapistPaginationSearchResponseDto {
    /**
     * 
     * @type {number}
     * @memberof TherapistPaginationSearchResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistPaginationSearchResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistPaginationSearchResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistPaginationSearchResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<TherapistSearchResponseDto>}
     * @memberof TherapistPaginationSearchResponseDto
     */
    'data': Array<TherapistSearchResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof TherapistPaginationSearchResponseDto
     */
    'diseaseId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPaginationSearchResponseDto
     */
    'diseaseName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPaginationSearchResponseDto
     */
    'diseaseH1'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPaginationSearchResponseDto
     */
    'diseaseTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPaginationSearchResponseDto
     */
    'diseaseDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPaginationSearchResponseDto
     */
    'therapyMethodH1'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPaginationSearchResponseDto
     */
    'therapyMethodTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPaginationSearchResponseDto
     */
    'therapyMethodDescription'?: string;
}
/**
 * 
 * @export
 * @interface TherapistPatientNoteRequestDto
 */
export interface TherapistPatientNoteRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistPatientNoteRequestDto
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface TherapistPatientNoteResponseDto
 */
export interface TherapistPatientNoteResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistPatientNoteResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPatientNoteResponseDto
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPatientNoteResponseDto
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface TherapistPatientResponseDto
 */
export interface TherapistPatientResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistPatientResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPatientResponseDto
     */
    'patientUserId': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPatientResponseDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPatientResponseDto
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPatientResponseDto
     */
    'totalSessions': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPatientResponseDto
     */
    'firstSessionDate': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPatientResponseDto
     */
    'lastSessionDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistPatientResponseDto
     */
    'isB2B': boolean;
}
/**
 * 
 * @export
 * @interface TherapistPatientsResponseDto
 */
export interface TherapistPatientsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof TherapistPatientsResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistPatientsResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistPatientsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistPatientsResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<TherapistPatientResponseDto>}
     * @memberof TherapistPatientsResponseDto
     */
    'data': Array<TherapistPatientResponseDto>;
}
/**
 * 
 * @export
 * @interface TherapistPersonalInfoRequestDto
 */
export interface TherapistPersonalInfoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoRequestDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoRequestDto
     */
    'lastname': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoRequestDto
     */
    'gender': TherapistPersonalInfoRequestDtoGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoRequestDto
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoRequestDto
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoRequestDto
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoRequestDto
     */
    'about': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoRequestDto
     */
    'shortAbout': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoRequestDto
     */
    'videoFilekey'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoRequestDto
     */
    'avatarFilekey'?: string;
}

export const TherapistPersonalInfoRequestDtoGenderEnum = {
    Male: 'male',
    Female: 'female',
    Transgender: 'transgender',
    Unknown: 'unknown'
} as const;

export type TherapistPersonalInfoRequestDtoGenderEnum = typeof TherapistPersonalInfoRequestDtoGenderEnum[keyof typeof TherapistPersonalInfoRequestDtoGenderEnum];

/**
 * 
 * @export
 * @interface TherapistPersonalInfoResponseDto
 */
export interface TherapistPersonalInfoResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoResponseDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoResponseDto
     */
    'lastname': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoResponseDto
     */
    'gender': TherapistPersonalInfoResponseDtoGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoResponseDto
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoResponseDto
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoResponseDto
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoResponseDto
     */
    'shortAbout'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoResponseDto
     */
    'about'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoResponseDto
     */
    'videoFilekey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TherapistPersonalInfoResponseDto
     */
    'avatarFilekey'?: string | null;
}

export const TherapistPersonalInfoResponseDtoGenderEnum = {
    Male: 'male',
    Female: 'female',
    Transgender: 'transgender',
    Unknown: 'unknown'
} as const;

export type TherapistPersonalInfoResponseDtoGenderEnum = typeof TherapistPersonalInfoResponseDtoGenderEnum[keyof typeof TherapistPersonalInfoResponseDtoGenderEnum];

/**
 * 
 * @export
 * @interface TherapistProfileUpdateAbout
 */
export interface TherapistProfileUpdateAbout {
    /**
     * 
     * @type {string}
     * @memberof TherapistProfileUpdateAbout
     */
    'about': string;
}
/**
 * 
 * @export
 * @interface TherapistProfileUpdateResponseDto
 */
export interface TherapistProfileUpdateResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'url': string;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'hasMedsiSessions'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'averageRating'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'isTop'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'isMedsi'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'isAdult': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'isChildTherapist'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'isSupervisor': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'isB2B': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'isCoach': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'isApproved': boolean;
    /**
     * 
     * @type {TherapistPersonalInfoResponseDto}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'personalInfo': TherapistPersonalInfoResponseDto;
    /**
     * 
     * @type {TherapistEducationInfoResponseDto}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'educationInfo': TherapistEducationInfoResponseDto;
    /**
     * 
     * @type {TherapistWorkingInfoResponseDto}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'workingInfo': TherapistWorkingInfoResponseDto;
    /**
     * 
     * @type {TherapistTherapiesInfoResponseDto}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'therapiesInfo': TherapistTherapiesInfoResponseDto;
    /**
     * 
     * @type {TherapistSupervisionInfoResponseDto}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'supervisionInfo': TherapistSupervisionInfoResponseDto;
    /**
     * 
     * @type {TherapistCollaborationInfoResponseDto}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'collaborationInfo': TherapistCollaborationInfoResponseDto;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {string}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'deletedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistProfileUpdateResponseDto
     */
    'isRejected': boolean;
}
/**
 * 
 * @export
 * @interface TherapistProfileUpdateShortAbout
 */
export interface TherapistProfileUpdateShortAbout {
    /**
     * 
     * @type {string}
     * @memberof TherapistProfileUpdateShortAbout
     */
    'shortAbout': string;
}
/**
 * 
 * @export
 * @interface TherapistProfileUpdatesResponseDto
 */
export interface TherapistProfileUpdatesResponseDto {
    /**
     * 
     * @type {Array<TherapistProfileUpdateResponseDto>}
     * @memberof TherapistProfileUpdatesResponseDto
     */
    'updates': Array<TherapistProfileUpdateResponseDto>;
}
/**
 * 
 * @export
 * @interface TherapistRecommendationInfoRequestDto
 */
export interface TherapistRecommendationInfoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistRecommendationInfoRequestDto
     */
    'recommendationText'?: string;
    /**
     * 
     * @type {Array<UserFileRequestDto>}
     * @memberof TherapistRecommendationInfoRequestDto
     */
    'recommendationFiles'?: Array<UserFileRequestDto>;
}
/**
 * 
 * @export
 * @interface TherapistReviewPaginationResponseDto
 */
export interface TherapistReviewPaginationResponseDto {
    /**
     * 
     * @type {number}
     * @memberof TherapistReviewPaginationResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistReviewPaginationResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistReviewPaginationResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistReviewPaginationResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<TherapistReviewResponseDto>}
     * @memberof TherapistReviewPaginationResponseDto
     */
    'data': Array<TherapistReviewResponseDto>;
}
/**
 * 
 * @export
 * @interface TherapistReviewResponseDto
 */
export interface TherapistReviewResponseDto {
    /**
     * 
     * @type {number}
     * @memberof TherapistReviewResponseDto
     */
    'rating': number;
    /**
     * 
     * @type {string}
     * @memberof TherapistReviewResponseDto
     */
    'review': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistReviewResponseDto
     */
    'createdAr': string;
    /**
     * 
     * @type {ReviewerResponseDto}
     * @memberof TherapistReviewResponseDto
     */
    'reviewer': ReviewerResponseDto;
}
/**
 * 
 * @export
 * @interface TherapistReviewsRequestDto
 */
export interface TherapistReviewsRequestDto {
    /**
     * 
     * @type {number}
     * @memberof TherapistReviewsRequestDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistReviewsRequestDto
     */
    'page': number;
    /**
     * 
     * @type {string}
     * @memberof TherapistReviewsRequestDto
     */
    'order'?: TherapistReviewsRequestDtoOrderEnum;
    /**
     * 
     * @type {string}
     * @memberof TherapistReviewsRequestDto
     */
    'orderTerms': TherapistReviewsRequestDtoOrderTermsEnum;
}

export const TherapistReviewsRequestDtoOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type TherapistReviewsRequestDtoOrderEnum = typeof TherapistReviewsRequestDtoOrderEnum[keyof typeof TherapistReviewsRequestDtoOrderEnum];
export const TherapistReviewsRequestDtoOrderTermsEnum = {
    Rating: 'rating',
    CreatedAt: 'createdAt'
} as const;

export type TherapistReviewsRequestDtoOrderTermsEnum = typeof TherapistReviewsRequestDtoOrderTermsEnum[keyof typeof TherapistReviewsRequestDtoOrderTermsEnum];

/**
 * 
 * @export
 * @interface TherapistScheduleResponseDto
 */
export interface TherapistScheduleResponseDto {
    /**
     * 
     * @type {Array<SessionResponseDto>}
     * @memberof TherapistScheduleResponseDto
     */
    'sessions': Array<SessionResponseDto>;
    /**
     * 
     * @type {Array<AvailabilityResponseDto>}
     * @memberof TherapistScheduleResponseDto
     */
    'availabilities': Array<AvailabilityResponseDto>;
    /**
     * 
     * @type {Array<AvailabilityRecurringResponseDto>}
     * @memberof TherapistScheduleResponseDto
     */
    'availabilityRecurrings': Array<AvailabilityRecurringResponseDto>;
}
/**
 * 
 * @export
 * @interface TherapistSearchDiseases
 */
export interface TherapistSearchDiseases {
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchDiseases
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchDiseases
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TherapistSearchDiseasesByDescription
 */
export interface TherapistSearchDiseasesByDescription {
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchDiseasesByDescription
     */
    'description': string;
    /**
     * 
     * @type {Array<TherapistSearchDiseases>}
     * @memberof TherapistSearchDiseasesByDescription
     */
    'diseases': Array<TherapistSearchDiseases>;
}
/**
 * 
 * @export
 * @interface TherapistSearchRequestDto
 */
export interface TherapistSearchRequestDto {
    /**
     * 
     * @type {number}
     * @memberof TherapistSearchRequestDto
     */
    'limit': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistSearchRequestDto
     */
    'page': number;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchRequestDto
     */
    'order'?: TherapistSearchRequestDtoOrderEnum;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchRequestDto
     */
    'orderTerms'?: TherapistSearchRequestDtoOrderTermsEnum;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchRequestDto
     */
    'gender'?: TherapistSearchRequestDtoGenderEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistSearchRequestDto
     */
    'therapyMethods'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistSearchRequestDto
     */
    'diseases'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchRequestDto
     */
    'diseaseUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchRequestDto
     */
    'therapyMethodUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof TherapistSearchRequestDto
     */
    'dayLimit'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchRequestDto
     */
    'workWithLgbt'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchRequestDto
     */
    'workWithEthnicGroups'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TherapistSearchRequestDto
     */
    'workingExperience'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchRequestDto
     */
    'isApproved'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchRequestDto
     */
    'firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchRequestDto
     */
    'lastname'?: string;
    /**
     * 
     * @type {number}
     * @memberof TherapistSearchRequestDto
     */
    'priceMin'?: number;
    /**
     * 
     * @type {number}
     * @memberof TherapistSearchRequestDto
     */
    'priceMax'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistSearchRequestDto
     */
    'religions'?: Array<TherapistSearchRequestDtoReligionsEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistSearchRequestDto
     */
    'specialisations'?: Array<TherapistSearchRequestDtoSpecialisationsEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchRequestDto
     */
    'debug'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchRequestDto
     */
    'childTherapists'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchRequestDto
     */
    'adultTherapists'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchRequestDto
     */
    'supervisorTherapists'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchRequestDto
     */
    'b2bTherapists'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchRequestDto
     */
    'coaches'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TherapistSearchRequestDto
     */
    'childOld'?: number;
    /**
     * Возраст терапевта должен быть в формате \"20-34\" или \"45+\"
     * @type {string}
     * @memberof TherapistSearchRequestDto
     */
    'therapistOld'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchRequestDto
     */
    'demo'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchRequestDto
     */
    'family'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchRequestDto
     */
    'workApproachGuidance'?: TherapistSearchRequestDtoWorkApproachGuidanceEnum;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchRequestDto
     */
    'workApproachInteraction'?: TherapistSearchRequestDtoWorkApproachInteractionEnum;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchRequestDto
     */
    'workApproachConnection'?: TherapistSearchRequestDtoWorkApproachConnectionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchRequestDto
     */
    'isFavorite'?: boolean;
}

export const TherapistSearchRequestDtoOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type TherapistSearchRequestDtoOrderEnum = typeof TherapistSearchRequestDtoOrderEnum[keyof typeof TherapistSearchRequestDtoOrderEnum];
export const TherapistSearchRequestDtoOrderTermsEnum = {
    Price: 'price',
    Experience: 'experience',
    Availability: 'availability'
} as const;

export type TherapistSearchRequestDtoOrderTermsEnum = typeof TherapistSearchRequestDtoOrderTermsEnum[keyof typeof TherapistSearchRequestDtoOrderTermsEnum];
export const TherapistSearchRequestDtoGenderEnum = {
    Male: 'male',
    Female: 'female',
    Transgender: 'transgender',
    Unknown: 'unknown'
} as const;

export type TherapistSearchRequestDtoGenderEnum = typeof TherapistSearchRequestDtoGenderEnum[keyof typeof TherapistSearchRequestDtoGenderEnum];
export const TherapistSearchRequestDtoReligionsEnum = {
    Christianity: 'christianity',
    Islamism: 'islamism',
    Judaism: 'judaism',
    Buddhism: 'buddhism'
} as const;

export type TherapistSearchRequestDtoReligionsEnum = typeof TherapistSearchRequestDtoReligionsEnum[keyof typeof TherapistSearchRequestDtoReligionsEnum];
export const TherapistSearchRequestDtoSpecialisationsEnum = {
    Unspecified: 'unspecified',
    Psychologist: 'psychologist',
    Psychoanalyst: 'psychoanalyst',
    Coach: 'coach',
    Supervisor: 'supervisor',
    ClinicalPsychologist: 'clinical_psychologist',
    Sexologist: 'sexologist'
} as const;

export type TherapistSearchRequestDtoSpecialisationsEnum = typeof TherapistSearchRequestDtoSpecialisationsEnum[keyof typeof TherapistSearchRequestDtoSpecialisationsEnum];
export const TherapistSearchRequestDtoWorkApproachGuidanceEnum = {
    Supporting: 'supporting',
    Guiding: 'guiding'
} as const;

export type TherapistSearchRequestDtoWorkApproachGuidanceEnum = typeof TherapistSearchRequestDtoWorkApproachGuidanceEnum[keyof typeof TherapistSearchRequestDtoWorkApproachGuidanceEnum];
export const TherapistSearchRequestDtoWorkApproachInteractionEnum = {
    Soft: 'soft',
    Straight: 'straight'
} as const;

export type TherapistSearchRequestDtoWorkApproachInteractionEnum = typeof TherapistSearchRequestDtoWorkApproachInteractionEnum[keyof typeof TherapistSearchRequestDtoWorkApproachInteractionEnum];
export const TherapistSearchRequestDtoWorkApproachConnectionEnum = {
    Serious: 'serious',
    Informal: 'informal'
} as const;

export type TherapistSearchRequestDtoWorkApproachConnectionEnum = typeof TherapistSearchRequestDtoWorkApproachConnectionEnum[keyof typeof TherapistSearchRequestDtoWorkApproachConnectionEnum];

/**
 * 
 * @export
 * @interface TherapistSearchResponseDto
 */
export interface TherapistSearchResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchResponseDto
     */
    'firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchResponseDto
     */
    'lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchResponseDto
     */
    'gender': TherapistSearchResponseDtoGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchResponseDto
     */
    'avatarKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchResponseDto
     */
    'miniAvatarKey'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchResponseDto
     */
    'isTop': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchResponseDto
     */
    'url': boolean;
    /**
     * 
     * @type {number}
     * @memberof TherapistSearchResponseDto
     */
    'workingExperience': number;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchResponseDto
     */
    'workingExperienceDescription': string;
    /**
     * 
     * @type {AvailabilityResponseDto}
     * @memberof TherapistSearchResponseDto
     */
    'closestFreeAvailability': AvailabilityResponseDto;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchResponseDto
     */
    'recommendationText': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistSearchResponseDto
     */
    'specialisation': Array<TherapistSearchResponseDtoSpecialisationEnum>;
    /**
     * 
     * @type {Array<TherapyMethodResponseDto>}
     * @memberof TherapistSearchResponseDto
     */
    'therapyMethods': Array<TherapyMethodResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof TherapistSearchResponseDto
     */
    'price': number;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchResponseDto
     */
    'isApproved': boolean;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchResponseDto
     */
    'about': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchResponseDto
     */
    'shortAbout': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchResponseDto
     */
    'dateOfBirth': string;
    /**
     * 
     * @type {number}
     * @memberof TherapistSearchResponseDto
     */
    'totalSessions': number;
    /**
     * 
     * @type {Array<TherapistSearchDiseasesByDescription>}
     * @memberof TherapistSearchResponseDto
     */
    'diseases': Array<TherapistSearchDiseasesByDescription>;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchResponseDto
     */
    'videoKey': string;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchResponseDto
     */
    'hasMedsiSessions': boolean;
    /**
     * 
     * @type {number}
     * @memberof TherapistSearchResponseDto
     */
    'childOldFrom': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistSearchResponseDto
     */
    'childOldTo': number;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchResponseDto
     */
    'isSupervisor': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchResponseDto
     */
    'isMedsi': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchResponseDto
     */
    'isAdult': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchResponseDto
     */
    'isChildTherapist': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchResponseDto
     */
    'isCoach': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSearchResponseDto
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {string}
     * @memberof TherapistSearchResponseDto
     */
    'createdAt': string;
}

export const TherapistSearchResponseDtoGenderEnum = {
    Male: 'male',
    Female: 'female',
    Transgender: 'transgender',
    Unknown: 'unknown'
} as const;

export type TherapistSearchResponseDtoGenderEnum = typeof TherapistSearchResponseDtoGenderEnum[keyof typeof TherapistSearchResponseDtoGenderEnum];
export const TherapistSearchResponseDtoSpecialisationEnum = {
    Unspecified: 'unspecified',
    Psychologist: 'psychologist',
    Psychoanalyst: 'psychoanalyst',
    Coach: 'coach',
    Supervisor: 'supervisor',
    ClinicalPsychologist: 'clinical_psychologist',
    Sexologist: 'sexologist'
} as const;

export type TherapistSearchResponseDtoSpecialisationEnum = typeof TherapistSearchResponseDtoSpecialisationEnum[keyof typeof TherapistSearchResponseDtoSpecialisationEnum];

/**
 * 
 * @export
 * @interface TherapistSupervisionInfoRequestDto
 */
export interface TherapistSupervisionInfoRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSupervisionInfoRequestDto
     */
    'isSupervisor': boolean;
    /**
     * 
     * @type {number}
     * @memberof TherapistSupervisionInfoRequestDto
     */
    'supervisionExperience'?: number;
    /**
     * 
     * @type {RequiredSupervisionInfoRequestDto}
     * @memberof TherapistSupervisionInfoRequestDto
     */
    'therapistSupervisionInfo'?: RequiredSupervisionInfoRequestDto;
}
/**
 * 
 * @export
 * @interface TherapistSupervisionInfoResponseDto
 */
export interface TherapistSupervisionInfoResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof TherapistSupervisionInfoResponseDto
     */
    'isSupervisor': boolean;
    /**
     * 
     * @type {number}
     * @memberof TherapistSupervisionInfoResponseDto
     */
    'supervisionExperience': number;
    /**
     * 
     * @type {RequiredSupervisionInfoResponseDto}
     * @memberof TherapistSupervisionInfoResponseDto
     */
    'therapistSupervisionInfo': RequiredSupervisionInfoResponseDto;
}
/**
 * 
 * @export
 * @interface TherapistSupervisorResponseDto
 */
export interface TherapistSupervisorResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TherapistSupervisorResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistSupervisorResponseDto
     */
    'avatarKey': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistSupervisorResponseDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistSupervisorResponseDto
     */
    'lastname': string;
    /**
     * 
     * @type {number}
     * @memberof TherapistSupervisorResponseDto
     */
    'supervisionCount': number;
    /**
     * 
     * @type {string}
     * @memberof TherapistSupervisorResponseDto
     */
    'firstSupervisionDate': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistSupervisorResponseDto
     */
    'lastSupervisionDate': string;
}
/**
 * 
 * @export
 * @interface TherapistSupervisorsResponseDto
 */
export interface TherapistSupervisorsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof TherapistSupervisorsResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistSupervisorsResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistSupervisorsResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistSupervisorsResponseDto
     */
    'totalPage': number;
    /**
     * 
     * @type {Array<TherapistSupervisorResponseDto>}
     * @memberof TherapistSupervisorsResponseDto
     */
    'data': Array<TherapistSupervisorResponseDto>;
}
/**
 * 
 * @export
 * @interface TherapistTherapiesInfoRequestDto
 */
export interface TherapistTherapiesInfoRequestDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistTherapiesInfoRequestDto
     */
    'specialisation': Array<TherapistTherapiesInfoRequestDtoSpecialisationEnum>;
    /**
     * UUID of therapy methods
     * @type {Array<string>}
     * @memberof TherapistTherapiesInfoRequestDto
     */
    'therapyMethodIds': Array<string>;
    /**
     * UUID of diseases
     * @type {Array<string>}
     * @memberof TherapistTherapiesInfoRequestDto
     */
    'diseaseIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistTherapiesInfoRequestDto
     */
    'excludedDiseases': Array<string>;
    /**
     * Есть ли опыт совместной работы с психиатром
     * @type {boolean}
     * @memberof TherapistTherapiesInfoRequestDto
     */
    'workWithPsychiatristExperience': boolean;
    /**
     * Сотрудничаете ли вы в настоящее время с психиатром по клиентам?
     * @type {string}
     * @memberof TherapistTherapiesInfoRequestDto
     */
    'psychiatristCollaboration'?: string;
}

export const TherapistTherapiesInfoRequestDtoSpecialisationEnum = {
    Unspecified: 'unspecified',
    Psychologist: 'psychologist',
    Psychoanalyst: 'psychoanalyst',
    Coach: 'coach',
    Supervisor: 'supervisor',
    ClinicalPsychologist: 'clinical_psychologist',
    Sexologist: 'sexologist'
} as const;

export type TherapistTherapiesInfoRequestDtoSpecialisationEnum = typeof TherapistTherapiesInfoRequestDtoSpecialisationEnum[keyof typeof TherapistTherapiesInfoRequestDtoSpecialisationEnum];

/**
 * 
 * @export
 * @interface TherapistTherapiesInfoResponseDto
 */
export interface TherapistTherapiesInfoResponseDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistTherapiesInfoResponseDto
     */
    'specialisation': Array<TherapistTherapiesInfoResponseDtoSpecialisationEnum>;
    /**
     * 
     * @type {Array<TherapyMethodResponseDto>}
     * @memberof TherapistTherapiesInfoResponseDto
     */
    'therapyMethods': Array<TherapyMethodResponseDto>;
    /**
     * 
     * @type {Array<DiseaseResponseDto>}
     * @memberof TherapistTherapiesInfoResponseDto
     */
    'diseases': Array<DiseaseResponseDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistTherapiesInfoResponseDto
     */
    'excludedDiseases': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistTherapiesInfoResponseDto
     */
    'workWithPsychiatristExperience': boolean;
    /**
     * 
     * @type {string}
     * @memberof TherapistTherapiesInfoResponseDto
     */
    'psychiatristCollaboration': string;
}

export const TherapistTherapiesInfoResponseDtoSpecialisationEnum = {
    Unspecified: 'unspecified',
    Psychologist: 'psychologist',
    Psychoanalyst: 'psychoanalyst',
    Coach: 'coach',
    Supervisor: 'supervisor',
    ClinicalPsychologist: 'clinical_psychologist',
    Sexologist: 'sexologist'
} as const;

export type TherapistTherapiesInfoResponseDtoSpecialisationEnum = typeof TherapistTherapiesInfoResponseDtoSpecialisationEnum[keyof typeof TherapistTherapiesInfoResponseDtoSpecialisationEnum];

/**
 * 
 * @export
 * @interface TherapistUpdateIsAdult
 */
export interface TherapistUpdateIsAdult {
    /**
     * 
     * @type {boolean}
     * @memberof TherapistUpdateIsAdult
     */
    'isAdult': boolean;
}
/**
 * 
 * @export
 * @interface TherapistUpdateIsB2BDto
 */
export interface TherapistUpdateIsB2BDto {
    /**
     * 
     * @type {boolean}
     * @memberof TherapistUpdateIsB2BDto
     */
    'isB2B': boolean;
}
/**
 * 
 * @export
 * @interface TherapistUpdateIsChildTherapistDto
 */
export interface TherapistUpdateIsChildTherapistDto {
    /**
     * 
     * @type {boolean}
     * @memberof TherapistUpdateIsChildTherapistDto
     */
    'isChildTherapist': boolean;
}
/**
 * 
 * @export
 * @interface TherapistUpdateIsCoachDto
 */
export interface TherapistUpdateIsCoachDto {
    /**
     * 
     * @type {boolean}
     * @memberof TherapistUpdateIsCoachDto
     */
    'isCoach': boolean;
}
/**
 * 
 * @export
 * @interface TherapistUpdateIsMedsiDto
 */
export interface TherapistUpdateIsMedsiDto {
    /**
     * 
     * @type {boolean}
     * @memberof TherapistUpdateIsMedsiDto
     */
    'isMedsi': boolean;
}
/**
 * 
 * @export
 * @interface TherapistUpdateIsSupervisorDto
 */
export interface TherapistUpdateIsSupervisorDto {
    /**
     * 
     * @type {boolean}
     * @memberof TherapistUpdateIsSupervisorDto
     */
    'isSupervisor': boolean;
}
/**
 * 
 * @export
 * @interface TherapistUpdateIsTestDto
 */
export interface TherapistUpdateIsTestDto {
    /**
     * 
     * @type {boolean}
     * @memberof TherapistUpdateIsTestDto
     */
    'isTest': boolean;
}
/**
 * 
 * @export
 * @interface TherapistUpdateIsTopDto
 */
export interface TherapistUpdateIsTopDto {
    /**
     * 
     * @type {boolean}
     * @memberof TherapistUpdateIsTopDto
     */
    'isTop': boolean;
}
/**
 * 
 * @export
 * @interface TherapistUpdateRewardInPercent
 */
export interface TherapistUpdateRewardInPercent {
    /**
     * 
     * @type {number}
     * @memberof TherapistUpdateRewardInPercent
     */
    'rewardInPercent': number;
}
/**
 * 
 * @export
 * @interface TherapistUpdateSessionPrice
 */
export interface TherapistUpdateSessionPrice {
    /**
     * 
     * @type {number}
     * @memberof TherapistUpdateSessionPrice
     */
    'price': number;
}
/**
 * 
 * @export
 * @interface TherapistUpdateSpecialisationDto
 */
export interface TherapistUpdateSpecialisationDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistUpdateSpecialisationDto
     */
    'specialisation': Array<TherapistUpdateSpecialisationDtoSpecialisationEnum>;
}

export const TherapistUpdateSpecialisationDtoSpecialisationEnum = {
    Unspecified: 'unspecified',
    Psychologist: 'psychologist',
    Psychoanalyst: 'psychoanalyst',
    Coach: 'coach',
    Supervisor: 'supervisor',
    ClinicalPsychologist: 'clinical_psychologist',
    Sexologist: 'sexologist'
} as const;

export type TherapistUpdateSpecialisationDtoSpecialisationEnum = typeof TherapistUpdateSpecialisationDtoSpecialisationEnum[keyof typeof TherapistUpdateSpecialisationDtoSpecialisationEnum];

/**
 * 
 * @export
 * @interface TherapistWorkingInfoRequestDto
 */
export interface TherapistWorkingInfoRequestDto {
    /**
     * 
     * @type {number}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'workingExperience': number;
    /**
     * 
     * @type {string}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'workingExperienceDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'workWithLgbt': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'workWithIndividual': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'workWithCouples': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'workWithFamilies': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'workWithChildren': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'workWithGroups': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'workWithClinical': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'workWithCheckup': boolean;
    /**
     * 
     * @type {string}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'workWithReligions'?: TherapistWorkingInfoRequestDtoWorkWithReligionsEnum;
    /**
     * 
     * @type {string}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'ethnicExperienceDescription'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'languages': TherapistWorkingInfoRequestDtoLanguagesEnum;
    /**
     * 
     * @type {number}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'numberOfPatients': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'devoteHoursToPlatform': number;
    /**
     * Флаг проведения очных сессий
     * @type {boolean}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'hasOfflineSessions'?: boolean;
    /**
     * Общее количество сессий проведенных терапевтом за всю практику
     * @type {number}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'totalSessions'?: number;
    /**
     * 
     * @type {string}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'workApproach1': string | null;
    /**
     * 
     * @type {string}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'workApproach2': string | null;
    /**
     * 
     * @type {string}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'workApproach3': string | null;
    /**
     * 
     * @type {number}
     * @memberof TherapistWorkingInfoRequestDto
     */
    'price': number;
}

export const TherapistWorkingInfoRequestDtoWorkWithReligionsEnum = {
    Christianity: 'christianity',
    Islamism: 'islamism',
    Judaism: 'judaism',
    Buddhism: 'buddhism'
} as const;

export type TherapistWorkingInfoRequestDtoWorkWithReligionsEnum = typeof TherapistWorkingInfoRequestDtoWorkWithReligionsEnum[keyof typeof TherapistWorkingInfoRequestDtoWorkWithReligionsEnum];
export const TherapistWorkingInfoRequestDtoLanguagesEnum = {
    English: 'english',
    Russian: 'russian',
    Kazakh: 'kazakh',
    German: 'german',
    Tatar: 'tatar',
    Armenian: 'armenian',
    French: 'french',
    Spanish: 'spanish',
    Italian: 'italian',
    Chinese: 'chinese',
    Arab: 'arab',
    Azerbaijani: 'azerbaijani',
    Georgian: 'georgian',
    Uzbek: 'uzbek'
} as const;

export type TherapistWorkingInfoRequestDtoLanguagesEnum = typeof TherapistWorkingInfoRequestDtoLanguagesEnum[keyof typeof TherapistWorkingInfoRequestDtoLanguagesEnum];

/**
 * 
 * @export
 * @interface TherapistWorkingInfoResponseDto
 */
export interface TherapistWorkingInfoResponseDto {
    /**
     * 
     * @type {number}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'workingExperience': number;
    /**
     * 
     * @type {string}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'workingExperienceDescription': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'workApproach1': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'workApproach2': string;
    /**
     * 
     * @type {string}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'workApproach3': string;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'workWithLgbt': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'workWithCouples': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'workWithFamilies': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'workWithChildren': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'workWithIndividual': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'workWithClinical': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'workWithCheckup': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'workWithGroups': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'workWithReligions'?: Array<TherapistWorkingInfoResponseDtoWorkWithReligionsEnum>;
    /**
     * 
     * @type {string}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'ethnicExperienceDescription'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'languages': Array<TherapistWorkingInfoResponseDtoLanguagesEnum>;
    /**
     * 
     * @type {number}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'numberOfPatients': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'devoteHoursToPlatform': number;
    /**
     * 
     * @type {number}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'price': number;
    /**
     * Флаг проведения очных сессий
     * @type {boolean}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'hasOfflineSessions': boolean;
    /**
     * Общее количество сессий проведенных терапевтом за всю практику
     * @type {number}
     * @memberof TherapistWorkingInfoResponseDto
     */
    'totalSessions'?: number;
}

export const TherapistWorkingInfoResponseDtoWorkWithReligionsEnum = {
    Christianity: 'christianity',
    Islamism: 'islamism',
    Judaism: 'judaism',
    Buddhism: 'buddhism'
} as const;

export type TherapistWorkingInfoResponseDtoWorkWithReligionsEnum = typeof TherapistWorkingInfoResponseDtoWorkWithReligionsEnum[keyof typeof TherapistWorkingInfoResponseDtoWorkWithReligionsEnum];
export const TherapistWorkingInfoResponseDtoLanguagesEnum = {
    English: 'english',
    Russian: 'russian',
    Kazakh: 'kazakh',
    German: 'german',
    Tatar: 'tatar',
    Armenian: 'armenian',
    French: 'french',
    Spanish: 'spanish',
    Italian: 'italian',
    Chinese: 'chinese',
    Arab: 'arab',
    Azerbaijani: 'azerbaijani',
    Georgian: 'georgian',
    Uzbek: 'uzbek'
} as const;

export type TherapistWorkingInfoResponseDtoLanguagesEnum = typeof TherapistWorkingInfoResponseDtoLanguagesEnum[keyof typeof TherapistWorkingInfoResponseDtoLanguagesEnum];

/**
 * 
 * @export
 * @interface TherapyMethodResponseDto
 */
export interface TherapyMethodResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TherapyMethodResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TherapyMethodResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TherapyMethodResponseDto
     */
    'tip': string;
    /**
     * 
     * @type {string}
     * @memberof TherapyMethodResponseDto
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface TherapyMethodsResponseDto
 */
export interface TherapyMethodsResponseDto {
    /**
     * 
     * @type {Array<TherapyMethodResponseDto>}
     * @memberof TherapyMethodsResponseDto
     */
    'data': Array<TherapyMethodResponseDto>;
}
/**
 * 
 * @export
 * @interface TherapyMethodsSearchStatisticsResponseDto
 */
export interface TherapyMethodsSearchStatisticsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TherapyMethodsSearchStatisticsResponseDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TherapyMethodsSearchStatisticsResponseDto
     */
    'percentage': string;
}
/**
 * 
 * @export
 * @interface UpcomingSessionPaymentInfoResponseDto
 */
export interface UpcomingSessionPaymentInfoResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UpcomingSessionPaymentInfoResponseDto
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingSessionPaymentInfoResponseDto
     */
    'therapistId': string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingSessionPaymentInfoResponseDto
     */
    'therapistFirstname': string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingSessionPaymentInfoResponseDto
     */
    'therapistLastname': string;
    /**
     * 
     * @type {string}
     * @memberof UpcomingSessionPaymentInfoResponseDto
     */
    'therapistAvatarKey': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpcomingSessionPaymentInfoResponseDto
     */
    'therapistSpecialization': Array<UpcomingSessionPaymentInfoResponseDtoTherapistSpecializationEnum>;
    /**
     * 
     * @type {number}
     * @memberof UpcomingSessionPaymentInfoResponseDto
     */
    'therapistWorkingExperience': number;
    /**
     * 
     * @type {PaymentMethodResponseDto}
     * @memberof UpcomingSessionPaymentInfoResponseDto
     */
    'paymentMethod'?: PaymentMethodResponseDto;
    /**
     * 
     * @type {number}
     * @memberof UpcomingSessionPaymentInfoResponseDto
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpcomingSessionPaymentInfoResponseDto
     */
    'usdPrice'?: number;
}

export const UpcomingSessionPaymentInfoResponseDtoTherapistSpecializationEnum = {
    Unspecified: 'unspecified',
    Psychologist: 'psychologist',
    Psychoanalyst: 'psychoanalyst',
    Coach: 'coach',
    Supervisor: 'supervisor',
    ClinicalPsychologist: 'clinical_psychologist',
    Sexologist: 'sexologist'
} as const;

export type UpcomingSessionPaymentInfoResponseDtoTherapistSpecializationEnum = typeof UpcomingSessionPaymentInfoResponseDtoTherapistSpecializationEnum[keyof typeof UpcomingSessionPaymentInfoResponseDtoTherapistSpecializationEnum];

/**
 * 
 * @export
 * @interface UpdateAvailabilityRequestDto
 */
export interface UpdateAvailabilityRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailabilityRequestDto
     */
    'startPeriodDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailabilityRequestDto
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailabilityRequestDto
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailabilityRequestDto
     */
    'type'?: UpdateAvailabilityRequestDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailabilityRequestDto
     */
    'offsetHours'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailabilityRequestDto
     */
    'changeMode'?: UpdateAvailabilityRequestDtoChangeModeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailabilityRequestDto
     */
    'changeDate'?: string;
}

export const UpdateAvailabilityRequestDtoTypeEnum = {
    Day: 'every_day',
    Weekday: 'every_weekday',
    Monday: 'every_monday',
    Tuesday: 'every_tuesday',
    Wednesday: 'every_wednesday',
    Thursday: 'every_thursday',
    Friday: 'every_friday',
    Saturday: 'every_saturday',
    Sunday: 'every_sunday'
} as const;

export type UpdateAvailabilityRequestDtoTypeEnum = typeof UpdateAvailabilityRequestDtoTypeEnum[keyof typeof UpdateAvailabilityRequestDtoTypeEnum];
export const UpdateAvailabilityRequestDtoChangeModeEnum = {
    All: 'all',
    OnlyThis: 'only_this',
    ThisAndNext: 'this_and_next'
} as const;

export type UpdateAvailabilityRequestDtoChangeModeEnum = typeof UpdateAvailabilityRequestDtoChangeModeEnum[keyof typeof UpdateAvailabilityRequestDtoChangeModeEnum];

/**
 * 
 * @export
 * @interface UpdateAvatarRequestDto
 */
export interface UpdateAvatarRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvatarRequestDto
     */
    'avatarKey': string;
}
/**
 * 
 * @export
 * @interface UpdateCompanyRequestDto
 */
export interface UpdateCompanyRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequestDto
     */
    'avatarKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompanyRequestDto
     */
    'name'?: string;
    /**
     * 
     * @type {Array<CreateCompanyCompanyInfoTherapistsFiltersRequestDto>}
     * @memberof UpdateCompanyRequestDto
     */
    'therapistsFilters'?: Array<CreateCompanyCompanyInfoTherapistsFiltersRequestDto>;
}
/**
 * 
 * @export
 * @interface UpdateDiseaseRequestDto
 */
export interface UpdateDiseaseRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateDiseaseRequestDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiseaseRequestDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiseaseRequestDto
     */
    'diseasesGroupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiseaseRequestDto
     */
    'tip'?: string;
}
/**
 * 
 * @export
 * @interface UpdateEmailWithoutConfirmationRequestDto
 */
export interface UpdateEmailWithoutConfirmationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailWithoutConfirmationRequestDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface UpdateFaqGroupRequestDto
 */
export interface UpdateFaqGroupRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateFaqGroupRequestDto
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface UpdateFaqQuestionRequestDto
 */
export interface UpdateFaqQuestionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateFaqQuestionRequestDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFaqQuestionRequestDto
     */
    'text'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFaqQuestionRequestDto
     */
    'groupId'?: string;
}
/**
 * 
 * @export
 * @interface UpdateNotificationSettingsRequestDto
 */
export interface UpdateNotificationSettingsRequestDto {
    /**
     * Включить/выключить email уведомления
     * @type {boolean}
     * @memberof UpdateNotificationSettingsRequestDto
     */
    'isEmailNotificationsEnabled'?: boolean;
    /**
     * Включить/выключить SMS уведомления
     * @type {boolean}
     * @memberof UpdateNotificationSettingsRequestDto
     */
    'isSmsNotificationsEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateNotificationTimeRequestDto
 */
export interface UpdateNotificationTimeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateNotificationTimeRequestDto
     */
    'timeInHours': UpdateNotificationTimeRequestDtoTimeInHoursEnum;
}

export const UpdateNotificationTimeRequestDtoTimeInHoursEnum = {
    _0: '0',
    _1: '1',
    _8: '8',
    _16: '16',
    _24: '24',
    _48: '48'
} as const;

export type UpdateNotificationTimeRequestDtoTimeInHoursEnum = typeof UpdateNotificationTimeRequestDtoTimeInHoursEnum[keyof typeof UpdateNotificationTimeRequestDtoTimeInHoursEnum];

/**
 * 
 * @export
 * @interface UpdatePasswordRequestDto
 */
export interface UpdatePasswordRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordRequestDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordRequestDto
     */
    'oldPassword': string;
}
/**
 * 
 * @export
 * @interface UpdatePatientProfileRequestDto
 */
export interface UpdatePatientProfileRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientProfileRequestDto
     */
    'firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientProfileRequestDto
     */
    'lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientProfileRequestDto
     */
    'dateOfBirth'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePatientProfileRequestDto
     */
    'avatarKey'?: string;
}
/**
 * 
 * @export
 * @interface UpdatePhoneRequestDto
 */
export interface UpdatePhoneRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePhoneRequestDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePhoneRequestDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface UpdatePromocodeRequestDto
 */
export interface UpdatePromocodeRequestDto {
    /**
     * 
     * @type {number}
     * @memberof UpdatePromocodeRequestDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdatePromocodeRequestDto
     */
    'percentage'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdatePromocodeRequestDto
     */
    'discountType'?: UpdatePromocodeRequestDtoDiscountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdatePromocodeRequestDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePromocodeRequestDto
     */
    'expireDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePromocodeRequestDto
     */
    'firstUseOnly'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdatePromocodeRequestDto
     */
    'useLimitPerUser'?: number;
}

export const UpdatePromocodeRequestDtoDiscountTypeEnum = {
    Amount: 'amount',
    Percentage: 'percentage'
} as const;

export type UpdatePromocodeRequestDtoDiscountTypeEnum = typeof UpdatePromocodeRequestDtoDiscountTypeEnum[keyof typeof UpdatePromocodeRequestDtoDiscountTypeEnum];

/**
 * 
 * @export
 * @interface UpdateSessionNoteRequestDto
 */
export interface UpdateSessionNoteRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSessionNoteRequestDto
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface UpdateTherapistMessageSuccessResponseDto
 */
export interface UpdateTherapistMessageSuccessResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTherapistMessageSuccessResponseDto
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface UpdateTherapyMethodRequestDto
 */
export interface UpdateTherapyMethodRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTherapyMethodRequestDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface UploadedMaterialResponseDto
 */
export interface UploadedMaterialResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UploadedMaterialResponseDto
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof UploadedMaterialResponseDto
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface UpsertGroupCallLinkRequestDto
 */
export interface UpsertGroupCallLinkRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertGroupCallLinkRequestDto
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertGroupCallLinkRequestDto
     */
    'companyId': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertGroupCallLinkRequestDto
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof UpsertGroupCallLinkRequestDto
     */
    'startsAt': string;
    /**
     *
     * @type {string}
     * @memberof UpsertGroupCallLinkRequestDto
     */
    'name'?: string | null;
    /**
     *
     * @type {string}
     * @memberof UpsertGroupCallLinkRequestDto
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface UserEmailDto
 */
export interface UserEmailDto {
    /**
     * 
     * @type {string}
     * @memberof UserEmailDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserEmailDto
     */
    'redirectUrl'?: string;
}
/**
 * 
 * @export
 * @interface UserEmailSignUpRequestDto
 */
export interface UserEmailSignUpRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UserEmailSignUpRequestDto
     */
    'redirectUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEmailSignUpRequestDto
     */
    'role': UserEmailSignUpRequestDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UserEmailSignUpRequestDto
     */
    'utmSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEmailSignUpRequestDto
     */
    'utmMedium'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEmailSignUpRequestDto
     */
    'utmCampaign'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserEmailSignUpRequestDto
     */
    'assignedDiscountType'?: UserEmailSignUpRequestDtoAssignedDiscountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UserEmailSignUpRequestDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserEmailSignUpRequestDto
     */
    'password': string;
}

export const UserEmailSignUpRequestDtoRoleEnum = {
    Patient: 'patient',
    Therapist: 'therapist',
    Company: 'company',
    B2bPatient: 'b2b_patient',
    Hr: 'hr'
} as const;

export type UserEmailSignUpRequestDtoRoleEnum = typeof UserEmailSignUpRequestDtoRoleEnum[keyof typeof UserEmailSignUpRequestDtoRoleEnum];
export const UserEmailSignUpRequestDtoAssignedDiscountTypeEnum = {
    Amount: 'amount',
    Percentage: 'percentage'
} as const;

export type UserEmailSignUpRequestDtoAssignedDiscountTypeEnum = typeof UserEmailSignUpRequestDtoAssignedDiscountTypeEnum[keyof typeof UserEmailSignUpRequestDtoAssignedDiscountTypeEnum];

/**
 * 
 * @export
 * @interface UserFileRequestDto
 */
export interface UserFileRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UserFileRequestDto
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof UserFileRequestDto
     */
    'key': string;
}
/**
 * 
 * @export
 * @interface UserFileResponseDto
 */
export interface UserFileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UserFileResponseDto
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof UserFileResponseDto
     */
    'key': string;
}
/**
 * 
 * @export
 * @interface UserMetadataResponseDto
 */
export interface UserMetadataResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponseDto
     */
    'therapistStatus'?: UserMetadataResponseDtoTherapistStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponseDto
     */
    'patientStatus'?: UserMetadataResponseDtoPatientStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UserMetadataResponseDto
     */
    'allowedRecommendedSearch'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponseDto
     */
    'integration'?: UserMetadataResponseDtoIntegrationEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UserMetadataResponseDto
     */
    'isVideoUploaded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserMetadataResponseDto
     */
    'hasSessions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserMetadataResponseDto
     */
    'isB2B'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponseDto
     */
    'companyType'?: UserMetadataResponseDtoCompanyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UserMetadataResponseDto
     */
    'companyId'?: string;
    /**
     * 
     * @type {TherapistFiltersResponseDto}
     * @memberof UserMetadataResponseDto
     */
    'therapistsFilters'?: TherapistFiltersResponseDto;
    /**
     * 
     * @type {boolean}
     * @memberof UserMetadataResponseDto
     */
    'hasPassword'?: boolean;
}

export const UserMetadataResponseDtoTherapistStatusEnum = {
    NotExists: 'not-exists',
    NotVerified: 'not-verified',
    Verified: 'verified'
} as const;

export type UserMetadataResponseDtoTherapistStatusEnum = typeof UserMetadataResponseDtoTherapistStatusEnum[keyof typeof UserMetadataResponseDtoTherapistStatusEnum];
export const UserMetadataResponseDtoPatientStatusEnum = {
    NotVerified: 'not-verified',
    Verified: 'verified'
} as const;

export type UserMetadataResponseDtoPatientStatusEnum = typeof UserMetadataResponseDtoPatientStatusEnum[keyof typeof UserMetadataResponseDtoPatientStatusEnum];
export const UserMetadataResponseDtoIntegrationEnum = {
    Medsi: 'medsi'
} as const;

export type UserMetadataResponseDtoIntegrationEnum = typeof UserMetadataResponseDtoIntegrationEnum[keyof typeof UserMetadataResponseDtoIntegrationEnum];
export const UserMetadataResponseDtoCompanyTypeEnum = {
    Promocode: 'promocode',
    Balance: 'balance'
} as const;

export type UserMetadataResponseDtoCompanyTypeEnum = typeof UserMetadataResponseDtoCompanyTypeEnum[keyof typeof UserMetadataResponseDtoCompanyTypeEnum];

/**
 * 
 * @export
 * @interface UserPhoneSignInRequestDto
 */
export interface UserPhoneSignInRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UserPhoneSignInRequestDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof UserPhoneSignInRequestDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface UserPhoneSignUpRequestDto
 */
export interface UserPhoneSignUpRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UserPhoneSignUpRequestDto
     */
    'redirectUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPhoneSignUpRequestDto
     */
    'role': UserPhoneSignUpRequestDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UserPhoneSignUpRequestDto
     */
    'utmSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPhoneSignUpRequestDto
     */
    'utmMedium'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPhoneSignUpRequestDto
     */
    'utmCampaign'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPhoneSignUpRequestDto
     */
    'assignedDiscountType'?: UserPhoneSignUpRequestDtoAssignedDiscountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UserPhoneSignUpRequestDto
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof UserPhoneSignUpRequestDto
     */
    'code': string;
}

export const UserPhoneSignUpRequestDtoRoleEnum = {
    Patient: 'patient',
    Therapist: 'therapist',
    Company: 'company',
    B2bPatient: 'b2b_patient',
    Hr: 'hr'
} as const;

export type UserPhoneSignUpRequestDtoRoleEnum = typeof UserPhoneSignUpRequestDtoRoleEnum[keyof typeof UserPhoneSignUpRequestDtoRoleEnum];
export const UserPhoneSignUpRequestDtoAssignedDiscountTypeEnum = {
    Amount: 'amount',
    Percentage: 'percentage'
} as const;

export type UserPhoneSignUpRequestDtoAssignedDiscountTypeEnum = typeof UserPhoneSignUpRequestDtoAssignedDiscountTypeEnum[keyof typeof UserPhoneSignUpRequestDtoAssignedDiscountTypeEnum];

/**
 * 
 * @export
 * @interface UserResponseDto
 */
export interface UserResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'firstname'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'lastname'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'role': UserResponseDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'gender': UserResponseDtoGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'avatarKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'miniAvatarKey'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponseDto
     */
    'isEmailConfirmed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponseDto
     */
    'isPhoneConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'notificationBeforeTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'paymentMethodId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'utmSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'utmMedium'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    'utmCampaign'?: string;
}

export const UserResponseDtoRoleEnum = {
    Patient: 'patient',
    Therapist: 'therapist',
    Company: 'company',
    B2bPatient: 'b2b_patient',
    Hr: 'hr'
} as const;

export type UserResponseDtoRoleEnum = typeof UserResponseDtoRoleEnum[keyof typeof UserResponseDtoRoleEnum];
export const UserResponseDtoGenderEnum = {
    Male: 'male',
    Female: 'female',
    Transgender: 'transgender',
    Unknown: 'unknown'
} as const;

export type UserResponseDtoGenderEnum = typeof UserResponseDtoGenderEnum[keyof typeof UserResponseDtoGenderEnum];

/**
 * 
 * @export
 * @interface UserSignInDto
 */
export interface UserSignInDto {
    /**
     * 
     * @type {string}
     * @memberof UserSignInDto
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSignInDto
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSignInDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface UserStatisticsDto
 */
export interface UserStatisticsDto {
    /**
     * 
     * @type {string}
     * @memberof UserStatisticsDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserStatisticsDto
     */
    'firstname': string;
    /**
     * 
     * @type {string}
     * @memberof UserStatisticsDto
     */
    'lastname': string;
    /**
     * 
     * @type {string}
     * @memberof UserStatisticsDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserStatisticsDto
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface UserWithMetadataResponseDto
 */
export interface UserWithMetadataResponseDto {
    /**
     * 
     * @type {UserResponseDto}
     * @memberof UserWithMetadataResponseDto
     */
    'user': UserResponseDto;
    /**
     * 
     * @type {UserMetadataResponseDto}
     * @memberof UserWithMetadataResponseDto
     */
    'metadata': UserMetadataResponseDto;
}
/**
 * 
 * @export
 * @interface UserWithTokenAndMetadataResponseDto
 */
export interface UserWithTokenAndMetadataResponseDto {
    /**
     * 
     * @type {UserResponseDto}
     * @memberof UserWithTokenAndMetadataResponseDto
     */
    'user': UserResponseDto;
    /**
     * 
     * @type {string}
     * @memberof UserWithTokenAndMetadataResponseDto
     */
    'accessToken': string;
    /**
     * 
     * @type {UserMetadataResponseDto}
     * @memberof UserWithTokenAndMetadataResponseDto
     */
    'metadata': UserMetadataResponseDto;
}
/**
 * 
 * @export
 * @interface UserWithTokenResponseDto
 */
export interface UserWithTokenResponseDto {
    /**
     * 
     * @type {UserResponseDto}
     * @memberof UserWithTokenResponseDto
     */
    'user': UserResponseDto;
    /**
     * 
     * @type {string}
     * @memberof UserWithTokenResponseDto
     */
    'accessToken': string;
}
/**
 * 
 * @export
 * @interface ValidateMedsiTokenResponse
 */
export interface ValidateMedsiTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof ValidateMedsiTokenResponse
     */
    'action': ValidateMedsiTokenResponseActionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateMedsiTokenResponse
     */
    'isPhoneTaken': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateMedsiTokenResponse
     */
    'isIntegrationExists': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ValidateMedsiTokenResponse
     */
    'isRequiredRecover': boolean;
}

export const ValidateMedsiTokenResponseActionEnum = {
    SignUp: 'sign_up',
    SignIn: 'sign_in',
    Recover: 'recover',
    Skip: 'skip'
} as const;

export type ValidateMedsiTokenResponseActionEnum = typeof ValidateMedsiTokenResponseActionEnum[keyof typeof ValidateMedsiTokenResponseActionEnum];


/**
 * AdminB2BApi - axios parameter creator
 * @export
 */
export const AdminB2BApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add patients to company
         * @param {string} companyId 
         * @param {AddCompanyPatientsRequestDto} addCompanyPatientsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerAddCompanyPatients: async (companyId: string, addCompanyPatientsRequestDto: AddCompanyPatientsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BControllerAddCompanyPatients', 'companyId', companyId)
            // verify required parameter 'addCompanyPatientsRequestDto' is not null or undefined
            assertParamExists('adminB2BControllerAddCompanyPatients', 'addCompanyPatientsRequestDto', addCompanyPatientsRequestDto)
            const localVarPath = `/api/v1/admin/b2b/companies/{companyId}/patients`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCompanyPatientsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add promocodes to company
         * @param {string} companyId 
         * @param {AddPromocodesToCompany} addPromocodesToCompany 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerAddPromocodesToCompany: async (companyId: string, addPromocodesToCompany: AddPromocodesToCompany, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BControllerAddPromocodesToCompany', 'companyId', companyId)
            // verify required parameter 'addPromocodesToCompany' is not null or undefined
            assertParamExists('adminB2BControllerAddPromocodesToCompany', 'addPromocodesToCompany', addPromocodesToCompany)
            const localVarPath = `/api/v1/admin/b2b/companies/{companyId}/promocodes`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPromocodesToCompany, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerArchiveCompany: async (companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BControllerArchiveCompany', 'companyId', companyId)
            const localVarPath = `/api/v1/admin/b2b/companies/{companyId}/archive`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create company
         * @param {CreateCompanyRequestDto} createCompanyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerCreateCompany: async (createCompanyRequestDto: CreateCompanyRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCompanyRequestDto' is not null or undefined
            assertParamExists('adminB2BControllerCreateCompany', 'createCompanyRequestDto', createCompanyRequestDto)
            const localVarPath = `/api/v1/admin/b2b/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get companies
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'name'} [orderTerms] 
         * @param {boolean} [isArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanies: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'name', isArchived?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanies', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanies', 'page', page)
            const localVarPath = `/api/v1/admin/b2b/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['isArchived'] = isArchived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanyById', 'id', id)
            const localVarPath = `/api/v1/admin/b2b/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company create requests
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyCreateRequests: async (limit: number, page: number, order?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanyCreateRequests', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanyCreateRequests', 'page', page)
            const localVarPath = `/api/v1/admin/b2b/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company\'s groups
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyGroups: async (companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanyGroups', 'companyId', companyId)
            const localVarPath = `/api/v1/admin/b2b/companies/{companyId}/groups`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company patient
         * @param {string} companyId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyPatient: async (companyId: string, patientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanyPatient', 'companyId', companyId)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanyPatient', 'patientId', patientId)
            const localVarPath = `/api/v1/admin/b2b/companies/{companyId}/patients/{patientId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company patients
         * @param {string} companyId 
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting'} [orderTerms] 
         * @param {string} [email] 
         * @param {string} [search] 
         * @param {boolean} [isAuthorized] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyPatients: async (companyId: string, limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting', email?: string, search?: string, isAuthorized?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanyPatients', 'companyId', companyId)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanyPatients', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanyPatients', 'page', page)
            const localVarPath = `/api/v1/admin/b2b/companies/{companyId}/patients`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (isAuthorized !== undefined) {
                localVarQueryParameter['isAuthorized'] = isAuthorized;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company\'s promocodes
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyPromocodes: async (companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanyPromocodes', 'companyId', companyId)
            const localVarPath = `/api/v1/admin/b2b/companies/{companyId}/promocodes`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company\'s roles
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyRoles: async (companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanyRoles', 'companyId', companyId)
            const localVarPath = `/api/v1/admin/b2b/companies/{companyId}/roles`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company\'s statistics
         * @param {string} companyId 
         * @param {string} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyStatistics: async (companyId: string, year: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanyStatistics', 'companyId', companyId)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('adminB2BControllerGetCompanyStatistics', 'year', year)
            const localVarPath = `/api/v1/admin/b2b/companies/{companyId}/statistics`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get B2B sessions
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [therapistId] 
         * @param {'awaiting' | 'live' | 'complete' | 'canceled'} [status] 
         * @param {string} [patientId] 
         * @param {'createdAt'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetSessions: async (limit: number, page: number, order?: 'ASC' | 'DESC', therapistId?: string, status?: 'awaiting' | 'live' | 'complete' | 'canceled', patientId?: string, orderTerms?: 'createdAt', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminB2BControllerGetSessions', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminB2BControllerGetSessions', 'page', page)
            const localVarPath = `/api/v1/admin/b2b/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (therapistId !== undefined) {
                localVarQueryParameter['therapistId'] = therapistId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Тестирование отправки B2B писем (публичный endpoint)
         * @param {TestB2bEmailRequestDto} testB2bEmailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerTestB2bEmail: async (testB2bEmailRequestDto: TestB2bEmailRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testB2bEmailRequestDto' is not null or undefined
            assertParamExists('adminB2BControllerTestB2bEmail', 'testB2bEmailRequestDto', testB2bEmailRequestDto)
            const localVarPath = `/api/v1/admin/b2b/test-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testB2bEmailRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unarchive company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerUnarchiveCompany: async (companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BControllerUnarchiveCompany', 'companyId', companyId)
            const localVarPath = `/api/v1/admin/b2b/companies/{companyId}/unarchive`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update company
         * @param {string} companyId 
         * @param {UpdateCompanyRequestDto} updateCompanyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerUpdateCompany: async (companyId: string, updateCompanyRequestDto: UpdateCompanyRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BControllerUpdateCompany', 'companyId', companyId)
            // verify required parameter 'updateCompanyRequestDto' is not null or undefined
            assertParamExists('adminB2BControllerUpdateCompany', 'updateCompanyRequestDto', updateCompanyRequestDto)
            const localVarPath = `/api/v1/admin/b2b/companies/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompanyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company patient balance list
         * @param {string} patientId 
         * @param {string} companyId 
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'startWith' | 'endWith'} [orderTerms] Сортировать по
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BStatsControllerGetCompanyPatientBalance: async (patientId: string, companyId: string, limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startWith' | 'endWith', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('adminB2BStatsControllerGetCompanyPatientBalance', 'patientId', patientId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BStatsControllerGetCompanyPatientBalance', 'companyId', companyId)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminB2BStatsControllerGetCompanyPatientBalance', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminB2BStatsControllerGetCompanyPatientBalance', 'page', page)
            const localVarPath = `/api/v1/admin/b2b/companies/{companyId}/patients/{patientId}/balance/list`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company patient balance stats
         * @param {string} patientId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BStatsControllerGetCompanyPatientBalanceStats: async (patientId: string, companyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('adminB2BStatsControllerGetCompanyPatientBalanceStats', 'patientId', patientId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BStatsControllerGetCompanyPatientBalanceStats', 'companyId', companyId)
            const localVarPath = `/api/v1/admin/b2b/companies/{companyId}/patients/{patientId}/balance/stats`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary B2B session statistics export
         * @param {string} companyId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BStatsControllerGetSessionsStats: async (companyId: string, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BStatsControllerGetSessionsStats', 'companyId', companyId)
            const localVarPath = `/api/v1/admin/b2b/stats/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary B2B statistics
         * @param {string} companyId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BStatsControllerGetStats: async (companyId: string, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('adminB2BStatsControllerGetStats', 'companyId', companyId)
            const localVarPath = `/api/v1/admin/b2b/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminB2BApi - functional programming interface
 * @export
 */
export const AdminB2BApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminB2BApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add patients to company
         * @param {string} companyId 
         * @param {AddCompanyPatientsRequestDto} addCompanyPatientsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerAddCompanyPatients(companyId: string, addCompanyPatientsRequestDto: AddCompanyPatientsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerAddCompanyPatients(companyId, addCompanyPatientsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add promocodes to company
         * @param {string} companyId 
         * @param {AddPromocodesToCompany} addPromocodesToCompany 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerAddPromocodesToCompany(companyId: string, addPromocodesToCompany: AddPromocodesToCompany, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerAddPromocodesToCompany(companyId, addPromocodesToCompany, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Archive company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerArchiveCompany(companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerArchiveCompany(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create company
         * @param {CreateCompanyRequestDto} createCompanyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerCreateCompany(createCompanyRequestDto: CreateCompanyRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerCreateCompany(createCompanyRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get companies
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'name'} [orderTerms] 
         * @param {boolean} [isArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerGetCompanies(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'name', isArchived?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPaginatedCompaniesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerGetCompanies(limit, page, order, orderTerms, isArchived, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get company by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerGetCompanyById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCompanyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerGetCompanyById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get company create requests
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerGetCompanyCreateRequests(limit: number, page: number, order?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPaginatedCompanyCreateRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerGetCompanyCreateRequests(limit, page, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get company\'s groups
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerGetCompanyGroups(companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCompanyGroupsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerGetCompanyGroups(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get company patient
         * @param {string} companyId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerGetCompanyPatient(companyId: string, patientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminB2BPatientResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerGetCompanyPatient(companyId, patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get company patients
         * @param {string} companyId 
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting'} [orderTerms] 
         * @param {string} [email] 
         * @param {string} [search] 
         * @param {boolean} [isAuthorized] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerGetCompanyPatients(companyId: string, limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting', email?: string, search?: string, isAuthorized?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminB2BPaginatedPatientsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerGetCompanyPatients(companyId, limit, page, order, orderTerms, email, search, isAuthorized, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get company\'s promocodes
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerGetCompanyPromocodes(companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPromocodesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerGetCompanyPromocodes(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get company\'s roles
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerGetCompanyRoles(companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCompanyRolesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerGetCompanyRoles(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get company\'s statistics
         * @param {string} companyId 
         * @param {string} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerGetCompanyStatistics(companyId: string, year: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatisticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerGetCompanyStatistics(companyId, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get B2B sessions
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [therapistId] 
         * @param {'awaiting' | 'live' | 'complete' | 'canceled'} [status] 
         * @param {string} [patientId] 
         * @param {'createdAt'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerGetSessions(limit: number, page: number, order?: 'ASC' | 'DESC', therapistId?: string, status?: 'awaiting' | 'live' | 'complete' | 'canceled', patientId?: string, orderTerms?: 'createdAt', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPaginatedB2BSessionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerGetSessions(limit, page, order, therapistId, status, patientId, orderTerms, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Тестирование отправки B2B писем (публичный endpoint)
         * @param {TestB2bEmailRequestDto} testB2bEmailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerTestB2bEmail(testB2bEmailRequestDto: TestB2bEmailRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerTestB2bEmail(testB2bEmailRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unarchive company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerUnarchiveCompany(companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerUnarchiveCompany(companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update company
         * @param {string} companyId 
         * @param {UpdateCompanyRequestDto} updateCompanyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BControllerUpdateCompany(companyId: string, updateCompanyRequestDto: UpdateCompanyRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BControllerUpdateCompany(companyId, updateCompanyRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get company patient balance list
         * @param {string} patientId 
         * @param {string} companyId 
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'startWith' | 'endWith'} [orderTerms] Сортировать по
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BStatsControllerGetCompanyPatientBalance(patientId: string, companyId: string, limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startWith' | 'endWith', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSessionBalancePaginatedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BStatsControllerGetCompanyPatientBalance(patientId, companyId, limit, page, order, orderTerms, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get company patient balance stats
         * @param {string} patientId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BStatsControllerGetCompanyPatientBalanceStats(patientId: string, companyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSessionBalanceUsageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BStatsControllerGetCompanyPatientBalanceStats(patientId, companyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary B2B session statistics export
         * @param {string} companyId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BStatsControllerGetSessionsStats(companyId: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BStatsControllerGetSessionsStats(companyId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary B2B statistics
         * @param {string} companyId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BStatsControllerGetStats(companyId: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BStatsControllerGetStats(companyId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminB2BApi - factory interface
 * @export
 */
export const AdminB2BApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminB2BApiFp(configuration)
    return {
        /**
         * 
         * @summary Add patients to company
         * @param {string} companyId 
         * @param {AddCompanyPatientsRequestDto} addCompanyPatientsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerAddCompanyPatients(companyId: string, addCompanyPatientsRequestDto: AddCompanyPatientsRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminB2BControllerAddCompanyPatients(companyId, addCompanyPatientsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add promocodes to company
         * @param {string} companyId 
         * @param {AddPromocodesToCompany} addPromocodesToCompany 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerAddPromocodesToCompany(companyId: string, addPromocodesToCompany: AddPromocodesToCompany, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminB2BControllerAddPromocodesToCompany(companyId, addPromocodesToCompany, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerArchiveCompany(companyId: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminB2BControllerArchiveCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create company
         * @param {CreateCompanyRequestDto} createCompanyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerCreateCompany(createCompanyRequestDto: CreateCompanyRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminB2BControllerCreateCompany(createCompanyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get companies
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'name'} [orderTerms] 
         * @param {boolean} [isArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanies(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'name', isArchived?: boolean, options?: any): AxiosPromise<AdminPaginatedCompaniesResponseDto> {
            return localVarFp.adminB2BControllerGetCompanies(limit, page, order, orderTerms, isArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get company by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyById(id: string, options?: any): AxiosPromise<AdminCompanyResponseDto> {
            return localVarFp.adminB2BControllerGetCompanyById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get company create requests
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyCreateRequests(limit: number, page: number, order?: 'ASC' | 'DESC', options?: any): AxiosPromise<AdminPaginatedCompanyCreateRequestResponseDto> {
            return localVarFp.adminB2BControllerGetCompanyCreateRequests(limit, page, order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get company\'s groups
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyGroups(companyId: string, options?: any): AxiosPromise<AdminCompanyGroupsResponseDto> {
            return localVarFp.adminB2BControllerGetCompanyGroups(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get company patient
         * @param {string} companyId 
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyPatient(companyId: string, patientId: string, options?: any): AxiosPromise<AdminB2BPatientResponseDto> {
            return localVarFp.adminB2BControllerGetCompanyPatient(companyId, patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get company patients
         * @param {string} companyId 
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting'} [orderTerms] 
         * @param {string} [email] 
         * @param {string} [search] 
         * @param {boolean} [isAuthorized] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyPatients(companyId: string, limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting', email?: string, search?: string, isAuthorized?: boolean, options?: any): AxiosPromise<AdminB2BPaginatedPatientsResponseDto> {
            return localVarFp.adminB2BControllerGetCompanyPatients(companyId, limit, page, order, orderTerms, email, search, isAuthorized, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get company\'s promocodes
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyPromocodes(companyId: string, options?: any): AxiosPromise<GetPromocodesResponseDto> {
            return localVarFp.adminB2BControllerGetCompanyPromocodes(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get company\'s roles
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyRoles(companyId: string, options?: any): AxiosPromise<AdminCompanyRolesResponseDto> {
            return localVarFp.adminB2BControllerGetCompanyRoles(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get company\'s statistics
         * @param {string} companyId 
         * @param {string} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetCompanyStatistics(companyId: string, year: string, options?: any): AxiosPromise<GetStatisticsResponseDto> {
            return localVarFp.adminB2BControllerGetCompanyStatistics(companyId, year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get B2B sessions
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [therapistId] 
         * @param {'awaiting' | 'live' | 'complete' | 'canceled'} [status] 
         * @param {string} [patientId] 
         * @param {'createdAt'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerGetSessions(limit: number, page: number, order?: 'ASC' | 'DESC', therapistId?: string, status?: 'awaiting' | 'live' | 'complete' | 'canceled', patientId?: string, orderTerms?: 'createdAt', options?: any): AxiosPromise<AdminPaginatedB2BSessionsResponseDto> {
            return localVarFp.adminB2BControllerGetSessions(limit, page, order, therapistId, status, patientId, orderTerms, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Тестирование отправки B2B писем (публичный endpoint)
         * @param {TestB2bEmailRequestDto} testB2bEmailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerTestB2bEmail(testB2bEmailRequestDto: TestB2bEmailRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminB2BControllerTestB2bEmail(testB2bEmailRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unarchive company
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerUnarchiveCompany(companyId: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminB2BControllerUnarchiveCompany(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update company
         * @param {string} companyId 
         * @param {UpdateCompanyRequestDto} updateCompanyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BControllerUpdateCompany(companyId: string, updateCompanyRequestDto: UpdateCompanyRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminB2BControllerUpdateCompany(companyId, updateCompanyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get company patient balance list
         * @param {string} patientId 
         * @param {string} companyId 
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'startWith' | 'endWith'} [orderTerms] Сортировать по
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BStatsControllerGetCompanyPatientBalance(patientId: string, companyId: string, limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startWith' | 'endWith', options?: any): AxiosPromise<AdminSessionBalancePaginatedResponseDto> {
            return localVarFp.adminB2BStatsControllerGetCompanyPatientBalance(patientId, companyId, limit, page, order, orderTerms, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get company patient balance stats
         * @param {string} patientId 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BStatsControllerGetCompanyPatientBalanceStats(patientId: string, companyId: string, options?: any): AxiosPromise<AdminSessionBalanceUsageResponseDto> {
            return localVarFp.adminB2BStatsControllerGetCompanyPatientBalanceStats(patientId, companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary B2B session statistics export
         * @param {string} companyId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BStatsControllerGetSessionsStats(companyId: string, startDate?: string, endDate?: string, options?: any): AxiosPromise<File> {
            return localVarFp.adminB2BStatsControllerGetSessionsStats(companyId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary B2B statistics
         * @param {string} companyId 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BStatsControllerGetStats(companyId: string, startDate?: string, endDate?: string, options?: any): AxiosPromise<File> {
            return localVarFp.adminB2BStatsControllerGetStats(companyId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminB2BApi - object-oriented interface
 * @export
 * @class AdminB2BApi
 * @extends {BaseAPI}
 */
export class AdminB2BApi extends BaseAPI {
    /**
     * 
     * @summary Add patients to company
     * @param {string} companyId 
     * @param {AddCompanyPatientsRequestDto} addCompanyPatientsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerAddCompanyPatients(companyId: string, addCompanyPatientsRequestDto: AddCompanyPatientsRequestDto, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerAddCompanyPatients(companyId, addCompanyPatientsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add promocodes to company
     * @param {string} companyId 
     * @param {AddPromocodesToCompany} addPromocodesToCompany 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerAddPromocodesToCompany(companyId: string, addPromocodesToCompany: AddPromocodesToCompany, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerAddPromocodesToCompany(companyId, addPromocodesToCompany, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive company
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerArchiveCompany(companyId: string, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerArchiveCompany(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create company
     * @param {CreateCompanyRequestDto} createCompanyRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerCreateCompany(createCompanyRequestDto: CreateCompanyRequestDto, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerCreateCompany(createCompanyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get companies
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'createdAt' | 'name'} [orderTerms] 
     * @param {boolean} [isArchived] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerGetCompanies(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'name', isArchived?: boolean, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerGetCompanies(limit, page, order, orderTerms, isArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get company by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerGetCompanyById(id: string, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerGetCompanyById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get company create requests
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerGetCompanyCreateRequests(limit: number, page: number, order?: 'ASC' | 'DESC', options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerGetCompanyCreateRequests(limit, page, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get company\'s groups
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerGetCompanyGroups(companyId: string, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerGetCompanyGroups(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get company patient
     * @param {string} companyId 
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerGetCompanyPatient(companyId: string, patientId: string, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerGetCompanyPatient(companyId, patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get company patients
     * @param {string} companyId 
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting'} [orderTerms] 
     * @param {string} [email] 
     * @param {string} [search] 
     * @param {boolean} [isAuthorized] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerGetCompanyPatients(companyId: string, limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting', email?: string, search?: string, isAuthorized?: boolean, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerGetCompanyPatients(companyId, limit, page, order, orderTerms, email, search, isAuthorized, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get company\'s promocodes
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerGetCompanyPromocodes(companyId: string, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerGetCompanyPromocodes(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get company\'s roles
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerGetCompanyRoles(companyId: string, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerGetCompanyRoles(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get company\'s statistics
     * @param {string} companyId 
     * @param {string} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerGetCompanyStatistics(companyId: string, year: string, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerGetCompanyStatistics(companyId, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get B2B sessions
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {string} [therapistId] 
     * @param {'awaiting' | 'live' | 'complete' | 'canceled'} [status] 
     * @param {string} [patientId] 
     * @param {'createdAt'} [orderTerms] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerGetSessions(limit: number, page: number, order?: 'ASC' | 'DESC', therapistId?: string, status?: 'awaiting' | 'live' | 'complete' | 'canceled', patientId?: string, orderTerms?: 'createdAt', options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerGetSessions(limit, page, order, therapistId, status, patientId, orderTerms, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Тестирование отправки B2B писем (публичный endpoint)
     * @param {TestB2bEmailRequestDto} testB2bEmailRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerTestB2bEmail(testB2bEmailRequestDto: TestB2bEmailRequestDto, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerTestB2bEmail(testB2bEmailRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unarchive company
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerUnarchiveCompany(companyId: string, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerUnarchiveCompany(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update company
     * @param {string} companyId 
     * @param {UpdateCompanyRequestDto} updateCompanyRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BControllerUpdateCompany(companyId: string, updateCompanyRequestDto: UpdateCompanyRequestDto, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BControllerUpdateCompany(companyId, updateCompanyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get company patient balance list
     * @param {string} patientId 
     * @param {string} companyId 
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'createdAt' | 'startWith' | 'endWith'} [orderTerms] Сортировать по
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BStatsControllerGetCompanyPatientBalance(patientId: string, companyId: string, limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startWith' | 'endWith', options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BStatsControllerGetCompanyPatientBalance(patientId, companyId, limit, page, order, orderTerms, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get company patient balance stats
     * @param {string} patientId 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BStatsControllerGetCompanyPatientBalanceStats(patientId: string, companyId: string, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BStatsControllerGetCompanyPatientBalanceStats(patientId, companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary B2B session statistics export
     * @param {string} companyId 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BStatsControllerGetSessionsStats(companyId: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BStatsControllerGetSessionsStats(companyId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary B2B statistics
     * @param {string} companyId 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BApi
     */
    public adminB2BStatsControllerGetStats(companyId: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig) {
        return AdminB2BApiFp(this.configuration).adminB2BStatsControllerGetStats(companyId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminB2BMaterialsApi - axios parameter creator
 * @export
 */
export const AdminB2BMaterialsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Удалить B2B материал
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BMaterialsControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminB2BMaterialsControllerDelete', 'id', id)
            const localVarPath = `/api/v1/admin/b2b-materials/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить список B2B материалов
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BMaterialsControllerGetList: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/b2b-materials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать/обновить B2B материал
         * @param {AdminUpsertB2BMaterialRequestDto} adminUpsertB2BMaterialRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BMaterialsControllerUpsert: async (adminUpsertB2BMaterialRequestDto: AdminUpsertB2BMaterialRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUpsertB2BMaterialRequestDto' is not null or undefined
            assertParamExists('adminB2BMaterialsControllerUpsert', 'adminUpsertB2BMaterialRequestDto', adminUpsertB2BMaterialRequestDto)
            const localVarPath = `/api/v1/admin/b2b-materials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpsertB2BMaterialRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminB2BMaterialsApi - functional programming interface
 * @export
 */
export const AdminB2BMaterialsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminB2BMaterialsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Удалить B2B материал
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BMaterialsControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BMaterialsControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Получить список B2B материалов
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BMaterialsControllerGetList(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPaginatedB2BMaterialsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BMaterialsControllerGetList(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Создать/обновить B2B материал
         * @param {AdminUpsertB2BMaterialRequestDto} adminUpsertB2BMaterialRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminB2BMaterialsControllerUpsert(adminUpsertB2BMaterialRequestDto: AdminUpsertB2BMaterialRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminB2BMaterialResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminB2BMaterialsControllerUpsert(adminUpsertB2BMaterialRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminB2BMaterialsApi - factory interface
 * @export
 */
export const AdminB2BMaterialsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminB2BMaterialsApiFp(configuration)
    return {
        /**
         * 
         * @summary Удалить B2B материал
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BMaterialsControllerDelete(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminB2BMaterialsControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить список B2B материалов
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BMaterialsControllerGetList(page?: number, limit?: number, options?: any): AxiosPromise<AdminPaginatedB2BMaterialsResponseDto> {
            return localVarFp.adminB2BMaterialsControllerGetList(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать/обновить B2B материал
         * @param {AdminUpsertB2BMaterialRequestDto} adminUpsertB2BMaterialRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminB2BMaterialsControllerUpsert(adminUpsertB2BMaterialRequestDto: AdminUpsertB2BMaterialRequestDto, options?: any): AxiosPromise<AdminB2BMaterialResponseDto> {
            return localVarFp.adminB2BMaterialsControllerUpsert(adminUpsertB2BMaterialRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminB2BMaterialsApi - object-oriented interface
 * @export
 * @class AdminB2BMaterialsApi
 * @extends {BaseAPI}
 */
export class AdminB2BMaterialsApi extends BaseAPI {
    /**
     * 
     * @summary Удалить B2B материал
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BMaterialsApi
     */
    public adminB2BMaterialsControllerDelete(id: string, options?: AxiosRequestConfig) {
        return AdminB2BMaterialsApiFp(this.configuration).adminB2BMaterialsControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить список B2B материалов
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BMaterialsApi
     */
    public adminB2BMaterialsControllerGetList(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return AdminB2BMaterialsApiFp(this.configuration).adminB2BMaterialsControllerGetList(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать/обновить B2B материал
     * @param {AdminUpsertB2BMaterialRequestDto} adminUpsertB2BMaterialRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminB2BMaterialsApi
     */
    public adminB2BMaterialsControllerUpsert(adminUpsertB2BMaterialRequestDto: AdminUpsertB2BMaterialRequestDto, options?: AxiosRequestConfig) {
        return AdminB2BMaterialsApiFp(this.configuration).adminB2BMaterialsControllerUpsert(adminUpsertB2BMaterialRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminContentApi - axios parameter creator
 * @export
 */
export const AdminContentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Удалить контент
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContentControllerDelete', 'id', id)
            const localVarPath = `/api/v1/admin/content/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить список контента
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [folderId] 
         * @param {string} [courseId] 
         * @param {'active' | 'archived' | 'all'} [archiveFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentControllerGetList: async (page?: number, limit?: number, folderId?: string, courseId?: string, archiveFilter?: 'active' | 'archived' | 'all', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/content`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }

            if (archiveFilter !== undefined) {
                localVarQueryParameter['archiveFilter'] = archiveFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить порядок видео в папке
         * @param {AdminReorderContentsRequestDto} adminReorderContentsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentControllerReorder: async (adminReorderContentsRequestDto: AdminReorderContentsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminReorderContentsRequestDto' is not null or undefined
            assertParamExists('adminContentControllerReorder', 'adminReorderContentsRequestDto', adminReorderContentsRequestDto)
            const localVarPath = `/api/v1/admin/content/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminReorderContentsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать/обновить контент
         * @param {AdminUpsertContentRequestDto} adminUpsertContentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentControllerUpsert: async (adminUpsertContentRequestDto: AdminUpsertContentRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUpsertContentRequestDto' is not null or undefined
            assertParamExists('adminContentControllerUpsert', 'adminUpsertContentRequestDto', adminUpsertContentRequestDto)
            const localVarPath = `/api/v1/admin/content`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpsertContentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminContentApi - functional programming interface
 * @export
 */
export const AdminContentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminContentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Удалить контент
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContentControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContentControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Получить список контента
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [folderId] 
         * @param {string} [courseId] 
         * @param {'active' | 'archived' | 'all'} [archiveFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContentControllerGetList(page?: number, limit?: number, folderId?: string, courseId?: string, archiveFilter?: 'active' | 'archived' | 'all', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPaginatedContentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContentControllerGetList(page, limit, folderId, courseId, archiveFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Изменить порядок видео в папке
         * @param {AdminReorderContentsRequestDto} adminReorderContentsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContentControllerReorder(adminReorderContentsRequestDto: AdminReorderContentsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContentControllerReorder(adminReorderContentsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Создать/обновить контент
         * @param {AdminUpsertContentRequestDto} adminUpsertContentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContentControllerUpsert(adminUpsertContentRequestDto: AdminUpsertContentRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminContentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContentControllerUpsert(adminUpsertContentRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminContentApi - factory interface
 * @export
 */
export const AdminContentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminContentApiFp(configuration)
    return {
        /**
         * 
         * @summary Удалить контент
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentControllerDelete(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminContentControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить список контента
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [folderId] 
         * @param {string} [courseId] 
         * @param {'active' | 'archived' | 'all'} [archiveFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentControllerGetList(page?: number, limit?: number, folderId?: string, courseId?: string, archiveFilter?: 'active' | 'archived' | 'all', options?: any): AxiosPromise<AdminPaginatedContentsResponseDto> {
            return localVarFp.adminContentControllerGetList(page, limit, folderId, courseId, archiveFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить порядок видео в папке
         * @param {AdminReorderContentsRequestDto} adminReorderContentsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentControllerReorder(adminReorderContentsRequestDto: AdminReorderContentsRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminContentControllerReorder(adminReorderContentsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать/обновить контент
         * @param {AdminUpsertContentRequestDto} adminUpsertContentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentControllerUpsert(adminUpsertContentRequestDto: AdminUpsertContentRequestDto, options?: any): AxiosPromise<AdminContentResponseDto> {
            return localVarFp.adminContentControllerUpsert(adminUpsertContentRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminContentApi - object-oriented interface
 * @export
 * @class AdminContentApi
 * @extends {BaseAPI}
 */
export class AdminContentApi extends BaseAPI {
    /**
     * 
     * @summary Удалить контент
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContentApi
     */
    public adminContentControllerDelete(id: string, options?: AxiosRequestConfig) {
        return AdminContentApiFp(this.configuration).adminContentControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить список контента
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [folderId] 
     * @param {string} [courseId] 
     * @param {'active' | 'archived' | 'all'} [archiveFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContentApi
     */
    public adminContentControllerGetList(page?: number, limit?: number, folderId?: string, courseId?: string, archiveFilter?: 'active' | 'archived' | 'all', options?: AxiosRequestConfig) {
        return AdminContentApiFp(this.configuration).adminContentControllerGetList(page, limit, folderId, courseId, archiveFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить порядок видео в папке
     * @param {AdminReorderContentsRequestDto} adminReorderContentsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContentApi
     */
    public adminContentControllerReorder(adminReorderContentsRequestDto: AdminReorderContentsRequestDto, options?: AxiosRequestConfig) {
        return AdminContentApiFp(this.configuration).adminContentControllerReorder(adminReorderContentsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать/обновить контент
     * @param {AdminUpsertContentRequestDto} adminUpsertContentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContentApi
     */
    public adminContentControllerUpsert(adminUpsertContentRequestDto: AdminUpsertContentRequestDto, options?: AxiosRequestConfig) {
        return AdminContentApiFp(this.configuration).adminContentControllerUpsert(adminUpsertContentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminContentCoursesApi - axios parameter creator
 * @export
 */
export const AdminContentCoursesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Переместить курс в архив
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentCourseControllerArchive: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContentCourseControllerArchive', 'id', id)
            const localVarPath = `/api/v1/admin/content/courses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить курс с папками и видео
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentCourseControllerGetById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContentCourseControllerGetById', 'id', id)
            const localVarPath = `/api/v1/admin/content/courses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить список курсов
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [folderId] 
         * @param {string} [courseId] 
         * @param {'active' | 'archived' | 'all'} [archiveFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentCourseControllerGetList: async (page?: number, limit?: number, folderId?: string, courseId?: string, archiveFilter?: 'active' | 'archived' | 'all', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/content/courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }

            if (archiveFilter !== undefined) {
                localVarQueryParameter['archiveFilter'] = archiveFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить порядок курсов
         * @param {AdminReorderContentCoursesRequestDto} adminReorderContentCoursesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentCourseControllerReorder: async (adminReorderContentCoursesRequestDto: AdminReorderContentCoursesRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminReorderContentCoursesRequestDto' is not null or undefined
            assertParamExists('adminContentCourseControllerReorder', 'adminReorderContentCoursesRequestDto', adminReorderContentCoursesRequestDto)
            const localVarPath = `/api/v1/admin/content/courses/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminReorderContentCoursesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Восстановить курс из архива
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentCourseControllerRestore: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContentCourseControllerRestore', 'id', id)
            const localVarPath = `/api/v1/admin/content/courses/{id}/restore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать/обновить курс
         * @param {AdminUpsertContentCourseRequestDto} adminUpsertContentCourseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentCourseControllerUpsert: async (adminUpsertContentCourseRequestDto: AdminUpsertContentCourseRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUpsertContentCourseRequestDto' is not null or undefined
            assertParamExists('adminContentCourseControllerUpsert', 'adminUpsertContentCourseRequestDto', adminUpsertContentCourseRequestDto)
            const localVarPath = `/api/v1/admin/content/courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpsertContentCourseRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminContentCoursesApi - functional programming interface
 * @export
 */
export const AdminContentCoursesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminContentCoursesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Переместить курс в архив
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContentCourseControllerArchive(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContentCourseControllerArchive(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Получить курс с папками и видео
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContentCourseControllerGetById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminContentCourseWithFoldersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContentCourseControllerGetById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Получить список курсов
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [folderId] 
         * @param {string} [courseId] 
         * @param {'active' | 'archived' | 'all'} [archiveFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContentCourseControllerGetList(page?: number, limit?: number, folderId?: string, courseId?: string, archiveFilter?: 'active' | 'archived' | 'all', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPaginatedContentCoursesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContentCourseControllerGetList(page, limit, folderId, courseId, archiveFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Изменить порядок курсов
         * @param {AdminReorderContentCoursesRequestDto} adminReorderContentCoursesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContentCourseControllerReorder(adminReorderContentCoursesRequestDto: AdminReorderContentCoursesRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContentCourseControllerReorder(adminReorderContentCoursesRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Восстановить курс из архива
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContentCourseControllerRestore(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContentCourseControllerRestore(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Создать/обновить курс
         * @param {AdminUpsertContentCourseRequestDto} adminUpsertContentCourseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContentCourseControllerUpsert(adminUpsertContentCourseRequestDto: AdminUpsertContentCourseRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminContentCourseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContentCourseControllerUpsert(adminUpsertContentCourseRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminContentCoursesApi - factory interface
 * @export
 */
export const AdminContentCoursesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminContentCoursesApiFp(configuration)
    return {
        /**
         * 
         * @summary Переместить курс в архив
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentCourseControllerArchive(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminContentCourseControllerArchive(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить курс с папками и видео
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentCourseControllerGetById(id: string, options?: any): AxiosPromise<AdminContentCourseWithFoldersResponseDto> {
            return localVarFp.adminContentCourseControllerGetById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить список курсов
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [folderId] 
         * @param {string} [courseId] 
         * @param {'active' | 'archived' | 'all'} [archiveFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentCourseControllerGetList(page?: number, limit?: number, folderId?: string, courseId?: string, archiveFilter?: 'active' | 'archived' | 'all', options?: any): AxiosPromise<AdminPaginatedContentCoursesResponseDto> {
            return localVarFp.adminContentCourseControllerGetList(page, limit, folderId, courseId, archiveFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить порядок курсов
         * @param {AdminReorderContentCoursesRequestDto} adminReorderContentCoursesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentCourseControllerReorder(adminReorderContentCoursesRequestDto: AdminReorderContentCoursesRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminContentCourseControllerReorder(adminReorderContentCoursesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Восстановить курс из архива
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentCourseControllerRestore(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminContentCourseControllerRestore(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать/обновить курс
         * @param {AdminUpsertContentCourseRequestDto} adminUpsertContentCourseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentCourseControllerUpsert(adminUpsertContentCourseRequestDto: AdminUpsertContentCourseRequestDto, options?: any): AxiosPromise<AdminContentCourseResponseDto> {
            return localVarFp.adminContentCourseControllerUpsert(adminUpsertContentCourseRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminContentCoursesApi - object-oriented interface
 * @export
 * @class AdminContentCoursesApi
 * @extends {BaseAPI}
 */
export class AdminContentCoursesApi extends BaseAPI {
    /**
     * 
     * @summary Переместить курс в архив
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContentCoursesApi
     */
    public adminContentCourseControllerArchive(id: string, options?: AxiosRequestConfig) {
        return AdminContentCoursesApiFp(this.configuration).adminContentCourseControllerArchive(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить курс с папками и видео
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContentCoursesApi
     */
    public adminContentCourseControllerGetById(id: string, options?: AxiosRequestConfig) {
        return AdminContentCoursesApiFp(this.configuration).adminContentCourseControllerGetById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить список курсов
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [folderId] 
     * @param {string} [courseId] 
     * @param {'active' | 'archived' | 'all'} [archiveFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContentCoursesApi
     */
    public adminContentCourseControllerGetList(page?: number, limit?: number, folderId?: string, courseId?: string, archiveFilter?: 'active' | 'archived' | 'all', options?: AxiosRequestConfig) {
        return AdminContentCoursesApiFp(this.configuration).adminContentCourseControllerGetList(page, limit, folderId, courseId, archiveFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить порядок курсов
     * @param {AdminReorderContentCoursesRequestDto} adminReorderContentCoursesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContentCoursesApi
     */
    public adminContentCourseControllerReorder(adminReorderContentCoursesRequestDto: AdminReorderContentCoursesRequestDto, options?: AxiosRequestConfig) {
        return AdminContentCoursesApiFp(this.configuration).adminContentCourseControllerReorder(adminReorderContentCoursesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Восстановить курс из архива
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContentCoursesApi
     */
    public adminContentCourseControllerRestore(id: string, options?: AxiosRequestConfig) {
        return AdminContentCoursesApiFp(this.configuration).adminContentCourseControllerRestore(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать/обновить курс
     * @param {AdminUpsertContentCourseRequestDto} adminUpsertContentCourseRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContentCoursesApi
     */
    public adminContentCourseControllerUpsert(adminUpsertContentCourseRequestDto: AdminUpsertContentCourseRequestDto, options?: AxiosRequestConfig) {
        return AdminContentCoursesApiFp(this.configuration).adminContentCourseControllerUpsert(adminUpsertContentCourseRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminContentFoldersApi - axios parameter creator
 * @export
 */
export const AdminContentFoldersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Удалить папку
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentFolderControllerDelete: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContentFolderControllerDelete', 'id', id)
            const localVarPath = `/api/v1/admin/content/folders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить список папок с видео
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [folderId] 
         * @param {string} [courseId] 
         * @param {'active' | 'archived' | 'all'} [archiveFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentFolderControllerGetList: async (page?: number, limit?: number, folderId?: string, courseId?: string, archiveFilter?: 'active' | 'archived' | 'all', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/content/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (folderId !== undefined) {
                localVarQueryParameter['folderId'] = folderId;
            }

            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }

            if (archiveFilter !== undefined) {
                localVarQueryParameter['archiveFilter'] = archiveFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Изменить порядок папок
         * @param {AdminReorderContentFoldersRequestDto} adminReorderContentFoldersRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentFolderControllerReorder: async (adminReorderContentFoldersRequestDto: AdminReorderContentFoldersRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminReorderContentFoldersRequestDto' is not null or undefined
            assertParamExists('adminContentFolderControllerReorder', 'adminReorderContentFoldersRequestDto', adminReorderContentFoldersRequestDto)
            const localVarPath = `/api/v1/admin/content/folders/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminReorderContentFoldersRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать/обновить папку
         * @param {AdminUpsertContentFolderRequestDto} adminUpsertContentFolderRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentFolderControllerUpsert: async (adminUpsertContentFolderRequestDto: AdminUpsertContentFolderRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUpsertContentFolderRequestDto' is not null or undefined
            assertParamExists('adminContentFolderControllerUpsert', 'adminUpsertContentFolderRequestDto', adminUpsertContentFolderRequestDto)
            const localVarPath = `/api/v1/admin/content/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpsertContentFolderRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminContentFoldersApi - functional programming interface
 * @export
 */
export const AdminContentFoldersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminContentFoldersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Удалить папку
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContentFolderControllerDelete(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContentFolderControllerDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Получить список папок с видео
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [folderId] 
         * @param {string} [courseId] 
         * @param {'active' | 'archived' | 'all'} [archiveFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContentFolderControllerGetList(page?: number, limit?: number, folderId?: string, courseId?: string, archiveFilter?: 'active' | 'archived' | 'all', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPaginatedContentFoldersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContentFolderControllerGetList(page, limit, folderId, courseId, archiveFilter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Изменить порядок папок
         * @param {AdminReorderContentFoldersRequestDto} adminReorderContentFoldersRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContentFolderControllerReorder(adminReorderContentFoldersRequestDto: AdminReorderContentFoldersRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContentFolderControllerReorder(adminReorderContentFoldersRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Создать/обновить папку
         * @param {AdminUpsertContentFolderRequestDto} adminUpsertContentFolderRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminContentFolderControllerUpsert(adminUpsertContentFolderRequestDto: AdminUpsertContentFolderRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminContentFolderResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminContentFolderControllerUpsert(adminUpsertContentFolderRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminContentFoldersApi - factory interface
 * @export
 */
export const AdminContentFoldersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminContentFoldersApiFp(configuration)
    return {
        /**
         * 
         * @summary Удалить папку
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentFolderControllerDelete(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminContentFolderControllerDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить список папок с видео
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {string} [folderId] 
         * @param {string} [courseId] 
         * @param {'active' | 'archived' | 'all'} [archiveFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentFolderControllerGetList(page?: number, limit?: number, folderId?: string, courseId?: string, archiveFilter?: 'active' | 'archived' | 'all', options?: any): AxiosPromise<AdminPaginatedContentFoldersResponseDto> {
            return localVarFp.adminContentFolderControllerGetList(page, limit, folderId, courseId, archiveFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Изменить порядок папок
         * @param {AdminReorderContentFoldersRequestDto} adminReorderContentFoldersRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentFolderControllerReorder(adminReorderContentFoldersRequestDto: AdminReorderContentFoldersRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminContentFolderControllerReorder(adminReorderContentFoldersRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать/обновить папку
         * @param {AdminUpsertContentFolderRequestDto} adminUpsertContentFolderRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContentFolderControllerUpsert(adminUpsertContentFolderRequestDto: AdminUpsertContentFolderRequestDto, options?: any): AxiosPromise<AdminContentFolderResponseDto> {
            return localVarFp.adminContentFolderControllerUpsert(adminUpsertContentFolderRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminContentFoldersApi - object-oriented interface
 * @export
 * @class AdminContentFoldersApi
 * @extends {BaseAPI}
 */
export class AdminContentFoldersApi extends BaseAPI {
    /**
     * 
     * @summary Удалить папку
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContentFoldersApi
     */
    public adminContentFolderControllerDelete(id: string, options?: AxiosRequestConfig) {
        return AdminContentFoldersApiFp(this.configuration).adminContentFolderControllerDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить список папок с видео
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [folderId] 
     * @param {string} [courseId] 
     * @param {'active' | 'archived' | 'all'} [archiveFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContentFoldersApi
     */
    public adminContentFolderControllerGetList(page?: number, limit?: number, folderId?: string, courseId?: string, archiveFilter?: 'active' | 'archived' | 'all', options?: AxiosRequestConfig) {
        return AdminContentFoldersApiFp(this.configuration).adminContentFolderControllerGetList(page, limit, folderId, courseId, archiveFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Изменить порядок папок
     * @param {AdminReorderContentFoldersRequestDto} adminReorderContentFoldersRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContentFoldersApi
     */
    public adminContentFolderControllerReorder(adminReorderContentFoldersRequestDto: AdminReorderContentFoldersRequestDto, options?: AxiosRequestConfig) {
        return AdminContentFoldersApiFp(this.configuration).adminContentFolderControllerReorder(adminReorderContentFoldersRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать/обновить папку
     * @param {AdminUpsertContentFolderRequestDto} adminUpsertContentFolderRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContentFoldersApi
     */
    public adminContentFolderControllerUpsert(adminUpsertContentFolderRequestDto: AdminUpsertContentFolderRequestDto, options?: AxiosRequestConfig) {
        return AdminContentFoldersApiFp(this.configuration).adminContentFolderControllerUpsert(adminUpsertContentFolderRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminDiseasesAndTherapyMethodsApi - axios parameter creator
 * @export
 */
export const AdminDiseasesAndTherapyMethodsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add new disease
         * @summary Add new disease
         * @param {AddDiseaseRequestDto} addDiseaseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerAddDisease: async (addDiseaseRequestDto: AddDiseaseRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addDiseaseRequestDto' is not null or undefined
            assertParamExists('adminDiseasesControllerAddDisease', 'addDiseaseRequestDto', addDiseaseRequestDto)
            const localVarPath = `/api/v1/admin/diseases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDiseaseRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add new disease group
         * @summary Add new disease group
         * @param {AddDiseaseGroupRequestDto} addDiseaseGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerAddDiseaseGroup: async (addDiseaseGroupRequestDto: AddDiseaseGroupRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addDiseaseGroupRequestDto' is not null or undefined
            assertParamExists('adminDiseasesControllerAddDiseaseGroup', 'addDiseaseGroupRequestDto', addDiseaseGroupRequestDto)
            const localVarPath = `/api/v1/admin/diseases/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDiseaseGroupRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete disease by id
         * @summary Delete disease by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerDeleteDisease: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDiseasesControllerDeleteDisease', 'id', id)
            const localVarPath = `/api/v1/admin/diseases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete disease group with diseases by id
         * @summary Delete disease group with diseases by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerDeleteDiseaseGroup: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDiseasesControllerDeleteDiseaseGroup', 'id', id)
            const localVarPath = `/api/v1/admin/diseases/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get disease by id
         * @summary Get disease by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerGetDiseaseById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDiseasesControllerGetDiseaseById', 'id', id)
            const localVarPath = `/api/v1/admin/diseases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get disease group by id
         * @summary Get disease group by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerGetDiseaseGroupById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDiseasesControllerGetDiseaseGroupById', 'id', id)
            const localVarPath = `/api/v1/admin/diseases/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get disease groups with diseases
         * @summary Get disease groups with diseases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerGetDiseaseGroupsWithDiseases: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/diseases/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get diseases
         * @summary Get diseases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerGetDiseases: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/diseases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update disease by id
         * @summary Update disease by id
         * @param {string} id 
         * @param {UpdateDiseaseRequestDto} updateDiseaseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerUpdateDisease: async (id: string, updateDiseaseRequestDto: UpdateDiseaseRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDiseasesControllerUpdateDisease', 'id', id)
            // verify required parameter 'updateDiseaseRequestDto' is not null or undefined
            assertParamExists('adminDiseasesControllerUpdateDisease', 'updateDiseaseRequestDto', updateDiseaseRequestDto)
            const localVarPath = `/api/v1/admin/diseases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDiseaseRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update disease group by id
         * @summary Update disease group by id
         * @param {string} id 
         * @param {AddDiseaseGroupRequestDto} addDiseaseGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerUpdateDiseaseGroupById: async (id: string, addDiseaseGroupRequestDto: AddDiseaseGroupRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDiseasesControllerUpdateDiseaseGroupById', 'id', id)
            // verify required parameter 'addDiseaseGroupRequestDto' is not null or undefined
            assertParamExists('adminDiseasesControllerUpdateDiseaseGroupById', 'addDiseaseGroupRequestDto', addDiseaseGroupRequestDto)
            const localVarPath = `/api/v1/admin/diseases/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDiseaseGroupRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add new therapy method
         * @summary Add new therapy method
         * @param {AddTherapyMethodRequestDto} addTherapyMethodRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapyMethodsControllerAddTherapyMethod: async (addTherapyMethodRequestDto: AddTherapyMethodRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addTherapyMethodRequestDto' is not null or undefined
            assertParamExists('adminTherapyMethodsControllerAddTherapyMethod', 'addTherapyMethodRequestDto', addTherapyMethodRequestDto)
            const localVarPath = `/api/v1/admin/therapy_methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addTherapyMethodRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete therapy method by id
         * @summary Delete therapy method by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapyMethodsControllerDeleteTherapyMethod: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminTherapyMethodsControllerDeleteTherapyMethod', 'id', id)
            const localVarPath = `/api/v1/admin/therapy_methods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get therapy methods
         * @summary Get therapy methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapyMethodsControllerGetTherapyMethods: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/therapy_methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get therapy methods
         * @summary Get therapy methods
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapyMethodsControllerGetTherapyMethodsById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminTherapyMethodsControllerGetTherapyMethodsById', 'id', id)
            const localVarPath = `/api/v1/admin/therapy_methods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update therapy method by id
         * @summary Update therapy method by id
         * @param {string} id 
         * @param {UpdateTherapyMethodRequestDto} updateTherapyMethodRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapyMethodsControllerUpdateTherapyMethod: async (id: string, updateTherapyMethodRequestDto: UpdateTherapyMethodRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminTherapyMethodsControllerUpdateTherapyMethod', 'id', id)
            // verify required parameter 'updateTherapyMethodRequestDto' is not null or undefined
            assertParamExists('adminTherapyMethodsControllerUpdateTherapyMethod', 'updateTherapyMethodRequestDto', updateTherapyMethodRequestDto)
            const localVarPath = `/api/v1/admin/therapy_methods/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTherapyMethodRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDiseasesAndTherapyMethodsApi - functional programming interface
 * @export
 */
export const AdminDiseasesAndTherapyMethodsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDiseasesAndTherapyMethodsApiAxiosParamCreator(configuration)
    return {
        /**
         * Add new disease
         * @summary Add new disease
         * @param {AddDiseaseRequestDto} addDiseaseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDiseasesControllerAddDisease(addDiseaseRequestDto: AddDiseaseRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiseaseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDiseasesControllerAddDisease(addDiseaseRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add new disease group
         * @summary Add new disease group
         * @param {AddDiseaseGroupRequestDto} addDiseaseGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDiseasesControllerAddDiseaseGroup(addDiseaseGroupRequestDto: AddDiseaseGroupRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDiseaseGroupResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDiseasesControllerAddDiseaseGroup(addDiseaseGroupRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete disease by id
         * @summary Delete disease by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDiseasesControllerDeleteDisease(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDiseasesControllerDeleteDisease(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete disease group with diseases by id
         * @summary Delete disease group with diseases by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDiseasesControllerDeleteDiseaseGroup(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDiseasesControllerDeleteDiseaseGroup(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get disease by id
         * @summary Get disease by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDiseasesControllerGetDiseaseById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiseaseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDiseasesControllerGetDiseaseById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get disease group by id
         * @summary Get disease group by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDiseasesControllerGetDiseaseGroupById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDiseaseGroupResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDiseasesControllerGetDiseaseGroupById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get disease groups with diseases
         * @summary Get disease groups with diseases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDiseasesControllerGetDiseaseGroupsWithDiseases(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDiseaseGroupsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDiseasesControllerGetDiseaseGroupsWithDiseases(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get diseases
         * @summary Get diseases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDiseasesControllerGetDiseases(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDiseasesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDiseasesControllerGetDiseases(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update disease by id
         * @summary Update disease by id
         * @param {string} id 
         * @param {UpdateDiseaseRequestDto} updateDiseaseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDiseasesControllerUpdateDisease(id: string, updateDiseaseRequestDto: UpdateDiseaseRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiseaseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDiseasesControllerUpdateDisease(id, updateDiseaseRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update disease group by id
         * @summary Update disease group by id
         * @param {string} id 
         * @param {AddDiseaseGroupRequestDto} addDiseaseGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDiseasesControllerUpdateDiseaseGroupById(id: string, addDiseaseGroupRequestDto: AddDiseaseGroupRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiseaseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDiseasesControllerUpdateDiseaseGroupById(id, addDiseaseGroupRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add new therapy method
         * @summary Add new therapy method
         * @param {AddTherapyMethodRequestDto} addTherapyMethodRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapyMethodsControllerAddTherapyMethod(addTherapyMethodRequestDto: AddTherapyMethodRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapyMethodResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapyMethodsControllerAddTherapyMethod(addTherapyMethodRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete therapy method by id
         * @summary Delete therapy method by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapyMethodsControllerDeleteTherapyMethod(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapyMethodsControllerDeleteTherapyMethod(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get therapy methods
         * @summary Get therapy methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapyMethodsControllerGetTherapyMethods(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapyMethodsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapyMethodsControllerGetTherapyMethods(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get therapy methods
         * @summary Get therapy methods
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapyMethodsControllerGetTherapyMethodsById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapyMethodsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapyMethodsControllerGetTherapyMethodsById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update therapy method by id
         * @summary Update therapy method by id
         * @param {string} id 
         * @param {UpdateTherapyMethodRequestDto} updateTherapyMethodRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapyMethodsControllerUpdateTherapyMethod(id: string, updateTherapyMethodRequestDto: UpdateTherapyMethodRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapyMethodResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapyMethodsControllerUpdateTherapyMethod(id, updateTherapyMethodRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminDiseasesAndTherapyMethodsApi - factory interface
 * @export
 */
export const AdminDiseasesAndTherapyMethodsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDiseasesAndTherapyMethodsApiFp(configuration)
    return {
        /**
         * Add new disease
         * @summary Add new disease
         * @param {AddDiseaseRequestDto} addDiseaseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerAddDisease(addDiseaseRequestDto: AddDiseaseRequestDto, options?: any): AxiosPromise<DiseaseResponseDto> {
            return localVarFp.adminDiseasesControllerAddDisease(addDiseaseRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Add new disease group
         * @summary Add new disease group
         * @param {AddDiseaseGroupRequestDto} addDiseaseGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerAddDiseaseGroup(addDiseaseGroupRequestDto: AddDiseaseGroupRequestDto, options?: any): AxiosPromise<AdminDiseaseGroupResponseDto> {
            return localVarFp.adminDiseasesControllerAddDiseaseGroup(addDiseaseGroupRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete disease by id
         * @summary Delete disease by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerDeleteDisease(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminDiseasesControllerDeleteDisease(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete disease group with diseases by id
         * @summary Delete disease group with diseases by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerDeleteDiseaseGroup(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminDiseasesControllerDeleteDiseaseGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get disease by id
         * @summary Get disease by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerGetDiseaseById(id: string, options?: any): AxiosPromise<DiseaseResponseDto> {
            return localVarFp.adminDiseasesControllerGetDiseaseById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get disease group by id
         * @summary Get disease group by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerGetDiseaseGroupById(id: string, options?: any): AxiosPromise<AdminDiseaseGroupResponseDto> {
            return localVarFp.adminDiseasesControllerGetDiseaseGroupById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get disease groups with diseases
         * @summary Get disease groups with diseases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerGetDiseaseGroupsWithDiseases(options?: any): AxiosPromise<AdminDiseaseGroupsResponseDto> {
            return localVarFp.adminDiseasesControllerGetDiseaseGroupsWithDiseases(options).then((request) => request(axios, basePath));
        },
        /**
         * Get diseases
         * @summary Get diseases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerGetDiseases(options?: any): AxiosPromise<AdminDiseasesResponseDto> {
            return localVarFp.adminDiseasesControllerGetDiseases(options).then((request) => request(axios, basePath));
        },
        /**
         * Update disease by id
         * @summary Update disease by id
         * @param {string} id 
         * @param {UpdateDiseaseRequestDto} updateDiseaseRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerUpdateDisease(id: string, updateDiseaseRequestDto: UpdateDiseaseRequestDto, options?: any): AxiosPromise<DiseaseResponseDto> {
            return localVarFp.adminDiseasesControllerUpdateDisease(id, updateDiseaseRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update disease group by id
         * @summary Update disease group by id
         * @param {string} id 
         * @param {AddDiseaseGroupRequestDto} addDiseaseGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiseasesControllerUpdateDiseaseGroupById(id: string, addDiseaseGroupRequestDto: AddDiseaseGroupRequestDto, options?: any): AxiosPromise<DiseaseResponseDto> {
            return localVarFp.adminDiseasesControllerUpdateDiseaseGroupById(id, addDiseaseGroupRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Add new therapy method
         * @summary Add new therapy method
         * @param {AddTherapyMethodRequestDto} addTherapyMethodRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapyMethodsControllerAddTherapyMethod(addTherapyMethodRequestDto: AddTherapyMethodRequestDto, options?: any): AxiosPromise<TherapyMethodResponseDto> {
            return localVarFp.adminTherapyMethodsControllerAddTherapyMethod(addTherapyMethodRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete therapy method by id
         * @summary Delete therapy method by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapyMethodsControllerDeleteTherapyMethod(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapyMethodsControllerDeleteTherapyMethod(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get therapy methods
         * @summary Get therapy methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapyMethodsControllerGetTherapyMethods(options?: any): AxiosPromise<TherapyMethodsResponseDto> {
            return localVarFp.adminTherapyMethodsControllerGetTherapyMethods(options).then((request) => request(axios, basePath));
        },
        /**
         * Get therapy methods
         * @summary Get therapy methods
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapyMethodsControllerGetTherapyMethodsById(id: string, options?: any): AxiosPromise<TherapyMethodsResponseDto> {
            return localVarFp.adminTherapyMethodsControllerGetTherapyMethodsById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update therapy method by id
         * @summary Update therapy method by id
         * @param {string} id 
         * @param {UpdateTherapyMethodRequestDto} updateTherapyMethodRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapyMethodsControllerUpdateTherapyMethod(id: string, updateTherapyMethodRequestDto: UpdateTherapyMethodRequestDto, options?: any): AxiosPromise<TherapyMethodResponseDto> {
            return localVarFp.adminTherapyMethodsControllerUpdateTherapyMethod(id, updateTherapyMethodRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDiseasesAndTherapyMethodsApi - object-oriented interface
 * @export
 * @class AdminDiseasesAndTherapyMethodsApi
 * @extends {BaseAPI}
 */
export class AdminDiseasesAndTherapyMethodsApi extends BaseAPI {
    /**
     * Add new disease
     * @summary Add new disease
     * @param {AddDiseaseRequestDto} addDiseaseRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminDiseasesControllerAddDisease(addDiseaseRequestDto: AddDiseaseRequestDto, options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminDiseasesControllerAddDisease(addDiseaseRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add new disease group
     * @summary Add new disease group
     * @param {AddDiseaseGroupRequestDto} addDiseaseGroupRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminDiseasesControllerAddDiseaseGroup(addDiseaseGroupRequestDto: AddDiseaseGroupRequestDto, options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminDiseasesControllerAddDiseaseGroup(addDiseaseGroupRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete disease by id
     * @summary Delete disease by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminDiseasesControllerDeleteDisease(id: string, options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminDiseasesControllerDeleteDisease(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete disease group with diseases by id
     * @summary Delete disease group with diseases by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminDiseasesControllerDeleteDiseaseGroup(id: string, options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminDiseasesControllerDeleteDiseaseGroup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get disease by id
     * @summary Get disease by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminDiseasesControllerGetDiseaseById(id: string, options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminDiseasesControllerGetDiseaseById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get disease group by id
     * @summary Get disease group by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminDiseasesControllerGetDiseaseGroupById(id: string, options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminDiseasesControllerGetDiseaseGroupById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get disease groups with diseases
     * @summary Get disease groups with diseases
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminDiseasesControllerGetDiseaseGroupsWithDiseases(options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminDiseasesControllerGetDiseaseGroupsWithDiseases(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get diseases
     * @summary Get diseases
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminDiseasesControllerGetDiseases(options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminDiseasesControllerGetDiseases(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update disease by id
     * @summary Update disease by id
     * @param {string} id 
     * @param {UpdateDiseaseRequestDto} updateDiseaseRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminDiseasesControllerUpdateDisease(id: string, updateDiseaseRequestDto: UpdateDiseaseRequestDto, options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminDiseasesControllerUpdateDisease(id, updateDiseaseRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update disease group by id
     * @summary Update disease group by id
     * @param {string} id 
     * @param {AddDiseaseGroupRequestDto} addDiseaseGroupRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminDiseasesControllerUpdateDiseaseGroupById(id: string, addDiseaseGroupRequestDto: AddDiseaseGroupRequestDto, options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminDiseasesControllerUpdateDiseaseGroupById(id, addDiseaseGroupRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add new therapy method
     * @summary Add new therapy method
     * @param {AddTherapyMethodRequestDto} addTherapyMethodRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminTherapyMethodsControllerAddTherapyMethod(addTherapyMethodRequestDto: AddTherapyMethodRequestDto, options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminTherapyMethodsControllerAddTherapyMethod(addTherapyMethodRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete therapy method by id
     * @summary Delete therapy method by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminTherapyMethodsControllerDeleteTherapyMethod(id: string, options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminTherapyMethodsControllerDeleteTherapyMethod(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get therapy methods
     * @summary Get therapy methods
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminTherapyMethodsControllerGetTherapyMethods(options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminTherapyMethodsControllerGetTherapyMethods(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get therapy methods
     * @summary Get therapy methods
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminTherapyMethodsControllerGetTherapyMethodsById(id: string, options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminTherapyMethodsControllerGetTherapyMethodsById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update therapy method by id
     * @summary Update therapy method by id
     * @param {string} id 
     * @param {UpdateTherapyMethodRequestDto} updateTherapyMethodRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiseasesAndTherapyMethodsApi
     */
    public adminTherapyMethodsControllerUpdateTherapyMethod(id: string, updateTherapyMethodRequestDto: UpdateTherapyMethodRequestDto, options?: AxiosRequestConfig) {
        return AdminDiseasesAndTherapyMethodsApiFp(this.configuration).adminTherapyMethodsControllerUpdateTherapyMethod(id, updateTherapyMethodRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminFAQApi - axios parameter creator
 * @export
 */
export const AdminFAQApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add FAQ group
         * @param {AdminAddFaqGroupRequestDto} adminAddFaqGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerAddFaqGroup: async (adminAddFaqGroupRequestDto: AdminAddFaqGroupRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminAddFaqGroupRequestDto' is not null or undefined
            assertParamExists('adminFaqControllerAddFaqGroup', 'adminAddFaqGroupRequestDto', adminAddFaqGroupRequestDto)
            const localVarPath = `/api/v1/admin/faq/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminAddFaqGroupRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add FAQ question
         * @param {AdminAddFaqQuestionRequestDto} adminAddFaqQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerAddFaqQuestion: async (adminAddFaqQuestionRequestDto: AdminAddFaqQuestionRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminAddFaqQuestionRequestDto' is not null or undefined
            assertParamExists('adminFaqControllerAddFaqQuestion', 'adminAddFaqQuestionRequestDto', adminAddFaqQuestionRequestDto)
            const localVarPath = `/api/v1/admin/faq/question`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminAddFaqQuestionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete FAQ group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerDeleteFaqGroup: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminFaqControllerDeleteFaqGroup', 'id', id)
            const localVarPath = `/api/v1/admin/faq/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete FAQ question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerDeleteFaqQuestion: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminFaqControllerDeleteFaqQuestion', 'id', id)
            const localVarPath = `/api/v1/admin/faq/question/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all FAQ groups with questions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerGetFaqGroupsWithQuestions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/faq/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all FAQ questions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerGetFaqQuestions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/faq/question`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one FAQ group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerGetOneFaqGroup: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminFaqControllerGetOneFaqGroup', 'id', id)
            const localVarPath = `/api/v1/admin/faq/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get one FAQ question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerGetOneFaqQuestion: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminFaqControllerGetOneFaqQuestion', 'id', id)
            const localVarPath = `/api/v1/admin/faq/question/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update FAQ group
         * @param {string} id 
         * @param {AdminUpdateFaqGroupRequestDto} adminUpdateFaqGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerUpdateFaqGroup: async (id: string, adminUpdateFaqGroupRequestDto: AdminUpdateFaqGroupRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminFaqControllerUpdateFaqGroup', 'id', id)
            // verify required parameter 'adminUpdateFaqGroupRequestDto' is not null or undefined
            assertParamExists('adminFaqControllerUpdateFaqGroup', 'adminUpdateFaqGroupRequestDto', adminUpdateFaqGroupRequestDto)
            const localVarPath = `/api/v1/admin/faq/group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateFaqGroupRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update FAQ question
         * @param {string} id 
         * @param {AdminUpdateFaqQuestionRequestDto} adminUpdateFaqQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerUpdateFaqQuestion: async (id: string, adminUpdateFaqQuestionRequestDto: AdminUpdateFaqQuestionRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminFaqControllerUpdateFaqQuestion', 'id', id)
            // verify required parameter 'adminUpdateFaqQuestionRequestDto' is not null or undefined
            assertParamExists('adminFaqControllerUpdateFaqQuestion', 'adminUpdateFaqQuestionRequestDto', adminUpdateFaqQuestionRequestDto)
            const localVarPath = `/api/v1/admin/faq/question/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateFaqQuestionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminFAQApi - functional programming interface
 * @export
 */
export const AdminFAQApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminFAQApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add FAQ group
         * @param {AdminAddFaqGroupRequestDto} adminAddFaqGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFaqControllerAddFaqGroup(adminAddFaqGroupRequestDto: AdminAddFaqGroupRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFaqGroupWithQuestionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFaqControllerAddFaqGroup(adminAddFaqGroupRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add FAQ question
         * @param {AdminAddFaqQuestionRequestDto} adminAddFaqQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFaqControllerAddFaqQuestion(adminAddFaqQuestionRequestDto: AdminAddFaqQuestionRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFaqQuestionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFaqControllerAddFaqQuestion(adminAddFaqQuestionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete FAQ group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFaqControllerDeleteFaqGroup(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFaqControllerDeleteFaqGroup(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete FAQ question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFaqControllerDeleteFaqQuestion(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFaqControllerDeleteFaqQuestion(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all FAQ groups with questions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFaqControllerGetFaqGroupsWithQuestions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFaqGroupsWithQuestionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFaqControllerGetFaqGroupsWithQuestions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all FAQ questions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFaqControllerGetFaqQuestions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFaqQuestionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFaqControllerGetFaqQuestions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get one FAQ group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFaqControllerGetOneFaqGroup(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFaqGroupWithQuestionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFaqControllerGetOneFaqGroup(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get one FAQ question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFaqControllerGetOneFaqQuestion(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFaqQuestionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFaqControllerGetOneFaqQuestion(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update FAQ group
         * @param {string} id 
         * @param {AdminUpdateFaqGroupRequestDto} adminUpdateFaqGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFaqControllerUpdateFaqGroup(id: string, adminUpdateFaqGroupRequestDto: AdminUpdateFaqGroupRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFaqGroupWithQuestionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFaqControllerUpdateFaqGroup(id, adminUpdateFaqGroupRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update FAQ question
         * @param {string} id 
         * @param {AdminUpdateFaqQuestionRequestDto} adminUpdateFaqQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFaqControllerUpdateFaqQuestion(id: string, adminUpdateFaqQuestionRequestDto: AdminUpdateFaqQuestionRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminFaqQuestionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFaqControllerUpdateFaqQuestion(id, adminUpdateFaqQuestionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminFAQApi - factory interface
 * @export
 */
export const AdminFAQApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminFAQApiFp(configuration)
    return {
        /**
         * 
         * @summary Add FAQ group
         * @param {AdminAddFaqGroupRequestDto} adminAddFaqGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerAddFaqGroup(adminAddFaqGroupRequestDto: AdminAddFaqGroupRequestDto, options?: any): AxiosPromise<AdminFaqGroupWithQuestionsResponseDto> {
            return localVarFp.adminFaqControllerAddFaqGroup(adminAddFaqGroupRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add FAQ question
         * @param {AdminAddFaqQuestionRequestDto} adminAddFaqQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerAddFaqQuestion(adminAddFaqQuestionRequestDto: AdminAddFaqQuestionRequestDto, options?: any): AxiosPromise<AdminFaqQuestionResponseDto> {
            return localVarFp.adminFaqControllerAddFaqQuestion(adminAddFaqQuestionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete FAQ group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerDeleteFaqGroup(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminFaqControllerDeleteFaqGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete FAQ question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerDeleteFaqQuestion(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminFaqControllerDeleteFaqQuestion(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all FAQ groups with questions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerGetFaqGroupsWithQuestions(options?: any): AxiosPromise<AdminFaqGroupsWithQuestionsResponseDto> {
            return localVarFp.adminFaqControllerGetFaqGroupsWithQuestions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all FAQ questions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerGetFaqQuestions(options?: any): AxiosPromise<AdminFaqQuestionsResponseDto> {
            return localVarFp.adminFaqControllerGetFaqQuestions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one FAQ group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerGetOneFaqGroup(id: string, options?: any): AxiosPromise<AdminFaqGroupWithQuestionsResponseDto> {
            return localVarFp.adminFaqControllerGetOneFaqGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get one FAQ question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerGetOneFaqQuestion(id: string, options?: any): AxiosPromise<AdminFaqQuestionResponseDto> {
            return localVarFp.adminFaqControllerGetOneFaqQuestion(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update FAQ group
         * @param {string} id 
         * @param {AdminUpdateFaqGroupRequestDto} adminUpdateFaqGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerUpdateFaqGroup(id: string, adminUpdateFaqGroupRequestDto: AdminUpdateFaqGroupRequestDto, options?: any): AxiosPromise<AdminFaqGroupWithQuestionsResponseDto> {
            return localVarFp.adminFaqControllerUpdateFaqGroup(id, adminUpdateFaqGroupRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update FAQ question
         * @param {string} id 
         * @param {AdminUpdateFaqQuestionRequestDto} adminUpdateFaqQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFaqControllerUpdateFaqQuestion(id: string, adminUpdateFaqQuestionRequestDto: AdminUpdateFaqQuestionRequestDto, options?: any): AxiosPromise<AdminFaqQuestionResponseDto> {
            return localVarFp.adminFaqControllerUpdateFaqQuestion(id, adminUpdateFaqQuestionRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminFAQApi - object-oriented interface
 * @export
 * @class AdminFAQApi
 * @extends {BaseAPI}
 */
export class AdminFAQApi extends BaseAPI {
    /**
     * 
     * @summary Add FAQ group
     * @param {AdminAddFaqGroupRequestDto} adminAddFaqGroupRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFAQApi
     */
    public adminFaqControllerAddFaqGroup(adminAddFaqGroupRequestDto: AdminAddFaqGroupRequestDto, options?: AxiosRequestConfig) {
        return AdminFAQApiFp(this.configuration).adminFaqControllerAddFaqGroup(adminAddFaqGroupRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add FAQ question
     * @param {AdminAddFaqQuestionRequestDto} adminAddFaqQuestionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFAQApi
     */
    public adminFaqControllerAddFaqQuestion(adminAddFaqQuestionRequestDto: AdminAddFaqQuestionRequestDto, options?: AxiosRequestConfig) {
        return AdminFAQApiFp(this.configuration).adminFaqControllerAddFaqQuestion(adminAddFaqQuestionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete FAQ group
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFAQApi
     */
    public adminFaqControllerDeleteFaqGroup(id: string, options?: AxiosRequestConfig) {
        return AdminFAQApiFp(this.configuration).adminFaqControllerDeleteFaqGroup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete FAQ question
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFAQApi
     */
    public adminFaqControllerDeleteFaqQuestion(id: string, options?: AxiosRequestConfig) {
        return AdminFAQApiFp(this.configuration).adminFaqControllerDeleteFaqQuestion(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all FAQ groups with questions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFAQApi
     */
    public adminFaqControllerGetFaqGroupsWithQuestions(options?: AxiosRequestConfig) {
        return AdminFAQApiFp(this.configuration).adminFaqControllerGetFaqGroupsWithQuestions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all FAQ questions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFAQApi
     */
    public adminFaqControllerGetFaqQuestions(options?: AxiosRequestConfig) {
        return AdminFAQApiFp(this.configuration).adminFaqControllerGetFaqQuestions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one FAQ group
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFAQApi
     */
    public adminFaqControllerGetOneFaqGroup(id: string, options?: AxiosRequestConfig) {
        return AdminFAQApiFp(this.configuration).adminFaqControllerGetOneFaqGroup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get one FAQ question
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFAQApi
     */
    public adminFaqControllerGetOneFaqQuestion(id: string, options?: AxiosRequestConfig) {
        return AdminFAQApiFp(this.configuration).adminFaqControllerGetOneFaqQuestion(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update FAQ group
     * @param {string} id 
     * @param {AdminUpdateFaqGroupRequestDto} adminUpdateFaqGroupRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFAQApi
     */
    public adminFaqControllerUpdateFaqGroup(id: string, adminUpdateFaqGroupRequestDto: AdminUpdateFaqGroupRequestDto, options?: AxiosRequestConfig) {
        return AdminFAQApiFp(this.configuration).adminFaqControllerUpdateFaqGroup(id, adminUpdateFaqGroupRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update FAQ question
     * @param {string} id 
     * @param {AdminUpdateFaqQuestionRequestDto} adminUpdateFaqQuestionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFAQApi
     */
    public adminFaqControllerUpdateFaqQuestion(id: string, adminUpdateFaqQuestionRequestDto: AdminUpdateFaqQuestionRequestDto, options?: AxiosRequestConfig) {
        return AdminFAQApiFp(this.configuration).adminFaqControllerUpdateFaqQuestion(id, adminUpdateFaqQuestionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminGroupCallLinksApi - axios parameter creator
 * @export
 */
export const AdminGroupCallLinksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить ссылки на групповые созвоны
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGroupCallLinksControllerGetList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/group-call-links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создать или обновить ссылку на групповой созвон
         * @param {UpsertGroupCallLinkRequestDto} upsertGroupCallLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGroupCallLinksControllerUpsert: async (upsertGroupCallLinkRequestDto: UpsertGroupCallLinkRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'upsertGroupCallLinkRequestDto' is not null or undefined
            assertParamExists('adminGroupCallLinksControllerUpsert', 'upsertGroupCallLinkRequestDto', upsertGroupCallLinkRequestDto)
            const localVarPath = `/api/v1/admin/group-call-links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertGroupCallLinkRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminGroupCallLinksApi - functional programming interface
 * @export
 */
export const AdminGroupCallLinksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminGroupCallLinksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить ссылки на групповые созвоны
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGroupCallLinksControllerGetList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminGroupCallLinkResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGroupCallLinksControllerGetList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Создать или обновить ссылку на групповой созвон
         * @param {UpsertGroupCallLinkRequestDto} upsertGroupCallLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGroupCallLinksControllerUpsert(upsertGroupCallLinkRequestDto: UpsertGroupCallLinkRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGroupCallLinkResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGroupCallLinksControllerUpsert(upsertGroupCallLinkRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminGroupCallLinksApi - factory interface
 * @export
 */
export const AdminGroupCallLinksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminGroupCallLinksApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить ссылки на групповые созвоны
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGroupCallLinksControllerGetList(options?: any): AxiosPromise<Array<AdminGroupCallLinkResponseDto>> {
            return localVarFp.adminGroupCallLinksControllerGetList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создать или обновить ссылку на групповой созвон
         * @param {UpsertGroupCallLinkRequestDto} upsertGroupCallLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGroupCallLinksControllerUpsert(upsertGroupCallLinkRequestDto: UpsertGroupCallLinkRequestDto, options?: any): AxiosPromise<AdminGroupCallLinkResponseDto> {
            return localVarFp.adminGroupCallLinksControllerUpsert(upsertGroupCallLinkRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminGroupCallLinksApi - object-oriented interface
 * @export
 * @class AdminGroupCallLinksApi
 * @extends {BaseAPI}
 */
export class AdminGroupCallLinksApi extends BaseAPI {
    /**
     * 
     * @summary Получить ссылки на групповые созвоны
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminGroupCallLinksApi
     */
    public adminGroupCallLinksControllerGetList(options?: AxiosRequestConfig) {
        return AdminGroupCallLinksApiFp(this.configuration).adminGroupCallLinksControllerGetList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создать или обновить ссылку на групповой созвон
     * @param {UpsertGroupCallLinkRequestDto} upsertGroupCallLinkRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminGroupCallLinksApi
     */
    public adminGroupCallLinksControllerUpsert(upsertGroupCallLinkRequestDto: UpsertGroupCallLinkRequestDto, options?: AxiosRequestConfig) {
        return AdminGroupCallLinksApiFp(this.configuration).adminGroupCallLinksControllerUpsert(upsertGroupCallLinkRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminPatientsApi - axios parameter creator
 * @export
 */
export const AdminPatientsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Ban patient by id
         * @summary Ban patient by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPatientsControllerBanPatient: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPatientsControllerBanPatient', 'id', id)
            const localVarPath = `/api/v1/admin/patients/ban/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Удаляет профиль клиента (patient) и пользователя из БД. Только роли patient / b2b_patient. Разрешено только для «пустого» профиля без активности: — нет сессий и бронирований (в т.ч. отменённых — это уже активность); — нет активных payin/payout (статусы кроме canceled и failed); — нет ни одной записи в payments (любой статус; намеренный запрет любой платёжной истории); — нет записей в platform_feedbacks, promocodes (consumer_id). Если есть любая история payin/payout (включая canceled/failed) — 400 с просьбой обратиться к разработчикам для ручного удаления.
         * @summary Hard delete patient profile
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPatientsControllerDeletePatient: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPatientsControllerDeletePatient', 'id', id)
            const localVarPath = `/api/v1/admin/patients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get patient by id
         * @summary Get patient by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPatientsControllerGetPatientById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPatientsControllerGetPatientById', 'id', id)
            const localVarPath = `/api/v1/admin/patients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get patients
         * @summary Get patients
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting'} [orderTerms] 
         * @param {string} [email] 
         * @param {string} [search] 
         * @param {boolean} [isAuthorized] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPatientsControllerGetPatients: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting', email?: string, search?: string, isAuthorized?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminPatientsControllerGetPatients', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminPatientsControllerGetPatients', 'page', page)
            const localVarPath = `/api/v1/admin/patients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (isAuthorized !== undefined) {
                localVarQueryParameter['isAuthorized'] = isAuthorized;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unban patient by id
         * @summary Unban patient by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPatientsControllerUnbanPatient: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPatientsControllerUnbanPatient', 'id', id)
            const localVarPath = `/api/v1/admin/patients/unban/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update is test patient by id
         * @summary Update is test patient by id
         * @param {string} id 
         * @param {PatientUpdateIsTestDto} patientUpdateIsTestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPatientsControllerUpdateIsTest: async (id: string, patientUpdateIsTestDto: PatientUpdateIsTestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPatientsControllerUpdateIsTest', 'id', id)
            // verify required parameter 'patientUpdateIsTestDto' is not null or undefined
            assertParamExists('adminPatientsControllerUpdateIsTest', 'patientUpdateIsTestDto', patientUpdateIsTestDto)
            const localVarPath = `/api/v1/admin/patients/update-is-test/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientUpdateIsTestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPatientsApi - functional programming interface
 * @export
 */
export const AdminPatientsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPatientsApiAxiosParamCreator(configuration)
    return {
        /**
         * Ban patient by id
         * @summary Ban patient by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPatientsControllerBanPatient(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPatientsControllerBanPatient(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Удаляет профиль клиента (patient) и пользователя из БД. Только роли patient / b2b_patient. Разрешено только для «пустого» профиля без активности: — нет сессий и бронирований (в т.ч. отменённых — это уже активность); — нет активных payin/payout (статусы кроме canceled и failed); — нет ни одной записи в payments (любой статус; намеренный запрет любой платёжной истории); — нет записей в platform_feedbacks, promocodes (consumer_id). Если есть любая история payin/payout (включая canceled/failed) — 400 с просьбой обратиться к разработчикам для ручного удаления.
         * @summary Hard delete patient profile
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPatientsControllerDeletePatient(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPatientsControllerDeletePatient(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get patient by id
         * @summary Get patient by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPatientsControllerGetPatientById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPatientResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPatientsControllerGetPatientById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get patients
         * @summary Get patients
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting'} [orderTerms] 
         * @param {string} [email] 
         * @param {string} [search] 
         * @param {boolean} [isAuthorized] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPatientsControllerGetPatients(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting', email?: string, search?: string, isAuthorized?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPaginatedPatientsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPatientsControllerGetPatients(limit, page, order, orderTerms, email, search, isAuthorized, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unban patient by id
         * @summary Unban patient by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPatientsControllerUnbanPatient(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPatientsControllerUnbanPatient(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update is test patient by id
         * @summary Update is test patient by id
         * @param {string} id 
         * @param {PatientUpdateIsTestDto} patientUpdateIsTestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPatientsControllerUpdateIsTest(id: string, patientUpdateIsTestDto: PatientUpdateIsTestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPatientsControllerUpdateIsTest(id, patientUpdateIsTestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminPatientsApi - factory interface
 * @export
 */
export const AdminPatientsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPatientsApiFp(configuration)
    return {
        /**
         * Ban patient by id
         * @summary Ban patient by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPatientsControllerBanPatient(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminPatientsControllerBanPatient(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Удаляет профиль клиента (patient) и пользователя из БД. Только роли patient / b2b_patient. Разрешено только для «пустого» профиля без активности: — нет сессий и бронирований (в т.ч. отменённых — это уже активность); — нет активных payin/payout (статусы кроме canceled и failed); — нет ни одной записи в payments (любой статус; намеренный запрет любой платёжной истории); — нет записей в platform_feedbacks, promocodes (consumer_id). Если есть любая история payin/payout (включая canceled/failed) — 400 с просьбой обратиться к разработчикам для ручного удаления.
         * @summary Hard delete patient profile
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPatientsControllerDeletePatient(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminPatientsControllerDeletePatient(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get patient by id
         * @summary Get patient by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPatientsControllerGetPatientById(id: string, options?: any): AxiosPromise<AdminPatientResponseDto> {
            return localVarFp.adminPatientsControllerGetPatientById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get patients
         * @summary Get patients
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting'} [orderTerms] 
         * @param {string} [email] 
         * @param {string} [search] 
         * @param {boolean} [isAuthorized] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPatientsControllerGetPatients(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting', email?: string, search?: string, isAuthorized?: boolean, options?: any): AxiosPromise<AdminPaginatedPatientsResponseDto> {
            return localVarFp.adminPatientsControllerGetPatients(limit, page, order, orderTerms, email, search, isAuthorized, options).then((request) => request(axios, basePath));
        },
        /**
         * Unban patient by id
         * @summary Unban patient by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPatientsControllerUnbanPatient(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminPatientsControllerUnbanPatient(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update is test patient by id
         * @summary Update is test patient by id
         * @param {string} id 
         * @param {PatientUpdateIsTestDto} patientUpdateIsTestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPatientsControllerUpdateIsTest(id: string, patientUpdateIsTestDto: PatientUpdateIsTestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminPatientsControllerUpdateIsTest(id, patientUpdateIsTestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminPatientsApi - object-oriented interface
 * @export
 * @class AdminPatientsApi
 * @extends {BaseAPI}
 */
export class AdminPatientsApi extends BaseAPI {
    /**
     * Ban patient by id
     * @summary Ban patient by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPatientsApi
     */
    public adminPatientsControllerBanPatient(id: string, options?: AxiosRequestConfig) {
        return AdminPatientsApiFp(this.configuration).adminPatientsControllerBanPatient(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Удаляет профиль клиента (patient) и пользователя из БД. Только роли patient / b2b_patient. Разрешено только для «пустого» профиля без активности: — нет сессий и бронирований (в т.ч. отменённых — это уже активность); — нет активных payin/payout (статусы кроме canceled и failed); — нет ни одной записи в payments (любой статус; намеренный запрет любой платёжной истории); — нет записей в platform_feedbacks, promocodes (consumer_id). Если есть любая история payin/payout (включая canceled/failed) — 400 с просьбой обратиться к разработчикам для ручного удаления.
     * @summary Hard delete patient profile
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPatientsApi
     */
    public adminPatientsControllerDeletePatient(id: string, options?: AxiosRequestConfig) {
        return AdminPatientsApiFp(this.configuration).adminPatientsControllerDeletePatient(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get patient by id
     * @summary Get patient by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPatientsApi
     */
    public adminPatientsControllerGetPatientById(id: string, options?: AxiosRequestConfig) {
        return AdminPatientsApiFp(this.configuration).adminPatientsControllerGetPatientById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get patients
     * @summary Get patients
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting'} [orderTerms] 
     * @param {string} [email] 
     * @param {string} [search] 
     * @param {boolean} [isAuthorized] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPatientsApi
     */
    public adminPatientsControllerGetPatients(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname' | 'sessionsCompleted' | 'sessionsAwaiting', email?: string, search?: string, isAuthorized?: boolean, options?: AxiosRequestConfig) {
        return AdminPatientsApiFp(this.configuration).adminPatientsControllerGetPatients(limit, page, order, orderTerms, email, search, isAuthorized, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unban patient by id
     * @summary Unban patient by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPatientsApi
     */
    public adminPatientsControllerUnbanPatient(id: string, options?: AxiosRequestConfig) {
        return AdminPatientsApiFp(this.configuration).adminPatientsControllerUnbanPatient(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update is test patient by id
     * @summary Update is test patient by id
     * @param {string} id 
     * @param {PatientUpdateIsTestDto} patientUpdateIsTestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPatientsApi
     */
    public adminPatientsControllerUpdateIsTest(id: string, patientUpdateIsTestDto: PatientUpdateIsTestDto, options?: AxiosRequestConfig) {
        return AdminPatientsApiFp(this.configuration).adminPatientsControllerUpdateIsTest(id, patientUpdateIsTestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminPaymentGatewayApi - axios parameter creator
 * @export
 */
export const AdminPaymentGatewayApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get currency
         * @summary Get currency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPaymentGatewayControllerGetCurrencies: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/payment-gateway/currency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create/Update currency
         * @summary Add/Update currency
         * @param {AdminUpdateCurrenciesRequestDto} adminUpdateCurrenciesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPaymentGatewayControllerUpdateCurrency: async (adminUpdateCurrenciesRequestDto: AdminUpdateCurrenciesRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUpdateCurrenciesRequestDto' is not null or undefined
            assertParamExists('adminPaymentGatewayControllerUpdateCurrency', 'adminUpdateCurrenciesRequestDto', adminUpdateCurrenciesRequestDto)
            const localVarPath = `/api/v1/admin/payment-gateway/currency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateCurrenciesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPaymentGatewayApi - functional programming interface
 * @export
 */
export const AdminPaymentGatewayApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPaymentGatewayApiAxiosParamCreator(configuration)
    return {
        /**
         * Get currency
         * @summary Get currency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPaymentGatewayControllerGetCurrencies(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetCurrenciesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPaymentGatewayControllerGetCurrencies(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create/Update currency
         * @summary Add/Update currency
         * @param {AdminUpdateCurrenciesRequestDto} adminUpdateCurrenciesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPaymentGatewayControllerUpdateCurrency(adminUpdateCurrenciesRequestDto: AdminUpdateCurrenciesRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPaymentGatewayControllerUpdateCurrency(adminUpdateCurrenciesRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminPaymentGatewayApi - factory interface
 * @export
 */
export const AdminPaymentGatewayApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPaymentGatewayApiFp(configuration)
    return {
        /**
         * Get currency
         * @summary Get currency
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPaymentGatewayControllerGetCurrencies(options?: any): AxiosPromise<AdminGetCurrenciesResponseDto> {
            return localVarFp.adminPaymentGatewayControllerGetCurrencies(options).then((request) => request(axios, basePath));
        },
        /**
         * Create/Update currency
         * @summary Add/Update currency
         * @param {AdminUpdateCurrenciesRequestDto} adminUpdateCurrenciesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPaymentGatewayControllerUpdateCurrency(adminUpdateCurrenciesRequestDto: AdminUpdateCurrenciesRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminPaymentGatewayControllerUpdateCurrency(adminUpdateCurrenciesRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminPaymentGatewayApi - object-oriented interface
 * @export
 * @class AdminPaymentGatewayApi
 * @extends {BaseAPI}
 */
export class AdminPaymentGatewayApi extends BaseAPI {
    /**
     * Get currency
     * @summary Get currency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPaymentGatewayApi
     */
    public adminPaymentGatewayControllerGetCurrencies(options?: AxiosRequestConfig) {
        return AdminPaymentGatewayApiFp(this.configuration).adminPaymentGatewayControllerGetCurrencies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create/Update currency
     * @summary Add/Update currency
     * @param {AdminUpdateCurrenciesRequestDto} adminUpdateCurrenciesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPaymentGatewayApi
     */
    public adminPaymentGatewayControllerUpdateCurrency(adminUpdateCurrenciesRequestDto: AdminUpdateCurrenciesRequestDto, options?: AxiosRequestConfig) {
        return AdminPaymentGatewayApiFp(this.configuration).adminPaymentGatewayControllerUpdateCurrency(adminUpdateCurrenciesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminPromocodesReusableApi - axios parameter creator
 * @export
 */
export const AdminPromocodesReusableApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add promocode
         * @summary Add promocode
         * @param {AddPromocodeToCompanyRequestDto} addPromocodeToCompanyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPromocodesControllerAddPromocode: async (addPromocodeToCompanyRequestDto: AddPromocodeToCompanyRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addPromocodeToCompanyRequestDto' is not null or undefined
            assertParamExists('adminPromocodesControllerAddPromocode', 'addPromocodeToCompanyRequestDto', addPromocodeToCompanyRequestDto)
            const localVarPath = `/api/v1/admin/promocodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPromocodeToCompanyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete promocode by id
         * @summary Delete promocode by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPromocodesControllerDeletePromocodeById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPromocodesControllerDeletePromocodeById', 'id', id)
            const localVarPath = `/api/v1/admin/promocodes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get promocode by id
         * @summary Get promocode by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPromocodesControllerGetPromocodeById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPromocodesControllerGetPromocodeById', 'id', id)
            const localVarPath = `/api/v1/admin/promocodes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated promocodes
         * @summary Get paginated promocodes
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'amount' | 'percentage' | 'createdAt' | 'expireDate' | 'code' | 'timesUsed'} [orderTerms] 
         * @param {'consumerName' | 'consumerEmail' | 'companyName' | 'code' | 'adminName'} [searchTerm] name or email
         * @param {string} [searchValue] value to search by searchTerm
         * @param {string} [userId] User ID
         * @param {string} [companyId] Company ID
         * @param {string} [role] Company role
         * @param {string} [group] Company group
         * @param {boolean} [isB2B] is B2B promocode
         * @param {boolean} [named] is named promocodes
         * @param {boolean} [_private] is private promocodes
         * @param {boolean} [amount] amount typed promocode
         * @param {boolean} [percentage] percentage typed promocode
         * @param {boolean} [used] is used status
         * @param {boolean} [unused] is unused status
         * @param {boolean} [expired] is expired status
         * @param {boolean} [reusable] is reusable
         * @param {boolean} [oneuse] is single use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPromocodesControllerGetPromocodes: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'amount' | 'percentage' | 'createdAt' | 'expireDate' | 'code' | 'timesUsed', searchTerm?: 'consumerName' | 'consumerEmail' | 'companyName' | 'code' | 'adminName', searchValue?: string, userId?: string, companyId?: string, role?: string, group?: string, isB2B?: boolean, named?: boolean, _private?: boolean, amount?: boolean, percentage?: boolean, used?: boolean, unused?: boolean, expired?: boolean, reusable?: boolean, oneuse?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminPromocodesControllerGetPromocodes', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminPromocodesControllerGetPromocodes', 'page', page)
            const localVarPath = `/api/v1/admin/promocodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (searchValue !== undefined) {
                localVarQueryParameter['searchValue'] = searchValue;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }

            if (isB2B !== undefined) {
                localVarQueryParameter['isB2B'] = isB2B;
            }

            if (named !== undefined) {
                localVarQueryParameter['named'] = named;
            }

            if (_private !== undefined) {
                localVarQueryParameter['private'] = _private;
            }

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (percentage !== undefined) {
                localVarQueryParameter['percentage'] = percentage;
            }

            if (used !== undefined) {
                localVarQueryParameter['used'] = used;
            }

            if (unused !== undefined) {
                localVarQueryParameter['unused'] = unused;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }

            if (reusable !== undefined) {
                localVarQueryParameter['reusable'] = reusable;
            }

            if (oneuse !== undefined) {
                localVarQueryParameter['oneuse'] = oneuse;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update promocode by id
         * @summary Update promocode by id
         * @param {string} id 
         * @param {UpdatePromocodeRequestDto} updatePromocodeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPromocodesControllerUpdatePromocodeById: async (id: string, updatePromocodeRequestDto: UpdatePromocodeRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPromocodesControllerUpdatePromocodeById', 'id', id)
            // verify required parameter 'updatePromocodeRequestDto' is not null or undefined
            assertParamExists('adminPromocodesControllerUpdatePromocodeById', 'updatePromocodeRequestDto', updatePromocodeRequestDto)
            const localVarPath = `/api/v1/admin/promocodes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePromocodeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPromocodesReusableApi - functional programming interface
 * @export
 */
export const AdminPromocodesReusableApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPromocodesReusableApiAxiosParamCreator(configuration)
    return {
        /**
         * Add promocode
         * @summary Add promocode
         * @param {AddPromocodeToCompanyRequestDto} addPromocodeToCompanyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPromocodesControllerAddPromocode(addPromocodeToCompanyRequestDto: AddPromocodeToCompanyRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPromocodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPromocodesControllerAddPromocode(addPromocodeToCompanyRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete promocode by id
         * @summary Delete promocode by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPromocodesControllerDeletePromocodeById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPromocodesControllerDeletePromocodeById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get promocode by id
         * @summary Get promocode by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPromocodesControllerGetPromocodeById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPromocodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPromocodesControllerGetPromocodeById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get paginated promocodes
         * @summary Get paginated promocodes
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'amount' | 'percentage' | 'createdAt' | 'expireDate' | 'code' | 'timesUsed'} [orderTerms] 
         * @param {'consumerName' | 'consumerEmail' | 'companyName' | 'code' | 'adminName'} [searchTerm] name or email
         * @param {string} [searchValue] value to search by searchTerm
         * @param {string} [userId] User ID
         * @param {string} [companyId] Company ID
         * @param {string} [role] Company role
         * @param {string} [group] Company group
         * @param {boolean} [isB2B] is B2B promocode
         * @param {boolean} [named] is named promocodes
         * @param {boolean} [_private] is private promocodes
         * @param {boolean} [amount] amount typed promocode
         * @param {boolean} [percentage] percentage typed promocode
         * @param {boolean} [used] is used status
         * @param {boolean} [unused] is unused status
         * @param {boolean} [expired] is expired status
         * @param {boolean} [reusable] is reusable
         * @param {boolean} [oneuse] is single use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPromocodesControllerGetPromocodes(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'amount' | 'percentage' | 'createdAt' | 'expireDate' | 'code' | 'timesUsed', searchTerm?: 'consumerName' | 'consumerEmail' | 'companyName' | 'code' | 'adminName', searchValue?: string, userId?: string, companyId?: string, role?: string, group?: string, isB2B?: boolean, named?: boolean, _private?: boolean, amount?: boolean, percentage?: boolean, used?: boolean, unused?: boolean, expired?: boolean, reusable?: boolean, oneuse?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPromocodesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPromocodesControllerGetPromocodes(limit, page, order, orderTerms, searchTerm, searchValue, userId, companyId, role, group, isB2B, named, _private, amount, percentage, used, unused, expired, reusable, oneuse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update promocode by id
         * @summary Update promocode by id
         * @param {string} id 
         * @param {UpdatePromocodeRequestDto} updatePromocodeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPromocodesControllerUpdatePromocodeById(id: string, updatePromocodeRequestDto: UpdatePromocodeRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPromocodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPromocodesControllerUpdatePromocodeById(id, updatePromocodeRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminPromocodesReusableApi - factory interface
 * @export
 */
export const AdminPromocodesReusableApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPromocodesReusableApiFp(configuration)
    return {
        /**
         * Add promocode
         * @summary Add promocode
         * @param {AddPromocodeToCompanyRequestDto} addPromocodeToCompanyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPromocodesControllerAddPromocode(addPromocodeToCompanyRequestDto: AddPromocodeToCompanyRequestDto, options?: any): AxiosPromise<AdminPromocodeResponseDto> {
            return localVarFp.adminPromocodesControllerAddPromocode(addPromocodeToCompanyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete promocode by id
         * @summary Delete promocode by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPromocodesControllerDeletePromocodeById(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminPromocodesControllerDeletePromocodeById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get promocode by id
         * @summary Get promocode by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPromocodesControllerGetPromocodeById(id: string, options?: any): AxiosPromise<AdminPromocodeResponseDto> {
            return localVarFp.adminPromocodesControllerGetPromocodeById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated promocodes
         * @summary Get paginated promocodes
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'amount' | 'percentage' | 'createdAt' | 'expireDate' | 'code' | 'timesUsed'} [orderTerms] 
         * @param {'consumerName' | 'consumerEmail' | 'companyName' | 'code' | 'adminName'} [searchTerm] name or email
         * @param {string} [searchValue] value to search by searchTerm
         * @param {string} [userId] User ID
         * @param {string} [companyId] Company ID
         * @param {string} [role] Company role
         * @param {string} [group] Company group
         * @param {boolean} [isB2B] is B2B promocode
         * @param {boolean} [named] is named promocodes
         * @param {boolean} [_private] is private promocodes
         * @param {boolean} [amount] amount typed promocode
         * @param {boolean} [percentage] percentage typed promocode
         * @param {boolean} [used] is used status
         * @param {boolean} [unused] is unused status
         * @param {boolean} [expired] is expired status
         * @param {boolean} [reusable] is reusable
         * @param {boolean} [oneuse] is single use
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPromocodesControllerGetPromocodes(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'amount' | 'percentage' | 'createdAt' | 'expireDate' | 'code' | 'timesUsed', searchTerm?: 'consumerName' | 'consumerEmail' | 'companyName' | 'code' | 'adminName', searchValue?: string, userId?: string, companyId?: string, role?: string, group?: string, isB2B?: boolean, named?: boolean, _private?: boolean, amount?: boolean, percentage?: boolean, used?: boolean, unused?: boolean, expired?: boolean, reusable?: boolean, oneuse?: boolean, options?: any): AxiosPromise<AdminPromocodesResponseDto> {
            return localVarFp.adminPromocodesControllerGetPromocodes(limit, page, order, orderTerms, searchTerm, searchValue, userId, companyId, role, group, isB2B, named, _private, amount, percentage, used, unused, expired, reusable, oneuse, options).then((request) => request(axios, basePath));
        },
        /**
         * Update promocode by id
         * @summary Update promocode by id
         * @param {string} id 
         * @param {UpdatePromocodeRequestDto} updatePromocodeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPromocodesControllerUpdatePromocodeById(id: string, updatePromocodeRequestDto: UpdatePromocodeRequestDto, options?: any): AxiosPromise<AdminPromocodeResponseDto> {
            return localVarFp.adminPromocodesControllerUpdatePromocodeById(id, updatePromocodeRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminPromocodesReusableApi - object-oriented interface
 * @export
 * @class AdminPromocodesReusableApi
 * @extends {BaseAPI}
 */
export class AdminPromocodesReusableApi extends BaseAPI {
    /**
     * Add promocode
     * @summary Add promocode
     * @param {AddPromocodeToCompanyRequestDto} addPromocodeToCompanyRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPromocodesReusableApi
     */
    public adminPromocodesControllerAddPromocode(addPromocodeToCompanyRequestDto: AddPromocodeToCompanyRequestDto, options?: AxiosRequestConfig) {
        return AdminPromocodesReusableApiFp(this.configuration).adminPromocodesControllerAddPromocode(addPromocodeToCompanyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete promocode by id
     * @summary Delete promocode by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPromocodesReusableApi
     */
    public adminPromocodesControllerDeletePromocodeById(id: string, options?: AxiosRequestConfig) {
        return AdminPromocodesReusableApiFp(this.configuration).adminPromocodesControllerDeletePromocodeById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get promocode by id
     * @summary Get promocode by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPromocodesReusableApi
     */
    public adminPromocodesControllerGetPromocodeById(id: string, options?: AxiosRequestConfig) {
        return AdminPromocodesReusableApiFp(this.configuration).adminPromocodesControllerGetPromocodeById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated promocodes
     * @summary Get paginated promocodes
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'amount' | 'percentage' | 'createdAt' | 'expireDate' | 'code' | 'timesUsed'} [orderTerms] 
     * @param {'consumerName' | 'consumerEmail' | 'companyName' | 'code' | 'adminName'} [searchTerm] name or email
     * @param {string} [searchValue] value to search by searchTerm
     * @param {string} [userId] User ID
     * @param {string} [companyId] Company ID
     * @param {string} [role] Company role
     * @param {string} [group] Company group
     * @param {boolean} [isB2B] is B2B promocode
     * @param {boolean} [named] is named promocodes
     * @param {boolean} [_private] is private promocodes
     * @param {boolean} [amount] amount typed promocode
     * @param {boolean} [percentage] percentage typed promocode
     * @param {boolean} [used] is used status
     * @param {boolean} [unused] is unused status
     * @param {boolean} [expired] is expired status
     * @param {boolean} [reusable] is reusable
     * @param {boolean} [oneuse] is single use
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPromocodesReusableApi
     */
    public adminPromocodesControllerGetPromocodes(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'amount' | 'percentage' | 'createdAt' | 'expireDate' | 'code' | 'timesUsed', searchTerm?: 'consumerName' | 'consumerEmail' | 'companyName' | 'code' | 'adminName', searchValue?: string, userId?: string, companyId?: string, role?: string, group?: string, isB2B?: boolean, named?: boolean, _private?: boolean, amount?: boolean, percentage?: boolean, used?: boolean, unused?: boolean, expired?: boolean, reusable?: boolean, oneuse?: boolean, options?: AxiosRequestConfig) {
        return AdminPromocodesReusableApiFp(this.configuration).adminPromocodesControllerGetPromocodes(limit, page, order, orderTerms, searchTerm, searchValue, userId, companyId, role, group, isB2B, named, _private, amount, percentage, used, unused, expired, reusable, oneuse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update promocode by id
     * @summary Update promocode by id
     * @param {string} id 
     * @param {UpdatePromocodeRequestDto} updatePromocodeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPromocodesReusableApi
     */
    public adminPromocodesControllerUpdatePromocodeById(id: string, updatePromocodeRequestDto: UpdatePromocodeRequestDto, options?: AxiosRequestConfig) {
        return AdminPromocodesReusableApiFp(this.configuration).adminPromocodesControllerUpdatePromocodeById(id, updatePromocodeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminPromotedCompaniesApi - axios parameter creator
 * @export
 */
export const AdminPromotedCompaniesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get session statistics
         * @param {string} [promoted] 
         * @param {boolean} [isPromoted] 
         * @param {boolean} [isHavePromoCode] 
         * @param {Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>} [payoutStatuses] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPromoteControllerGetSessionStatistics: async (promoted?: string, isPromoted?: boolean, isHavePromoCode?: boolean, payoutStatuses?: Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/promote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (promoted !== undefined) {
                localVarQueryParameter['promoted'] = promoted;
            }

            if (isPromoted !== undefined) {
                localVarQueryParameter['isPromoted'] = isPromoted;
            }

            if (isHavePromoCode !== undefined) {
                localVarQueryParameter['isHavePromoCode'] = isHavePromoCode;
            }

            if (payoutStatuses) {
                localVarQueryParameter['payoutStatuses'] = payoutStatuses;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPromotedCompaniesApi - functional programming interface
 * @export
 */
export const AdminPromotedCompaniesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPromotedCompaniesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get session statistics
         * @param {string} [promoted] 
         * @param {boolean} [isPromoted] 
         * @param {boolean} [isHavePromoCode] 
         * @param {Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>} [payoutStatuses] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPromoteControllerGetSessionStatistics(promoted?: string, isPromoted?: boolean, isHavePromoCode?: boolean, payoutStatuses?: Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPromoteControllerGetSessionStatistics(promoted, isPromoted, isHavePromoCode, payoutStatuses, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminPromotedCompaniesApi - factory interface
 * @export
 */
export const AdminPromotedCompaniesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPromotedCompaniesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get session statistics
         * @param {string} [promoted] 
         * @param {boolean} [isPromoted] 
         * @param {boolean} [isHavePromoCode] 
         * @param {Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>} [payoutStatuses] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPromoteControllerGetSessionStatistics(promoted?: string, isPromoted?: boolean, isHavePromoCode?: boolean, payoutStatuses?: Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>, startDate?: string, endDate?: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminPromoteControllerGetSessionStatistics(promoted, isPromoted, isHavePromoCode, payoutStatuses, startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminPromotedCompaniesApi - object-oriented interface
 * @export
 * @class AdminPromotedCompaniesApi
 * @extends {BaseAPI}
 */
export class AdminPromotedCompaniesApi extends BaseAPI {
    /**
     * 
     * @summary Get session statistics
     * @param {string} [promoted] 
     * @param {boolean} [isPromoted] 
     * @param {boolean} [isHavePromoCode] 
     * @param {Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>} [payoutStatuses] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPromotedCompaniesApi
     */
    public adminPromoteControllerGetSessionStatistics(promoted?: string, isPromoted?: boolean, isHavePromoCode?: boolean, payoutStatuses?: Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>, startDate?: string, endDate?: string, options?: AxiosRequestConfig) {
        return AdminPromotedCompaniesApiFp(this.configuration).adminPromoteControllerGetSessionStatistics(promoted, isPromoted, isHavePromoCode, payoutStatuses, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminSearchStatisticsApi - axios parameter creator
 * @export
 */
export const AdminSearchStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Resolve search log statistics
         * @param {GetSearchStatisticsRequestDto} getSearchStatisticsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchStatisticsControllerGetSearchStatistics: async (getSearchStatisticsRequestDto: GetSearchStatisticsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getSearchStatisticsRequestDto' is not null or undefined
            assertParamExists('adminSearchStatisticsControllerGetSearchStatistics', 'getSearchStatisticsRequestDto', getSearchStatisticsRequestDto)
            const localVarPath = `/api/v1/admin/search-statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSearchStatisticsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSearchStatisticsApi - functional programming interface
 * @export
 */
export const AdminSearchStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSearchStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Resolve search log statistics
         * @param {GetSearchStatisticsRequestDto} getSearchStatisticsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSearchStatisticsControllerGetSearchStatistics(getSearchStatisticsRequestDto: GetSearchStatisticsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchStatisticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSearchStatisticsControllerGetSearchStatistics(getSearchStatisticsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminSearchStatisticsApi - factory interface
 * @export
 */
export const AdminSearchStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSearchStatisticsApiFp(configuration)
    return {
        /**
         * 
         * @summary Resolve search log statistics
         * @param {GetSearchStatisticsRequestDto} getSearchStatisticsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSearchStatisticsControllerGetSearchStatistics(getSearchStatisticsRequestDto: GetSearchStatisticsRequestDto, options?: any): AxiosPromise<SearchStatisticsResponseDto> {
            return localVarFp.adminSearchStatisticsControllerGetSearchStatistics(getSearchStatisticsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSearchStatisticsApi - object-oriented interface
 * @export
 * @class AdminSearchStatisticsApi
 * @extends {BaseAPI}
 */
export class AdminSearchStatisticsApi extends BaseAPI {
    /**
     * 
     * @summary Resolve search log statistics
     * @param {GetSearchStatisticsRequestDto} getSearchStatisticsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSearchStatisticsApi
     */
    public adminSearchStatisticsControllerGetSearchStatistics(getSearchStatisticsRequestDto: GetSearchStatisticsRequestDto, options?: AxiosRequestConfig) {
        return AdminSearchStatisticsApiFp(this.configuration).adminSearchStatisticsControllerGetSearchStatistics(getSearchStatisticsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminSessionBalancesApi - axios parameter creator
 * @export
 */
export const AdminSessionBalancesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete session balance by id
         * @param {string} sessionBalanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionBalancesControllerDeleteSessionBalance: async (sessionBalanceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionBalanceId' is not null or undefined
            assertParamExists('adminSessionBalancesControllerDeleteSessionBalance', 'sessionBalanceId', sessionBalanceId)
            const localVarPath = `/api/v1/admin/session-balances/{sessionBalanceId}`
                .replace(`{${"sessionBalanceId"}}`, encodeURIComponent(String(sessionBalanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get session balances by id
         * @param {string} sessionBalanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionBalancesControllerGetSessionBalance: async (sessionBalanceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionBalanceId' is not null or undefined
            assertParamExists('adminSessionBalancesControllerGetSessionBalance', 'sessionBalanceId', sessionBalanceId)
            const localVarPath = `/api/v1/admin/session-balances/{sessionBalanceId}`
                .replace(`{${"sessionBalanceId"}}`, encodeURIComponent(String(sessionBalanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get paginated session balances
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'startWith' | 'endWith'} [orderTerms] 
         * @param {'consumerEmail' | 'adminName'} [searchTerm] 
         * @param {string} [searchValue] value to search by searchTerm
         * @param {string} [companyId] Company ID
         * @param {string} [userId] User ID
         * @param {string} [role] Company role
         * @param {string} [group] Company group
         * @param {boolean} [used] is used status
         * @param {boolean} [unused] is unused status
         * @param {boolean} [notStarted] is not started status
         * @param {boolean} [expired] is expired status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionBalancesControllerGetSessionBalances: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startWith' | 'endWith', searchTerm?: 'consumerEmail' | 'adminName', searchValue?: string, companyId?: string, userId?: string, role?: string, group?: string, used?: boolean, unused?: boolean, notStarted?: boolean, expired?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminSessionBalancesControllerGetSessionBalances', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminSessionBalancesControllerGetSessionBalances', 'page', page)
            const localVarPath = `/api/v1/admin/session-balances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (searchValue !== undefined) {
                localVarQueryParameter['searchValue'] = searchValue;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }

            if (used !== undefined) {
                localVarQueryParameter['used'] = used;
            }

            if (unused !== undefined) {
                localVarQueryParameter['unused'] = unused;
            }

            if (notStarted !== undefined) {
                localVarQueryParameter['not_started'] = notStarted;
            }

            if (expired !== undefined) {
                localVarQueryParameter['expired'] = expired;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create session balance
         * @param {AdminCreateSessionBalancesRequestDto} adminCreateSessionBalancesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionBalancesControllerUseSessionBalance: async (adminCreateSessionBalancesRequestDto: AdminCreateSessionBalancesRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminCreateSessionBalancesRequestDto' is not null or undefined
            assertParamExists('adminSessionBalancesControllerUseSessionBalance', 'adminCreateSessionBalancesRequestDto', adminCreateSessionBalancesRequestDto)
            const localVarPath = `/api/v1/admin/session-balances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateSessionBalancesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSessionBalancesApi - functional programming interface
 * @export
 */
export const AdminSessionBalancesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSessionBalancesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete session balance by id
         * @param {string} sessionBalanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSessionBalancesControllerDeleteSessionBalance(sessionBalanceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSessionBalancesControllerDeleteSessionBalance(sessionBalanceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get session balances by id
         * @param {string} sessionBalanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSessionBalancesControllerGetSessionBalance(sessionBalanceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSessionBalanceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSessionBalancesControllerGetSessionBalance(sessionBalanceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get paginated session balances
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'startWith' | 'endWith'} [orderTerms] 
         * @param {'consumerEmail' | 'adminName'} [searchTerm] 
         * @param {string} [searchValue] value to search by searchTerm
         * @param {string} [companyId] Company ID
         * @param {string} [userId] User ID
         * @param {string} [role] Company role
         * @param {string} [group] Company group
         * @param {boolean} [used] is used status
         * @param {boolean} [unused] is unused status
         * @param {boolean} [notStarted] is not started status
         * @param {boolean} [expired] is expired status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSessionBalancesControllerGetSessionBalances(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startWith' | 'endWith', searchTerm?: 'consumerEmail' | 'adminName', searchValue?: string, companyId?: string, userId?: string, role?: string, group?: string, used?: boolean, unused?: boolean, notStarted?: boolean, expired?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSessionBalancesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSessionBalancesControllerGetSessionBalances(limit, page, order, orderTerms, searchTerm, searchValue, companyId, userId, role, group, used, unused, notStarted, expired, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create session balance
         * @param {AdminCreateSessionBalancesRequestDto} adminCreateSessionBalancesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSessionBalancesControllerUseSessionBalance(adminCreateSessionBalancesRequestDto: AdminCreateSessionBalancesRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSessionBalancesControllerUseSessionBalance(adminCreateSessionBalancesRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminSessionBalancesApi - factory interface
 * @export
 */
export const AdminSessionBalancesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSessionBalancesApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete session balance by id
         * @param {string} sessionBalanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionBalancesControllerDeleteSessionBalance(sessionBalanceId: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminSessionBalancesControllerDeleteSessionBalance(sessionBalanceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get session balances by id
         * @param {string} sessionBalanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionBalancesControllerGetSessionBalance(sessionBalanceId: string, options?: any): AxiosPromise<AdminSessionBalanceResponseDto> {
            return localVarFp.adminSessionBalancesControllerGetSessionBalance(sessionBalanceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get paginated session balances
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'startWith' | 'endWith'} [orderTerms] 
         * @param {'consumerEmail' | 'adminName'} [searchTerm] 
         * @param {string} [searchValue] value to search by searchTerm
         * @param {string} [companyId] Company ID
         * @param {string} [userId] User ID
         * @param {string} [role] Company role
         * @param {string} [group] Company group
         * @param {boolean} [used] is used status
         * @param {boolean} [unused] is unused status
         * @param {boolean} [notStarted] is not started status
         * @param {boolean} [expired] is expired status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionBalancesControllerGetSessionBalances(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startWith' | 'endWith', searchTerm?: 'consumerEmail' | 'adminName', searchValue?: string, companyId?: string, userId?: string, role?: string, group?: string, used?: boolean, unused?: boolean, notStarted?: boolean, expired?: boolean, options?: any): AxiosPromise<AdminSessionBalancesResponseDto> {
            return localVarFp.adminSessionBalancesControllerGetSessionBalances(limit, page, order, orderTerms, searchTerm, searchValue, companyId, userId, role, group, used, unused, notStarted, expired, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create session balance
         * @param {AdminCreateSessionBalancesRequestDto} adminCreateSessionBalancesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionBalancesControllerUseSessionBalance(adminCreateSessionBalancesRequestDto: AdminCreateSessionBalancesRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminSessionBalancesControllerUseSessionBalance(adminCreateSessionBalancesRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSessionBalancesApi - object-oriented interface
 * @export
 * @class AdminSessionBalancesApi
 * @extends {BaseAPI}
 */
export class AdminSessionBalancesApi extends BaseAPI {
    /**
     * 
     * @summary Delete session balance by id
     * @param {string} sessionBalanceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionBalancesApi
     */
    public adminSessionBalancesControllerDeleteSessionBalance(sessionBalanceId: string, options?: AxiosRequestConfig) {
        return AdminSessionBalancesApiFp(this.configuration).adminSessionBalancesControllerDeleteSessionBalance(sessionBalanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get session balances by id
     * @param {string} sessionBalanceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionBalancesApi
     */
    public adminSessionBalancesControllerGetSessionBalance(sessionBalanceId: string, options?: AxiosRequestConfig) {
        return AdminSessionBalancesApiFp(this.configuration).adminSessionBalancesControllerGetSessionBalance(sessionBalanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get paginated session balances
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'createdAt' | 'startWith' | 'endWith'} [orderTerms] 
     * @param {'consumerEmail' | 'adminName'} [searchTerm] 
     * @param {string} [searchValue] value to search by searchTerm
     * @param {string} [companyId] Company ID
     * @param {string} [userId] User ID
     * @param {string} [role] Company role
     * @param {string} [group] Company group
     * @param {boolean} [used] is used status
     * @param {boolean} [unused] is unused status
     * @param {boolean} [notStarted] is not started status
     * @param {boolean} [expired] is expired status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionBalancesApi
     */
    public adminSessionBalancesControllerGetSessionBalances(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startWith' | 'endWith', searchTerm?: 'consumerEmail' | 'adminName', searchValue?: string, companyId?: string, userId?: string, role?: string, group?: string, used?: boolean, unused?: boolean, notStarted?: boolean, expired?: boolean, options?: AxiosRequestConfig) {
        return AdminSessionBalancesApiFp(this.configuration).adminSessionBalancesControllerGetSessionBalances(limit, page, order, orderTerms, searchTerm, searchValue, companyId, userId, role, group, used, unused, notStarted, expired, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create session balance
     * @param {AdminCreateSessionBalancesRequestDto} adminCreateSessionBalancesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionBalancesApi
     */
    public adminSessionBalancesControllerUseSessionBalance(adminCreateSessionBalancesRequestDto: AdminCreateSessionBalancesRequestDto, options?: AxiosRequestConfig) {
        return AdminSessionBalancesApiFp(this.configuration).adminSessionBalancesControllerUseSessionBalance(adminCreateSessionBalancesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminSessionSummariesApi - axios parameter creator
 * @export
 */
export const AdminSessionSummariesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get session feedback by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFeedbackSummariesControllerGetSessionById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminFeedbackSummariesControllerGetSessionById', 'id', id)
            const localVarPath = `/api/v1/admin/session-summaries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get session feedback
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'startDate'} [orderTerms] 
         * @param {string} [therapistName] 
         * @param {string} [therapistEmail] 
         * @param {boolean} [isB2B] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFeedbackSummariesControllerGetSessions: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startDate', therapistName?: string, therapistEmail?: string, isB2B?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminFeedbackSummariesControllerGetSessions', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminFeedbackSummariesControllerGetSessions', 'page', page)
            const localVarPath = `/api/v1/admin/session-summaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (therapistName !== undefined) {
                localVarQueryParameter['therapistName'] = therapistName;
            }

            if (therapistEmail !== undefined) {
                localVarQueryParameter['therapistEmail'] = therapistEmail;
            }

            if (isB2B !== undefined) {
                localVarQueryParameter['isB2B'] = isB2B;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSessionSummariesApi - functional programming interface
 * @export
 */
export const AdminSessionSummariesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSessionSummariesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get session feedback by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFeedbackSummariesControllerGetSessionById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSessionFeedbackResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFeedbackSummariesControllerGetSessionById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get session feedback
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'startDate'} [orderTerms] 
         * @param {string} [therapistName] 
         * @param {string} [therapistEmail] 
         * @param {boolean} [isB2B] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminFeedbackSummariesControllerGetSessions(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startDate', therapistName?: string, therapistEmail?: string, isB2B?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSessionFeedbackListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminFeedbackSummariesControllerGetSessions(limit, page, order, orderTerms, therapistName, therapistEmail, isB2B, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminSessionSummariesApi - factory interface
 * @export
 */
export const AdminSessionSummariesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSessionSummariesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get session feedback by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFeedbackSummariesControllerGetSessionById(id: string, options?: any): AxiosPromise<AdminSessionFeedbackResponseDto> {
            return localVarFp.adminFeedbackSummariesControllerGetSessionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get session feedback
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'startDate'} [orderTerms] 
         * @param {string} [therapistName] 
         * @param {string} [therapistEmail] 
         * @param {boolean} [isB2B] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFeedbackSummariesControllerGetSessions(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startDate', therapistName?: string, therapistEmail?: string, isB2B?: boolean, options?: any): AxiosPromise<AdminSessionFeedbackListResponseDto> {
            return localVarFp.adminFeedbackSummariesControllerGetSessions(limit, page, order, orderTerms, therapistName, therapistEmail, isB2B, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSessionSummariesApi - object-oriented interface
 * @export
 * @class AdminSessionSummariesApi
 * @extends {BaseAPI}
 */
export class AdminSessionSummariesApi extends BaseAPI {
    /**
     * 
     * @summary Get session feedback by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionSummariesApi
     */
    public adminFeedbackSummariesControllerGetSessionById(id: string, options?: AxiosRequestConfig) {
        return AdminSessionSummariesApiFp(this.configuration).adminFeedbackSummariesControllerGetSessionById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get session feedback
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'createdAt' | 'startDate'} [orderTerms] 
     * @param {string} [therapistName] 
     * @param {string} [therapistEmail] 
     * @param {boolean} [isB2B] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionSummariesApi
     */
    public adminFeedbackSummariesControllerGetSessions(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startDate', therapistName?: string, therapistEmail?: string, isB2B?: boolean, options?: AxiosRequestConfig) {
        return AdminSessionSummariesApiFp(this.configuration).adminFeedbackSummariesControllerGetSessions(limit, page, order, orderTerms, therapistName, therapistEmail, isB2B, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminSessionsApi - axios parameter creator
 * @export
 */
export const AdminSessionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel session payment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionsControllerCancelSessionPayment: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminSessionsControllerCancelSessionPayment', 'id', id)
            const localVarPath = `/api/v1/admin/sessions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get therapist session by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionsControllerGetSessionById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminSessionsControllerGetSessionById', 'id', id)
            const localVarPath = `/api/v1/admin/sessions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get therapist sessions, order by startDate
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [therapistId] 
         * @param {'awaiting' | 'live' | 'complete' | 'canceled'} [status] 
         * @param {string} [patientId] 
         * @param {boolean} [isB2B] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionsControllerGetSessions: async (limit: number, page: number, order?: 'ASC' | 'DESC', therapistId?: string, status?: 'awaiting' | 'live' | 'complete' | 'canceled', patientId?: string, isB2B?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminSessionsControllerGetSessions', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminSessionsControllerGetSessions', 'page', page)
            const localVarPath = `/api/v1/admin/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (therapistId !== undefined) {
                localVarQueryParameter['therapistId'] = therapistId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (isB2B !== undefined) {
                localVarQueryParameter['isB2B'] = isB2B;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set session payment as paid for promocode
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionsControllerSetPaidForPromocode: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminSessionsControllerSetPaidForPromocode', 'id', id)
            const localVarPath = `/api/v1/admin/sessions/pay-promocode/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set session payment as paid
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionsControllerSetPaidForSession: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminSessionsControllerSetPaidForSession', 'id', id)
            const localVarPath = `/api/v1/admin/sessions/pay-session/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSessionsApi - functional programming interface
 * @export
 */
export const AdminSessionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSessionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel session payment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSessionsControllerCancelSessionPayment(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSessionsControllerCancelSessionPayment(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get therapist session by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSessionsControllerGetSessionById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSessionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSessionsControllerGetSessionById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get therapist sessions, order by startDate
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [therapistId] 
         * @param {'awaiting' | 'live' | 'complete' | 'canceled'} [status] 
         * @param {string} [patientId] 
         * @param {boolean} [isB2B] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSessionsControllerGetSessions(limit: number, page: number, order?: 'ASC' | 'DESC', therapistId?: string, status?: 'awaiting' | 'live' | 'complete' | 'canceled', patientId?: string, isB2B?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSessionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSessionsControllerGetSessions(limit, page, order, therapistId, status, patientId, isB2B, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set session payment as paid for promocode
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSessionsControllerSetPaidForPromocode(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSessionsControllerSetPaidForPromocode(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set session payment as paid
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSessionsControllerSetPaidForSession(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSessionsControllerSetPaidForSession(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminSessionsApi - factory interface
 * @export
 */
export const AdminSessionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSessionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel session payment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionsControllerCancelSessionPayment(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminSessionsControllerCancelSessionPayment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get therapist session by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionsControllerGetSessionById(id: string, options?: any): AxiosPromise<AdminSessionResponseDto> {
            return localVarFp.adminSessionsControllerGetSessionById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get therapist sessions, order by startDate
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [therapistId] 
         * @param {'awaiting' | 'live' | 'complete' | 'canceled'} [status] 
         * @param {string} [patientId] 
         * @param {boolean} [isB2B] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionsControllerGetSessions(limit: number, page: number, order?: 'ASC' | 'DESC', therapistId?: string, status?: 'awaiting' | 'live' | 'complete' | 'canceled', patientId?: string, isB2B?: boolean, options?: any): AxiosPromise<AdminSessionsResponseDto> {
            return localVarFp.adminSessionsControllerGetSessions(limit, page, order, therapistId, status, patientId, isB2B, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set session payment as paid for promocode
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionsControllerSetPaidForPromocode(id: string, options?: any): AxiosPromise<PaymentResponseDto> {
            return localVarFp.adminSessionsControllerSetPaidForPromocode(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set session payment as paid
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSessionsControllerSetPaidForSession(id: string, options?: any): AxiosPromise<PaymentResponseDto> {
            return localVarFp.adminSessionsControllerSetPaidForSession(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSessionsApi - object-oriented interface
 * @export
 * @class AdminSessionsApi
 * @extends {BaseAPI}
 */
export class AdminSessionsApi extends BaseAPI {
    /**
     * 
     * @summary Cancel session payment
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionsApi
     */
    public adminSessionsControllerCancelSessionPayment(id: string, options?: AxiosRequestConfig) {
        return AdminSessionsApiFp(this.configuration).adminSessionsControllerCancelSessionPayment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get therapist session by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionsApi
     */
    public adminSessionsControllerGetSessionById(id: string, options?: AxiosRequestConfig) {
        return AdminSessionsApiFp(this.configuration).adminSessionsControllerGetSessionById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get therapist sessions, order by startDate
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {string} [therapistId] 
     * @param {'awaiting' | 'live' | 'complete' | 'canceled'} [status] 
     * @param {string} [patientId] 
     * @param {boolean} [isB2B] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionsApi
     */
    public adminSessionsControllerGetSessions(limit: number, page: number, order?: 'ASC' | 'DESC', therapistId?: string, status?: 'awaiting' | 'live' | 'complete' | 'canceled', patientId?: string, isB2B?: boolean, options?: AxiosRequestConfig) {
        return AdminSessionsApiFp(this.configuration).adminSessionsControllerGetSessions(limit, page, order, therapistId, status, patientId, isB2B, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set session payment as paid for promocode
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionsApi
     */
    public adminSessionsControllerSetPaidForPromocode(id: string, options?: AxiosRequestConfig) {
        return AdminSessionsApiFp(this.configuration).adminSessionsControllerSetPaidForPromocode(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set session payment as paid
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSessionsApi
     */
    public adminSessionsControllerSetPaidForSession(id: string, options?: AxiosRequestConfig) {
        return AdminSessionsApiFp(this.configuration).adminSessionsControllerSetPaidForSession(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminStatisticsApi - axios parameter creator
 * @export
 */
export const AdminStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get session statistics for one patient by id
         * @param {string} patientId 
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStatisticsControllerGetPatientSessionStatistics: async (patientId: string, startDate: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('adminStatisticsControllerGetPatientSessionStatistics', 'patientId', patientId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('adminStatisticsControllerGetPatientSessionStatistics', 'startDate', startDate)
            const localVarPath = `/api/v1/admin/statistics/sessions/patient/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get session statistics
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStatisticsControllerGetSessionStatistics: async (startDate: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('adminStatisticsControllerGetSessionStatistics', 'startDate', startDate)
            const localVarPath = `/api/v1/admin/statistics/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get session client statistics
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStatisticsControllerGetSessionStatisticsClients: async (startDate: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('adminStatisticsControllerGetSessionStatisticsClients', 'startDate', startDate)
            const localVarPath = `/api/v1/admin/statistics/sessions-clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get session statistics for one patient by id
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {Array<string>} [therapistIds] 
         * @param {Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>} [payoutStatuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStatisticsControllerGetTherapistPromocodeStatistics: async (startDate: string, endDate?: string, therapistIds?: Array<string>, payoutStatuses?: Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('adminStatisticsControllerGetTherapistPromocodeStatistics', 'startDate', startDate)
            const localVarPath = `/api/v1/admin/statistics/therapists/promocodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (therapistIds) {
                localVarQueryParameter['therapistIds'] = therapistIds;
            }

            if (payoutStatuses) {
                localVarQueryParameter['payoutStatuses'] = payoutStatuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get session statistics for one therapist by id
         * @param {string} therapistId 
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStatisticsControllerGetTherapistSessionStatistics: async (therapistId: string, startDate: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('adminStatisticsControllerGetTherapistSessionStatistics', 'therapistId', therapistId)
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('adminStatisticsControllerGetTherapistSessionStatistics', 'startDate', startDate)
            const localVarPath = `/api/v1/admin/statistics/sessions/therapist/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Therapists statistics export
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStatisticsControllerGetTherapistsStatistics: async (startDate: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startDate' is not null or undefined
            assertParamExists('adminStatisticsControllerGetTherapistsStatistics', 'startDate', startDate)
            const localVarPath = `/api/v1/admin/statistics/therapists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminStatisticsApi - functional programming interface
 * @export
 */
export const AdminStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get session statistics for one patient by id
         * @param {string} patientId 
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminStatisticsControllerGetPatientSessionStatistics(patientId: string, startDate: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionStatisticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminStatisticsControllerGetPatientSessionStatistics(patientId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get session statistics
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminStatisticsControllerGetSessionStatistics(startDate: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionStatisticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminStatisticsControllerGetSessionStatistics(startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get session client statistics
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminStatisticsControllerGetSessionStatisticsClients(startDate: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignStatisticsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminStatisticsControllerGetSessionStatisticsClients(startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get session statistics for one patient by id
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {Array<string>} [therapistIds] 
         * @param {Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>} [payoutStatuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminStatisticsControllerGetTherapistPromocodeStatistics(startDate: string, endDate?: string, therapistIds?: Array<string>, payoutStatuses?: Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminStatisticsControllerGetTherapistPromocodeStatistics(startDate, endDate, therapistIds, payoutStatuses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get session statistics for one therapist by id
         * @param {string} therapistId 
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminStatisticsControllerGetTherapistSessionStatistics(therapistId: string, startDate: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionStatisticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminStatisticsControllerGetTherapistSessionStatistics(therapistId, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Therapists statistics export
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminStatisticsControllerGetTherapistsStatistics(startDate: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminStatisticsControllerGetTherapistsStatistics(startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminStatisticsApi - factory interface
 * @export
 */
export const AdminStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminStatisticsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get session statistics for one patient by id
         * @param {string} patientId 
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStatisticsControllerGetPatientSessionStatistics(patientId: string, startDate: string, endDate?: string, options?: any): AxiosPromise<SessionStatisticsResponseDto> {
            return localVarFp.adminStatisticsControllerGetPatientSessionStatistics(patientId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get session statistics
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStatisticsControllerGetSessionStatistics(startDate: string, endDate?: string, options?: any): AxiosPromise<SessionStatisticsResponseDto> {
            return localVarFp.adminStatisticsControllerGetSessionStatistics(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get session client statistics
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStatisticsControllerGetSessionStatisticsClients(startDate: string, endDate?: string, options?: any): AxiosPromise<CampaignStatisticsDto> {
            return localVarFp.adminStatisticsControllerGetSessionStatisticsClients(startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get session statistics for one patient by id
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {Array<string>} [therapistIds] 
         * @param {Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>} [payoutStatuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStatisticsControllerGetTherapistPromocodeStatistics(startDate: string, endDate?: string, therapistIds?: Array<string>, payoutStatuses?: Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>, options?: any): AxiosPromise<void> {
            return localVarFp.adminStatisticsControllerGetTherapistPromocodeStatistics(startDate, endDate, therapistIds, payoutStatuses, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get session statistics for one therapist by id
         * @param {string} therapistId 
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStatisticsControllerGetTherapistSessionStatistics(therapistId: string, startDate: string, endDate?: string, options?: any): AxiosPromise<SessionStatisticsResponseDto> {
            return localVarFp.adminStatisticsControllerGetTherapistSessionStatistics(therapistId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Therapists statistics export
         * @param {string} startDate 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminStatisticsControllerGetTherapistsStatistics(startDate: string, endDate?: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminStatisticsControllerGetTherapistsStatistics(startDate, endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminStatisticsApi - object-oriented interface
 * @export
 * @class AdminStatisticsApi
 * @extends {BaseAPI}
 */
export class AdminStatisticsApi extends BaseAPI {
    /**
     * 
     * @summary Get session statistics for one patient by id
     * @param {string} patientId 
     * @param {string} startDate 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminStatisticsApi
     */
    public adminStatisticsControllerGetPatientSessionStatistics(patientId: string, startDate: string, endDate?: string, options?: AxiosRequestConfig) {
        return AdminStatisticsApiFp(this.configuration).adminStatisticsControllerGetPatientSessionStatistics(patientId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get session statistics
     * @param {string} startDate 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminStatisticsApi
     */
    public adminStatisticsControllerGetSessionStatistics(startDate: string, endDate?: string, options?: AxiosRequestConfig) {
        return AdminStatisticsApiFp(this.configuration).adminStatisticsControllerGetSessionStatistics(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get session client statistics
     * @param {string} startDate 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminStatisticsApi
     */
    public adminStatisticsControllerGetSessionStatisticsClients(startDate: string, endDate?: string, options?: AxiosRequestConfig) {
        return AdminStatisticsApiFp(this.configuration).adminStatisticsControllerGetSessionStatisticsClients(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get session statistics for one patient by id
     * @param {string} startDate 
     * @param {string} [endDate] 
     * @param {Array<string>} [therapistIds] 
     * @param {Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>} [payoutStatuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminStatisticsApi
     */
    public adminStatisticsControllerGetTherapistPromocodeStatistics(startDate: string, endDate?: string, therapistIds?: Array<string>, payoutStatuses?: Array<'awaiting' | 'pending' | 'awaiting_promocode' | 'succeeded' | 'canceled'>, options?: AxiosRequestConfig) {
        return AdminStatisticsApiFp(this.configuration).adminStatisticsControllerGetTherapistPromocodeStatistics(startDate, endDate, therapistIds, payoutStatuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get session statistics for one therapist by id
     * @param {string} therapistId 
     * @param {string} startDate 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminStatisticsApi
     */
    public adminStatisticsControllerGetTherapistSessionStatistics(therapistId: string, startDate: string, endDate?: string, options?: AxiosRequestConfig) {
        return AdminStatisticsApiFp(this.configuration).adminStatisticsControllerGetTherapistSessionStatistics(therapistId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Therapists statistics export
     * @param {string} startDate 
     * @param {string} [endDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminStatisticsApi
     */
    public adminStatisticsControllerGetTherapistsStatistics(startDate: string, endDate?: string, options?: AxiosRequestConfig) {
        return AdminStatisticsApiFp(this.configuration).adminStatisticsControllerGetTherapistsStatistics(startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminTherapistsApi - axios parameter creator
 * @export
 */
export const AdminTherapistsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept profile update
         * @summary Accept profile update
         * @param {string} therapistProfileUpdateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerAcceptProfileUpdate: async (therapistProfileUpdateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistProfileUpdateId' is not null or undefined
            assertParamExists('adminTherapistsControllerAcceptProfileUpdate', 'therapistProfileUpdateId', therapistProfileUpdateId)
            const localVarPath = `/api/v1/admin/therapists/profile-updates/{therapistProfileUpdateId}/accept`
                .replace(`{${"therapistProfileUpdateId"}}`, encodeURIComponent(String(therapistProfileUpdateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Approve therapist by id
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerApproveTherapist: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminTherapistsControllerApproveTherapist', 'id', id)
            const localVarPath = `/api/v1/admin/therapists/approve/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ban therapist by id
         * @summary Ban therapist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerBanTherapist: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminTherapistsControllerBanTherapist', 'id', id)
            const localVarPath = `/api/v1/admin/therapists/ban/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get profile update by id
         * @summary Get profile update by id
         * @param {string} therapistProfileUpdateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerGetProfileUpdateById: async (therapistProfileUpdateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistProfileUpdateId' is not null or undefined
            assertParamExists('adminTherapistsControllerGetProfileUpdateById', 'therapistProfileUpdateId', therapistProfileUpdateId)
            const localVarPath = `/api/v1/admin/therapists/profile-updates/{therapistProfileUpdateId}`
                .replace(`{${"therapistProfileUpdateId"}}`, encodeURIComponent(String(therapistProfileUpdateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get profile updates, sorting by update\'s createdAt
         * @summary Get profile updates, sorting by update\'s createdAt
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerGetProfileUpdates: async (limit: number, page: number, order?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminTherapistsControllerGetProfileUpdates', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminTherapistsControllerGetProfileUpdates', 'page', page)
            const localVarPath = `/api/v1/admin/therapists/profile-updates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get therapist by id
         * @summary Get therapist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerGetTherapistById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminTherapistsControllerGetTherapistById', 'id', id)
            const localVarPath = `/api/v1/admin/therapists/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get therapist request by id
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerGetTherapistRequestByUserId: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminTherapistsControllerGetTherapistRequestByUserId', 'id', id)
            const localVarPath = `/api/v1/admin/therapists/requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get therapist requests, sorting by createdAt
         * @summary Get therapists
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname'} [orderTerms] 
         * @param {'name' | 'email'} [searchTerm] name or email
         * @param {string} [searchValue] value to search by searchTerm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerGetTherapistRequests: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname', searchTerm?: 'name' | 'email', searchValue?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminTherapistsControllerGetTherapistRequests', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminTherapistsControllerGetTherapistRequests', 'page', page)
            const localVarPath = `/api/v1/admin/therapists/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (searchValue !== undefined) {
                localVarQueryParameter['searchValue'] = searchValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get therapists
         * @summary Get therapists
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname'} [orderTerms] 
         * @param {'name' | 'email'} [searchTerm] name or email
         * @param {string} [searchValue] value to search by searchTerm
         * @param {boolean} [isB2B] 
         * @param {boolean} [isChildTherapist] 
         * @param {boolean} [isAdult] 
         * @param {boolean} [isSupervisor] 
         * @param {boolean} [isTest] 
         * @param {boolean} [isTop] 
         * @param {boolean} [isCoach] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerGetTherapists: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname', searchTerm?: 'name' | 'email', searchValue?: string, isB2B?: boolean, isChildTherapist?: boolean, isAdult?: boolean, isSupervisor?: boolean, isTest?: boolean, isTop?: boolean, isCoach?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminTherapistsControllerGetTherapists', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminTherapistsControllerGetTherapists', 'page', page)
            const localVarPath = `/api/v1/admin/therapists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (searchValue !== undefined) {
                localVarQueryParameter['searchValue'] = searchValue;
            }

            if (isB2B !== undefined) {
                localVarQueryParameter['isB2B'] = isB2B;
            }

            if (isChildTherapist !== undefined) {
                localVarQueryParameter['isChildTherapist'] = isChildTherapist;
            }

            if (isAdult !== undefined) {
                localVarQueryParameter['isAdult'] = isAdult;
            }

            if (isSupervisor !== undefined) {
                localVarQueryParameter['isSupervisor'] = isSupervisor;
            }

            if (isTest !== undefined) {
                localVarQueryParameter['isTest'] = isTest;
            }

            if (isTop !== undefined) {
                localVarQueryParameter['isTop'] = isTop;
            }

            if (isCoach !== undefined) {
                localVarQueryParameter['isCoach'] = isCoach;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get therapists statistic
         * @summary Get therapists statistics
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname'} [orderTerms] 
         * @param {'name' | 'email'} [searchTerm] name or email
         * @param {string} [searchValue] value to search by searchTerm
         * @param {boolean} [isB2B] 
         * @param {boolean} [isChildTherapist] 
         * @param {boolean} [isAdult] 
         * @param {boolean} [isSupervisor] 
         * @param {boolean} [isTest] 
         * @param {boolean} [isTop] 
         * @param {boolean} [isCoach] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerGetTherapistsStatistics: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname', searchTerm?: 'name' | 'email', searchValue?: string, isB2B?: boolean, isChildTherapist?: boolean, isAdult?: boolean, isSupervisor?: boolean, isTest?: boolean, isTop?: boolean, isCoach?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminTherapistsControllerGetTherapistsStatistics', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminTherapistsControllerGetTherapistsStatistics', 'page', page)
            const localVarPath = `/api/v1/admin/therapists/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (searchValue !== undefined) {
                localVarQueryParameter['searchValue'] = searchValue;
            }

            if (isB2B !== undefined) {
                localVarQueryParameter['isB2B'] = isB2B;
            }

            if (isChildTherapist !== undefined) {
                localVarQueryParameter['isChildTherapist'] = isChildTherapist;
            }

            if (isAdult !== undefined) {
                localVarQueryParameter['isAdult'] = isAdult;
            }

            if (isSupervisor !== undefined) {
                localVarQueryParameter['isSupervisor'] = isSupervisor;
            }

            if (isTest !== undefined) {
                localVarQueryParameter['isTest'] = isTest;
            }

            if (isTop !== undefined) {
                localVarQueryParameter['isTop'] = isTop;
            }

            if (isCoach !== undefined) {
                localVarQueryParameter['isCoach'] = isCoach;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject therapist profile update
         * @param {string} therapistProfileUpdateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerRejectProfileUpdate: async (therapistProfileUpdateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistProfileUpdateId' is not null or undefined
            assertParamExists('adminTherapistsControllerRejectProfileUpdate', 'therapistProfileUpdateId', therapistProfileUpdateId)
            const localVarPath = `/api/v1/admin/therapists/profile-updates/{therapistProfileUpdateId}/reject`
                .replace(`{${"therapistProfileUpdateId"}}`, encodeURIComponent(String(therapistProfileUpdateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify therapist
         * @param {string} id 
         * @param {AdminRejectTherapistRequestDto} adminRejectTherapistRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerRejectTherapist: async (id: string, adminRejectTherapistRequestDto: AdminRejectTherapistRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminTherapistsControllerRejectTherapist', 'id', id)
            // verify required parameter 'adminRejectTherapistRequestDto' is not null or undefined
            assertParamExists('adminTherapistsControllerRejectTherapist', 'adminRejectTherapistRequestDto', adminRejectTherapistRequestDto)
            const localVarPath = `/api/v1/admin/therapists/requests/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminRejectTherapistRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unapprove therapist by id
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUnapproveTherapist: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminTherapistsControllerUnapproveTherapist', 'id', id)
            const localVarPath = `/api/v1/admin/therapists/unapprove/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unban therapist by id
         * @summary Unban therapist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUnbanTherapist: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminTherapistsControllerUnbanTherapist', 'id', id)
            const localVarPath = `/api/v1/admin/therapists/unban/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change field about
         * @param {string} therapistId 
         * @param {TherapistProfileUpdateAbout} therapistProfileUpdateAbout 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateAbout: async (therapistId: string, therapistProfileUpdateAbout: TherapistProfileUpdateAbout, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateAbout', 'therapistId', therapistId)
            // verify required parameter 'therapistProfileUpdateAbout' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateAbout', 'therapistProfileUpdateAbout', therapistProfileUpdateAbout)
            const localVarPath = `/api/v1/admin/therapists/update-about/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistProfileUpdateAbout, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change field isAdult
         * @param {string} therapistId 
         * @param {TherapistUpdateIsAdult} therapistUpdateIsAdult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsAdult: async (therapistId: string, therapistUpdateIsAdult: TherapistUpdateIsAdult, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsAdult', 'therapistId', therapistId)
            // verify required parameter 'therapistUpdateIsAdult' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsAdult', 'therapistUpdateIsAdult', therapistUpdateIsAdult)
            const localVarPath = `/api/v1/admin/therapists/update-is-adult/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistUpdateIsAdult, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change field IsB2B
         * @param {string} therapistId 
         * @param {TherapistUpdateIsB2BDto} therapistUpdateIsB2BDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsB2B: async (therapistId: string, therapistUpdateIsB2BDto: TherapistUpdateIsB2BDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsB2B', 'therapistId', therapistId)
            // verify required parameter 'therapistUpdateIsB2BDto' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsB2B', 'therapistUpdateIsB2BDto', therapistUpdateIsB2BDto)
            const localVarPath = `/api/v1/admin/therapists/update-is-b2b/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistUpdateIsB2BDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change field isChildTherapist
         * @param {string} therapistId 
         * @param {TherapistUpdateIsChildTherapistDto} therapistUpdateIsChildTherapistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsChildTherapists: async (therapistId: string, therapistUpdateIsChildTherapistDto: TherapistUpdateIsChildTherapistDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsChildTherapists', 'therapistId', therapistId)
            // verify required parameter 'therapistUpdateIsChildTherapistDto' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsChildTherapists', 'therapistUpdateIsChildTherapistDto', therapistUpdateIsChildTherapistDto)
            const localVarPath = `/api/v1/admin/therapists/update-is-child-therapist/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistUpdateIsChildTherapistDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change field IsCoach
         * @param {string} therapistId 
         * @param {TherapistUpdateIsCoachDto} therapistUpdateIsCoachDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsCoach: async (therapistId: string, therapistUpdateIsCoachDto: TherapistUpdateIsCoachDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsCoach', 'therapistId', therapistId)
            // verify required parameter 'therapistUpdateIsCoachDto' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsCoach', 'therapistUpdateIsCoachDto', therapistUpdateIsCoachDto)
            const localVarPath = `/api/v1/admin/therapists/update-is-coach/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistUpdateIsCoachDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change field isMedsi
         * @param {string} therapistId 
         * @param {TherapistUpdateIsMedsiDto} therapistUpdateIsMedsiDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsMedsi: async (therapistId: string, therapistUpdateIsMedsiDto: TherapistUpdateIsMedsiDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsMedsi', 'therapistId', therapistId)
            // verify required parameter 'therapistUpdateIsMedsiDto' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsMedsi', 'therapistUpdateIsMedsiDto', therapistUpdateIsMedsiDto)
            const localVarPath = `/api/v1/admin/therapists/update-is-medsi/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistUpdateIsMedsiDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change field IsSupervisor
         * @param {string} therapistId 
         * @param {TherapistUpdateIsSupervisorDto} therapistUpdateIsSupervisorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsSupervisor: async (therapistId: string, therapistUpdateIsSupervisorDto: TherapistUpdateIsSupervisorDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsSupervisor', 'therapistId', therapistId)
            // verify required parameter 'therapistUpdateIsSupervisorDto' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsSupervisor', 'therapistUpdateIsSupervisorDto', therapistUpdateIsSupervisorDto)
            const localVarPath = `/api/v1/admin/therapists/update-is-supervisor/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistUpdateIsSupervisorDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change field isTest
         * @param {string} therapistId 
         * @param {TherapistUpdateIsTestDto} therapistUpdateIsTestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsTest: async (therapistId: string, therapistUpdateIsTestDto: TherapistUpdateIsTestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsTest', 'therapistId', therapistId)
            // verify required parameter 'therapistUpdateIsTestDto' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsTest', 'therapistUpdateIsTestDto', therapistUpdateIsTestDto)
            const localVarPath = `/api/v1/admin/therapists/update-is-test/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistUpdateIsTestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change field isTop
         * @param {string} therapistId 
         * @param {TherapistUpdateIsTopDto} therapistUpdateIsTopDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsTop: async (therapistId: string, therapistUpdateIsTopDto: TherapistUpdateIsTopDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsTop', 'therapistId', therapistId)
            // verify required parameter 'therapistUpdateIsTopDto' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateIsTop', 'therapistUpdateIsTopDto', therapistUpdateIsTopDto)
            const localVarPath = `/api/v1/admin/therapists/update-is-top/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistUpdateIsTopDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change field rewardInPercent
         * @param {string} therapistId 
         * @param {TherapistUpdateRewardInPercent} therapistUpdateRewardInPercent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateRewardInPercent: async (therapistId: string, therapistUpdateRewardInPercent: TherapistUpdateRewardInPercent, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateRewardInPercent', 'therapistId', therapistId)
            // verify required parameter 'therapistUpdateRewardInPercent' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateRewardInPercent', 'therapistUpdateRewardInPercent', therapistUpdateRewardInPercent)
            const localVarPath = `/api/v1/admin/therapists/update-reward-in-percent/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistUpdateRewardInPercent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change field (session) price
         * @param {string} therapistId 
         * @param {TherapistUpdateSessionPrice} therapistUpdateSessionPrice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateSessionPrice: async (therapistId: string, therapistUpdateSessionPrice: TherapistUpdateSessionPrice, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateSessionPrice', 'therapistId', therapistId)
            // verify required parameter 'therapistUpdateSessionPrice' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateSessionPrice', 'therapistUpdateSessionPrice', therapistUpdateSessionPrice)
            const localVarPath = `/api/v1/admin/therapists/update-session-price/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistUpdateSessionPrice, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change field shortAbout
         * @param {string} therapistId 
         * @param {TherapistProfileUpdateShortAbout} therapistProfileUpdateShortAbout 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateShortAbout: async (therapistId: string, therapistProfileUpdateShortAbout: TherapistProfileUpdateShortAbout, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateShortAbout', 'therapistId', therapistId)
            // verify required parameter 'therapistProfileUpdateShortAbout' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateShortAbout', 'therapistProfileUpdateShortAbout', therapistProfileUpdateShortAbout)
            const localVarPath = `/api/v1/admin/therapists/update-short-about/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistProfileUpdateShortAbout, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change field specialisation
         * @param {string} therapistId 
         * @param {TherapistUpdateSpecialisationDto} therapistUpdateSpecialisationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateSpecialisation: async (therapistId: string, therapistUpdateSpecialisationDto: TherapistUpdateSpecialisationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateSpecialisation', 'therapistId', therapistId)
            // verify required parameter 'therapistUpdateSpecialisationDto' is not null or undefined
            assertParamExists('adminTherapistsControllerUpdateSpecialisation', 'therapistUpdateSpecialisationDto', therapistUpdateSpecialisationDto)
            const localVarPath = `/api/v1/admin/therapists/update-specialisation/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistUpdateSpecialisationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify therapist by request id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerVerifyTherapist: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminTherapistsControllerVerifyTherapist', 'id', id)
            const localVarPath = `/api/v1/admin/therapists/requests/{id}/verify`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminTherapistsApi - functional programming interface
 * @export
 */
export const AdminTherapistsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminTherapistsApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept profile update
         * @summary Accept profile update
         * @param {string} therapistProfileUpdateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerAcceptProfileUpdate(therapistProfileUpdateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapistProfileUpdateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerAcceptProfileUpdate(therapistProfileUpdateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Approve therapist by id
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerApproveTherapist(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerApproveTherapist(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Ban therapist by id
         * @summary Ban therapist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerBanTherapist(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerBanTherapist(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get profile update by id
         * @summary Get profile update by id
         * @param {string} therapistProfileUpdateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerGetProfileUpdateById(therapistProfileUpdateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTherapistProfileUpdateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerGetProfileUpdateById(therapistProfileUpdateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get profile updates, sorting by update\'s createdAt
         * @summary Get profile updates, sorting by update\'s createdAt
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerGetProfileUpdates(limit: number, page: number, order?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTherapistProfileUpdatesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerGetProfileUpdates(limit, page, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get therapist by id
         * @summary Get therapist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerGetTherapistById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTherapistResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerGetTherapistById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get therapist request by id
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerGetTherapistRequestByUserId(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTherapistRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerGetTherapistRequestByUserId(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get therapist requests, sorting by createdAt
         * @summary Get therapists
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname'} [orderTerms] 
         * @param {'name' | 'email'} [searchTerm] name or email
         * @param {string} [searchValue] value to search by searchTerm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerGetTherapistRequests(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname', searchTerm?: 'name' | 'email', searchValue?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTherapistRequestsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerGetTherapistRequests(limit, page, order, orderTerms, searchTerm, searchValue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get therapists
         * @summary Get therapists
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname'} [orderTerms] 
         * @param {'name' | 'email'} [searchTerm] name or email
         * @param {string} [searchValue] value to search by searchTerm
         * @param {boolean} [isB2B] 
         * @param {boolean} [isChildTherapist] 
         * @param {boolean} [isAdult] 
         * @param {boolean} [isSupervisor] 
         * @param {boolean} [isTest] 
         * @param {boolean} [isTop] 
         * @param {boolean} [isCoach] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerGetTherapists(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname', searchTerm?: 'name' | 'email', searchValue?: string, isB2B?: boolean, isChildTherapist?: boolean, isAdult?: boolean, isSupervisor?: boolean, isTest?: boolean, isTop?: boolean, isCoach?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTherapistsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerGetTherapists(limit, page, order, orderTerms, searchTerm, searchValue, isB2B, isChildTherapist, isAdult, isSupervisor, isTest, isTop, isCoach, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get therapists statistic
         * @summary Get therapists statistics
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname'} [orderTerms] 
         * @param {'name' | 'email'} [searchTerm] name or email
         * @param {string} [searchValue] value to search by searchTerm
         * @param {boolean} [isB2B] 
         * @param {boolean} [isChildTherapist] 
         * @param {boolean} [isAdult] 
         * @param {boolean} [isSupervisor] 
         * @param {boolean} [isTest] 
         * @param {boolean} [isTop] 
         * @param {boolean} [isCoach] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerGetTherapistsStatistics(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname', searchTerm?: 'name' | 'email', searchValue?: string, isB2B?: boolean, isChildTherapist?: boolean, isAdult?: boolean, isSupervisor?: boolean, isTest?: boolean, isTop?: boolean, isCoach?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTherapisstStatisticResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerGetTherapistsStatistics(limit, page, order, orderTerms, searchTerm, searchValue, isB2B, isChildTherapist, isAdult, isSupervisor, isTest, isTop, isCoach, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject therapist profile update
         * @param {string} therapistProfileUpdateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerRejectProfileUpdate(therapistProfileUpdateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapistProfileUpdateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerRejectProfileUpdate(therapistProfileUpdateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verify therapist
         * @param {string} id 
         * @param {AdminRejectTherapistRequestDto} adminRejectTherapistRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerRejectTherapist(id: string, adminRejectTherapistRequestDto: AdminRejectTherapistRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerRejectTherapist(id, adminRejectTherapistRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unapprove therapist by id
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUnapproveTherapist(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUnapproveTherapist(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Unban therapist by id
         * @summary Unban therapist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUnbanTherapist(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUnbanTherapist(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change field about
         * @param {string} therapistId 
         * @param {TherapistProfileUpdateAbout} therapistProfileUpdateAbout 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUpdateAbout(therapistId: string, therapistProfileUpdateAbout: TherapistProfileUpdateAbout, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUpdateAbout(therapistId, therapistProfileUpdateAbout, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change field isAdult
         * @param {string} therapistId 
         * @param {TherapistUpdateIsAdult} therapistUpdateIsAdult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUpdateIsAdult(therapistId: string, therapistUpdateIsAdult: TherapistUpdateIsAdult, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUpdateIsAdult(therapistId, therapistUpdateIsAdult, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change field IsB2B
         * @param {string} therapistId 
         * @param {TherapistUpdateIsB2BDto} therapistUpdateIsB2BDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUpdateIsB2B(therapistId: string, therapistUpdateIsB2BDto: TherapistUpdateIsB2BDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUpdateIsB2B(therapistId, therapistUpdateIsB2BDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change field isChildTherapist
         * @param {string} therapistId 
         * @param {TherapistUpdateIsChildTherapistDto} therapistUpdateIsChildTherapistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUpdateIsChildTherapists(therapistId: string, therapistUpdateIsChildTherapistDto: TherapistUpdateIsChildTherapistDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUpdateIsChildTherapists(therapistId, therapistUpdateIsChildTherapistDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change field IsCoach
         * @param {string} therapistId 
         * @param {TherapistUpdateIsCoachDto} therapistUpdateIsCoachDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUpdateIsCoach(therapistId: string, therapistUpdateIsCoachDto: TherapistUpdateIsCoachDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUpdateIsCoach(therapistId, therapistUpdateIsCoachDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change field isMedsi
         * @param {string} therapistId 
         * @param {TherapistUpdateIsMedsiDto} therapistUpdateIsMedsiDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUpdateIsMedsi(therapistId: string, therapistUpdateIsMedsiDto: TherapistUpdateIsMedsiDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUpdateIsMedsi(therapistId, therapistUpdateIsMedsiDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change field IsSupervisor
         * @param {string} therapistId 
         * @param {TherapistUpdateIsSupervisorDto} therapistUpdateIsSupervisorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUpdateIsSupervisor(therapistId: string, therapistUpdateIsSupervisorDto: TherapistUpdateIsSupervisorDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUpdateIsSupervisor(therapistId, therapistUpdateIsSupervisorDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change field isTest
         * @param {string} therapistId 
         * @param {TherapistUpdateIsTestDto} therapistUpdateIsTestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUpdateIsTest(therapistId: string, therapistUpdateIsTestDto: TherapistUpdateIsTestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUpdateIsTest(therapistId, therapistUpdateIsTestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change field isTop
         * @param {string} therapistId 
         * @param {TherapistUpdateIsTopDto} therapistUpdateIsTopDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUpdateIsTop(therapistId: string, therapistUpdateIsTopDto: TherapistUpdateIsTopDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUpdateIsTop(therapistId, therapistUpdateIsTopDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change field rewardInPercent
         * @param {string} therapistId 
         * @param {TherapistUpdateRewardInPercent} therapistUpdateRewardInPercent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUpdateRewardInPercent(therapistId: string, therapistUpdateRewardInPercent: TherapistUpdateRewardInPercent, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUpdateRewardInPercent(therapistId, therapistUpdateRewardInPercent, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change field (session) price
         * @param {string} therapistId 
         * @param {TherapistUpdateSessionPrice} therapistUpdateSessionPrice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUpdateSessionPrice(therapistId: string, therapistUpdateSessionPrice: TherapistUpdateSessionPrice, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUpdateSessionPrice(therapistId, therapistUpdateSessionPrice, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change field shortAbout
         * @param {string} therapistId 
         * @param {TherapistProfileUpdateShortAbout} therapistProfileUpdateShortAbout 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUpdateShortAbout(therapistId: string, therapistProfileUpdateShortAbout: TherapistProfileUpdateShortAbout, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUpdateShortAbout(therapistId, therapistProfileUpdateShortAbout, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change field specialisation
         * @param {string} therapistId 
         * @param {TherapistUpdateSpecialisationDto} therapistUpdateSpecialisationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerUpdateSpecialisation(therapistId: string, therapistUpdateSpecialisationDto: TherapistUpdateSpecialisationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateTherapistMessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerUpdateSpecialisation(therapistId, therapistUpdateSpecialisationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verify therapist by request id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTherapistsControllerVerifyTherapist(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTherapistsControllerVerifyTherapist(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminTherapistsApi - factory interface
 * @export
 */
export const AdminTherapistsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminTherapistsApiFp(configuration)
    return {
        /**
         * Accept profile update
         * @summary Accept profile update
         * @param {string} therapistProfileUpdateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerAcceptProfileUpdate(therapistProfileUpdateId: string, options?: any): AxiosPromise<TherapistProfileUpdateResponseDto> {
            return localVarFp.adminTherapistsControllerAcceptProfileUpdate(therapistProfileUpdateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Approve therapist by id
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerApproveTherapist(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminTherapistsControllerApproveTherapist(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Ban therapist by id
         * @summary Ban therapist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerBanTherapist(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerBanTherapist(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get profile update by id
         * @summary Get profile update by id
         * @param {string} therapistProfileUpdateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerGetProfileUpdateById(therapistProfileUpdateId: string, options?: any): AxiosPromise<AdminTherapistProfileUpdateResponseDto> {
            return localVarFp.adminTherapistsControllerGetProfileUpdateById(therapistProfileUpdateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get profile updates, sorting by update\'s createdAt
         * @summary Get profile updates, sorting by update\'s createdAt
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerGetProfileUpdates(limit: number, page: number, order?: 'ASC' | 'DESC', options?: any): AxiosPromise<AdminTherapistProfileUpdatesResponseDto> {
            return localVarFp.adminTherapistsControllerGetProfileUpdates(limit, page, order, options).then((request) => request(axios, basePath));
        },
        /**
         * Get therapist by id
         * @summary Get therapist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerGetTherapistById(id: string, options?: any): AxiosPromise<AdminTherapistResponseDto> {
            return localVarFp.adminTherapistsControllerGetTherapistById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get therapist request by id
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerGetTherapistRequestByUserId(id: string, options?: any): AxiosPromise<AdminTherapistRequestResponseDto> {
            return localVarFp.adminTherapistsControllerGetTherapistRequestByUserId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get therapist requests, sorting by createdAt
         * @summary Get therapists
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname'} [orderTerms] 
         * @param {'name' | 'email'} [searchTerm] name or email
         * @param {string} [searchValue] value to search by searchTerm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerGetTherapistRequests(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname', searchTerm?: 'name' | 'email', searchValue?: string, options?: any): AxiosPromise<AdminTherapistRequestsResponseDto> {
            return localVarFp.adminTherapistsControllerGetTherapistRequests(limit, page, order, orderTerms, searchTerm, searchValue, options).then((request) => request(axios, basePath));
        },
        /**
         * Get therapists
         * @summary Get therapists
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname'} [orderTerms] 
         * @param {'name' | 'email'} [searchTerm] name or email
         * @param {string} [searchValue] value to search by searchTerm
         * @param {boolean} [isB2B] 
         * @param {boolean} [isChildTherapist] 
         * @param {boolean} [isAdult] 
         * @param {boolean} [isSupervisor] 
         * @param {boolean} [isTest] 
         * @param {boolean} [isTop] 
         * @param {boolean} [isCoach] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerGetTherapists(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname', searchTerm?: 'name' | 'email', searchValue?: string, isB2B?: boolean, isChildTherapist?: boolean, isAdult?: boolean, isSupervisor?: boolean, isTest?: boolean, isTop?: boolean, isCoach?: boolean, options?: any): AxiosPromise<AdminTherapistsResponseDto> {
            return localVarFp.adminTherapistsControllerGetTherapists(limit, page, order, orderTerms, searchTerm, searchValue, isB2B, isChildTherapist, isAdult, isSupervisor, isTest, isTop, isCoach, options).then((request) => request(axios, basePath));
        },
        /**
         * Get therapists statistic
         * @summary Get therapists statistics
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'lastname'} [orderTerms] 
         * @param {'name' | 'email'} [searchTerm] name or email
         * @param {string} [searchValue] value to search by searchTerm
         * @param {boolean} [isB2B] 
         * @param {boolean} [isChildTherapist] 
         * @param {boolean} [isAdult] 
         * @param {boolean} [isSupervisor] 
         * @param {boolean} [isTest] 
         * @param {boolean} [isTop] 
         * @param {boolean} [isCoach] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerGetTherapistsStatistics(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname', searchTerm?: 'name' | 'email', searchValue?: string, isB2B?: boolean, isChildTherapist?: boolean, isAdult?: boolean, isSupervisor?: boolean, isTest?: boolean, isTop?: boolean, isCoach?: boolean, options?: any): AxiosPromise<AdminTherapisstStatisticResponseDto> {
            return localVarFp.adminTherapistsControllerGetTherapistsStatistics(limit, page, order, orderTerms, searchTerm, searchValue, isB2B, isChildTherapist, isAdult, isSupervisor, isTest, isTop, isCoach, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject therapist profile update
         * @param {string} therapistProfileUpdateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerRejectProfileUpdate(therapistProfileUpdateId: string, options?: any): AxiosPromise<TherapistProfileUpdateResponseDto> {
            return localVarFp.adminTherapistsControllerRejectProfileUpdate(therapistProfileUpdateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify therapist
         * @param {string} id 
         * @param {AdminRejectTherapistRequestDto} adminRejectTherapistRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerRejectTherapist(id: string, adminRejectTherapistRequestDto: AdminRejectTherapistRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.adminTherapistsControllerRejectTherapist(id, adminRejectTherapistRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Unapprove therapist by id
         * @summary 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUnapproveTherapist(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminTherapistsControllerUnapproveTherapist(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Unban therapist by id
         * @summary Unban therapist by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUnbanTherapist(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerUnbanTherapist(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change field about
         * @param {string} therapistId 
         * @param {TherapistProfileUpdateAbout} therapistProfileUpdateAbout 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateAbout(therapistId: string, therapistProfileUpdateAbout: TherapistProfileUpdateAbout, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerUpdateAbout(therapistId, therapistProfileUpdateAbout, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change field isAdult
         * @param {string} therapistId 
         * @param {TherapistUpdateIsAdult} therapistUpdateIsAdult 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsAdult(therapistId: string, therapistUpdateIsAdult: TherapistUpdateIsAdult, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerUpdateIsAdult(therapistId, therapistUpdateIsAdult, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change field IsB2B
         * @param {string} therapistId 
         * @param {TherapistUpdateIsB2BDto} therapistUpdateIsB2BDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsB2B(therapistId: string, therapistUpdateIsB2BDto: TherapistUpdateIsB2BDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerUpdateIsB2B(therapistId, therapistUpdateIsB2BDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change field isChildTherapist
         * @param {string} therapistId 
         * @param {TherapistUpdateIsChildTherapistDto} therapistUpdateIsChildTherapistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsChildTherapists(therapistId: string, therapistUpdateIsChildTherapistDto: TherapistUpdateIsChildTherapistDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerUpdateIsChildTherapists(therapistId, therapistUpdateIsChildTherapistDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change field IsCoach
         * @param {string} therapistId 
         * @param {TherapistUpdateIsCoachDto} therapistUpdateIsCoachDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsCoach(therapistId: string, therapistUpdateIsCoachDto: TherapistUpdateIsCoachDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerUpdateIsCoach(therapistId, therapistUpdateIsCoachDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change field isMedsi
         * @param {string} therapistId 
         * @param {TherapistUpdateIsMedsiDto} therapistUpdateIsMedsiDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsMedsi(therapistId: string, therapistUpdateIsMedsiDto: TherapistUpdateIsMedsiDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerUpdateIsMedsi(therapistId, therapistUpdateIsMedsiDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change field IsSupervisor
         * @param {string} therapistId 
         * @param {TherapistUpdateIsSupervisorDto} therapistUpdateIsSupervisorDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsSupervisor(therapistId: string, therapistUpdateIsSupervisorDto: TherapistUpdateIsSupervisorDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerUpdateIsSupervisor(therapistId, therapistUpdateIsSupervisorDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change field isTest
         * @param {string} therapistId 
         * @param {TherapistUpdateIsTestDto} therapistUpdateIsTestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsTest(therapistId: string, therapistUpdateIsTestDto: TherapistUpdateIsTestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerUpdateIsTest(therapistId, therapistUpdateIsTestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change field isTop
         * @param {string} therapistId 
         * @param {TherapistUpdateIsTopDto} therapistUpdateIsTopDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateIsTop(therapistId: string, therapistUpdateIsTopDto: TherapistUpdateIsTopDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerUpdateIsTop(therapistId, therapistUpdateIsTopDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change field rewardInPercent
         * @param {string} therapistId 
         * @param {TherapistUpdateRewardInPercent} therapistUpdateRewardInPercent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateRewardInPercent(therapistId: string, therapistUpdateRewardInPercent: TherapistUpdateRewardInPercent, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerUpdateRewardInPercent(therapistId, therapistUpdateRewardInPercent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change field (session) price
         * @param {string} therapistId 
         * @param {TherapistUpdateSessionPrice} therapistUpdateSessionPrice 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateSessionPrice(therapistId: string, therapistUpdateSessionPrice: TherapistUpdateSessionPrice, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerUpdateSessionPrice(therapistId, therapistUpdateSessionPrice, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change field shortAbout
         * @param {string} therapistId 
         * @param {TherapistProfileUpdateShortAbout} therapistProfileUpdateShortAbout 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateShortAbout(therapistId: string, therapistProfileUpdateShortAbout: TherapistProfileUpdateShortAbout, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerUpdateShortAbout(therapistId, therapistProfileUpdateShortAbout, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change field specialisation
         * @param {string} therapistId 
         * @param {TherapistUpdateSpecialisationDto} therapistUpdateSpecialisationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerUpdateSpecialisation(therapistId: string, therapistUpdateSpecialisationDto: TherapistUpdateSpecialisationDto, options?: any): AxiosPromise<UpdateTherapistMessageSuccessResponseDto> {
            return localVarFp.adminTherapistsControllerUpdateSpecialisation(therapistId, therapistUpdateSpecialisationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify therapist by request id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTherapistsControllerVerifyTherapist(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminTherapistsControllerVerifyTherapist(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminTherapistsApi - object-oriented interface
 * @export
 * @class AdminTherapistsApi
 * @extends {BaseAPI}
 */
export class AdminTherapistsApi extends BaseAPI {
    /**
     * Accept profile update
     * @summary Accept profile update
     * @param {string} therapistProfileUpdateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerAcceptProfileUpdate(therapistProfileUpdateId: string, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerAcceptProfileUpdate(therapistProfileUpdateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Approve therapist by id
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerApproveTherapist(id: string, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerApproveTherapist(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ban therapist by id
     * @summary Ban therapist by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerBanTherapist(id: string, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerBanTherapist(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get profile update by id
     * @summary Get profile update by id
     * @param {string} therapistProfileUpdateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerGetProfileUpdateById(therapistProfileUpdateId: string, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerGetProfileUpdateById(therapistProfileUpdateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get profile updates, sorting by update\'s createdAt
     * @summary Get profile updates, sorting by update\'s createdAt
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerGetProfileUpdates(limit: number, page: number, order?: 'ASC' | 'DESC', options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerGetProfileUpdates(limit, page, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get therapist by id
     * @summary Get therapist by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerGetTherapistById(id: string, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerGetTherapistById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get therapist request by id
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerGetTherapistRequestByUserId(id: string, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerGetTherapistRequestByUserId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get therapist requests, sorting by createdAt
     * @summary Get therapists
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'createdAt' | 'lastname'} [orderTerms] 
     * @param {'name' | 'email'} [searchTerm] name or email
     * @param {string} [searchValue] value to search by searchTerm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerGetTherapistRequests(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname', searchTerm?: 'name' | 'email', searchValue?: string, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerGetTherapistRequests(limit, page, order, orderTerms, searchTerm, searchValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get therapists
     * @summary Get therapists
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'createdAt' | 'lastname'} [orderTerms] 
     * @param {'name' | 'email'} [searchTerm] name or email
     * @param {string} [searchValue] value to search by searchTerm
     * @param {boolean} [isB2B] 
     * @param {boolean} [isChildTherapist] 
     * @param {boolean} [isAdult] 
     * @param {boolean} [isSupervisor] 
     * @param {boolean} [isTest] 
     * @param {boolean} [isTop] 
     * @param {boolean} [isCoach] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerGetTherapists(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname', searchTerm?: 'name' | 'email', searchValue?: string, isB2B?: boolean, isChildTherapist?: boolean, isAdult?: boolean, isSupervisor?: boolean, isTest?: boolean, isTop?: boolean, isCoach?: boolean, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerGetTherapists(limit, page, order, orderTerms, searchTerm, searchValue, isB2B, isChildTherapist, isAdult, isSupervisor, isTest, isTop, isCoach, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get therapists statistic
     * @summary Get therapists statistics
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'createdAt' | 'lastname'} [orderTerms] 
     * @param {'name' | 'email'} [searchTerm] name or email
     * @param {string} [searchValue] value to search by searchTerm
     * @param {boolean} [isB2B] 
     * @param {boolean} [isChildTherapist] 
     * @param {boolean} [isAdult] 
     * @param {boolean} [isSupervisor] 
     * @param {boolean} [isTest] 
     * @param {boolean} [isTop] 
     * @param {boolean} [isCoach] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerGetTherapistsStatistics(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'lastname', searchTerm?: 'name' | 'email', searchValue?: string, isB2B?: boolean, isChildTherapist?: boolean, isAdult?: boolean, isSupervisor?: boolean, isTest?: boolean, isTop?: boolean, isCoach?: boolean, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerGetTherapistsStatistics(limit, page, order, orderTerms, searchTerm, searchValue, isB2B, isChildTherapist, isAdult, isSupervisor, isTest, isTop, isCoach, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject therapist profile update
     * @param {string} therapistProfileUpdateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerRejectProfileUpdate(therapistProfileUpdateId: string, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerRejectProfileUpdate(therapistProfileUpdateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify therapist
     * @param {string} id 
     * @param {AdminRejectTherapistRequestDto} adminRejectTherapistRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerRejectTherapist(id: string, adminRejectTherapistRequestDto: AdminRejectTherapistRequestDto, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerRejectTherapist(id, adminRejectTherapistRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unapprove therapist by id
     * @summary 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUnapproveTherapist(id: string, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUnapproveTherapist(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unban therapist by id
     * @summary Unban therapist by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUnbanTherapist(id: string, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUnbanTherapist(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change field about
     * @param {string} therapistId 
     * @param {TherapistProfileUpdateAbout} therapistProfileUpdateAbout 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUpdateAbout(therapistId: string, therapistProfileUpdateAbout: TherapistProfileUpdateAbout, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUpdateAbout(therapistId, therapistProfileUpdateAbout, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change field isAdult
     * @param {string} therapistId 
     * @param {TherapistUpdateIsAdult} therapistUpdateIsAdult 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUpdateIsAdult(therapistId: string, therapistUpdateIsAdult: TherapistUpdateIsAdult, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUpdateIsAdult(therapistId, therapistUpdateIsAdult, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change field IsB2B
     * @param {string} therapistId 
     * @param {TherapistUpdateIsB2BDto} therapistUpdateIsB2BDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUpdateIsB2B(therapistId: string, therapistUpdateIsB2BDto: TherapistUpdateIsB2BDto, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUpdateIsB2B(therapistId, therapistUpdateIsB2BDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change field isChildTherapist
     * @param {string} therapistId 
     * @param {TherapistUpdateIsChildTherapistDto} therapistUpdateIsChildTherapistDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUpdateIsChildTherapists(therapistId: string, therapistUpdateIsChildTherapistDto: TherapistUpdateIsChildTherapistDto, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUpdateIsChildTherapists(therapistId, therapistUpdateIsChildTherapistDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change field IsCoach
     * @param {string} therapistId 
     * @param {TherapistUpdateIsCoachDto} therapistUpdateIsCoachDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUpdateIsCoach(therapistId: string, therapistUpdateIsCoachDto: TherapistUpdateIsCoachDto, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUpdateIsCoach(therapistId, therapistUpdateIsCoachDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change field isMedsi
     * @param {string} therapistId 
     * @param {TherapistUpdateIsMedsiDto} therapistUpdateIsMedsiDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUpdateIsMedsi(therapistId: string, therapistUpdateIsMedsiDto: TherapistUpdateIsMedsiDto, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUpdateIsMedsi(therapistId, therapistUpdateIsMedsiDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change field IsSupervisor
     * @param {string} therapistId 
     * @param {TherapistUpdateIsSupervisorDto} therapistUpdateIsSupervisorDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUpdateIsSupervisor(therapistId: string, therapistUpdateIsSupervisorDto: TherapistUpdateIsSupervisorDto, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUpdateIsSupervisor(therapistId, therapistUpdateIsSupervisorDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change field isTest
     * @param {string} therapistId 
     * @param {TherapistUpdateIsTestDto} therapistUpdateIsTestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUpdateIsTest(therapistId: string, therapistUpdateIsTestDto: TherapistUpdateIsTestDto, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUpdateIsTest(therapistId, therapistUpdateIsTestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change field isTop
     * @param {string} therapistId 
     * @param {TherapistUpdateIsTopDto} therapistUpdateIsTopDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUpdateIsTop(therapistId: string, therapistUpdateIsTopDto: TherapistUpdateIsTopDto, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUpdateIsTop(therapistId, therapistUpdateIsTopDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change field rewardInPercent
     * @param {string} therapistId 
     * @param {TherapistUpdateRewardInPercent} therapistUpdateRewardInPercent 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUpdateRewardInPercent(therapistId: string, therapistUpdateRewardInPercent: TherapistUpdateRewardInPercent, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUpdateRewardInPercent(therapistId, therapistUpdateRewardInPercent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change field (session) price
     * @param {string} therapistId 
     * @param {TherapistUpdateSessionPrice} therapistUpdateSessionPrice 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUpdateSessionPrice(therapistId: string, therapistUpdateSessionPrice: TherapistUpdateSessionPrice, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUpdateSessionPrice(therapistId, therapistUpdateSessionPrice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change field shortAbout
     * @param {string} therapistId 
     * @param {TherapistProfileUpdateShortAbout} therapistProfileUpdateShortAbout 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUpdateShortAbout(therapistId: string, therapistProfileUpdateShortAbout: TherapistProfileUpdateShortAbout, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUpdateShortAbout(therapistId, therapistProfileUpdateShortAbout, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change field specialisation
     * @param {string} therapistId 
     * @param {TherapistUpdateSpecialisationDto} therapistUpdateSpecialisationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerUpdateSpecialisation(therapistId: string, therapistUpdateSpecialisationDto: TherapistUpdateSpecialisationDto, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerUpdateSpecialisation(therapistId, therapistUpdateSpecialisationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify therapist by request id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTherapistsApi
     */
    public adminTherapistsControllerVerifyTherapist(id: string, options?: AxiosRequestConfig) {
        return AdminTherapistsApiFp(this.configuration).adminTherapistsControllerVerifyTherapist(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AdminsApi - axios parameter creator
 * @export
 */
export const AdminsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateAdminRequestDto} createAdminRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminControllerCreateAdmin: async (createAdminRequestDto: CreateAdminRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAdminRequestDto' is not null or undefined
            assertParamExists('adminControllerCreateAdmin', 'createAdminRequestDto', createAdminRequestDto)
            const localVarPath = `/api/v1/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAdminRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminControllerDeleteAdmin: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminControllerDeleteAdmin', 'id', id)
            const localVarPath = `/api/v1/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminControllerGetAdmins: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get api key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeysControllerGetApiKey: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/api-keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update api key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeysControllerUpdateApiKey: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/api-keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminsApi - functional programming interface
 * @export
 */
export const AdminsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateAdminRequestDto} createAdminRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminControllerCreateAdmin(createAdminRequestDto: CreateAdminRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminControllerCreateAdmin(createAdminRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminControllerDeleteAdmin(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminControllerDeleteAdmin(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminControllerGetAdmins(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminControllerGetAdmins(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get api key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiKeysControllerGetApiKey(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetApiKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiKeysControllerGetApiKey(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update api key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiKeysControllerUpdateApiKey(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiKeysControllerUpdateApiKey(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminsApi - factory interface
 * @export
 */
export const AdminsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateAdminRequestDto} createAdminRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminControllerCreateAdmin(createAdminRequestDto: CreateAdminRequestDto, options?: any): AxiosPromise<AdminResponseDto> {
            return localVarFp.adminControllerCreateAdmin(createAdminRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminControllerDeleteAdmin(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.adminControllerDeleteAdmin(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminControllerGetAdmins(options?: any): AxiosPromise<AdminsResponseDto> {
            return localVarFp.adminControllerGetAdmins(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get api key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeysControllerGetApiKey(options?: any): AxiosPromise<GetApiKeyResponseDto> {
            return localVarFp.apiKeysControllerGetApiKey(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update api key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeysControllerUpdateApiKey(options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.apiKeysControllerUpdateApiKey(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminsApi - object-oriented interface
 * @export
 * @class AdminsApi
 * @extends {BaseAPI}
 */
export class AdminsApi extends BaseAPI {
    /**
     * 
     * @param {CreateAdminRequestDto} createAdminRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminControllerCreateAdmin(createAdminRequestDto: CreateAdminRequestDto, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminControllerCreateAdmin(createAdminRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminControllerDeleteAdmin(id: string, options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminControllerDeleteAdmin(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminControllerGetAdmins(options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminControllerGetAdmins(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get api key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public apiKeysControllerGetApiKey(options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).apiKeysControllerGetApiKey(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update api key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public apiKeysControllerUpdateApiKey(options?: AxiosRequestConfig) {
        return AdminsApiFp(this.configuration).apiKeysControllerUpdateApiKey(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AmoApi - axios parameter creator
 * @export
 */
export const AmoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create amo promocode
         * @summary Create  amo promocode
         * @param {string} token 
         * @param {CreateAmoPromocodeDto} createAmoPromocodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amoControllerCreateAmoPromocode: async (token: string, createAmoPromocodeDto: CreateAmoPromocodeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('amoControllerCreateAmoPromocode', 'token', token)
            // verify required parameter 'createAmoPromocodeDto' is not null or undefined
            assertParamExists('amoControllerCreateAmoPromocode', 'createAmoPromocodeDto', createAmoPromocodeDto)
            const localVarPath = `/api/v1/amo/add-promocode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAmoPromocodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send sertificate from amo
         * @summary Send sertificate
         * @param {string} token 
         * @param {SendCertificateMailRequestDto} sendCertificateMailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amoControllerSendCertificate: async (token: string, sendCertificateMailRequestDto: SendCertificateMailRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('amoControllerSendCertificate', 'token', token)
            // verify required parameter 'sendCertificateMailRequestDto' is not null or undefined
            assertParamExists('amoControllerSendCertificate', 'sendCertificateMailRequestDto', sendCertificateMailRequestDto)
            const localVarPath = `/api/v1/amo/send-certificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token != null) {
                localVarHeaderParameter['token'] = String(token);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendCertificateMailRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AmoApi - functional programming interface
 * @export
 */
export const AmoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AmoApiAxiosParamCreator(configuration)
    return {
        /**
         * Create amo promocode
         * @summary Create  amo promocode
         * @param {string} token 
         * @param {CreateAmoPromocodeDto} createAmoPromocodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async amoControllerCreateAmoPromocode(token: string, createAmoPromocodeDto: CreateAmoPromocodeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPromocodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.amoControllerCreateAmoPromocode(token, createAmoPromocodeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Send sertificate from amo
         * @summary Send sertificate
         * @param {string} token 
         * @param {SendCertificateMailRequestDto} sendCertificateMailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async amoControllerSendCertificate(token: string, sendCertificateMailRequestDto: SendCertificateMailRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPromocodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.amoControllerSendCertificate(token, sendCertificateMailRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AmoApi - factory interface
 * @export
 */
export const AmoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AmoApiFp(configuration)
    return {
        /**
         * Create amo promocode
         * @summary Create  amo promocode
         * @param {string} token 
         * @param {CreateAmoPromocodeDto} createAmoPromocodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amoControllerCreateAmoPromocode(token: string, createAmoPromocodeDto: CreateAmoPromocodeDto, options?: any): AxiosPromise<AdminPromocodeResponseDto> {
            return localVarFp.amoControllerCreateAmoPromocode(token, createAmoPromocodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Send sertificate from amo
         * @summary Send sertificate
         * @param {string} token 
         * @param {SendCertificateMailRequestDto} sendCertificateMailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        amoControllerSendCertificate(token: string, sendCertificateMailRequestDto: SendCertificateMailRequestDto, options?: any): AxiosPromise<AdminPromocodeResponseDto> {
            return localVarFp.amoControllerSendCertificate(token, sendCertificateMailRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AmoApi - object-oriented interface
 * @export
 * @class AmoApi
 * @extends {BaseAPI}
 */
export class AmoApi extends BaseAPI {
    /**
     * Create amo promocode
     * @summary Create  amo promocode
     * @param {string} token 
     * @param {CreateAmoPromocodeDto} createAmoPromocodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmoApi
     */
    public amoControllerCreateAmoPromocode(token: string, createAmoPromocodeDto: CreateAmoPromocodeDto, options?: AxiosRequestConfig) {
        return AmoApiFp(this.configuration).amoControllerCreateAmoPromocode(token, createAmoPromocodeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send sertificate from amo
     * @summary Send sertificate
     * @param {string} token 
     * @param {SendCertificateMailRequestDto} sendCertificateMailRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AmoApi
     */
    public amoControllerSendCertificate(token: string, sendCertificateMailRequestDto: SendCertificateMailRequestDto, options?: AxiosRequestConfig) {
        return AmoApiFp(this.configuration).amoControllerSendCertificate(token, sendCertificateMailRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AdminSignInDto} adminSignInDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerAdminSignIn: async (adminSignInDto: AdminSignInDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminSignInDto' is not null or undefined
            assertParamExists('authControllerAdminSignIn', 'adminSignInDto', adminSignInDto)
            const localVarPath = `/api/v1/auth/admins/sign-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSignInDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if email is available
         * @param {CheckEmailRequestDto} checkEmailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerCheckEmail: async (checkEmailRequestDto: CheckEmailRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkEmailRequestDto' is not null or undefined
            assertParamExists('authControllerCheckEmail', 'checkEmailRequestDto', checkEmailRequestDto)
            const localVarPath = `/api/v1/auth/check/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkEmailRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if password is valid
         * @param {CheckPasswordRequestDto} checkPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerCheckPassword: async (checkPasswordRequestDto: CheckPasswordRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkPasswordRequestDto' is not null or undefined
            assertParamExists('authControllerCheckPassword', 'checkPasswordRequestDto', checkPasswordRequestDto)
            const localVarPath = `/api/v1/auth/check/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkPasswordRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if phone is available
         * @param {CheckPhoneRequestDto} checkPhoneRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerCheckPhone: async (checkPhoneRequestDto: CheckPhoneRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkPhoneRequestDto' is not null or undefined
            assertParamExists('authControllerCheckPhone', 'checkPhoneRequestDto', checkPhoneRequestDto)
            const localVarPath = `/api/v1/auth/check/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkPhoneRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CheckPhoneNumberVerificationDto} checkPhoneNumberVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerCheckPhoneNumberVerification: async (checkPhoneNumberVerificationDto: CheckPhoneNumberVerificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkPhoneNumberVerificationDto' is not null or undefined
            assertParamExists('authControllerCheckPhoneNumberVerification', 'checkPhoneNumberVerificationDto', checkPhoneNumberVerificationDto)
            const localVarPath = `/api/v1/auth/phone_number/check_verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkPhoneNumberVerificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm user email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerConfirmUserEmail: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/confirm_email/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerGetEmailConfirmationToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/confirm-email-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change forgotten password
         * @param {RestorePasswordByEmailRequestDto} restorePasswordByEmailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRestorePasswordByJwtToken: async (restorePasswordByEmailRequestDto: RestorePasswordByEmailRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'restorePasswordByEmailRequestDto' is not null or undefined
            assertParamExists('authControllerRestorePasswordByJwtToken', 'restorePasswordByEmailRequestDto', restorePasswordByEmailRequestDto)
            const localVarPath = `/api/v1/auth/forget_password/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(restorePasswordByEmailRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change forgotten password
         * @param {RestorePasswordByPhoneRequestDto} restorePasswordByPhoneRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRestorePasswordByPhone: async (restorePasswordByPhoneRequestDto: RestorePasswordByPhoneRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'restorePasswordByPhoneRequestDto' is not null or undefined
            assertParamExists('authControllerRestorePasswordByPhone', 'restorePasswordByPhoneRequestDto', restorePasswordByPhoneRequestDto)
            const localVarPath = `/api/v1/auth/forget_password/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(restorePasswordByPhoneRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send url for change forgotten password
         * @param {SendPhoneNumberVerificationDto} sendPhoneNumberVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendChangeForgetPasswordCode: async (sendPhoneNumberVerificationDto: SendPhoneNumberVerificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendPhoneNumberVerificationDto' is not null or undefined
            assertParamExists('authControllerSendChangeForgetPasswordCode', 'sendPhoneNumberVerificationDto', sendPhoneNumberVerificationDto)
            const localVarPath = `/api/v1/auth/forget_password/phone/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPhoneNumberVerificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send url for change forgotten password
         * @param {UserEmailDto} userEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendChangeForgetPasswordUrl: async (userEmailDto: UserEmailDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userEmailDto' is not null or undefined
            assertParamExists('authControllerSendChangeForgetPasswordUrl', 'userEmailDto', userEmailDto)
            const localVarPath = `/api/v1/auth/forget_password/email/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendPhoneNumberVerificationDto} sendPhoneNumberVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendPhoneNumberVerification: async (sendPhoneNumberVerificationDto: SendPhoneNumberVerificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendPhoneNumberVerificationDto' is not null or undefined
            assertParamExists('authControllerSendPhoneNumberVerification', 'sendPhoneNumberVerificationDto', sendPhoneNumberVerificationDto)
            const localVarPath = `/api/v1/auth/phone_number/send_verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPhoneNumberVerificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendPhoneNumberVerificationDto} sendPhoneNumberVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendPhoneNumberVerificationForSignIn: async (sendPhoneNumberVerificationDto: SendPhoneNumberVerificationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendPhoneNumberVerificationDto' is not null or undefined
            assertParamExists('authControllerSendPhoneNumberVerificationForSignIn', 'sendPhoneNumberVerificationDto', sendPhoneNumberVerificationDto)
            const localVarPath = `/api/v1/auth/sign-in/phone/send_verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPhoneNumberVerificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send update email confirmation link
         * @param {SendUpdateEmailConfirmationRequestDto} sendUpdateEmailConfirmationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendUpdateEmailConfirmation: async (sendUpdateEmailConfirmationRequestDto: SendUpdateEmailConfirmationRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendUpdateEmailConfirmationRequestDto' is not null or undefined
            assertParamExists('authControllerSendUpdateEmailConfirmation', 'sendUpdateEmailConfirmationRequestDto', sendUpdateEmailConfirmationRequestDto)
            const localVarPath = `/api/v1/auth/email/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendUpdateEmailConfirmationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send email confirmation
         * @param {UserEmailDto} userEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendUserConfirmationEmail: async (userEmailDto: UserEmailDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userEmailDto' is not null or undefined
            assertParamExists('authControllerSendUserConfirmationEmail', 'userEmailDto', userEmailDto)
            const localVarPath = `/api/v1/auth/confirm_email/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userEmailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserSignInDto} userSignInDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignIn: async (userSignInDto: UserSignInDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userSignInDto' is not null or undefined
            assertParamExists('authControllerSignIn', 'userSignInDto', userSignInDto)
            const localVarPath = `/api/v1/auth/sign-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSignInDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserPhoneSignInRequestDto} userPhoneSignInRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignInByPhone: async (userPhoneSignInRequestDto: UserPhoneSignInRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userPhoneSignInRequestDto' is not null or undefined
            assertParamExists('authControllerSignInByPhone', 'userPhoneSignInRequestDto', userPhoneSignInRequestDto)
            const localVarPath = `/api/v1/auth/sign-in/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userPhoneSignInRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserEmailSignUpRequestDto} userEmailSignUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUpWithEmail: async (userEmailSignUpRequestDto: UserEmailSignUpRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userEmailSignUpRequestDto' is not null or undefined
            assertParamExists('authControllerSignUpWithEmail', 'userEmailSignUpRequestDto', userEmailSignUpRequestDto)
            const localVarPath = `/api/v1/auth/sign-up/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userEmailSignUpRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserPhoneSignUpRequestDto} userPhoneSignUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUpWithPhone: async (userPhoneSignUpRequestDto: UserPhoneSignUpRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userPhoneSignUpRequestDto' is not null or undefined
            assertParamExists('authControllerSignUpWithPhone', 'userPhoneSignUpRequestDto', userPhoneSignUpRequestDto)
            const localVarPath = `/api/v1/auth/sign-up/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userPhoneSignUpRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update email (require confirmation token from mail)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerUpdateEmail: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * temporary
         * @summary Update email (only for user without email and password)
         * @param {UpdateEmailWithoutConfirmationRequestDto} updateEmailWithoutConfirmationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerUpdateEmailWithNoConfirmation: async (updateEmailWithoutConfirmationRequestDto: UpdateEmailWithoutConfirmationRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateEmailWithoutConfirmationRequestDto' is not null or undefined
            assertParamExists('authControllerUpdateEmailWithNoConfirmation', 'updateEmailWithoutConfirmationRequestDto', updateEmailWithoutConfirmationRequestDto)
            const localVarPath = `/api/v1/auth/email/with_no_confirmation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailWithoutConfirmationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update password
         * @param {UpdatePasswordRequestDto} updatePasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerUpdatePassword: async (updatePasswordRequestDto: UpdatePasswordRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePasswordRequestDto' is not null or undefined
            assertParamExists('authControllerUpdatePassword', 'updatePasswordRequestDto', updatePasswordRequestDto)
            const localVarPath = `/api/v1/auth/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePasswordRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update phone
         * @param {UpdatePhoneRequestDto} updatePhoneRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerUpdatePhone: async (updatePhoneRequestDto: UpdatePhoneRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePhoneRequestDto' is not null or undefined
            assertParamExists('authControllerUpdatePhone', 'updatePhoneRequestDto', updatePhoneRequestDto)
            const localVarPath = `/api/v1/auth/phone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePhoneRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AdminSignInDto} adminSignInDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerAdminSignIn(adminSignInDto: AdminSignInDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminWithTokenResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerAdminSignIn(adminSignInDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check if email is available
         * @param {CheckEmailRequestDto} checkEmailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerCheckEmail(checkEmailRequestDto: CheckEmailRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckAuthTermResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerCheckEmail(checkEmailRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check if password is valid
         * @param {CheckPasswordRequestDto} checkPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerCheckPassword(checkPasswordRequestDto: CheckPasswordRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckAuthTermResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerCheckPassword(checkPasswordRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check if phone is available
         * @param {CheckPhoneRequestDto} checkPhoneRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerCheckPhone(checkPhoneRequestDto: CheckPhoneRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckAuthTermResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerCheckPhone(checkPhoneRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CheckPhoneNumberVerificationDto} checkPhoneNumberVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerCheckPhoneNumberVerification(checkPhoneNumberVerificationDto: CheckPhoneNumberVerificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckVerificationCodeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerCheckPhoneNumberVerification(checkPhoneNumberVerificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Confirm user email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerConfirmUserEmail(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithTokenAndMetadataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerConfirmUserEmail(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerGetEmailConfirmationToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerGetEmailConfirmationToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change forgotten password
         * @param {RestorePasswordByEmailRequestDto} restorePasswordByEmailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerRestorePasswordByJwtToken(restorePasswordByEmailRequestDto: RestorePasswordByEmailRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithTokenResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerRestorePasswordByJwtToken(restorePasswordByEmailRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change forgotten password
         * @param {RestorePasswordByPhoneRequestDto} restorePasswordByPhoneRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerRestorePasswordByPhone(restorePasswordByPhoneRequestDto: RestorePasswordByPhoneRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithTokenResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerRestorePasswordByPhone(restorePasswordByPhoneRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send url for change forgotten password
         * @param {SendPhoneNumberVerificationDto} sendPhoneNumberVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSendChangeForgetPasswordCode(sendPhoneNumberVerificationDto: SendPhoneNumberVerificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendingStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSendChangeForgetPasswordCode(sendPhoneNumberVerificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send url for change forgotten password
         * @param {UserEmailDto} userEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSendChangeForgetPasswordUrl(userEmailDto: UserEmailDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendingStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSendChangeForgetPasswordUrl(userEmailDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SendPhoneNumberVerificationDto} sendPhoneNumberVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSendPhoneNumberVerification(sendPhoneNumberVerificationDto: SendPhoneNumberVerificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendingStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSendPhoneNumberVerification(sendPhoneNumberVerificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SendPhoneNumberVerificationDto} sendPhoneNumberVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSendPhoneNumberVerificationForSignIn(sendPhoneNumberVerificationDto: SendPhoneNumberVerificationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendingStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSendPhoneNumberVerificationForSignIn(sendPhoneNumberVerificationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send update email confirmation link
         * @param {SendUpdateEmailConfirmationRequestDto} sendUpdateEmailConfirmationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSendUpdateEmailConfirmation(sendUpdateEmailConfirmationRequestDto: SendUpdateEmailConfirmationRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendingStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSendUpdateEmailConfirmation(sendUpdateEmailConfirmationRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send email confirmation
         * @param {UserEmailDto} userEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSendUserConfirmationEmail(userEmailDto: UserEmailDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendingStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSendUserConfirmationEmail(userEmailDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UserSignInDto} userSignInDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSignIn(userSignInDto: UserSignInDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithTokenAndMetadataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSignIn(userSignInDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UserPhoneSignInRequestDto} userPhoneSignInRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSignInByPhone(userPhoneSignInRequestDto: UserPhoneSignInRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithTokenAndMetadataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSignInByPhone(userPhoneSignInRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UserEmailSignUpRequestDto} userEmailSignUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSignUpWithEmail(userEmailSignUpRequestDto: UserEmailSignUpRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithTokenAndMetadataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSignUpWithEmail(userEmailSignUpRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UserPhoneSignUpRequestDto} userPhoneSignUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSignUpWithPhone(userPhoneSignUpRequestDto: UserPhoneSignUpRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithTokenAndMetadataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSignUpWithPhone(userPhoneSignUpRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update email (require confirmation token from mail)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerUpdateEmail(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithTokenAndMetadataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerUpdateEmail(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * temporary
         * @summary Update email (only for user without email and password)
         * @param {UpdateEmailWithoutConfirmationRequestDto} updateEmailWithoutConfirmationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerUpdateEmailWithNoConfirmation(updateEmailWithoutConfirmationRequestDto: UpdateEmailWithoutConfirmationRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithTokenAndMetadataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerUpdateEmailWithNoConfirmation(updateEmailWithoutConfirmationRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update password
         * @param {UpdatePasswordRequestDto} updatePasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerUpdatePassword(updatePasswordRequestDto: UpdatePasswordRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithTokenAndMetadataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerUpdatePassword(updatePasswordRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update phone
         * @param {UpdatePhoneRequestDto} updatePhoneRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerUpdatePhone(updatePhoneRequestDto: UpdatePhoneRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithTokenAndMetadataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerUpdatePhone(updatePhoneRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminSignInDto} adminSignInDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerAdminSignIn(adminSignInDto: AdminSignInDto, options?: any): AxiosPromise<AdminWithTokenResponseDto> {
            return localVarFp.authControllerAdminSignIn(adminSignInDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if email is available
         * @param {CheckEmailRequestDto} checkEmailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerCheckEmail(checkEmailRequestDto: CheckEmailRequestDto, options?: any): AxiosPromise<CheckAuthTermResponseDto> {
            return localVarFp.authControllerCheckEmail(checkEmailRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if password is valid
         * @param {CheckPasswordRequestDto} checkPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerCheckPassword(checkPasswordRequestDto: CheckPasswordRequestDto, options?: any): AxiosPromise<CheckAuthTermResponseDto> {
            return localVarFp.authControllerCheckPassword(checkPasswordRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if phone is available
         * @param {CheckPhoneRequestDto} checkPhoneRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerCheckPhone(checkPhoneRequestDto: CheckPhoneRequestDto, options?: any): AxiosPromise<CheckAuthTermResponseDto> {
            return localVarFp.authControllerCheckPhone(checkPhoneRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CheckPhoneNumberVerificationDto} checkPhoneNumberVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerCheckPhoneNumberVerification(checkPhoneNumberVerificationDto: CheckPhoneNumberVerificationDto, options?: any): AxiosPromise<CheckVerificationCodeDto> {
            return localVarFp.authControllerCheckPhoneNumberVerification(checkPhoneNumberVerificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm user email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerConfirmUserEmail(options?: any): AxiosPromise<UserWithTokenAndMetadataResponseDto> {
            return localVarFp.authControllerConfirmUserEmail(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerGetEmailConfirmationToken(options?: any): AxiosPromise<void> {
            return localVarFp.authControllerGetEmailConfirmationToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change forgotten password
         * @param {RestorePasswordByEmailRequestDto} restorePasswordByEmailRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRestorePasswordByJwtToken(restorePasswordByEmailRequestDto: RestorePasswordByEmailRequestDto, options?: any): AxiosPromise<UserWithTokenResponseDto> {
            return localVarFp.authControllerRestorePasswordByJwtToken(restorePasswordByEmailRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change forgotten password
         * @param {RestorePasswordByPhoneRequestDto} restorePasswordByPhoneRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRestorePasswordByPhone(restorePasswordByPhoneRequestDto: RestorePasswordByPhoneRequestDto, options?: any): AxiosPromise<UserWithTokenResponseDto> {
            return localVarFp.authControllerRestorePasswordByPhone(restorePasswordByPhoneRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send url for change forgotten password
         * @param {SendPhoneNumberVerificationDto} sendPhoneNumberVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendChangeForgetPasswordCode(sendPhoneNumberVerificationDto: SendPhoneNumberVerificationDto, options?: any): AxiosPromise<SendingStatusDto> {
            return localVarFp.authControllerSendChangeForgetPasswordCode(sendPhoneNumberVerificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send url for change forgotten password
         * @param {UserEmailDto} userEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendChangeForgetPasswordUrl(userEmailDto: UserEmailDto, options?: any): AxiosPromise<SendingStatusDto> {
            return localVarFp.authControllerSendChangeForgetPasswordUrl(userEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendPhoneNumberVerificationDto} sendPhoneNumberVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendPhoneNumberVerification(sendPhoneNumberVerificationDto: SendPhoneNumberVerificationDto, options?: any): AxiosPromise<SendingStatusDto> {
            return localVarFp.authControllerSendPhoneNumberVerification(sendPhoneNumberVerificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendPhoneNumberVerificationDto} sendPhoneNumberVerificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendPhoneNumberVerificationForSignIn(sendPhoneNumberVerificationDto: SendPhoneNumberVerificationDto, options?: any): AxiosPromise<SendingStatusDto> {
            return localVarFp.authControllerSendPhoneNumberVerificationForSignIn(sendPhoneNumberVerificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send update email confirmation link
         * @param {SendUpdateEmailConfirmationRequestDto} sendUpdateEmailConfirmationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendUpdateEmailConfirmation(sendUpdateEmailConfirmationRequestDto: SendUpdateEmailConfirmationRequestDto, options?: any): AxiosPromise<SendingStatusDto> {
            return localVarFp.authControllerSendUpdateEmailConfirmation(sendUpdateEmailConfirmationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send email confirmation
         * @param {UserEmailDto} userEmailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendUserConfirmationEmail(userEmailDto: UserEmailDto, options?: any): AxiosPromise<SendingStatusDto> {
            return localVarFp.authControllerSendUserConfirmationEmail(userEmailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserSignInDto} userSignInDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignIn(userSignInDto: UserSignInDto, options?: any): AxiosPromise<UserWithTokenAndMetadataResponseDto> {
            return localVarFp.authControllerSignIn(userSignInDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserPhoneSignInRequestDto} userPhoneSignInRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignInByPhone(userPhoneSignInRequestDto: UserPhoneSignInRequestDto, options?: any): AxiosPromise<UserWithTokenAndMetadataResponseDto> {
            return localVarFp.authControllerSignInByPhone(userPhoneSignInRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserEmailSignUpRequestDto} userEmailSignUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUpWithEmail(userEmailSignUpRequestDto: UserEmailSignUpRequestDto, options?: any): AxiosPromise<UserWithTokenAndMetadataResponseDto> {
            return localVarFp.authControllerSignUpWithEmail(userEmailSignUpRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserPhoneSignUpRequestDto} userPhoneSignUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUpWithPhone(userPhoneSignUpRequestDto: UserPhoneSignUpRequestDto, options?: any): AxiosPromise<UserWithTokenAndMetadataResponseDto> {
            return localVarFp.authControllerSignUpWithPhone(userPhoneSignUpRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update email (require confirmation token from mail)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerUpdateEmail(options?: any): AxiosPromise<UserWithTokenAndMetadataResponseDto> {
            return localVarFp.authControllerUpdateEmail(options).then((request) => request(axios, basePath));
        },
        /**
         * temporary
         * @summary Update email (only for user without email and password)
         * @param {UpdateEmailWithoutConfirmationRequestDto} updateEmailWithoutConfirmationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerUpdateEmailWithNoConfirmation(updateEmailWithoutConfirmationRequestDto: UpdateEmailWithoutConfirmationRequestDto, options?: any): AxiosPromise<UserWithTokenAndMetadataResponseDto> {
            return localVarFp.authControllerUpdateEmailWithNoConfirmation(updateEmailWithoutConfirmationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update password
         * @param {UpdatePasswordRequestDto} updatePasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerUpdatePassword(updatePasswordRequestDto: UpdatePasswordRequestDto, options?: any): AxiosPromise<UserWithTokenAndMetadataResponseDto> {
            return localVarFp.authControllerUpdatePassword(updatePasswordRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update phone
         * @param {UpdatePhoneRequestDto} updatePhoneRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerUpdatePhone(updatePhoneRequestDto: UpdatePhoneRequestDto, options?: any): AxiosPromise<UserWithTokenAndMetadataResponseDto> {
            return localVarFp.authControllerUpdatePhone(updatePhoneRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @param {AdminSignInDto} adminSignInDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerAdminSignIn(adminSignInDto: AdminSignInDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerAdminSignIn(adminSignInDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if email is available
     * @param {CheckEmailRequestDto} checkEmailRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerCheckEmail(checkEmailRequestDto: CheckEmailRequestDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerCheckEmail(checkEmailRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if password is valid
     * @param {CheckPasswordRequestDto} checkPasswordRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerCheckPassword(checkPasswordRequestDto: CheckPasswordRequestDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerCheckPassword(checkPasswordRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if phone is available
     * @param {CheckPhoneRequestDto} checkPhoneRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerCheckPhone(checkPhoneRequestDto: CheckPhoneRequestDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerCheckPhone(checkPhoneRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CheckPhoneNumberVerificationDto} checkPhoneNumberVerificationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerCheckPhoneNumberVerification(checkPhoneNumberVerificationDto: CheckPhoneNumberVerificationDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerCheckPhoneNumberVerification(checkPhoneNumberVerificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm user email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerConfirmUserEmail(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerConfirmUserEmail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerGetEmailConfirmationToken(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerGetEmailConfirmationToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change forgotten password
     * @param {RestorePasswordByEmailRequestDto} restorePasswordByEmailRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerRestorePasswordByJwtToken(restorePasswordByEmailRequestDto: RestorePasswordByEmailRequestDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerRestorePasswordByJwtToken(restorePasswordByEmailRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change forgotten password
     * @param {RestorePasswordByPhoneRequestDto} restorePasswordByPhoneRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerRestorePasswordByPhone(restorePasswordByPhoneRequestDto: RestorePasswordByPhoneRequestDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerRestorePasswordByPhone(restorePasswordByPhoneRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send url for change forgotten password
     * @param {SendPhoneNumberVerificationDto} sendPhoneNumberVerificationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerSendChangeForgetPasswordCode(sendPhoneNumberVerificationDto: SendPhoneNumberVerificationDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerSendChangeForgetPasswordCode(sendPhoneNumberVerificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send url for change forgotten password
     * @param {UserEmailDto} userEmailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerSendChangeForgetPasswordUrl(userEmailDto: UserEmailDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerSendChangeForgetPasswordUrl(userEmailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendPhoneNumberVerificationDto} sendPhoneNumberVerificationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerSendPhoneNumberVerification(sendPhoneNumberVerificationDto: SendPhoneNumberVerificationDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerSendPhoneNumberVerification(sendPhoneNumberVerificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendPhoneNumberVerificationDto} sendPhoneNumberVerificationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerSendPhoneNumberVerificationForSignIn(sendPhoneNumberVerificationDto: SendPhoneNumberVerificationDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerSendPhoneNumberVerificationForSignIn(sendPhoneNumberVerificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send update email confirmation link
     * @param {SendUpdateEmailConfirmationRequestDto} sendUpdateEmailConfirmationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerSendUpdateEmailConfirmation(sendUpdateEmailConfirmationRequestDto: SendUpdateEmailConfirmationRequestDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerSendUpdateEmailConfirmation(sendUpdateEmailConfirmationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send email confirmation
     * @param {UserEmailDto} userEmailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerSendUserConfirmationEmail(userEmailDto: UserEmailDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerSendUserConfirmationEmail(userEmailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserSignInDto} userSignInDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerSignIn(userSignInDto: UserSignInDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerSignIn(userSignInDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserPhoneSignInRequestDto} userPhoneSignInRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerSignInByPhone(userPhoneSignInRequestDto: UserPhoneSignInRequestDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerSignInByPhone(userPhoneSignInRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserEmailSignUpRequestDto} userEmailSignUpRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerSignUpWithEmail(userEmailSignUpRequestDto: UserEmailSignUpRequestDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerSignUpWithEmail(userEmailSignUpRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserPhoneSignUpRequestDto} userPhoneSignUpRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerSignUpWithPhone(userPhoneSignUpRequestDto: UserPhoneSignUpRequestDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerSignUpWithPhone(userPhoneSignUpRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update email (require confirmation token from mail)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerUpdateEmail(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerUpdateEmail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * temporary
     * @summary Update email (only for user without email and password)
     * @param {UpdateEmailWithoutConfirmationRequestDto} updateEmailWithoutConfirmationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerUpdateEmailWithNoConfirmation(updateEmailWithoutConfirmationRequestDto: UpdateEmailWithoutConfirmationRequestDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerUpdateEmailWithNoConfirmation(updateEmailWithoutConfirmationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update password
     * @param {UpdatePasswordRequestDto} updatePasswordRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerUpdatePassword(updatePasswordRequestDto: UpdatePasswordRequestDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerUpdatePassword(updatePasswordRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update phone
     * @param {UpdatePhoneRequestDto} updatePhoneRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerUpdatePhone(updatePhoneRequestDto: UpdatePhoneRequestDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerUpdatePhone(updatePhoneRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * B2BMaterialsApi - axios parameter creator
 * @export
 */
export const B2BMaterialsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить B2B материалы пользователя
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        b2BMaterialsControllerGetMaterials: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/b2b-materials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * B2BMaterialsApi - functional programming interface
 * @export
 */
export const B2BMaterialsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = B2BMaterialsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить B2B материалы пользователя
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async b2BMaterialsControllerGetMaterials(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<B2BMaterialsPaginatedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.b2BMaterialsControllerGetMaterials(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * B2BMaterialsApi - factory interface
 * @export
 */
export const B2BMaterialsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = B2BMaterialsApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить B2B материалы пользователя
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        b2BMaterialsControllerGetMaterials(page?: number, limit?: number, options?: any): AxiosPromise<B2BMaterialsPaginatedResponseDto> {
            return localVarFp.b2BMaterialsControllerGetMaterials(page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * B2BMaterialsApi - object-oriented interface
 * @export
 * @class B2BMaterialsApi
 * @extends {BaseAPI}
 */
export class B2BMaterialsApi extends BaseAPI {
    /**
     * 
     * @summary Получить B2B материалы пользователя
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof B2BMaterialsApi
     */
    public b2BMaterialsControllerGetMaterials(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return B2BMaterialsApiFp(this.configuration).b2BMaterialsControllerGetMaterials(page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CommonApi - axios parameter creator
 * @export
 */
export const CommonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add platform feedback
         * @param {AddPlatformFeedbackRequestDto} addPlatformFeedbackRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerAddPlatformFeedback: async (addPlatformFeedbackRequestDto: AddPlatformFeedbackRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addPlatformFeedbackRequestDto' is not null or undefined
            assertParamExists('commonControllerAddPlatformFeedback', 'addPlatformFeedbackRequestDto', addPlatformFeedbackRequestDto)
            const localVarPath = `/api/v1/common/add-platform-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPlatformFeedbackRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create child therapist ticket
         * @param {ChildTherapistTicketRequestDto} childTherapistTicketRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerCreateChildTherapistTicket: async (childTherapistTicketRequestDto: ChildTherapistTicketRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'childTherapistTicketRequestDto' is not null or undefined
            assertParamExists('commonControllerCreateChildTherapistTicket', 'childTherapistTicketRequestDto', childTherapistTicketRequestDto)
            const localVarPath = `/api/v1/common/find-child-therapist-ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(childTherapistTicketRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerGetDiseaseUrlsForSitemap: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/common/diseases/get-urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all diseases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerGetDiseases: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/common/diseases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all diseases groups
         * @param {boolean} [isChild] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerGetDiseasesGroups: async (isChild?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/common/diseases_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isChild !== undefined) {
                localVarQueryParameter['isChild'] = isChild;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get FAQ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerGetFaqList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/common/faq`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all therapy methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerGetTherapyMethods: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/common/therapy_methods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerGetTherapyMethodsUrlsForSitemap: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/common/therapy_methods/get-urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommonApi - functional programming interface
 * @export
 */
export const CommonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommonApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add platform feedback
         * @param {AddPlatformFeedbackRequestDto} addPlatformFeedbackRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commonControllerAddPlatformFeedback(addPlatformFeedbackRequestDto: AddPlatformFeedbackRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commonControllerAddPlatformFeedback(addPlatformFeedbackRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create child therapist ticket
         * @param {ChildTherapistTicketRequestDto} childTherapistTicketRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commonControllerCreateChildTherapistTicket(childTherapistTicketRequestDto: ChildTherapistTicketRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commonControllerCreateChildTherapistTicket(childTherapistTicketRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commonControllerGetDiseaseUrlsForSitemap(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commonControllerGetDiseaseUrlsForSitemap(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all diseases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commonControllerGetDiseases(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiseaseResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commonControllerGetDiseases(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all diseases groups
         * @param {boolean} [isChild] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commonControllerGetDiseasesGroups(isChild?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiseaseGroupResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commonControllerGetDiseasesGroups(isChild, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get FAQ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commonControllerGetFaqList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FaqResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commonControllerGetFaqList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all therapy methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commonControllerGetTherapyMethods(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TherapyMethodResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commonControllerGetTherapyMethods(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commonControllerGetTherapyMethodsUrlsForSitemap(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commonControllerGetTherapyMethodsUrlsForSitemap(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CommonApi - factory interface
 * @export
 */
export const CommonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommonApiFp(configuration)
    return {
        /**
         * 
         * @summary Add platform feedback
         * @param {AddPlatformFeedbackRequestDto} addPlatformFeedbackRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerAddPlatformFeedback(addPlatformFeedbackRequestDto: AddPlatformFeedbackRequestDto, options?: any): AxiosPromise<object> {
            return localVarFp.commonControllerAddPlatformFeedback(addPlatformFeedbackRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create child therapist ticket
         * @param {ChildTherapistTicketRequestDto} childTherapistTicketRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerCreateChildTherapistTicket(childTherapistTicketRequestDto: ChildTherapistTicketRequestDto, options?: any): AxiosPromise<object> {
            return localVarFp.commonControllerCreateChildTherapistTicket(childTherapistTicketRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerGetDiseaseUrlsForSitemap(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.commonControllerGetDiseaseUrlsForSitemap(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all diseases
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerGetDiseases(options?: any): AxiosPromise<Array<DiseaseResponseDto>> {
            return localVarFp.commonControllerGetDiseases(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all diseases groups
         * @param {boolean} [isChild] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerGetDiseasesGroups(isChild?: boolean, options?: any): AxiosPromise<Array<DiseaseGroupResponseDto>> {
            return localVarFp.commonControllerGetDiseasesGroups(isChild, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get FAQ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerGetFaqList(options?: any): AxiosPromise<FaqResponseDto> {
            return localVarFp.commonControllerGetFaqList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all therapy methods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerGetTherapyMethods(options?: any): AxiosPromise<Array<TherapyMethodResponseDto>> {
            return localVarFp.commonControllerGetTherapyMethods(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commonControllerGetTherapyMethodsUrlsForSitemap(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.commonControllerGetTherapyMethodsUrlsForSitemap(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommonApi - object-oriented interface
 * @export
 * @class CommonApi
 * @extends {BaseAPI}
 */
export class CommonApi extends BaseAPI {
    /**
     * 
     * @summary Add platform feedback
     * @param {AddPlatformFeedbackRequestDto} addPlatformFeedbackRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonApi
     */
    public commonControllerAddPlatformFeedback(addPlatformFeedbackRequestDto: AddPlatformFeedbackRequestDto, options?: AxiosRequestConfig) {
        return CommonApiFp(this.configuration).commonControllerAddPlatformFeedback(addPlatformFeedbackRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create child therapist ticket
     * @param {ChildTherapistTicketRequestDto} childTherapistTicketRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonApi
     */
    public commonControllerCreateChildTherapistTicket(childTherapistTicketRequestDto: ChildTherapistTicketRequestDto, options?: AxiosRequestConfig) {
        return CommonApiFp(this.configuration).commonControllerCreateChildTherapistTicket(childTherapistTicketRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonApi
     */
    public commonControllerGetDiseaseUrlsForSitemap(options?: AxiosRequestConfig) {
        return CommonApiFp(this.configuration).commonControllerGetDiseaseUrlsForSitemap(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all diseases
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonApi
     */
    public commonControllerGetDiseases(options?: AxiosRequestConfig) {
        return CommonApiFp(this.configuration).commonControllerGetDiseases(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all diseases groups
     * @param {boolean} [isChild] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonApi
     */
    public commonControllerGetDiseasesGroups(isChild?: boolean, options?: AxiosRequestConfig) {
        return CommonApiFp(this.configuration).commonControllerGetDiseasesGroups(isChild, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get FAQ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonApi
     */
    public commonControllerGetFaqList(options?: AxiosRequestConfig) {
        return CommonApiFp(this.configuration).commonControllerGetFaqList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all therapy methods
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonApi
     */
    public commonControllerGetTherapyMethods(options?: AxiosRequestConfig) {
        return CommonApiFp(this.configuration).commonControllerGetTherapyMethods(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommonApi
     */
    public commonControllerGetTherapyMethodsUrlsForSitemap(options?: AxiosRequestConfig) {
        return CommonApiFp(this.configuration).commonControllerGetTherapyMethodsUrlsForSitemap(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CompanyApi - axios parameter creator
 * @export
 */
export const CompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create company create request
         * @param {CreateCompanyCreateRequestRequestDto} createCompanyCreateRequestRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesControllerCreateCompanyCreateRequest: async (createCompanyCreateRequestRequestDto: CreateCompanyCreateRequestRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCompanyCreateRequestRequestDto' is not null or undefined
            assertParamExists('companiesControllerCreateCompanyCreateRequest', 'createCompanyCreateRequestRequestDto', createCompanyCreateRequestRequestDto)
            const localVarPath = `/api/v1/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyCreateRequestRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send promocode request
         * @param {PromocodeRequestRequestDto} promocodeRequestRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesControllerCreatePromocodeRequest: async (promocodeRequestRequestDto: PromocodeRequestRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promocodeRequestRequestDto' is not null or undefined
            assertParamExists('companiesControllerCreatePromocodeRequest', 'promocodeRequestRequestDto', promocodeRequestRequestDto)
            const localVarPath = `/api/v1/companies/promocodes-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promocodeRequestRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get promocodes
         * @param {boolean} isExpired 
         * @param {Array<string>} [amountFilter] 
         * @param {Array<string>} [percentageFilter] 
         * @param {'expired' | 'used'} [statusFilter] 
         * @param {'expireDate' | 'amount'} [sortTerm] 
         * @param {'ASC' | 'DESC'} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesControllerGetPromocodes: async (isExpired: boolean, amountFilter?: Array<string>, percentageFilter?: Array<string>, statusFilter?: 'expired' | 'used', sortTerm?: 'expireDate' | 'amount', sortOrder?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isExpired' is not null or undefined
            assertParamExists('companiesControllerGetPromocodes', 'isExpired', isExpired)
            const localVarPath = `/api/v1/companies/promocodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isExpired !== undefined) {
                localVarQueryParameter['isExpired'] = isExpired;
            }

            if (amountFilter) {
                localVarQueryParameter['amountFilter'] = amountFilter;
            }

            if (percentageFilter) {
                localVarQueryParameter['percentageFilter'] = percentageFilter;
            }

            if (statusFilter !== undefined) {
                localVarQueryParameter['statusFilter'] = statusFilter;
            }

            if (sortTerm !== undefined) {
                localVarQueryParameter['sortTerm'] = sortTerm;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company\'s statistics
         * @param {string} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesControllerGetStatistics: async (year: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('companiesControllerGetStatistics', 'year', year)
            const localVarPath = `/api/v1/companies/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get company\'s statistics in xls format
         * @param {string} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesControllerGetXlsStatistics: async (year: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('companiesControllerGetXlsStatistics', 'year', year)
            const localVarPath = `/api/v1/companies/statistics/xls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send promocodes
         * @param {SendPromocodesRequestDto} sendPromocodesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesControllerSendPromocodes: async (sendPromocodesRequestDto: SendPromocodesRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendPromocodesRequestDto' is not null or undefined
            assertParamExists('companiesControllerSendPromocodes', 'sendPromocodesRequestDto', sendPromocodesRequestDto)
            const localVarPath = `/api/v1/companies/promocodes/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPromocodesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create company create request
         * @param {CreateCompanyCreateRequestRequestDto} createCompanyCreateRequestRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesControllerCreateCompanyCreateRequest(createCompanyCreateRequestRequestDto: CreateCompanyCreateRequestRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesControllerCreateCompanyCreateRequest(createCompanyCreateRequestRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send promocode request
         * @param {PromocodeRequestRequestDto} promocodeRequestRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesControllerCreatePromocodeRequest(promocodeRequestRequestDto: PromocodeRequestRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesControllerCreatePromocodeRequest(promocodeRequestRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get promocodes
         * @param {boolean} isExpired 
         * @param {Array<string>} [amountFilter] 
         * @param {Array<string>} [percentageFilter] 
         * @param {'expired' | 'used'} [statusFilter] 
         * @param {'expireDate' | 'amount'} [sortTerm] 
         * @param {'ASC' | 'DESC'} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesControllerGetPromocodes(isExpired: boolean, amountFilter?: Array<string>, percentageFilter?: Array<string>, statusFilter?: 'expired' | 'used', sortTerm?: 'expireDate' | 'amount', sortOrder?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPromocodesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesControllerGetPromocodes(isExpired, amountFilter, percentageFilter, statusFilter, sortTerm, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get company\'s statistics
         * @param {string} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesControllerGetStatistics(year: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatisticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesControllerGetStatistics(year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get company\'s statistics in xls format
         * @param {string} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesControllerGetXlsStatistics(year: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesControllerGetXlsStatistics(year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send promocodes
         * @param {SendPromocodesRequestDto} sendPromocodesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companiesControllerSendPromocodes(sendPromocodesRequestDto: SendPromocodesRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companiesControllerSendPromocodes(sendPromocodesRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyApiFp(configuration)
    return {
        /**
         * 
         * @summary Create company create request
         * @param {CreateCompanyCreateRequestRequestDto} createCompanyCreateRequestRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesControllerCreateCompanyCreateRequest(createCompanyCreateRequestRequestDto: CreateCompanyCreateRequestRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.companiesControllerCreateCompanyCreateRequest(createCompanyCreateRequestRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send promocode request
         * @param {PromocodeRequestRequestDto} promocodeRequestRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesControllerCreatePromocodeRequest(promocodeRequestRequestDto: PromocodeRequestRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.companiesControllerCreatePromocodeRequest(promocodeRequestRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get promocodes
         * @param {boolean} isExpired 
         * @param {Array<string>} [amountFilter] 
         * @param {Array<string>} [percentageFilter] 
         * @param {'expired' | 'used'} [statusFilter] 
         * @param {'expireDate' | 'amount'} [sortTerm] 
         * @param {'ASC' | 'DESC'} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesControllerGetPromocodes(isExpired: boolean, amountFilter?: Array<string>, percentageFilter?: Array<string>, statusFilter?: 'expired' | 'used', sortTerm?: 'expireDate' | 'amount', sortOrder?: 'ASC' | 'DESC', options?: any): AxiosPromise<GetPromocodesResponseDto> {
            return localVarFp.companiesControllerGetPromocodes(isExpired, amountFilter, percentageFilter, statusFilter, sortTerm, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get company\'s statistics
         * @param {string} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesControllerGetStatistics(year: string, options?: any): AxiosPromise<GetStatisticsResponseDto> {
            return localVarFp.companiesControllerGetStatistics(year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get company\'s statistics in xls format
         * @param {string} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesControllerGetXlsStatistics(year: string, options?: any): AxiosPromise<void> {
            return localVarFp.companiesControllerGetXlsStatistics(year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send promocodes
         * @param {SendPromocodesRequestDto} sendPromocodesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesControllerSendPromocodes(sendPromocodesRequestDto: SendPromocodesRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.companiesControllerSendPromocodes(sendPromocodesRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
    /**
     * 
     * @summary Create company create request
     * @param {CreateCompanyCreateRequestRequestDto} createCompanyCreateRequestRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public companiesControllerCreateCompanyCreateRequest(createCompanyCreateRequestRequestDto: CreateCompanyCreateRequestRequestDto, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).companiesControllerCreateCompanyCreateRequest(createCompanyCreateRequestRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send promocode request
     * @param {PromocodeRequestRequestDto} promocodeRequestRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public companiesControllerCreatePromocodeRequest(promocodeRequestRequestDto: PromocodeRequestRequestDto, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).companiesControllerCreatePromocodeRequest(promocodeRequestRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get promocodes
     * @param {boolean} isExpired 
     * @param {Array<string>} [amountFilter] 
     * @param {Array<string>} [percentageFilter] 
     * @param {'expired' | 'used'} [statusFilter] 
     * @param {'expireDate' | 'amount'} [sortTerm] 
     * @param {'ASC' | 'DESC'} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public companiesControllerGetPromocodes(isExpired: boolean, amountFilter?: Array<string>, percentageFilter?: Array<string>, statusFilter?: 'expired' | 'used', sortTerm?: 'expireDate' | 'amount', sortOrder?: 'ASC' | 'DESC', options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).companiesControllerGetPromocodes(isExpired, amountFilter, percentageFilter, statusFilter, sortTerm, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get company\'s statistics
     * @param {string} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public companiesControllerGetStatistics(year: string, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).companiesControllerGetStatistics(year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get company\'s statistics in xls format
     * @param {string} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public companiesControllerGetXlsStatistics(year: string, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).companiesControllerGetXlsStatistics(year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send promocodes
     * @param {SendPromocodesRequestDto} sendPromocodesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompanyApi
     */
    public companiesControllerSendPromocodes(sendPromocodesRequestDto: SendPromocodesRequestDto, options?: AxiosRequestConfig) {
        return CompanyApiFp(this.configuration).companiesControllerSendPromocodes(sendPromocodesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ContentApi - axios parameter creator
 * @export
 */
export const ContentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Отметить видео как просмотренное
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentControllerCompleteVideo: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('contentControllerCompleteVideo', 'id', id)
            const localVarPath = `/api/v1/content/{id}/complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить курс с папками и видео
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentControllerGetCourseDetail: async (courseId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('contentControllerGetCourseDetail', 'courseId', courseId)
            const localVarPath = `/api/v1/content/courses/{courseId}`
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить список курсов обучения (только для B2B)
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentControllerGetCourses: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/content/courses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentApi - functional programming interface
 * @export
 */
export const ContentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Отметить видео как просмотренное
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentControllerCompleteVideo(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentControllerCompleteVideo(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Получить курс с папками и видео
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentControllerGetCourseDetail(courseId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicContentCourseDetailResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentControllerGetCourseDetail(courseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Получить список курсов обучения (только для B2B)
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentControllerGetCourses(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicContentCoursesPaginatedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentControllerGetCourses(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContentApi - factory interface
 * @export
 */
export const ContentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContentApiFp(configuration)
    return {
        /**
         * 
         * @summary Отметить видео как просмотренное
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentControllerCompleteVideo(id: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.contentControllerCompleteVideo(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить курс с папками и видео
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentControllerGetCourseDetail(courseId: string, options?: any): AxiosPromise<PublicContentCourseDetailResponseDto> {
            return localVarFp.contentControllerGetCourseDetail(courseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить список курсов обучения (только для B2B)
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentControllerGetCourses(page?: number, limit?: number, options?: any): AxiosPromise<PublicContentCoursesPaginatedResponseDto> {
            return localVarFp.contentControllerGetCourses(page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContentApi - object-oriented interface
 * @export
 * @class ContentApi
 * @extends {BaseAPI}
 */
export class ContentApi extends BaseAPI {
    /**
     * 
     * @summary Отметить видео как просмотренное
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public contentControllerCompleteVideo(id: string, options?: AxiosRequestConfig) {
        return ContentApiFp(this.configuration).contentControllerCompleteVideo(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить курс с папками и видео
     * @param {string} courseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public contentControllerGetCourseDetail(courseId: string, options?: AxiosRequestConfig) {
        return ContentApiFp(this.configuration).contentControllerGetCourseDetail(courseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить список курсов обучения (только для B2B)
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public contentControllerGetCourses(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return ContentApiFp(this.configuration).contentControllerGetCourses(page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create payment link
         * @summary Create payment link (only stripe)
         * @param {AdminCreatePaymentLinkRequestDto} adminCreatePaymentLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPaymentLinkControllerCreatePaymentLink: async (adminCreatePaymentLinkRequestDto: AdminCreatePaymentLinkRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminCreatePaymentLinkRequestDto' is not null or undefined
            assertParamExists('adminPaymentLinkControllerCreatePaymentLink', 'adminCreatePaymentLinkRequestDto', adminCreatePaymentLinkRequestDto)
            const localVarPath = `/api/v1/admin/payment-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreatePaymentLinkRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create payment link
         * @summary Create payment link (only stripe)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPaymentLinkControllerGetPaginatedPaymentLink: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/payment-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CancelDealRequestDto} cancelDealRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiControllerCancelPayment: async (cancelDealRequestDto: CancelDealRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cancelDealRequestDto' is not null or undefined
            assertParamExists('apiControllerCancelPayment', 'cancelDealRequestDto', cancelDealRequestDto)
            const localVarPath = `/api/v1/payment-gateway/api/cancel-deal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelDealRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiControllerCheckDealStatus: async (dealId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('apiControllerCheckDealStatus', 'dealId', dealId)
            const localVarPath = `/api/v1/payment-gateway/api/check-deal-status/{dealId}`
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDealRequestDto} createDealRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiControllerCreatePayment: async (createDealRequestDto: CreateDealRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDealRequestDto' is not null or undefined
            assertParamExists('apiControllerCreatePayment', 'createDealRequestDto', createDealRequestDto)
            const localVarPath = `/api/v1/payment-gateway/api/create-deal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDealRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiControllerRefund: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment-gateway/api/process-refund`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RescheduleDealRequestDto} rescheduleDealRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiControllerReschedulePayment: async (rescheduleDealRequestDto: RescheduleDealRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rescheduleDealRequestDto' is not null or undefined
            assertParamExists('apiControllerReschedulePayment', 'rescheduleDealRequestDto', rescheduleDealRequestDto)
            const localVarPath = `/api/v1/payment-gateway/api/reschedule-deal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleDealRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetMiniAvatarKeyRequest} setMiniAvatarKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lambdaControllerSetMiniAvatarKey: async (setMiniAvatarKeyRequest: SetMiniAvatarKeyRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setMiniAvatarKeyRequest' is not null or undefined
            assertParamExists('lambdaControllerSetMiniAvatarKey', 'setMiniAvatarKeyRequest', setMiniAvatarKeyRequest)
            const localVarPath = `/api/v1/lambdas/set-mini-avatar-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setMiniAvatarKeyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loggerControllerFindAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/logger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loggerControllerPixel: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/logger/pixel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Создание ссылки для привязки карты к пользователю
         * @param {AttachCardRequestDto} attachCardRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentMethodControllerAttachCard: async (attachCardRequestDto: AttachCardRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachCardRequestDto' is not null or undefined
            assertParamExists('paymentMethodControllerAttachCard', 'attachCardRequestDto', attachCardRequestDto)
            const localVarPath = `/api/v1/payment-gateway/payment-method/attach`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attachCardRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удаление карты для пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentMethodControllerDetachCard: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment-gateway/payment-method/detach`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get credit card info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentMethodControllerGetPaymentMethod: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment-gateway/payment-method`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Create payment link
         * @summary Create payment link (only stripe)
         * @param {AdminCreatePaymentLinkRequestDto} adminCreatePaymentLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPaymentLinkControllerCreatePaymentLink(adminCreatePaymentLinkRequestDto: AdminCreatePaymentLinkRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCreatePaymentLinkResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPaymentLinkControllerCreatePaymentLink(adminCreatePaymentLinkRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create payment link
         * @summary Create payment link (only stripe)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPaymentLinkControllerGetPaginatedPaymentLink(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCreatePaymentLinkResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPaymentLinkControllerGetPaginatedPaymentLink(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CancelDealRequestDto} cancelDealRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiControllerCancelPayment(cancelDealRequestDto: CancelDealRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiControllerCancelPayment(cancelDealRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiControllerCheckDealStatus(dealId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiControllerCheckDealStatus(dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateDealRequestDto} createDealRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiControllerCreatePayment(createDealRequestDto: CreateDealRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiControllerCreatePayment(createDealRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiControllerRefund(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiControllerRefund(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RescheduleDealRequestDto} rescheduleDealRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiControllerReschedulePayment(rescheduleDealRequestDto: RescheduleDealRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiControllerReschedulePayment(rescheduleDealRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetMiniAvatarKeyRequest} setMiniAvatarKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lambdaControllerSetMiniAvatarKey(setMiniAvatarKeyRequest: SetMiniAvatarKeyRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lambdaControllerSetMiniAvatarKey(setMiniAvatarKeyRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loggerControllerFindAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loggerControllerFindAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loggerControllerPixel(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loggerControllerPixel(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Создание ссылки для привязки карты к пользователю
         * @param {AttachCardRequestDto} attachCardRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentMethodControllerAttachCard(attachCardRequestDto: AttachCardRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachCardResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentMethodControllerAttachCard(attachCardRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Удаление карты для пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentMethodControllerDetachCard(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentMethodControllerDetachCard(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get credit card info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentMethodControllerGetPaymentMethod(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentMethodResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentMethodControllerGetPaymentMethod(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Create payment link
         * @summary Create payment link (only stripe)
         * @param {AdminCreatePaymentLinkRequestDto} adminCreatePaymentLinkRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPaymentLinkControllerCreatePaymentLink(adminCreatePaymentLinkRequestDto: AdminCreatePaymentLinkRequestDto, options?: any): AxiosPromise<AdminCreatePaymentLinkResponseDto> {
            return localVarFp.adminPaymentLinkControllerCreatePaymentLink(adminCreatePaymentLinkRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Create payment link
         * @summary Create payment link (only stripe)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPaymentLinkControllerGetPaginatedPaymentLink(options?: any): AxiosPromise<AdminCreatePaymentLinkResponseDto> {
            return localVarFp.adminPaymentLinkControllerGetPaginatedPaymentLink(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CancelDealRequestDto} cancelDealRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiControllerCancelPayment(cancelDealRequestDto: CancelDealRequestDto, options?: any): AxiosPromise<object> {
            return localVarFp.apiControllerCancelPayment(cancelDealRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiControllerCheckDealStatus(dealId: string, options?: any): AxiosPromise<object> {
            return localVarFp.apiControllerCheckDealStatus(dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateDealRequestDto} createDealRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiControllerCreatePayment(createDealRequestDto: CreateDealRequestDto, options?: any): AxiosPromise<object> {
            return localVarFp.apiControllerCreatePayment(createDealRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiControllerRefund(options?: any): AxiosPromise<string> {
            return localVarFp.apiControllerRefund(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RescheduleDealRequestDto} rescheduleDealRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiControllerReschedulePayment(rescheduleDealRequestDto: RescheduleDealRequestDto, options?: any): AxiosPromise<object> {
            return localVarFp.apiControllerReschedulePayment(rescheduleDealRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetMiniAvatarKeyRequest} setMiniAvatarKeyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lambdaControllerSetMiniAvatarKey(setMiniAvatarKeyRequest: SetMiniAvatarKeyRequest, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.lambdaControllerSetMiniAvatarKey(setMiniAvatarKeyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loggerControllerFindAll(options?: any): AxiosPromise<object> {
            return localVarFp.loggerControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loggerControllerPixel(options?: any): AxiosPromise<object> {
            return localVarFp.loggerControllerPixel(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Создание ссылки для привязки карты к пользователю
         * @param {AttachCardRequestDto} attachCardRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentMethodControllerAttachCard(attachCardRequestDto: AttachCardRequestDto, options?: any): AxiosPromise<AttachCardResponseDto> {
            return localVarFp.paymentMethodControllerAttachCard(attachCardRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удаление карты для пользователя
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentMethodControllerDetachCard(options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.paymentMethodControllerDetachCard(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get credit card info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentMethodControllerGetPaymentMethod(options?: any): AxiosPromise<PaymentMethodResponseDto> {
            return localVarFp.paymentMethodControllerGetPaymentMethod(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Create payment link
     * @summary Create payment link (only stripe)
     * @param {AdminCreatePaymentLinkRequestDto} adminCreatePaymentLinkRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminPaymentLinkControllerCreatePaymentLink(adminCreatePaymentLinkRequestDto: AdminCreatePaymentLinkRequestDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminPaymentLinkControllerCreatePaymentLink(adminCreatePaymentLinkRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create payment link
     * @summary Create payment link (only stripe)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminPaymentLinkControllerGetPaginatedPaymentLink(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminPaymentLinkControllerGetPaginatedPaymentLink(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CancelDealRequestDto} cancelDealRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiControllerCancelPayment(cancelDealRequestDto: CancelDealRequestDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiControllerCancelPayment(cancelDealRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} dealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiControllerCheckDealStatus(dealId: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiControllerCheckDealStatus(dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateDealRequestDto} createDealRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiControllerCreatePayment(createDealRequestDto: CreateDealRequestDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiControllerCreatePayment(createDealRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiControllerRefund(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiControllerRefund(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RescheduleDealRequestDto} rescheduleDealRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiControllerReschedulePayment(rescheduleDealRequestDto: RescheduleDealRequestDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiControllerReschedulePayment(rescheduleDealRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetMiniAvatarKeyRequest} setMiniAvatarKeyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public lambdaControllerSetMiniAvatarKey(setMiniAvatarKeyRequest: SetMiniAvatarKeyRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).lambdaControllerSetMiniAvatarKey(setMiniAvatarKeyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loggerControllerFindAll(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loggerControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loggerControllerPixel(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loggerControllerPixel(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Создание ссылки для привязки карты к пользователю
     * @param {AttachCardRequestDto} attachCardRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public paymentMethodControllerAttachCard(attachCardRequestDto: AttachCardRequestDto, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).paymentMethodControllerAttachCard(attachCardRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удаление карты для пользователя
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public paymentMethodControllerDetachCard(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).paymentMethodControllerDetachCard(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get credit card info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public paymentMethodControllerGetPaymentMethod(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).paymentMethodControllerGetPaymentMethod(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FAQApi - axios parameter creator
 * @export
 */
export const FAQApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add FAQ group
         * @summary Add FAQ group
         * @param {AddFaqGroupRequestDto} addFaqGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faqControllerAddFaqGroup: async (addFaqGroupRequestDto: AddFaqGroupRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addFaqGroupRequestDto' is not null or undefined
            assertParamExists('faqControllerAddFaqGroup', 'addFaqGroupRequestDto', addFaqGroupRequestDto)
            const localVarPath = `/api/v1/faq/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addFaqGroupRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add FAQ question
         * @summary Add FAQ question
         * @param {string} groupId 
         * @param {AddFaqQuestionRequestDto} addFaqQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faqControllerAddFaqQuestion: async (groupId: string, addFaqQuestionRequestDto: AddFaqQuestionRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('faqControllerAddFaqQuestion', 'groupId', groupId)
            // verify required parameter 'addFaqQuestionRequestDto' is not null or undefined
            assertParamExists('faqControllerAddFaqQuestion', 'addFaqQuestionRequestDto', addFaqQuestionRequestDto)
            const localVarPath = `/api/v1/faq/groups/{group_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addFaqQuestionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete FAQ group
         * @summary Delete FAQ group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faqControllerDeleteFaqGroup: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('faqControllerDeleteFaqGroup', 'id', id)
            const localVarPath = `/api/v1/faq/groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete FAQ question
         * @summary Delete FAQ question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faqControllerDeleteFaqQuestion: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('faqControllerDeleteFaqQuestion', 'id', id)
            const localVarPath = `/api/v1/faq/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update FAQ group
         * @summary Update FAQ group
         * @param {string} id 
         * @param {UpdateFaqGroupRequestDto} updateFaqGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faqControllerUpdateFaqGroup: async (id: string, updateFaqGroupRequestDto: UpdateFaqGroupRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('faqControllerUpdateFaqGroup', 'id', id)
            // verify required parameter 'updateFaqGroupRequestDto' is not null or undefined
            assertParamExists('faqControllerUpdateFaqGroup', 'updateFaqGroupRequestDto', updateFaqGroupRequestDto)
            const localVarPath = `/api/v1/faq/groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFaqGroupRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update FAQ question
         * @summary Update FAQ question
         * @param {string} id 
         * @param {UpdateFaqQuestionRequestDto} updateFaqQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faqControllerUpdateFaqQuestion: async (id: string, updateFaqQuestionRequestDto: UpdateFaqQuestionRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('faqControllerUpdateFaqQuestion', 'id', id)
            // verify required parameter 'updateFaqQuestionRequestDto' is not null or undefined
            assertParamExists('faqControllerUpdateFaqQuestion', 'updateFaqQuestionRequestDto', updateFaqQuestionRequestDto)
            const localVarPath = `/api/v1/faq/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFaqQuestionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FAQApi - functional programming interface
 * @export
 */
export const FAQApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FAQApiAxiosParamCreator(configuration)
    return {
        /**
         * Add FAQ group
         * @summary Add FAQ group
         * @param {AddFaqGroupRequestDto} addFaqGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async faqControllerAddFaqGroup(addFaqGroupRequestDto: AddFaqGroupRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FaqGroupResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.faqControllerAddFaqGroup(addFaqGroupRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add FAQ question
         * @summary Add FAQ question
         * @param {string} groupId 
         * @param {AddFaqQuestionRequestDto} addFaqQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async faqControllerAddFaqQuestion(groupId: string, addFaqQuestionRequestDto: AddFaqQuestionRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FaqQuestionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.faqControllerAddFaqQuestion(groupId, addFaqQuestionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete FAQ group
         * @summary Delete FAQ group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async faqControllerDeleteFaqGroup(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.faqControllerDeleteFaqGroup(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete FAQ question
         * @summary Delete FAQ question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async faqControllerDeleteFaqQuestion(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.faqControllerDeleteFaqQuestion(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update FAQ group
         * @summary Update FAQ group
         * @param {string} id 
         * @param {UpdateFaqGroupRequestDto} updateFaqGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async faqControllerUpdateFaqGroup(id: string, updateFaqGroupRequestDto: UpdateFaqGroupRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FaqGroupResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.faqControllerUpdateFaqGroup(id, updateFaqGroupRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update FAQ question
         * @summary Update FAQ question
         * @param {string} id 
         * @param {UpdateFaqQuestionRequestDto} updateFaqQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async faqControllerUpdateFaqQuestion(id: string, updateFaqQuestionRequestDto: UpdateFaqQuestionRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FaqQuestionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.faqControllerUpdateFaqQuestion(id, updateFaqQuestionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FAQApi - factory interface
 * @export
 */
export const FAQApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FAQApiFp(configuration)
    return {
        /**
         * Add FAQ group
         * @summary Add FAQ group
         * @param {AddFaqGroupRequestDto} addFaqGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faqControllerAddFaqGroup(addFaqGroupRequestDto: AddFaqGroupRequestDto, options?: any): AxiosPromise<FaqGroupResponseDto> {
            return localVarFp.faqControllerAddFaqGroup(addFaqGroupRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Add FAQ question
         * @summary Add FAQ question
         * @param {string} groupId 
         * @param {AddFaqQuestionRequestDto} addFaqQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faqControllerAddFaqQuestion(groupId: string, addFaqQuestionRequestDto: AddFaqQuestionRequestDto, options?: any): AxiosPromise<FaqQuestionResponseDto> {
            return localVarFp.faqControllerAddFaqQuestion(groupId, addFaqQuestionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete FAQ group
         * @summary Delete FAQ group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faqControllerDeleteFaqGroup(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.faqControllerDeleteFaqGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete FAQ question
         * @summary Delete FAQ question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faqControllerDeleteFaqQuestion(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.faqControllerDeleteFaqQuestion(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update FAQ group
         * @summary Update FAQ group
         * @param {string} id 
         * @param {UpdateFaqGroupRequestDto} updateFaqGroupRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faqControllerUpdateFaqGroup(id: string, updateFaqGroupRequestDto: UpdateFaqGroupRequestDto, options?: any): AxiosPromise<FaqGroupResponseDto> {
            return localVarFp.faqControllerUpdateFaqGroup(id, updateFaqGroupRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update FAQ question
         * @summary Update FAQ question
         * @param {string} id 
         * @param {UpdateFaqQuestionRequestDto} updateFaqQuestionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faqControllerUpdateFaqQuestion(id: string, updateFaqQuestionRequestDto: UpdateFaqQuestionRequestDto, options?: any): AxiosPromise<FaqQuestionResponseDto> {
            return localVarFp.faqControllerUpdateFaqQuestion(id, updateFaqQuestionRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FAQApi - object-oriented interface
 * @export
 * @class FAQApi
 * @extends {BaseAPI}
 */
export class FAQApi extends BaseAPI {
    /**
     * Add FAQ group
     * @summary Add FAQ group
     * @param {AddFaqGroupRequestDto} addFaqGroupRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQApi
     */
    public faqControllerAddFaqGroup(addFaqGroupRequestDto: AddFaqGroupRequestDto, options?: AxiosRequestConfig) {
        return FAQApiFp(this.configuration).faqControllerAddFaqGroup(addFaqGroupRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add FAQ question
     * @summary Add FAQ question
     * @param {string} groupId 
     * @param {AddFaqQuestionRequestDto} addFaqQuestionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQApi
     */
    public faqControllerAddFaqQuestion(groupId: string, addFaqQuestionRequestDto: AddFaqQuestionRequestDto, options?: AxiosRequestConfig) {
        return FAQApiFp(this.configuration).faqControllerAddFaqQuestion(groupId, addFaqQuestionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete FAQ group
     * @summary Delete FAQ group
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQApi
     */
    public faqControllerDeleteFaqGroup(id: string, options?: AxiosRequestConfig) {
        return FAQApiFp(this.configuration).faqControllerDeleteFaqGroup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete FAQ question
     * @summary Delete FAQ question
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQApi
     */
    public faqControllerDeleteFaqQuestion(id: string, options?: AxiosRequestConfig) {
        return FAQApiFp(this.configuration).faqControllerDeleteFaqQuestion(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update FAQ group
     * @summary Update FAQ group
     * @param {string} id 
     * @param {UpdateFaqGroupRequestDto} updateFaqGroupRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQApi
     */
    public faqControllerUpdateFaqGroup(id: string, updateFaqGroupRequestDto: UpdateFaqGroupRequestDto, options?: AxiosRequestConfig) {
        return FAQApiFp(this.configuration).faqControllerUpdateFaqGroup(id, updateFaqGroupRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update FAQ question
     * @summary Update FAQ question
     * @param {string} id 
     * @param {UpdateFaqQuestionRequestDto} updateFaqQuestionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FAQApi
     */
    public faqControllerUpdateFaqQuestion(id: string, updateFaqQuestionRequestDto: UpdateFaqQuestionRequestDto, options?: AxiosRequestConfig) {
        return FAQApiFp(this.configuration).faqControllerUpdateFaqQuestion(id, updateFaqQuestionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FilesApi - axios parameter creator
 * @export
 */
export const FilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get private signed url for file upload
         * @param {CreateFileRequestDto} createFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signedUrlControllerGetPrivateSignedUrl: async (createFileRequestDto: CreateFileRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFileRequestDto' is not null or undefined
            assertParamExists('signedUrlControllerGetPrivateSignedUrl', 'createFileRequestDto', createFileRequestDto)
            const localVarPath = `/api/v1/get-private-signed-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get public signed url for file upload
         * @param {CreateFileRequestDto} createFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signedUrlControllerGetPublicSignedUrl: async (createFileRequestDto: CreateFileRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFileRequestDto' is not null or undefined
            assertParamExists('signedUrlControllerGetPublicSignedUrl', 'createFileRequestDto', createFileRequestDto)
            const localVarPath = `/api/v1/get-public-signed-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload B2B material file to MinIO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signedUrlControllerUploadB2BMaterialFile: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/b2b-materials/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload video lesson document to MinIO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signedUrlControllerUploadContentDocument: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/content/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesApi - functional programming interface
 * @export
 */
export const FilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get private signed url for file upload
         * @param {CreateFileRequestDto} createFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signedUrlControllerGetPrivateSignedUrl(createFileRequestDto: CreateFileRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signedUrlControllerGetPrivateSignedUrl(createFileRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get public signed url for file upload
         * @param {CreateFileRequestDto} createFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signedUrlControllerGetPublicSignedUrl(createFileRequestDto: CreateFileRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signedUrlControllerGetPublicSignedUrl(createFileRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload B2B material file to MinIO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signedUrlControllerUploadB2BMaterialFile(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedMaterialResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signedUrlControllerUploadB2BMaterialFile(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload video lesson document to MinIO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signedUrlControllerUploadContentDocument(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedMaterialResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signedUrlControllerUploadContentDocument(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FilesApi - factory interface
 * @export
 */
export const FilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get private signed url for file upload
         * @param {CreateFileRequestDto} createFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signedUrlControllerGetPrivateSignedUrl(createFileRequestDto: CreateFileRequestDto, options?: any): AxiosPromise<string> {
            return localVarFp.signedUrlControllerGetPrivateSignedUrl(createFileRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get public signed url for file upload
         * @param {CreateFileRequestDto} createFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signedUrlControllerGetPublicSignedUrl(createFileRequestDto: CreateFileRequestDto, options?: any): AxiosPromise<string> {
            return localVarFp.signedUrlControllerGetPublicSignedUrl(createFileRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload B2B material file to MinIO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signedUrlControllerUploadB2BMaterialFile(options?: any): AxiosPromise<UploadedMaterialResponseDto> {
            return localVarFp.signedUrlControllerUploadB2BMaterialFile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload video lesson document to MinIO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signedUrlControllerUploadContentDocument(options?: any): AxiosPromise<UploadedMaterialResponseDto> {
            return localVarFp.signedUrlControllerUploadContentDocument(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FilesApi - object-oriented interface
 * @export
 * @class FilesApi
 * @extends {BaseAPI}
 */
export class FilesApi extends BaseAPI {
    /**
     * 
     * @summary Get private signed url for file upload
     * @param {CreateFileRequestDto} createFileRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public signedUrlControllerGetPrivateSignedUrl(createFileRequestDto: CreateFileRequestDto, options?: AxiosRequestConfig) {
        return FilesApiFp(this.configuration).signedUrlControllerGetPrivateSignedUrl(createFileRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get public signed url for file upload
     * @param {CreateFileRequestDto} createFileRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public signedUrlControllerGetPublicSignedUrl(createFileRequestDto: CreateFileRequestDto, options?: AxiosRequestConfig) {
        return FilesApiFp(this.configuration).signedUrlControllerGetPublicSignedUrl(createFileRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload B2B material file to MinIO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public signedUrlControllerUploadB2BMaterialFile(options?: AxiosRequestConfig) {
        return FilesApiFp(this.configuration).signedUrlControllerUploadB2BMaterialFile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload video lesson document to MinIO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApi
     */
    public signedUrlControllerUploadContentDocument(options?: AxiosRequestConfig) {
        return FilesApiFp(this.configuration).signedUrlControllerUploadContentDocument(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GroupCallLinksApi - axios parameter creator
 * @export
 */
export const GroupCallLinksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получить доступные ссылки на групповые созвоны
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupCallLinksControllerGetList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/group-call-links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupCallLinksApi - functional programming interface
 * @export
 */
export const GroupCallLinksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupCallLinksApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получить доступные ссылки на групповые созвоны
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupCallLinksControllerGetList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupCallLinkResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupCallLinksControllerGetList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GroupCallLinksApi - factory interface
 * @export
 */
export const GroupCallLinksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupCallLinksApiFp(configuration)
    return {
        /**
         * 
         * @summary Получить доступные ссылки на групповые созвоны
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupCallLinksControllerGetList(options?: any): AxiosPromise<Array<GroupCallLinkResponseDto>> {
            return localVarFp.groupCallLinksControllerGetList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GroupCallLinksApi - object-oriented interface
 * @export
 * @class GroupCallLinksApi
 * @extends {BaseAPI}
 */
export class GroupCallLinksApi extends BaseAPI {
    /**
     * 
     * @summary Получить доступные ссылки на групповые созвоны
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupCallLinksApi
     */
    public groupCallLinksControllerGetList(options?: AxiosRequestConfig) {
        return GroupCallLinksApiFp(this.configuration).groupCallLinksControllerGetList(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MedsiAuthApi - axios parameter creator
 * @export
 */
export const MedsiAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GenerateTokenRequestDto} generateTokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medsiAuthControllerCreateMedsiToken: async (generateTokenRequestDto: GenerateTokenRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateTokenRequestDto' is not null or undefined
            assertParamExists('medsiAuthControllerCreateMedsiToken', 'generateTokenRequestDto', generateTokenRequestDto)
            const localVarPath = `/api/v1/medsi/auth/generate-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateTokenRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recover medsi user
         * @param {MedsiSignUpRequestDto} medsiSignUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medsiAuthControllerRecover: async (medsiSignUpRequestDto: MedsiSignUpRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medsiSignUpRequestDto' is not null or undefined
            assertParamExists('medsiAuthControllerRecover', 'medsiSignUpRequestDto', medsiSignUpRequestDto)
            const localVarPath = `/api/v1/medsi/auth/recover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medsiSignUpRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sign in medsi user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medsiAuthControllerSignIn: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/medsi/auth/sign-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sign up medsi user
         * @param {MedsiSignUpRequestDto} medsiSignUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medsiAuthControllerSignUp: async (medsiSignUpRequestDto: MedsiSignUpRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'medsiSignUpRequestDto' is not null or undefined
            assertParamExists('medsiAuthControllerSignUp', 'medsiSignUpRequestDto', medsiSignUpRequestDto)
            const localVarPath = `/api/v1/medsi/auth/sign-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(medsiSignUpRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate medsi token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medsiAuthControllerValidateToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/medsi/auth/validate-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MedsiAuthApi - functional programming interface
 * @export
 */
export const MedsiAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MedsiAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {GenerateTokenRequestDto} generateTokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medsiAuthControllerCreateMedsiToken(generateTokenRequestDto: GenerateTokenRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateTokenResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medsiAuthControllerCreateMedsiToken(generateTokenRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Recover medsi user
         * @param {MedsiSignUpRequestDto} medsiSignUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medsiAuthControllerRecover(medsiSignUpRequestDto: MedsiSignUpRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithTokenAndMetadataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medsiAuthControllerRecover(medsiSignUpRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sign in medsi user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medsiAuthControllerSignIn(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithTokenAndMetadataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medsiAuthControllerSignIn(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sign up medsi user
         * @param {MedsiSignUpRequestDto} medsiSignUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medsiAuthControllerSignUp(medsiSignUpRequestDto: MedsiSignUpRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithTokenAndMetadataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medsiAuthControllerSignUp(medsiSignUpRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validate medsi token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async medsiAuthControllerValidateToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateMedsiTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.medsiAuthControllerValidateToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MedsiAuthApi - factory interface
 * @export
 */
export const MedsiAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MedsiAuthApiFp(configuration)
    return {
        /**
         * 
         * @param {GenerateTokenRequestDto} generateTokenRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medsiAuthControllerCreateMedsiToken(generateTokenRequestDto: GenerateTokenRequestDto, options?: any): AxiosPromise<GenerateTokenResponseDto> {
            return localVarFp.medsiAuthControllerCreateMedsiToken(generateTokenRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recover medsi user
         * @param {MedsiSignUpRequestDto} medsiSignUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medsiAuthControllerRecover(medsiSignUpRequestDto: MedsiSignUpRequestDto, options?: any): AxiosPromise<UserWithTokenAndMetadataResponseDto> {
            return localVarFp.medsiAuthControllerRecover(medsiSignUpRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sign in medsi user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medsiAuthControllerSignIn(options?: any): AxiosPromise<UserWithTokenAndMetadataResponseDto> {
            return localVarFp.medsiAuthControllerSignIn(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sign up medsi user
         * @param {MedsiSignUpRequestDto} medsiSignUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medsiAuthControllerSignUp(medsiSignUpRequestDto: MedsiSignUpRequestDto, options?: any): AxiosPromise<UserWithTokenAndMetadataResponseDto> {
            return localVarFp.medsiAuthControllerSignUp(medsiSignUpRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate medsi token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        medsiAuthControllerValidateToken(options?: any): AxiosPromise<ValidateMedsiTokenResponse> {
            return localVarFp.medsiAuthControllerValidateToken(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MedsiAuthApi - object-oriented interface
 * @export
 * @class MedsiAuthApi
 * @extends {BaseAPI}
 */
export class MedsiAuthApi extends BaseAPI {
    /**
     * 
     * @param {GenerateTokenRequestDto} generateTokenRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedsiAuthApi
     */
    public medsiAuthControllerCreateMedsiToken(generateTokenRequestDto: GenerateTokenRequestDto, options?: AxiosRequestConfig) {
        return MedsiAuthApiFp(this.configuration).medsiAuthControllerCreateMedsiToken(generateTokenRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recover medsi user
     * @param {MedsiSignUpRequestDto} medsiSignUpRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedsiAuthApi
     */
    public medsiAuthControllerRecover(medsiSignUpRequestDto: MedsiSignUpRequestDto, options?: AxiosRequestConfig) {
        return MedsiAuthApiFp(this.configuration).medsiAuthControllerRecover(medsiSignUpRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sign in medsi user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedsiAuthApi
     */
    public medsiAuthControllerSignIn(options?: AxiosRequestConfig) {
        return MedsiAuthApiFp(this.configuration).medsiAuthControllerSignIn(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sign up medsi user
     * @param {MedsiSignUpRequestDto} medsiSignUpRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedsiAuthApi
     */
    public medsiAuthControllerSignUp(medsiSignUpRequestDto: MedsiSignUpRequestDto, options?: AxiosRequestConfig) {
        return MedsiAuthApiFp(this.configuration).medsiAuthControllerSignUp(medsiSignUpRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate medsi token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MedsiAuthApi
     */
    public medsiAuthControllerValidateToken(options?: AxiosRequestConfig) {
        return MedsiAuthApiFp(this.configuration).medsiAuthControllerValidateToken(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Unsubscribe from email notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerUnsubscribeFromEmailNotifications: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notification/unsubscribe/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unsubscribe from email notifications
         * @param {UpdateNotificationSettingsRequestDto} updateNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerUpdateNotificationSettings: async (updateNotificationSettingsRequestDto: UpdateNotificationSettingsRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateNotificationSettingsRequestDto' is not null or undefined
            assertParamExists('notificationControllerUpdateNotificationSettings', 'updateNotificationSettingsRequestDto', updateNotificationSettingsRequestDto)
            const localVarPath = `/api/v1/notification/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Unsubscribe from email notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationControllerUnsubscribeFromEmailNotifications(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationControllerUnsubscribeFromEmailNotifications(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unsubscribe from email notifications
         * @param {UpdateNotificationSettingsRequestDto} updateNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationControllerUpdateNotificationSettings(updateNotificationSettingsRequestDto: UpdateNotificationSettingsRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationSettingsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationControllerUpdateNotificationSettings(updateNotificationSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Unsubscribe from email notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerUnsubscribeFromEmailNotifications(options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.notificationControllerUnsubscribeFromEmailNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unsubscribe from email notifications
         * @param {UpdateNotificationSettingsRequestDto} updateNotificationSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerUpdateNotificationSettings(updateNotificationSettingsRequestDto: UpdateNotificationSettingsRequestDto, options?: any): AxiosPromise<NotificationSettingsResponseDto> {
            return localVarFp.notificationControllerUpdateNotificationSettings(updateNotificationSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @summary Unsubscribe from email notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationControllerUnsubscribeFromEmailNotifications(options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationControllerUnsubscribeFromEmailNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unsubscribe from email notifications
     * @param {UpdateNotificationSettingsRequestDto} updateNotificationSettingsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationControllerUpdateNotificationSettings(updateNotificationSettingsRequestDto: UpdateNotificationSettingsRequestDto, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationControllerUpdateNotificationSettings(updateNotificationSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PatientsApi - axios parameter creator
 * @export
 */
export const PatientsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create recommendation filter (only for patients)
         * @param {CreateRecommendedFilterRequestDto} createRecommendedFilterRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerAddRecommendedFilter: async (createRecommendedFilterRequestDto: CreateRecommendedFilterRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRecommendedFilterRequestDto' is not null or undefined
            assertParamExists('patientsControllerAddRecommendedFilter', 'createRecommendedFilterRequestDto', createRecommendedFilterRequestDto)
            const localVarPath = `/api/v1/patients/recommendation-filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRecommendedFilterRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete avatar (only for patients)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerDeleteAvatar: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/patients/avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get active sessions (only for patient)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [therapistFirstname] 
         * @param {string} [therapistLastname] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerGetActiveSessions: async (limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, therapistFirstname?: string, therapistLastname?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('patientsControllerGetActiveSessions', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('patientsControllerGetActiveSessions', 'page', page)
            const localVarPath = `/api/v1/patients/sessions/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (therapistFirstname !== undefined) {
                localVarQueryParameter['therapistFirstname'] = therapistFirstname;
            }

            if (therapistLastname !== undefined) {
                localVarQueryParameter['therapistLastname'] = therapistLastname;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get patient profile (only for sessioned therapists)
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerGetPatient: async (patientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('patientsControllerGetPatient', 'patientId', patientId)
            const localVarPath = `/api/v1/patients/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get patient profile (only for patient)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerGetPatientProfile: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/patients/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get session history (only for patient)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [therapistFirstname] 
         * @param {string} [therapistLastname] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerGetSessionHistory: async (limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, therapistFirstname?: string, therapistLastname?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('patientsControllerGetSessionHistory', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('patientsControllerGetSessionHistory', 'page', page)
            const localVarPath = `/api/v1/patients/sessions/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (therapistFirstname !== undefined) {
                localVarQueryParameter['therapistFirstname'] = therapistFirstname;
            }

            if (therapistLastname !== undefined) {
                localVarQueryParameter['therapistLastname'] = therapistLastname;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get tiny sessions (only for patient)
         * @param {boolean} isActive 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerGetSessions: async (isActive: boolean, from?: string, to?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isActive' is not null or undefined
            assertParamExists('patientsControllerGetSessions', 'isActive', isActive)
            const localVarPath = `/api/v1/patients/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get patient\'s therapists (only for patients)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'therapistName' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerGetTherapists: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'therapistName' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('patientsControllerGetTherapists', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('patientsControllerGetTherapists', 'page', page)
            const localVarPath = `/api/v1/patients/therapist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get total session (only for patient)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Array<string>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerGetTotalSessionSession: async (limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, statuses?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('patientsControllerGetTotalSessionSession', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('patientsControllerGetTotalSessionSession', 'page', page)
            const localVarPath = `/api/v1/patients/sessions/total`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Onboarding (only for patients)
         * @param {PatientOnboardingRequestDto} patientOnboardingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerOnboarding: async (patientOnboardingRequestDto: PatientOnboardingRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientOnboardingRequestDto' is not null or undefined
            assertParamExists('patientsControllerOnboarding', 'patientOnboardingRequestDto', patientOnboardingRequestDto)
            const localVarPath = `/api/v1/patients/onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientOnboardingRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update avatar (only for patients)
         * @param {UpdateAvatarRequestDto} updateAvatarRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerUpdateAvatar: async (updateAvatarRequestDto: UpdateAvatarRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAvatarRequestDto' is not null or undefined
            assertParamExists('patientsControllerUpdateAvatar', 'updateAvatarRequestDto', updateAvatarRequestDto)
            const localVarPath = `/api/v1/patients/avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAvatarRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update self information
         * @param {UpdatePatientProfileRequestDto} updatePatientProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerUpdateOne: async (updatePatientProfileRequestDto: UpdatePatientProfileRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePatientProfileRequestDto' is not null or undefined
            assertParamExists('patientsControllerUpdateOne', 'updatePatientProfileRequestDto', updatePatientProfileRequestDto)
            const localVarPath = `/api/v1/patients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePatientProfileRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PatientsApi - functional programming interface
 * @export
 */
export const PatientsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PatientsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create recommendation filter (only for patients)
         * @param {CreateRecommendedFilterRequestDto} createRecommendedFilterRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientsControllerAddRecommendedFilter(createRecommendedFilterRequestDto: CreateRecommendedFilterRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientProfileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientsControllerAddRecommendedFilter(createRecommendedFilterRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete avatar (only for patients)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientsControllerDeleteAvatar(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientProfileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientsControllerDeleteAvatar(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get active sessions (only for patient)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [therapistFirstname] 
         * @param {string} [therapistLastname] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientsControllerGetActiveSessions(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, therapistFirstname?: string, therapistLastname?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSessionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientsControllerGetActiveSessions(limit, page, order, from, to, therapistFirstname, therapistLastname, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get patient profile (only for sessioned therapists)
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientsControllerGetPatient(patientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicPatientProfileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientsControllerGetPatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get patient profile (only for patient)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientsControllerGetPatientProfile(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientProfileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientsControllerGetPatientProfile(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get session history (only for patient)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [therapistFirstname] 
         * @param {string} [therapistLastname] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientsControllerGetSessionHistory(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, therapistFirstname?: string, therapistLastname?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSessionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientsControllerGetSessionHistory(limit, page, order, from, to, therapistFirstname, therapistLastname, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get tiny sessions (only for patient)
         * @param {boolean} isActive 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientsControllerGetSessions(isActive: boolean, from?: string, to?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsWithStartDate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientsControllerGetSessions(isActive, from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get patient\'s therapists (only for patients)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'therapistName' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientsControllerGetTherapists(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'therapistName' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientTherapistsShortInfosResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientsControllerGetTherapists(limit, page, order, orderTerms, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get total session (only for patient)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Array<string>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientsControllerGetTotalSessionSession(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, statuses?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSessionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientsControllerGetTotalSessionSession(limit, page, order, from, to, statuses, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Onboarding (only for patients)
         * @param {PatientOnboardingRequestDto} patientOnboardingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientsControllerOnboarding(patientOnboardingRequestDto: PatientOnboardingRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientProfileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientsControllerOnboarding(patientOnboardingRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update avatar (only for patients)
         * @param {UpdateAvatarRequestDto} updateAvatarRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientsControllerUpdateAvatar(updateAvatarRequestDto: UpdateAvatarRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientProfileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientsControllerUpdateAvatar(updateAvatarRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update self information
         * @param {UpdatePatientProfileRequestDto} updatePatientProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientsControllerUpdateOne(updatePatientProfileRequestDto: UpdatePatientProfileRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatientProfileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientsControllerUpdateOne(updatePatientProfileRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PatientsApi - factory interface
 * @export
 */
export const PatientsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PatientsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create recommendation filter (only for patients)
         * @param {CreateRecommendedFilterRequestDto} createRecommendedFilterRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerAddRecommendedFilter(createRecommendedFilterRequestDto: CreateRecommendedFilterRequestDto, options?: any): AxiosPromise<PatientProfileResponseDto> {
            return localVarFp.patientsControllerAddRecommendedFilter(createRecommendedFilterRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete avatar (only for patients)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerDeleteAvatar(options?: any): AxiosPromise<PatientProfileResponseDto> {
            return localVarFp.patientsControllerDeleteAvatar(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get active sessions (only for patient)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [therapistFirstname] 
         * @param {string} [therapistLastname] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerGetActiveSessions(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, therapistFirstname?: string, therapistLastname?: string, options?: any): AxiosPromise<PaginatedSessionResponseDto> {
            return localVarFp.patientsControllerGetActiveSessions(limit, page, order, from, to, therapistFirstname, therapistLastname, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get patient profile (only for sessioned therapists)
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerGetPatient(patientId: string, options?: any): AxiosPromise<PublicPatientProfileResponseDto> {
            return localVarFp.patientsControllerGetPatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get patient profile (only for patient)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerGetPatientProfile(options?: any): AxiosPromise<PatientProfileResponseDto> {
            return localVarFp.patientsControllerGetPatientProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get session history (only for patient)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [therapistFirstname] 
         * @param {string} [therapistLastname] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerGetSessionHistory(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, therapistFirstname?: string, therapistLastname?: string, options?: any): AxiosPromise<PaginatedSessionResponseDto> {
            return localVarFp.patientsControllerGetSessionHistory(limit, page, order, from, to, therapistFirstname, therapistLastname, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get tiny sessions (only for patient)
         * @param {boolean} isActive 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerGetSessions(isActive: boolean, from?: string, to?: string, options?: any): AxiosPromise<SessionsWithStartDate> {
            return localVarFp.patientsControllerGetSessions(isActive, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get patient\'s therapists (only for patients)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'therapistName' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerGetTherapists(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'therapistName' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate', options?: any): AxiosPromise<PatientTherapistsShortInfosResponseDto> {
            return localVarFp.patientsControllerGetTherapists(limit, page, order, orderTerms, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get total session (only for patient)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {Array<string>} [statuses] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerGetTotalSessionSession(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, statuses?: Array<string>, options?: any): AxiosPromise<PaginatedSessionResponseDto> {
            return localVarFp.patientsControllerGetTotalSessionSession(limit, page, order, from, to, statuses, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Onboarding (only for patients)
         * @param {PatientOnboardingRequestDto} patientOnboardingRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerOnboarding(patientOnboardingRequestDto: PatientOnboardingRequestDto, options?: any): AxiosPromise<PatientProfileResponseDto> {
            return localVarFp.patientsControllerOnboarding(patientOnboardingRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update avatar (only for patients)
         * @param {UpdateAvatarRequestDto} updateAvatarRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerUpdateAvatar(updateAvatarRequestDto: UpdateAvatarRequestDto, options?: any): AxiosPromise<PatientProfileResponseDto> {
            return localVarFp.patientsControllerUpdateAvatar(updateAvatarRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update self information
         * @param {UpdatePatientProfileRequestDto} updatePatientProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientsControllerUpdateOne(updatePatientProfileRequestDto: UpdatePatientProfileRequestDto, options?: any): AxiosPromise<PatientProfileResponseDto> {
            return localVarFp.patientsControllerUpdateOne(updatePatientProfileRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PatientsApi - object-oriented interface
 * @export
 * @class PatientsApi
 * @extends {BaseAPI}
 */
export class PatientsApi extends BaseAPI {
    /**
     * 
     * @summary Create recommendation filter (only for patients)
     * @param {CreateRecommendedFilterRequestDto} createRecommendedFilterRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public patientsControllerAddRecommendedFilter(createRecommendedFilterRequestDto: CreateRecommendedFilterRequestDto, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).patientsControllerAddRecommendedFilter(createRecommendedFilterRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete avatar (only for patients)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public patientsControllerDeleteAvatar(options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).patientsControllerDeleteAvatar(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get active sessions (only for patient)
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [therapistFirstname] 
     * @param {string} [therapistLastname] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public patientsControllerGetActiveSessions(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, therapistFirstname?: string, therapistLastname?: string, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).patientsControllerGetActiveSessions(limit, page, order, from, to, therapistFirstname, therapistLastname, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get patient profile (only for sessioned therapists)
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public patientsControllerGetPatient(patientId: string, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).patientsControllerGetPatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get patient profile (only for patient)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public patientsControllerGetPatientProfile(options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).patientsControllerGetPatientProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get session history (only for patient)
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [therapistFirstname] 
     * @param {string} [therapistLastname] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public patientsControllerGetSessionHistory(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, therapistFirstname?: string, therapistLastname?: string, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).patientsControllerGetSessionHistory(limit, page, order, from, to, therapistFirstname, therapistLastname, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get tiny sessions (only for patient)
     * @param {boolean} isActive 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public patientsControllerGetSessions(isActive: boolean, from?: string, to?: string, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).patientsControllerGetSessions(isActive, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get patient\'s therapists (only for patients)
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'therapistName' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate'} [orderTerms] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public patientsControllerGetTherapists(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'therapistName' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate', options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).patientsControllerGetTherapists(limit, page, order, orderTerms, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get total session (only for patient)
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {Array<string>} [statuses] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public patientsControllerGetTotalSessionSession(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, statuses?: Array<string>, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).patientsControllerGetTotalSessionSession(limit, page, order, from, to, statuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Onboarding (only for patients)
     * @param {PatientOnboardingRequestDto} patientOnboardingRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public patientsControllerOnboarding(patientOnboardingRequestDto: PatientOnboardingRequestDto, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).patientsControllerOnboarding(patientOnboardingRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update avatar (only for patients)
     * @param {UpdateAvatarRequestDto} updateAvatarRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public patientsControllerUpdateAvatar(updateAvatarRequestDto: UpdateAvatarRequestDto, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).patientsControllerUpdateAvatar(updateAvatarRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update self information
     * @param {UpdatePatientProfileRequestDto} updatePatientProfileRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    public patientsControllerUpdateOne(updatePatientProfileRequestDto: UpdatePatientProfileRequestDto, options?: AxiosRequestConfig) {
        return PatientsApiFp(this.configuration).patientsControllerUpdateOne(updatePatientProfileRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get payment list
         * @param {number} limit 
         * @param {number} page 
         * @param {boolean} isSender 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'startDate' | 'value' | 'createdAt' | 'dealStartDate'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerGetPaymentList: async (limit: number, page: number, isSender: boolean, order?: 'ASC' | 'DESC', orderTerms?: 'startDate' | 'value' | 'createdAt' | 'dealStartDate', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('paymentsControllerGetPaymentList', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('paymentsControllerGetPaymentList', 'page', page)
            // verify required parameter 'isSender' is not null or undefined
            assertParamExists('paymentsControllerGetPaymentList', 'isSender', isSender)
            const localVarPath = `/api/v1/payments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (isSender !== undefined) {
                localVarQueryParameter['isSender'] = isSender;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get yearly payment statistics for therapist
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerGetYearlyStatistics: async (year: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('paymentsControllerGetYearlyStatistics', 'year', year)
            const localVarPath = `/api/v1/payments/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get payment list
         * @param {number} limit 
         * @param {number} page 
         * @param {boolean} isSender 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'startDate' | 'value' | 'createdAt' | 'dealStartDate'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerGetPaymentList(limit: number, page: number, isSender: boolean, order?: 'ASC' | 'DESC', orderTerms?: 'startDate' | 'value' | 'createdAt' | 'dealStartDate', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentsListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerGetPaymentList(limit, page, isSender, order, orderTerms, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get yearly payment statistics for therapist
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentsControllerGetYearlyStatistics(year: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentStatisticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentsControllerGetYearlyStatistics(year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get payment list
         * @param {number} limit 
         * @param {number} page 
         * @param {boolean} isSender 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'startDate' | 'value' | 'createdAt' | 'dealStartDate'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerGetPaymentList(limit: number, page: number, isSender: boolean, order?: 'ASC' | 'DESC', orderTerms?: 'startDate' | 'value' | 'createdAt' | 'dealStartDate', options?: any): AxiosPromise<PaymentsListResponseDto> {
            return localVarFp.paymentsControllerGetPaymentList(limit, page, isSender, order, orderTerms, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get yearly payment statistics for therapist
         * @param {number} year 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsControllerGetYearlyStatistics(year: number, options?: any): AxiosPromise<PaymentStatisticsResponseDto> {
            return localVarFp.paymentsControllerGetYearlyStatistics(year, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     * 
     * @summary Get payment list
     * @param {number} limit 
     * @param {number} page 
     * @param {boolean} isSender 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'startDate' | 'value' | 'createdAt' | 'dealStartDate'} [orderTerms] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerGetPaymentList(limit: number, page: number, isSender: boolean, order?: 'ASC' | 'DESC', orderTerms?: 'startDate' | 'value' | 'createdAt' | 'dealStartDate', options?: AxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerGetPaymentList(limit, page, isSender, order, orderTerms, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get yearly payment statistics for therapist
     * @param {number} year 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public paymentsControllerGetYearlyStatistics(year: number, options?: AxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).paymentsControllerGetYearlyStatistics(year, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PromocodeApi - axios parameter creator
 * @export
 */
export const PromocodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check promocode (from admin-panel)
         * @param {string} code 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promocodesControllerAdminCheckPromocode: async (code: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('promocodesControllerAdminCheckPromocode', 'code', code)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('promocodesControllerAdminCheckPromocode', 'userId', userId)
            const localVarPath = `/api/v1/promocodes/check-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check promocode
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promocodesControllerCheckPromocode: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('promocodesControllerCheckPromocode', 'code', code)
            const localVarPath = `/api/v1/promocodes/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check promocode by therapist
         * @param {CheckPromocodeByTherapistRequestDto} checkPromocodeByTherapistRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promocodesControllerCheckPromocodeByTherapist: async (checkPromocodeByTherapistRequestDto: CheckPromocodeByTherapistRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkPromocodeByTherapistRequestDto' is not null or undefined
            assertParamExists('promocodesControllerCheckPromocodeByTherapist', 'checkPromocodeByTherapistRequestDto', checkPromocodeByTherapistRequestDto)
            const localVarPath = `/api/v1/promocodes/check-by-therapist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkPromocodeByTherapistRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get patients active promocodes
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'expireDate'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promocodesControllerGetActivePromocodes: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'expireDate', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('promocodesControllerGetActivePromocodes', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('promocodesControllerGetActivePromocodes', 'page', page)
            const localVarPath = `/api/v1/promocodes/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromocodeApi - functional programming interface
 * @export
 */
export const PromocodeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromocodeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check promocode (from admin-panel)
         * @param {string} code 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promocodesControllerAdminCheckPromocode(code: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromocodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promocodesControllerAdminCheckPromocode(code, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check promocode
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promocodesControllerCheckPromocode(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromocodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promocodesControllerCheckPromocode(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check promocode by therapist
         * @param {CheckPromocodeByTherapistRequestDto} checkPromocodeByTherapistRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promocodesControllerCheckPromocodeByTherapist(checkPromocodeByTherapistRequestDto: CheckPromocodeByTherapistRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromocodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promocodesControllerCheckPromocodeByTherapist(checkPromocodeByTherapistRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get patients active promocodes
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'expireDate'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promocodesControllerGetActivePromocodes(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'expireDate', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedPromocodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promocodesControllerGetActivePromocodes(limit, page, order, orderTerms, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PromocodeApi - factory interface
 * @export
 */
export const PromocodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromocodeApiFp(configuration)
    return {
        /**
         * 
         * @summary Check promocode (from admin-panel)
         * @param {string} code 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promocodesControllerAdminCheckPromocode(code: string, userId: string, options?: any): AxiosPromise<PromocodeResponseDto> {
            return localVarFp.promocodesControllerAdminCheckPromocode(code, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check promocode
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promocodesControllerCheckPromocode(code: string, options?: any): AxiosPromise<PromocodeResponseDto> {
            return localVarFp.promocodesControllerCheckPromocode(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check promocode by therapist
         * @param {CheckPromocodeByTherapistRequestDto} checkPromocodeByTherapistRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promocodesControllerCheckPromocodeByTherapist(checkPromocodeByTherapistRequestDto: CheckPromocodeByTherapistRequestDto, options?: any): AxiosPromise<PromocodeResponseDto> {
            return localVarFp.promocodesControllerCheckPromocodeByTherapist(checkPromocodeByTherapistRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get patients active promocodes
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'expireDate'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promocodesControllerGetActivePromocodes(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'expireDate', options?: any): AxiosPromise<PaginatedPromocodeResponseDto> {
            return localVarFp.promocodesControllerGetActivePromocodes(limit, page, order, orderTerms, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PromocodeApi - object-oriented interface
 * @export
 * @class PromocodeApi
 * @extends {BaseAPI}
 */
export class PromocodeApi extends BaseAPI {
    /**
     * 
     * @summary Check promocode (from admin-panel)
     * @param {string} code 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromocodeApi
     */
    public promocodesControllerAdminCheckPromocode(code: string, userId: string, options?: AxiosRequestConfig) {
        return PromocodeApiFp(this.configuration).promocodesControllerAdminCheckPromocode(code, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check promocode
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromocodeApi
     */
    public promocodesControllerCheckPromocode(code: string, options?: AxiosRequestConfig) {
        return PromocodeApiFp(this.configuration).promocodesControllerCheckPromocode(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check promocode by therapist
     * @param {CheckPromocodeByTherapistRequestDto} checkPromocodeByTherapistRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromocodeApi
     */
    public promocodesControllerCheckPromocodeByTherapist(checkPromocodeByTherapistRequestDto: CheckPromocodeByTherapistRequestDto, options?: AxiosRequestConfig) {
        return PromocodeApiFp(this.configuration).promocodesControllerCheckPromocodeByTherapist(checkPromocodeByTherapistRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get patients active promocodes
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'expireDate'} [orderTerms] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromocodeApi
     */
    public promocodesControllerGetActivePromocodes(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'expireDate', options?: AxiosRequestConfig) {
        return PromocodeApiFp(this.configuration).promocodesControllerGetActivePromocodes(limit, page, order, orderTerms, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SessionBookingApi - axios parameter creator
 * @export
 */
export const SessionBookingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Бронирование сессии. Только для клиентов)
         * @param {BookSessionRequestDto} bookSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionBookingControllerBookSession: async (bookSessionRequestDto: BookSessionRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookSessionRequestDto' is not null or undefined
            assertParamExists('sessionBookingControllerBookSession', 'bookSessionRequestDto', bookSessionRequestDto)
            const localVarPath = `/api/v1/session-booking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookSessionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Отмена сессии. Только для клиентов)
         * @param {CancelSessionRequestDto} cancelSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionBookingControllerCancelSession: async (cancelSessionRequestDto: CancelSessionRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cancelSessionRequestDto' is not null or undefined
            assertParamExists('sessionBookingControllerCancelSession', 'cancelSessionRequestDto', cancelSessionRequestDto)
            const localVarPath = `/api/v1/session-booking/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelSessionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get upcoming session payment info (only for patients)
         * @param {string} availabilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionBookingControllerGetUpcomingSessionPaymentInfo: async (availabilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityId' is not null or undefined
            assertParamExists('sessionBookingControllerGetUpcomingSessionPaymentInfo', 'availabilityId', availabilityId)
            const localVarPath = `/api/v1/session-booking/upcoming/{availabilityId}`
                .replace(`{${"availabilityId"}}`, encodeURIComponent(String(availabilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionBookingControllerHandleEvent: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/session-booking/handle-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Перенес сессии. Только для клиентов)
         * @param {RescheduleSessionRequestDto} rescheduleSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionBookingControllerRescheduleSession: async (rescheduleSessionRequestDto: RescheduleSessionRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rescheduleSessionRequestDto' is not null or undefined
            assertParamExists('sessionBookingControllerRescheduleSession', 'rescheduleSessionRequestDto', rescheduleSessionRequestDto)
            const localVarPath = `/api/v1/session-booking/reschedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescheduleSessionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionBookingApi - functional programming interface
 * @export
 */
export const SessionBookingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SessionBookingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Бронирование сессии. Только для клиентов)
         * @param {BookSessionRequestDto} bookSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionBookingControllerBookSession(bookSessionRequestDto: BookSessionRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookSessionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionBookingControllerBookSession(bookSessionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Отмена сессии. Только для клиентов)
         * @param {CancelSessionRequestDto} cancelSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionBookingControllerCancelSession(cancelSessionRequestDto: CancelSessionRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionBookingControllerCancelSession(cancelSessionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get upcoming session payment info (only for patients)
         * @param {string} availabilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionBookingControllerGetUpcomingSessionPaymentInfo(availabilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionBookingUpcomingResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionBookingControllerGetUpcomingSessionPaymentInfo(availabilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionBookingControllerHandleEvent(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionBookingControllerHandleEvent(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Перенес сессии. Только для клиентов)
         * @param {RescheduleSessionRequestDto} rescheduleSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionBookingControllerRescheduleSession(rescheduleSessionRequestDto: RescheduleSessionRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionBookingControllerRescheduleSession(rescheduleSessionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SessionBookingApi - factory interface
 * @export
 */
export const SessionBookingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SessionBookingApiFp(configuration)
    return {
        /**
         * 
         * @summary Бронирование сессии. Только для клиентов)
         * @param {BookSessionRequestDto} bookSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionBookingControllerBookSession(bookSessionRequestDto: BookSessionRequestDto, options?: any): AxiosPromise<BookSessionResponseDto> {
            return localVarFp.sessionBookingControllerBookSession(bookSessionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Отмена сессии. Только для клиентов)
         * @param {CancelSessionRequestDto} cancelSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionBookingControllerCancelSession(cancelSessionRequestDto: CancelSessionRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.sessionBookingControllerCancelSession(cancelSessionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get upcoming session payment info (only for patients)
         * @param {string} availabilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionBookingControllerGetUpcomingSessionPaymentInfo(availabilityId: string, options?: any): AxiosPromise<SessionBookingUpcomingResponseDto> {
            return localVarFp.sessionBookingControllerGetUpcomingSessionPaymentInfo(availabilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionBookingControllerHandleEvent(options?: any): AxiosPromise<string> {
            return localVarFp.sessionBookingControllerHandleEvent(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Перенес сессии. Только для клиентов)
         * @param {RescheduleSessionRequestDto} rescheduleSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionBookingControllerRescheduleSession(rescheduleSessionRequestDto: RescheduleSessionRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.sessionBookingControllerRescheduleSession(rescheduleSessionRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SessionBookingApi - object-oriented interface
 * @export
 * @class SessionBookingApi
 * @extends {BaseAPI}
 */
export class SessionBookingApi extends BaseAPI {
    /**
     * 
     * @summary Бронирование сессии. Только для клиентов)
     * @param {BookSessionRequestDto} bookSessionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionBookingApi
     */
    public sessionBookingControllerBookSession(bookSessionRequestDto: BookSessionRequestDto, options?: AxiosRequestConfig) {
        return SessionBookingApiFp(this.configuration).sessionBookingControllerBookSession(bookSessionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Отмена сессии. Только для клиентов)
     * @param {CancelSessionRequestDto} cancelSessionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionBookingApi
     */
    public sessionBookingControllerCancelSession(cancelSessionRequestDto: CancelSessionRequestDto, options?: AxiosRequestConfig) {
        return SessionBookingApiFp(this.configuration).sessionBookingControllerCancelSession(cancelSessionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get upcoming session payment info (only for patients)
     * @param {string} availabilityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionBookingApi
     */
    public sessionBookingControllerGetUpcomingSessionPaymentInfo(availabilityId: string, options?: AxiosRequestConfig) {
        return SessionBookingApiFp(this.configuration).sessionBookingControllerGetUpcomingSessionPaymentInfo(availabilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionBookingApi
     */
    public sessionBookingControllerHandleEvent(options?: AxiosRequestConfig) {
        return SessionBookingApiFp(this.configuration).sessionBookingControllerHandleEvent(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Перенес сессии. Только для клиентов)
     * @param {RescheduleSessionRequestDto} rescheduleSessionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionBookingApi
     */
    public sessionBookingControllerRescheduleSession(rescheduleSessionRequestDto: RescheduleSessionRequestDto, options?: AxiosRequestConfig) {
        return SessionBookingApiFp(this.configuration).sessionBookingControllerRescheduleSession(rescheduleSessionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SessionFeedbackApi - axios parameter creator
 * @export
 */
export const SessionFeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Добавить обратную связь по сессии. Только для терапевтов
         * @param {AddSessionFeedbackRequestDto} addSessionFeedbackRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionFeedbackControllerBookSession: async (addSessionFeedbackRequestDto: AddSessionFeedbackRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addSessionFeedbackRequestDto' is not null or undefined
            assertParamExists('sessionFeedbackControllerBookSession', 'addSessionFeedbackRequestDto', addSessionFeedbackRequestDto)
            const localVarPath = `/api/v1/sessions/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSessionFeedbackRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение списка тем сессий для обратной связи. Только для терапевтов
         * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialistType] Тип специалиста
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionFeedbackControllerGetSessionThemes: async (specialistType?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sessions/feedback/themes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (specialistType) {
                localVarQueryParameter['specialistType'] = specialistType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionFeedbackApi - functional programming interface
 * @export
 */
export const SessionFeedbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SessionFeedbackApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Добавить обратную связь по сессии. Только для терапевтов
         * @param {AddSessionFeedbackRequestDto} addSessionFeedbackRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionFeedbackControllerBookSession(addSessionFeedbackRequestDto: AddSessionFeedbackRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionFeedbackControllerBookSession(addSessionFeedbackRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Получение списка тем сессий для обратной связи. Только для терапевтов
         * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialistType] Тип специалиста
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionFeedbackControllerGetSessionThemes(specialistType?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionFeedbackThemesByCategoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionFeedbackControllerGetSessionThemes(specialistType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SessionFeedbackApi - factory interface
 * @export
 */
export const SessionFeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SessionFeedbackApiFp(configuration)
    return {
        /**
         * 
         * @summary Добавить обратную связь по сессии. Только для терапевтов
         * @param {AddSessionFeedbackRequestDto} addSessionFeedbackRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionFeedbackControllerBookSession(addSessionFeedbackRequestDto: AddSessionFeedbackRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.sessionFeedbackControllerBookSession(addSessionFeedbackRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение списка тем сессий для обратной связи. Только для терапевтов
         * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialistType] Тип специалиста
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionFeedbackControllerGetSessionThemes(specialistType?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, options?: any): AxiosPromise<SessionFeedbackThemesByCategoryResponseDto> {
            return localVarFp.sessionFeedbackControllerGetSessionThemes(specialistType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SessionFeedbackApi - object-oriented interface
 * @export
 * @class SessionFeedbackApi
 * @extends {BaseAPI}
 */
export class SessionFeedbackApi extends BaseAPI {
    /**
     * 
     * @summary Добавить обратную связь по сессии. Только для терапевтов
     * @param {AddSessionFeedbackRequestDto} addSessionFeedbackRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionFeedbackApi
     */
    public sessionFeedbackControllerBookSession(addSessionFeedbackRequestDto: AddSessionFeedbackRequestDto, options?: AxiosRequestConfig) {
        return SessionFeedbackApiFp(this.configuration).sessionFeedbackControllerBookSession(addSessionFeedbackRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение списка тем сессий для обратной связи. Только для терапевтов
     * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialistType] Тип специалиста
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionFeedbackApi
     */
    public sessionFeedbackControllerGetSessionThemes(specialistType?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, options?: AxiosRequestConfig) {
        return SessionFeedbackApiFp(this.configuration).sessionFeedbackControllerGetSessionThemes(specialistType, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SessionOutcomeApi - axios parameter creator
 * @export
 */
export const SessionOutcomeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add session outcome (only for patient)
         * @param {AddSessionOutcomeRequestDto} addSessionOutcomeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionOutcomeControllerAddSessionOutcome: async (addSessionOutcomeRequestDto: AddSessionOutcomeRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addSessionOutcomeRequestDto' is not null or undefined
            assertParamExists('sessionOutcomeControllerAddSessionOutcome', 'addSessionOutcomeRequestDto', addSessionOutcomeRequestDto)
            const localVarPath = `/api/v1/sessions/outcome`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSessionOutcomeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionOutcomeApi - functional programming interface
 * @export
 */
export const SessionOutcomeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SessionOutcomeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add session outcome (only for patient)
         * @param {AddSessionOutcomeRequestDto} addSessionOutcomeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionOutcomeControllerAddSessionOutcome(addSessionOutcomeRequestDto: AddSessionOutcomeRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionOutcomeControllerAddSessionOutcome(addSessionOutcomeRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SessionOutcomeApi - factory interface
 * @export
 */
export const SessionOutcomeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SessionOutcomeApiFp(configuration)
    return {
        /**
         * 
         * @summary Add session outcome (only for patient)
         * @param {AddSessionOutcomeRequestDto} addSessionOutcomeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionOutcomeControllerAddSessionOutcome(addSessionOutcomeRequestDto: AddSessionOutcomeRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.sessionOutcomeControllerAddSessionOutcome(addSessionOutcomeRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SessionOutcomeApi - object-oriented interface
 * @export
 * @class SessionOutcomeApi
 * @extends {BaseAPI}
 */
export class SessionOutcomeApi extends BaseAPI {
    /**
     * 
     * @summary Add session outcome (only for patient)
     * @param {AddSessionOutcomeRequestDto} addSessionOutcomeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionOutcomeApi
     */
    public sessionOutcomeControllerAddSessionOutcome(addSessionOutcomeRequestDto: AddSessionOutcomeRequestDto, options?: AxiosRequestConfig) {
        return SessionOutcomeApiFp(this.configuration).sessionOutcomeControllerAddSessionOutcome(addSessionOutcomeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SessionPaymentApi - axios parameter creator
 * @export
 */
export const SessionPaymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Book session (only for admin)
         * @param {BookSessionByAdminDto} bookSessionByAdminDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionPaymentsControllerBookSessionByAdmin: async (bookSessionByAdminDto: BookSessionByAdminDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookSessionByAdminDto' is not null or undefined
            assertParamExists('sessionPaymentsControllerBookSessionByAdmin', 'bookSessionByAdminDto', bookSessionByAdminDto)
            const localVarPath = `/api/v1/session-payment/book_by_admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookSessionByAdminDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Book session (only for therapist)
         * @param {BookSessionByTherapistDto} bookSessionByTherapistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionPaymentsControllerBookSessionByTherapist: async (bookSessionByTherapistDto: BookSessionByTherapistDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookSessionByTherapistDto' is not null or undefined
            assertParamExists('sessionPaymentsControllerBookSessionByTherapist', 'bookSessionByTherapistDto', bookSessionByTherapistDto)
            const localVarPath = `/api/v1/session-payment/book_by_therapist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookSessionByTherapistDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get upcoming session payment info (only for patients)
         * @param {string} availabilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionPaymentsControllerGetUpcomingSessionPaymentInfo: async (availabilityId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityId' is not null or undefined
            assertParamExists('sessionPaymentsControllerGetUpcomingSessionPaymentInfo', 'availabilityId', availabilityId)
            const localVarPath = `/api/v1/session-payment/upcoming/{availabilityId}`
                .replace(`{${"availabilityId"}}`, encodeURIComponent(String(availabilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionPaymentApi - functional programming interface
 * @export
 */
export const SessionPaymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SessionPaymentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Book session (only for admin)
         * @param {BookSessionByAdminDto} bookSessionByAdminDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionPaymentsControllerBookSessionByAdmin(bookSessionByAdminDto: BookSessionByAdminDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionPaymentsControllerBookSessionByAdmin(bookSessionByAdminDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Book session (only for therapist)
         * @param {BookSessionByTherapistDto} bookSessionByTherapistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionPaymentsControllerBookSessionByTherapist(bookSessionByTherapistDto: BookSessionByTherapistDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionPaymentsControllerBookSessionByTherapist(bookSessionByTherapistDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get upcoming session payment info (only for patients)
         * @param {string} availabilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionPaymentsControllerGetUpcomingSessionPaymentInfo(availabilityId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpcomingSessionPaymentInfoResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionPaymentsControllerGetUpcomingSessionPaymentInfo(availabilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SessionPaymentApi - factory interface
 * @export
 */
export const SessionPaymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SessionPaymentApiFp(configuration)
    return {
        /**
         * 
         * @summary Book session (only for admin)
         * @param {BookSessionByAdminDto} bookSessionByAdminDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionPaymentsControllerBookSessionByAdmin(bookSessionByAdminDto: BookSessionByAdminDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.sessionPaymentsControllerBookSessionByAdmin(bookSessionByAdminDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Book session (only for therapist)
         * @param {BookSessionByTherapistDto} bookSessionByTherapistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionPaymentsControllerBookSessionByTherapist(bookSessionByTherapistDto: BookSessionByTherapistDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.sessionPaymentsControllerBookSessionByTherapist(bookSessionByTherapistDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get upcoming session payment info (only for patients)
         * @param {string} availabilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionPaymentsControllerGetUpcomingSessionPaymentInfo(availabilityId: string, options?: any): AxiosPromise<UpcomingSessionPaymentInfoResponseDto> {
            return localVarFp.sessionPaymentsControllerGetUpcomingSessionPaymentInfo(availabilityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SessionPaymentApi - object-oriented interface
 * @export
 * @class SessionPaymentApi
 * @extends {BaseAPI}
 */
export class SessionPaymentApi extends BaseAPI {
    /**
     * 
     * @summary Book session (only for admin)
     * @param {BookSessionByAdminDto} bookSessionByAdminDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionPaymentApi
     */
    public sessionPaymentsControllerBookSessionByAdmin(bookSessionByAdminDto: BookSessionByAdminDto, options?: AxiosRequestConfig) {
        return SessionPaymentApiFp(this.configuration).sessionPaymentsControllerBookSessionByAdmin(bookSessionByAdminDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Book session (only for therapist)
     * @param {BookSessionByTherapistDto} bookSessionByTherapistDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionPaymentApi
     */
    public sessionPaymentsControllerBookSessionByTherapist(bookSessionByTherapistDto: BookSessionByTherapistDto, options?: AxiosRequestConfig) {
        return SessionPaymentApiFp(this.configuration).sessionPaymentsControllerBookSessionByTherapist(bookSessionByTherapistDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get upcoming session payment info (only for patients)
     * @param {string} availabilityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionPaymentApi
     */
    public sessionPaymentsControllerGetUpcomingSessionPaymentInfo(availabilityId: string, options?: AxiosRequestConfig) {
        return SessionPaymentApiFp(this.configuration).sessionPaymentsControllerGetUpcomingSessionPaymentInfo(availabilityId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SessionV2Api - axios parameter creator
 * @export
 */
export const SessionV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Получение баланса сессий. Только для b2b клиентов)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionBalanceControllerGetSessionBalance: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/session/balance/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение списка баланса сессий. Только для b2b клиентов)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'startWith' | 'endWith'} [orderTerms] Сортировать по
         * @param {'onlyUsed' | 'onlyAvailable' | 'onlyExpired' | 'all'} [balanceStatus] Статус баланса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionBalanceControllerGetSessionBalanceList: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startWith' | 'endWith', balanceStatus?: 'onlyUsed' | 'onlyAvailable' | 'onlyExpired' | 'all', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('sessionBalanceControllerGetSessionBalanceList', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('sessionBalanceControllerGetSessionBalanceList', 'page', page)
            const localVarPath = `/api/v1/session/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (balanceStatus !== undefined) {
                localVarQueryParameter['balanceStatus'] = balanceStatus;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionV2Api - functional programming interface
 * @export
 */
export const SessionV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SessionV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Получение баланса сессий. Только для b2b клиентов)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionBalanceControllerGetSessionBalance(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionBalanceUsageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionBalanceControllerGetSessionBalance(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Получение списка баланса сессий. Только для b2b клиентов)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'startWith' | 'endWith'} [orderTerms] Сортировать по
         * @param {'onlyUsed' | 'onlyAvailable' | 'onlyExpired' | 'all'} [balanceStatus] Статус баланса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionBalanceControllerGetSessionBalanceList(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startWith' | 'endWith', balanceStatus?: 'onlyUsed' | 'onlyAvailable' | 'onlyExpired' | 'all', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionBalancePaginatedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionBalanceControllerGetSessionBalanceList(limit, page, order, orderTerms, balanceStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SessionV2Api - factory interface
 * @export
 */
export const SessionV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SessionV2ApiFp(configuration)
    return {
        /**
         * 
         * @summary Получение баланса сессий. Только для b2b клиентов)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionBalanceControllerGetSessionBalance(options?: any): AxiosPromise<SessionBalanceUsageResponseDto> {
            return localVarFp.sessionBalanceControllerGetSessionBalance(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение списка баланса сессий. Только для b2b клиентов)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'createdAt' | 'startWith' | 'endWith'} [orderTerms] Сортировать по
         * @param {'onlyUsed' | 'onlyAvailable' | 'onlyExpired' | 'all'} [balanceStatus] Статус баланса
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionBalanceControllerGetSessionBalanceList(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startWith' | 'endWith', balanceStatus?: 'onlyUsed' | 'onlyAvailable' | 'onlyExpired' | 'all', options?: any): AxiosPromise<SessionBalancePaginatedResponseDto> {
            return localVarFp.sessionBalanceControllerGetSessionBalanceList(limit, page, order, orderTerms, balanceStatus, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SessionV2Api - object-oriented interface
 * @export
 * @class SessionV2Api
 * @extends {BaseAPI}
 */
export class SessionV2Api extends BaseAPI {
    /**
     * 
     * @summary Получение баланса сессий. Только для b2b клиентов)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionV2Api
     */
    public sessionBalanceControllerGetSessionBalance(options?: AxiosRequestConfig) {
        return SessionV2ApiFp(this.configuration).sessionBalanceControllerGetSessionBalance(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение списка баланса сессий. Только для b2b клиентов)
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'createdAt' | 'startWith' | 'endWith'} [orderTerms] Сортировать по
     * @param {'onlyUsed' | 'onlyAvailable' | 'onlyExpired' | 'all'} [balanceStatus] Статус баланса
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionV2Api
     */
    public sessionBalanceControllerGetSessionBalanceList(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'createdAt' | 'startWith' | 'endWith', balanceStatus?: 'onlyUsed' | 'onlyAvailable' | 'onlyExpired' | 'all', options?: AxiosRequestConfig) {
        return SessionV2ApiFp(this.configuration).sessionBalanceControllerGetSessionBalanceList(limit, page, order, orderTerms, balanceStatus, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SessionsApi - axios parameter creator
 * @export
 */
export const SessionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept session request (only for therapist)
         * @param {string} sessionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerAcceptSessionRequest: async (sessionRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionRequestId' is not null or undefined
            assertParamExists('sessionsControllerAcceptSessionRequest', 'sessionRequestId', sessionRequestId)
            const localVarPath = `/api/v1/sessions/request/{sessionRequestId}/accept`
                .replace(`{${"sessionRequestId"}}`, encodeURIComponent(String(sessionRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add session note
         * @param {string} sessionId 
         * @param {UpdateSessionNoteRequestDto} updateSessionNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerAddSessionNotes: async (sessionId: string, updateSessionNoteRequestDto: UpdateSessionNoteRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('sessionsControllerAddSessionNotes', 'sessionId', sessionId)
            // verify required parameter 'updateSessionNoteRequestDto' is not null or undefined
            assertParamExists('sessionsControllerAddSessionNotes', 'updateSessionNoteRequestDto', updateSessionNoteRequestDto)
            const localVarPath = `/api/v1/sessions/{sessionId}/notes`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSessionNoteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add session outcome (only for patient)
         * @param {string} sessionId 
         * @param {AddSessionOutcomeRequestDto} addSessionOutcomeRequestDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sessionsControllerAddSessionOutcome: async (sessionId: string, addSessionOutcomeRequestDto: AddSessionOutcomeRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('sessionsControllerAddSessionOutcome', 'sessionId', sessionId)
            // verify required parameter 'addSessionOutcomeRequestDto' is not null or undefined
            assertParamExists('sessionsControllerAddSessionOutcome', 'addSessionOutcomeRequestDto', addSessionOutcomeRequestDto)
            const localVarPath = `/api/v1/sessions/{sessionId}/outcome`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSessionOutcomeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel session request (only for patient)
         * @param {string} sessionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerCancelSessionRequest: async (sessionRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionRequestId' is not null or undefined
            assertParamExists('sessionsControllerCancelSessionRequest', 'sessionRequestId', sessionRequestId)
            const localVarPath = `/api/v1/sessions/request/{sessionRequestId}/cancel`
                .replace(`{${"sessionRequestId"}}`, encodeURIComponent(String(sessionRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerCompleteSession: async (sessionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('sessionsControllerCompleteSession', 'sessionId', sessionId)
            const localVarPath = `/api/v1/sessions/{sessionId}/complete`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept session request (only for therapist)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerCreateTestSession: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/sessions/get-test-session-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive sessions with therapist (only for patient)
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerDeleteSession: async (therapistId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('sessionsControllerDeleteSession', 'therapistId', therapistId)
            const localVarPath = `/api/v1/sessions/therapist/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete session notes
         * @param {string} notesId 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerDeleteSessionNotes: async (notesId: string, sessionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notesId' is not null or undefined
            assertParamExists('sessionsControllerDeleteSessionNotes', 'notesId', notesId)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('sessionsControllerDeleteSessionNotes', 'sessionId', sessionId)
            const localVarPath = `/api/v1/sessions/{sessionId}/notes/{notesId}`
                .replace(`{${"notesId"}}`, encodeURIComponent(String(notesId)))
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update session notes
         * @param {string} notesId 
         * @param {UpdateSessionNoteRequestDto} updateSessionNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerEditSessionNote: async (notesId: string, updateSessionNoteRequestDto: UpdateSessionNoteRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notesId' is not null or undefined
            assertParamExists('sessionsControllerEditSessionNote', 'notesId', notesId)
            // verify required parameter 'updateSessionNoteRequestDto' is not null or undefined
            assertParamExists('sessionsControllerEditSessionNote', 'updateSessionNoteRequestDto', updateSessionNoteRequestDto)
            const localVarPath = `/api/v1/sessions/notes/{notesId}`
                .replace(`{${"notesId"}}`, encodeURIComponent(String(notesId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSessionNoteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить сессию по id
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionById: async (sessionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('sessionsControllerGetSessionById', 'sessionId', sessionId)
            const localVarPath = `/api/v1/sessions/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get session notes
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionNotes: async (sessionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('sessionsControllerGetSessionNotes', 'sessionId', sessionId)
            const localVarPath = `/api/v1/sessions/{sessionId}/notes`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sessions by therapist id
         * @param {string} therapistId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionsByTherapistId: async (therapistId: string, from?: string, to?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('sessionsControllerGetSessionsByTherapistId', 'therapistId', therapistId)
            const localVarPath = `/api/v1/sessions/therapist/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start/join session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerJoinSession: async (sessionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('sessionsControllerJoinSession', 'sessionId', sessionId)
            const localVarPath = `/api/v1/sessions/{sessionId}/join`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject session request (only for therapist)
         * @param {string} sessionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerRejectSessionRequest: async (sessionRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionRequestId' is not null or undefined
            assertParamExists('sessionsControllerRejectSessionRequest', 'sessionRequestId', sessionRequestId)
            const localVarPath = `/api/v1/sessions/request/{sessionRequestId}/reject`
                .replace(`{${"sessionRequestId"}}`, encodeURIComponent(String(sessionRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SessionsApi - functional programming interface
 * @export
 */
export const SessionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SessionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept session request (only for therapist)
         * @param {string} sessionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerAcceptSessionRequest(sessionRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionCreateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerAcceptSessionRequest(sessionRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add session note
         * @param {string} sessionId 
         * @param {UpdateSessionNoteRequestDto} updateSessionNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerAddSessionNotes(sessionId: string, updateSessionNoteRequestDto: UpdateSessionNoteRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionNoteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerAddSessionNotes(sessionId, updateSessionNoteRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add session outcome (only for patient)
         * @param {string} sessionId 
         * @param {AddSessionOutcomeRequestDto} addSessionOutcomeRequestDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async sessionsControllerAddSessionOutcome(sessionId: string, addSessionOutcomeRequestDto: AddSessionOutcomeRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerAddSessionOutcome(sessionId, addSessionOutcomeRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel session request (only for patient)
         * @param {string} sessionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerCancelSessionRequest(sessionRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerCancelSessionRequest(sessionRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Complete session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerCompleteSession(sessionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerCompleteSession(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Accept session request (only for therapist)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerCreateTestSession(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateTestSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerCreateTestSession(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Archive sessions with therapist (only for patient)
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerDeleteSession(therapistId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerDeleteSession(therapistId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete session notes
         * @param {string} notesId 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerDeleteSessionNotes(notesId: string, sessionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionNoteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerDeleteSessionNotes(notesId, sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update session notes
         * @param {string} notesId 
         * @param {UpdateSessionNoteRequestDto} updateSessionNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerEditSessionNote(notesId: string, updateSessionNoteRequestDto: UpdateSessionNoteRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionNoteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerEditSessionNote(notesId, updateSessionNoteRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Получить сессию по id
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerGetSessionById(sessionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerGetSessionById(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get session notes
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerGetSessionNotes(sessionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionNotesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerGetSessionNotes(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get sessions by therapist id
         * @param {string} therapistId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerGetSessionsByTherapistId(therapistId: string, from?: string, to?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerGetSessionsByTherapistId(therapistId, from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start/join session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerJoinSession(sessionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JoinSessionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerJoinSession(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject session request (only for therapist)
         * @param {string} sessionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionsControllerRejectSessionRequest(sessionRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionsControllerRejectSessionRequest(sessionRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SessionsApi - factory interface
 * @export
 */
export const SessionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SessionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept session request (only for therapist)
         * @param {string} sessionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerAcceptSessionRequest(sessionRequestId: string, options?: any): AxiosPromise<SessionCreateResponseDto> {
            return localVarFp.sessionsControllerAcceptSessionRequest(sessionRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add session note
         * @param {string} sessionId 
         * @param {UpdateSessionNoteRequestDto} updateSessionNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerAddSessionNotes(sessionId: string, updateSessionNoteRequestDto: UpdateSessionNoteRequestDto, options?: any): AxiosPromise<SessionNoteResponseDto> {
            return localVarFp.sessionsControllerAddSessionNotes(sessionId, updateSessionNoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add session outcome (only for patient)
         * @param {string} sessionId 
         * @param {AddSessionOutcomeRequestDto} addSessionOutcomeRequestDto 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        sessionsControllerAddSessionOutcome(sessionId: string, addSessionOutcomeRequestDto: AddSessionOutcomeRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.sessionsControllerAddSessionOutcome(sessionId, addSessionOutcomeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel session request (only for patient)
         * @param {string} sessionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerCancelSessionRequest(sessionRequestId: string, options?: any): AxiosPromise<SessionRequestResponseDto> {
            return localVarFp.sessionsControllerCancelSessionRequest(sessionRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerCompleteSession(sessionId: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.sessionsControllerCompleteSession(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept session request (only for therapist)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerCreateTestSession(options?: any): AxiosPromise<CreateTestSessionResponse> {
            return localVarFp.sessionsControllerCreateTestSession(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive sessions with therapist (only for patient)
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerDeleteSession(therapistId: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.sessionsControllerDeleteSession(therapistId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete session notes
         * @param {string} notesId 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerDeleteSessionNotes(notesId: string, sessionId: string, options?: any): AxiosPromise<SessionNoteResponseDto> {
            return localVarFp.sessionsControllerDeleteSessionNotes(notesId, sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update session notes
         * @param {string} notesId 
         * @param {UpdateSessionNoteRequestDto} updateSessionNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerEditSessionNote(notesId: string, updateSessionNoteRequestDto: UpdateSessionNoteRequestDto, options?: any): AxiosPromise<SessionNoteResponseDto> {
            return localVarFp.sessionsControllerEditSessionNote(notesId, updateSessionNoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить сессию по id
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionById(sessionId: string, options?: any): AxiosPromise<SessionResponseDto> {
            return localVarFp.sessionsControllerGetSessionById(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get session notes
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionNotes(sessionId: string, options?: any): AxiosPromise<SessionNotesResponseDto> {
            return localVarFp.sessionsControllerGetSessionNotes(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sessions by therapist id
         * @param {string} therapistId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerGetSessionsByTherapistId(therapistId: string, from?: string, to?: string, options?: any): AxiosPromise<SessionsResponseDto> {
            return localVarFp.sessionsControllerGetSessionsByTherapistId(therapistId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start/join session
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerJoinSession(sessionId: string, options?: any): AxiosPromise<JoinSessionResponseDto> {
            return localVarFp.sessionsControllerJoinSession(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject session request (only for therapist)
         * @param {string} sessionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionsControllerRejectSessionRequest(sessionRequestId: string, options?: any): AxiosPromise<SessionRequestResponseDto> {
            return localVarFp.sessionsControllerRejectSessionRequest(sessionRequestId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SessionsApi - object-oriented interface
 * @export
 * @class SessionsApi
 * @extends {BaseAPI}
 */
export class SessionsApi extends BaseAPI {
    /**
     * 
     * @summary Accept session request (only for therapist)
     * @param {string} sessionRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public sessionsControllerAcceptSessionRequest(sessionRequestId: string, options?: AxiosRequestConfig) {
        return SessionsApiFp(this.configuration).sessionsControllerAcceptSessionRequest(sessionRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add session note
     * @param {string} sessionId 
     * @param {UpdateSessionNoteRequestDto} updateSessionNoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public sessionsControllerAddSessionNotes(sessionId: string, updateSessionNoteRequestDto: UpdateSessionNoteRequestDto, options?: AxiosRequestConfig) {
        return SessionsApiFp(this.configuration).sessionsControllerAddSessionNotes(sessionId, updateSessionNoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add session outcome (only for patient)
     * @param {string} sessionId 
     * @param {AddSessionOutcomeRequestDto} addSessionOutcomeRequestDto 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public sessionsControllerAddSessionOutcome(sessionId: string, addSessionOutcomeRequestDto: AddSessionOutcomeRequestDto, options?: AxiosRequestConfig) {
        return SessionsApiFp(this.configuration).sessionsControllerAddSessionOutcome(sessionId, addSessionOutcomeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel session request (only for patient)
     * @param {string} sessionRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public sessionsControllerCancelSessionRequest(sessionRequestId: string, options?: AxiosRequestConfig) {
        return SessionsApiFp(this.configuration).sessionsControllerCancelSessionRequest(sessionRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete session
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public sessionsControllerCompleteSession(sessionId: string, options?: AxiosRequestConfig) {
        return SessionsApiFp(this.configuration).sessionsControllerCompleteSession(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept session request (only for therapist)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public sessionsControllerCreateTestSession(options?: AxiosRequestConfig) {
        return SessionsApiFp(this.configuration).sessionsControllerCreateTestSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive sessions with therapist (only for patient)
     * @param {string} therapistId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public sessionsControllerDeleteSession(therapistId: string, options?: AxiosRequestConfig) {
        return SessionsApiFp(this.configuration).sessionsControllerDeleteSession(therapistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete session notes
     * @param {string} notesId 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public sessionsControllerDeleteSessionNotes(notesId: string, sessionId: string, options?: AxiosRequestConfig) {
        return SessionsApiFp(this.configuration).sessionsControllerDeleteSessionNotes(notesId, sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update session notes
     * @param {string} notesId 
     * @param {UpdateSessionNoteRequestDto} updateSessionNoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public sessionsControllerEditSessionNote(notesId: string, updateSessionNoteRequestDto: UpdateSessionNoteRequestDto, options?: AxiosRequestConfig) {
        return SessionsApiFp(this.configuration).sessionsControllerEditSessionNote(notesId, updateSessionNoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить сессию по id
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public sessionsControllerGetSessionById(sessionId: string, options?: AxiosRequestConfig) {
        return SessionsApiFp(this.configuration).sessionsControllerGetSessionById(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get session notes
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public sessionsControllerGetSessionNotes(sessionId: string, options?: AxiosRequestConfig) {
        return SessionsApiFp(this.configuration).sessionsControllerGetSessionNotes(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sessions by therapist id
     * @param {string} therapistId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public sessionsControllerGetSessionsByTherapistId(therapistId: string, from?: string, to?: string, options?: AxiosRequestConfig) {
        return SessionsApiFp(this.configuration).sessionsControllerGetSessionsByTherapistId(therapistId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start/join session
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public sessionsControllerJoinSession(sessionId: string, options?: AxiosRequestConfig) {
        return SessionsApiFp(this.configuration).sessionsControllerJoinSession(sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject session request (only for therapist)
     * @param {string} sessionRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionsApi
     */
    public sessionsControllerRejectSessionRequest(sessionRequestId: string, options?: AxiosRequestConfig) {
        return SessionsApiFp(this.configuration).sessionsControllerRejectSessionRequest(sessionRequestId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SupervisionNotesApi - axios parameter creator
 * @export
 */
export const SupervisionNotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add session note
         * @param {string} supervisionId 
         * @param {SupervisionNoteRequestDto} supervisionNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionNotesControllerAddNote: async (supervisionId: string, supervisionNoteRequestDto: SupervisionNoteRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supervisionId' is not null or undefined
            assertParamExists('supervisionNotesControllerAddNote', 'supervisionId', supervisionId)
            // verify required parameter 'supervisionNoteRequestDto' is not null or undefined
            assertParamExists('supervisionNotesControllerAddNote', 'supervisionNoteRequestDto', supervisionNoteRequestDto)
            const localVarPath = `/api/v1/supervisions/{supervisionId}/notes`
                .replace(`{${"supervisionId"}}`, encodeURIComponent(String(supervisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supervisionNoteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete session notes
         * @param {string} notesId 
         * @param {string} supervisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionNotesControllerDeleteNote: async (notesId: string, supervisionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notesId' is not null or undefined
            assertParamExists('supervisionNotesControllerDeleteNote', 'notesId', notesId)
            // verify required parameter 'supervisionId' is not null or undefined
            assertParamExists('supervisionNotesControllerDeleteNote', 'supervisionId', supervisionId)
            const localVarPath = `/api/v1/supervisions/{supervisionId}/notes/{notesId}`
                .replace(`{${"notesId"}}`, encodeURIComponent(String(notesId)))
                .replace(`{${"supervisionId"}}`, encodeURIComponent(String(supervisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update session notes
         * @param {string} notesId 
         * @param {string} supervisionId 
         * @param {SupervisionNoteRequestDto} supervisionNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionNotesControllerEditSessionNote: async (notesId: string, supervisionId: string, supervisionNoteRequestDto: SupervisionNoteRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notesId' is not null or undefined
            assertParamExists('supervisionNotesControllerEditSessionNote', 'notesId', notesId)
            // verify required parameter 'supervisionId' is not null or undefined
            assertParamExists('supervisionNotesControllerEditSessionNote', 'supervisionId', supervisionId)
            // verify required parameter 'supervisionNoteRequestDto' is not null or undefined
            assertParamExists('supervisionNotesControllerEditSessionNote', 'supervisionNoteRequestDto', supervisionNoteRequestDto)
            const localVarPath = `/api/v1/supervisions/{supervisionId}/notes/{notesId}`
                .replace(`{${"notesId"}}`, encodeURIComponent(String(notesId)))
                .replace(`{${"supervisionId"}}`, encodeURIComponent(String(supervisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supervisionNoteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get supervision notes
         * @param {string} supervisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionNotesControllerGetNotes: async (supervisionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supervisionId' is not null or undefined
            assertParamExists('supervisionNotesControllerGetNotes', 'supervisionId', supervisionId)
            const localVarPath = `/api/v1/supervisions/{supervisionId}/notes`
                .replace(`{${"supervisionId"}}`, encodeURIComponent(String(supervisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupervisionNotesApi - functional programming interface
 * @export
 */
export const SupervisionNotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupervisionNotesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add session note
         * @param {string} supervisionId 
         * @param {SupervisionNoteRequestDto} supervisionNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisionNotesControllerAddNote(supervisionId: string, supervisionNoteRequestDto: SupervisionNoteRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisionNoteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisionNotesControllerAddNote(supervisionId, supervisionNoteRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete session notes
         * @param {string} notesId 
         * @param {string} supervisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisionNotesControllerDeleteNote(notesId: string, supervisionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisionNoteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisionNotesControllerDeleteNote(notesId, supervisionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update session notes
         * @param {string} notesId 
         * @param {string} supervisionId 
         * @param {SupervisionNoteRequestDto} supervisionNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisionNotesControllerEditSessionNote(notesId: string, supervisionId: string, supervisionNoteRequestDto: SupervisionNoteRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisionNoteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisionNotesControllerEditSessionNote(notesId, supervisionId, supervisionNoteRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get supervision notes
         * @param {string} supervisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisionNotesControllerGetNotes(supervisionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisionNotesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisionNotesControllerGetNotes(supervisionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SupervisionNotesApi - factory interface
 * @export
 */
export const SupervisionNotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupervisionNotesApiFp(configuration)
    return {
        /**
         * 
         * @summary Add session note
         * @param {string} supervisionId 
         * @param {SupervisionNoteRequestDto} supervisionNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionNotesControllerAddNote(supervisionId: string, supervisionNoteRequestDto: SupervisionNoteRequestDto, options?: any): AxiosPromise<SupervisionNoteResponseDto> {
            return localVarFp.supervisionNotesControllerAddNote(supervisionId, supervisionNoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete session notes
         * @param {string} notesId 
         * @param {string} supervisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionNotesControllerDeleteNote(notesId: string, supervisionId: string, options?: any): AxiosPromise<SupervisionNoteResponseDto> {
            return localVarFp.supervisionNotesControllerDeleteNote(notesId, supervisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update session notes
         * @param {string} notesId 
         * @param {string} supervisionId 
         * @param {SupervisionNoteRequestDto} supervisionNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionNotesControllerEditSessionNote(notesId: string, supervisionId: string, supervisionNoteRequestDto: SupervisionNoteRequestDto, options?: any): AxiosPromise<SupervisionNoteResponseDto> {
            return localVarFp.supervisionNotesControllerEditSessionNote(notesId, supervisionId, supervisionNoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get supervision notes
         * @param {string} supervisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionNotesControllerGetNotes(supervisionId: string, options?: any): AxiosPromise<SupervisionNotesResponseDto> {
            return localVarFp.supervisionNotesControllerGetNotes(supervisionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupervisionNotesApi - object-oriented interface
 * @export
 * @class SupervisionNotesApi
 * @extends {BaseAPI}
 */
export class SupervisionNotesApi extends BaseAPI {
    /**
     * 
     * @summary Add session note
     * @param {string} supervisionId 
     * @param {SupervisionNoteRequestDto} supervisionNoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisionNotesApi
     */
    public supervisionNotesControllerAddNote(supervisionId: string, supervisionNoteRequestDto: SupervisionNoteRequestDto, options?: AxiosRequestConfig) {
        return SupervisionNotesApiFp(this.configuration).supervisionNotesControllerAddNote(supervisionId, supervisionNoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete session notes
     * @param {string} notesId 
     * @param {string} supervisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisionNotesApi
     */
    public supervisionNotesControllerDeleteNote(notesId: string, supervisionId: string, options?: AxiosRequestConfig) {
        return SupervisionNotesApiFp(this.configuration).supervisionNotesControllerDeleteNote(notesId, supervisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update session notes
     * @param {string} notesId 
     * @param {string} supervisionId 
     * @param {SupervisionNoteRequestDto} supervisionNoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisionNotesApi
     */
    public supervisionNotesControllerEditSessionNote(notesId: string, supervisionId: string, supervisionNoteRequestDto: SupervisionNoteRequestDto, options?: AxiosRequestConfig) {
        return SupervisionNotesApiFp(this.configuration).supervisionNotesControllerEditSessionNote(notesId, supervisionId, supervisionNoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get supervision notes
     * @param {string} supervisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisionNotesApi
     */
    public supervisionNotesControllerGetNotes(supervisionId: string, options?: AxiosRequestConfig) {
        return SupervisionNotesApiFp(this.configuration).supervisionNotesControllerGetNotes(supervisionId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SupervisionRequestsApi - axios parameter creator
 * @export
 */
export const SupervisionRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept supervision request (only for supervisor)
         * @param {string} supervisionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionRequestsControllerAcceptSessionRequest: async (supervisionRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supervisionRequestId' is not null or undefined
            assertParamExists('supervisionRequestsControllerAcceptSessionRequest', 'supervisionRequestId', supervisionRequestId)
            const localVarPath = `/api/v1/supervisions/requests/{supervisionRequestId}/accept`
                .replace(`{${"supervisionRequestId"}}`, encodeURIComponent(String(supervisionRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel supervision request (only for supervised therapist)
         * @param {string} supervisionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionRequestsControllerCancelSessionRequest: async (supervisionRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supervisionRequestId' is not null or undefined
            assertParamExists('supervisionRequestsControllerCancelSessionRequest', 'supervisionRequestId', supervisionRequestId)
            const localVarPath = `/api/v1/supervisions/requests/{supervisionRequestId}/cancel`
                .replace(`{${"supervisionRequestId"}}`, encodeURIComponent(String(supervisionRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create supervision (only for supervised therapist)
         * @param {CreateSupervisionRequestDto} createSupervisionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionRequestsControllerCreateSession: async (createSupervisionRequestDto: CreateSupervisionRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSupervisionRequestDto' is not null or undefined
            assertParamExists('supervisionRequestsControllerCreateSession', 'createSupervisionRequestDto', createSupervisionRequestDto)
            const localVarPath = `/api/v1/supervisions/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSupervisionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject supervision request (only for supervisor)
         * @param {string} supervisionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionRequestsControllerRejectSessionRequest: async (supervisionRequestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supervisionRequestId' is not null or undefined
            assertParamExists('supervisionRequestsControllerRejectSessionRequest', 'supervisionRequestId', supervisionRequestId)
            const localVarPath = `/api/v1/supervisions/requests/{supervisionRequestId}/reject`
                .replace(`{${"supervisionRequestId"}}`, encodeURIComponent(String(supervisionRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupervisionRequestsApi - functional programming interface
 * @export
 */
export const SupervisionRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupervisionRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept supervision request (only for supervisor)
         * @param {string} supervisionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisionRequestsControllerAcceptSessionRequest(supervisionRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisionCreateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisionRequestsControllerAcceptSessionRequest(supervisionRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel supervision request (only for supervised therapist)
         * @param {string} supervisionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisionRequestsControllerCancelSessionRequest(supervisionRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisionRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisionRequestsControllerCancelSessionRequest(supervisionRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create supervision (only for supervised therapist)
         * @param {CreateSupervisionRequestDto} createSupervisionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisionRequestsControllerCreateSession(createSupervisionRequestDto: CreateSupervisionRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisionCreateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisionRequestsControllerCreateSession(createSupervisionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject supervision request (only for supervisor)
         * @param {string} supervisionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisionRequestsControllerRejectSessionRequest(supervisionRequestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisionRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisionRequestsControllerRejectSessionRequest(supervisionRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SupervisionRequestsApi - factory interface
 * @export
 */
export const SupervisionRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupervisionRequestsApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept supervision request (only for supervisor)
         * @param {string} supervisionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionRequestsControllerAcceptSessionRequest(supervisionRequestId: string, options?: any): AxiosPromise<SupervisionCreateResponseDto> {
            return localVarFp.supervisionRequestsControllerAcceptSessionRequest(supervisionRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel supervision request (only for supervised therapist)
         * @param {string} supervisionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionRequestsControllerCancelSessionRequest(supervisionRequestId: string, options?: any): AxiosPromise<SupervisionRequestResponseDto> {
            return localVarFp.supervisionRequestsControllerCancelSessionRequest(supervisionRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create supervision (only for supervised therapist)
         * @param {CreateSupervisionRequestDto} createSupervisionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionRequestsControllerCreateSession(createSupervisionRequestDto: CreateSupervisionRequestDto, options?: any): AxiosPromise<SupervisionCreateResponseDto> {
            return localVarFp.supervisionRequestsControllerCreateSession(createSupervisionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject supervision request (only for supervisor)
         * @param {string} supervisionRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionRequestsControllerRejectSessionRequest(supervisionRequestId: string, options?: any): AxiosPromise<SupervisionRequestResponseDto> {
            return localVarFp.supervisionRequestsControllerRejectSessionRequest(supervisionRequestId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupervisionRequestsApi - object-oriented interface
 * @export
 * @class SupervisionRequestsApi
 * @extends {BaseAPI}
 */
export class SupervisionRequestsApi extends BaseAPI {
    /**
     * 
     * @summary Accept supervision request (only for supervisor)
     * @param {string} supervisionRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisionRequestsApi
     */
    public supervisionRequestsControllerAcceptSessionRequest(supervisionRequestId: string, options?: AxiosRequestConfig) {
        return SupervisionRequestsApiFp(this.configuration).supervisionRequestsControllerAcceptSessionRequest(supervisionRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel supervision request (only for supervised therapist)
     * @param {string} supervisionRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisionRequestsApi
     */
    public supervisionRequestsControllerCancelSessionRequest(supervisionRequestId: string, options?: AxiosRequestConfig) {
        return SupervisionRequestsApiFp(this.configuration).supervisionRequestsControllerCancelSessionRequest(supervisionRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create supervision (only for supervised therapist)
     * @param {CreateSupervisionRequestDto} createSupervisionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisionRequestsApi
     */
    public supervisionRequestsControllerCreateSession(createSupervisionRequestDto: CreateSupervisionRequestDto, options?: AxiosRequestConfig) {
        return SupervisionRequestsApiFp(this.configuration).supervisionRequestsControllerCreateSession(createSupervisionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject supervision request (only for supervisor)
     * @param {string} supervisionRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisionRequestsApi
     */
    public supervisionRequestsControllerRejectSessionRequest(supervisionRequestId: string, options?: AxiosRequestConfig) {
        return SupervisionRequestsApiFp(this.configuration).supervisionRequestsControllerRejectSessionRequest(supervisionRequestId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SupervisionsApi - axios parameter creator
 * @export
 */
export const SupervisionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel supervision
         * @param {string} supervisionId 
         * @param {CancelSupervisionRequestDto} cancelSupervisionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionsControllerCancelSupervision: async (supervisionId: string, cancelSupervisionRequestDto: CancelSupervisionRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supervisionId' is not null or undefined
            assertParamExists('supervisionsControllerCancelSupervision', 'supervisionId', supervisionId)
            // verify required parameter 'cancelSupervisionRequestDto' is not null or undefined
            assertParamExists('supervisionsControllerCancelSupervision', 'cancelSupervisionRequestDto', cancelSupervisionRequestDto)
            const localVarPath = `/api/v1/supervisions/{supervisionId}/cancel`
                .replace(`{${"supervisionId"}}`, encodeURIComponent(String(supervisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelSupervisionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete supervision
         * @param {string} supervisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionsControllerCompleteSupervision: async (supervisionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supervisionId' is not null or undefined
            assertParamExists('supervisionsControllerCompleteSupervision', 'supervisionId', supervisionId)
            const localVarPath = `/api/v1/supervisions/{supervisionId}/complete`
                .replace(`{${"supervisionId"}}`, encodeURIComponent(String(supervisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start/join supervision
         * @param {string} supervisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionsControllerJoinSupervision: async (supervisionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supervisionId' is not null or undefined
            assertParamExists('supervisionsControllerJoinSupervision', 'supervisionId', supervisionId)
            const localVarPath = `/api/v1/supervisions/{supervisionId}/join`
                .replace(`{${"supervisionId"}}`, encodeURIComponent(String(supervisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Shift supervision
         * @param {string} supervisionId 
         * @param {ShiftSupervisionRequestDto} shiftSupervisionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionsControllerShiftSupervision: async (supervisionId: string, shiftSupervisionRequestDto: ShiftSupervisionRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supervisionId' is not null or undefined
            assertParamExists('supervisionsControllerShiftSupervision', 'supervisionId', supervisionId)
            // verify required parameter 'shiftSupervisionRequestDto' is not null or undefined
            assertParamExists('supervisionsControllerShiftSupervision', 'shiftSupervisionRequestDto', shiftSupervisionRequestDto)
            const localVarPath = `/api/v1/supervisions/{supervisionId}/shift`
                .replace(`{${"supervisionId"}}`, encodeURIComponent(String(supervisionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shiftSupervisionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupervisionsApi - functional programming interface
 * @export
 */
export const SupervisionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupervisionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel supervision
         * @param {string} supervisionId 
         * @param {CancelSupervisionRequestDto} cancelSupervisionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisionsControllerCancelSupervision(supervisionId: string, cancelSupervisionRequestDto: CancelSupervisionRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisionBaseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisionsControllerCancelSupervision(supervisionId, cancelSupervisionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Complete supervision
         * @param {string} supervisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisionsControllerCompleteSupervision(supervisionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisionsControllerCompleteSupervision(supervisionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start/join supervision
         * @param {string} supervisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisionsControllerJoinSupervision(supervisionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JoinSupervisionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisionsControllerJoinSupervision(supervisionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Shift supervision
         * @param {string} supervisionId 
         * @param {ShiftSupervisionRequestDto} shiftSupervisionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisionsControllerShiftSupervision(supervisionId: string, shiftSupervisionRequestDto: ShiftSupervisionRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisionBaseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisionsControllerShiftSupervision(supervisionId, shiftSupervisionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SupervisionsApi - factory interface
 * @export
 */
export const SupervisionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupervisionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel supervision
         * @param {string} supervisionId 
         * @param {CancelSupervisionRequestDto} cancelSupervisionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionsControllerCancelSupervision(supervisionId: string, cancelSupervisionRequestDto: CancelSupervisionRequestDto, options?: any): AxiosPromise<SupervisionBaseResponseDto> {
            return localVarFp.supervisionsControllerCancelSupervision(supervisionId, cancelSupervisionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete supervision
         * @param {string} supervisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionsControllerCompleteSupervision(supervisionId: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.supervisionsControllerCompleteSupervision(supervisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start/join supervision
         * @param {string} supervisionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionsControllerJoinSupervision(supervisionId: string, options?: any): AxiosPromise<JoinSupervisionResponseDto> {
            return localVarFp.supervisionsControllerJoinSupervision(supervisionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Shift supervision
         * @param {string} supervisionId 
         * @param {ShiftSupervisionRequestDto} shiftSupervisionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisionsControllerShiftSupervision(supervisionId: string, shiftSupervisionRequestDto: ShiftSupervisionRequestDto, options?: any): AxiosPromise<SupervisionBaseResponseDto> {
            return localVarFp.supervisionsControllerShiftSupervision(supervisionId, shiftSupervisionRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupervisionsApi - object-oriented interface
 * @export
 * @class SupervisionsApi
 * @extends {BaseAPI}
 */
export class SupervisionsApi extends BaseAPI {
    /**
     * 
     * @summary Cancel supervision
     * @param {string} supervisionId 
     * @param {CancelSupervisionRequestDto} cancelSupervisionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisionsApi
     */
    public supervisionsControllerCancelSupervision(supervisionId: string, cancelSupervisionRequestDto: CancelSupervisionRequestDto, options?: AxiosRequestConfig) {
        return SupervisionsApiFp(this.configuration).supervisionsControllerCancelSupervision(supervisionId, cancelSupervisionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete supervision
     * @param {string} supervisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisionsApi
     */
    public supervisionsControllerCompleteSupervision(supervisionId: string, options?: AxiosRequestConfig) {
        return SupervisionsApiFp(this.configuration).supervisionsControllerCompleteSupervision(supervisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start/join supervision
     * @param {string} supervisionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisionsApi
     */
    public supervisionsControllerJoinSupervision(supervisionId: string, options?: AxiosRequestConfig) {
        return SupervisionsApiFp(this.configuration).supervisionsControllerJoinSupervision(supervisionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Shift supervision
     * @param {string} supervisionId 
     * @param {ShiftSupervisionRequestDto} shiftSupervisionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisionsApi
     */
    public supervisionsControllerShiftSupervision(supervisionId: string, shiftSupervisionRequestDto: ShiftSupervisionRequestDto, options?: AxiosRequestConfig) {
        return SupervisionsApiFp(this.configuration).supervisionsControllerShiftSupervision(supervisionId, shiftSupervisionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SupervisorsApi - axios parameter creator
 * @export
 */
export const SupervisorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Archive supervised therapists
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorsControllerArchiveSupervisedTherapist: async (therapistId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('supervisorsControllerArchiveSupervisedTherapist', 'therapistId', therapistId)
            const localVarPath = `/api/v1/supervisors/therapists/{therapistId}/archive`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive supervisions and supervisor (only for supervised therapist)
         * @param {string} supervisorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorsControllerArchiveSupervisions: async (supervisorId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supervisorId' is not null or undefined
            assertParamExists('supervisorsControllerArchiveSupervisions', 'supervisorId', supervisorId)
            const localVarPath = `/api/v1/supervisors/{supervisorId}`
                .replace(`{${"supervisorId"}}`, encodeURIComponent(String(supervisorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get supervisor\'s therapists
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate'} [orderTerms] 
         * @param {boolean} [archivedBySupervisor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorsControllerGetSupervisorTherapists: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate', archivedBySupervisor?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('supervisorsControllerGetSupervisorTherapists', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('supervisorsControllerGetSupervisorTherapists', 'page', page)
            const localVarPath = `/api/v1/supervisors/therapists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (archivedBySupervisor !== undefined) {
                localVarQueryParameter['archivedBySupervisor'] = archivedBySupervisor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get therapist\'s supervisors
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorsControllerGetSupervisors: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('supervisorsControllerGetSupervisors', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('supervisorsControllerGetSupervisors', 'page', page)
            const localVarPath = `/api/v1/supervisors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject supervised therapist
         * @param {string} therapistId 
         * @param {RejectTherapistRequestDto} rejectTherapistRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorsControllerRejectSupervisedTherapist: async (therapistId: string, rejectTherapistRequestDto: RejectTherapistRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('supervisorsControllerRejectSupervisedTherapist', 'therapistId', therapistId)
            // verify required parameter 'rejectTherapistRequestDto' is not null or undefined
            assertParamExists('supervisorsControllerRejectSupervisedTherapist', 'rejectTherapistRequestDto', rejectTherapistRequestDto)
            const localVarPath = `/api/v1/supervisors/therapists/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectTherapistRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unarchive supervised therapist
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorsControllerUnarchiveSupervisedTherapist: async (therapistId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('supervisorsControllerUnarchiveSupervisedTherapist', 'therapistId', therapistId)
            const localVarPath = `/api/v1/supervisors/therapists/{therapistId}/unarchive`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupervisorsApi - functional programming interface
 * @export
 */
export const SupervisorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupervisorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Archive supervised therapists
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisorsControllerArchiveSupervisedTherapist(therapistId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisorsControllerArchiveSupervisedTherapist(therapistId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Archive supervisions and supervisor (only for supervised therapist)
         * @param {string} supervisorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisorsControllerArchiveSupervisions(supervisorId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisorsControllerArchiveSupervisions(supervisorId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get supervisor\'s therapists
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate'} [orderTerms] 
         * @param {boolean} [archivedBySupervisor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisorsControllerGetSupervisorTherapists(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate', archivedBySupervisor?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisorTherapistsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisorsControllerGetSupervisorTherapists(limit, page, order, orderTerms, archivedBySupervisor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get therapist\'s supervisors
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisorsControllerGetSupervisors(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapistSupervisorsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisorsControllerGetSupervisors(limit, page, order, orderTerms, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject supervised therapist
         * @param {string} therapistId 
         * @param {RejectTherapistRequestDto} rejectTherapistRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisorsControllerRejectSupervisedTherapist(therapistId: string, rejectTherapistRequestDto: RejectTherapistRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisorsControllerRejectSupervisedTherapist(therapistId, rejectTherapistRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unarchive supervised therapist
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisorsControllerUnarchiveSupervisedTherapist(therapistId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisorsControllerUnarchiveSupervisedTherapist(therapistId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SupervisorsApi - factory interface
 * @export
 */
export const SupervisorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupervisorsApiFp(configuration)
    return {
        /**
         * 
         * @summary Archive supervised therapists
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorsControllerArchiveSupervisedTherapist(therapistId: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.supervisorsControllerArchiveSupervisedTherapist(therapistId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive supervisions and supervisor (only for supervised therapist)
         * @param {string} supervisorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorsControllerArchiveSupervisions(supervisorId: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.supervisorsControllerArchiveSupervisions(supervisorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get supervisor\'s therapists
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate'} [orderTerms] 
         * @param {boolean} [archivedBySupervisor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorsControllerGetSupervisorTherapists(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate', archivedBySupervisor?: boolean, options?: any): AxiosPromise<SupervisorTherapistsResponseDto> {
            return localVarFp.supervisorsControllerGetSupervisorTherapists(limit, page, order, orderTerms, archivedBySupervisor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get therapist\'s supervisors
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate'} [orderTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorsControllerGetSupervisors(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate', options?: any): AxiosPromise<TherapistSupervisorsResponseDto> {
            return localVarFp.supervisorsControllerGetSupervisors(limit, page, order, orderTerms, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject supervised therapist
         * @param {string} therapistId 
         * @param {RejectTherapistRequestDto} rejectTherapistRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorsControllerRejectSupervisedTherapist(therapistId: string, rejectTherapistRequestDto: RejectTherapistRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.supervisorsControllerRejectSupervisedTherapist(therapistId, rejectTherapistRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unarchive supervised therapist
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorsControllerUnarchiveSupervisedTherapist(therapistId: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.supervisorsControllerUnarchiveSupervisedTherapist(therapistId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupervisorsApi - object-oriented interface
 * @export
 * @class SupervisorsApi
 * @extends {BaseAPI}
 */
export class SupervisorsApi extends BaseAPI {
    /**
     * 
     * @summary Archive supervised therapists
     * @param {string} therapistId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisorsApi
     */
    public supervisorsControllerArchiveSupervisedTherapist(therapistId: string, options?: AxiosRequestConfig) {
        return SupervisorsApiFp(this.configuration).supervisorsControllerArchiveSupervisedTherapist(therapistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive supervisions and supervisor (only for supervised therapist)
     * @param {string} supervisorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisorsApi
     */
    public supervisorsControllerArchiveSupervisions(supervisorId: string, options?: AxiosRequestConfig) {
        return SupervisorsApiFp(this.configuration).supervisorsControllerArchiveSupervisions(supervisorId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get supervisor\'s therapists
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate'} [orderTerms] 
     * @param {boolean} [archivedBySupervisor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisorsApi
     */
    public supervisorsControllerGetSupervisorTherapists(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate', archivedBySupervisor?: boolean, options?: AxiosRequestConfig) {
        return SupervisorsApiFp(this.configuration).supervisorsControllerGetSupervisorTherapists(limit, page, order, orderTerms, archivedBySupervisor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get therapist\'s supervisors
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate'} [orderTerms] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisorsApi
     */
    public supervisorsControllerGetSupervisors(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'therapistName' | 'supervisionCount' | 'firstSupervisionDate' | 'lastSupervisionDate', options?: AxiosRequestConfig) {
        return SupervisorsApiFp(this.configuration).supervisorsControllerGetSupervisors(limit, page, order, orderTerms, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject supervised therapist
     * @param {string} therapistId 
     * @param {RejectTherapistRequestDto} rejectTherapistRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisorsApi
     */
    public supervisorsControllerRejectSupervisedTherapist(therapistId: string, rejectTherapistRequestDto: RejectTherapistRequestDto, options?: AxiosRequestConfig) {
        return SupervisorsApiFp(this.configuration).supervisorsControllerRejectSupervisedTherapist(therapistId, rejectTherapistRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unarchive supervised therapist
     * @param {string} therapistId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisorsApi
     */
    public supervisorsControllerUnarchiveSupervisedTherapist(therapistId: string, options?: AxiosRequestConfig) {
        return SupervisorsApiFp(this.configuration).supervisorsControllerUnarchiveSupervisedTherapist(therapistId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TherapistUpdatesApi - axios parameter creator
 * @export
 */
export const TherapistUpdatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create therapist profile update (only for therapist)
         * @param {CreateTherapistProfileRequestDto} createTherapistProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistUpdatesControllerCreateProfileUpdate: async (createTherapistProfileRequestDto: CreateTherapistProfileRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTherapistProfileRequestDto' is not null or undefined
            assertParamExists('therapistUpdatesControllerCreateProfileUpdate', 'createTherapistProfileRequestDto', createTherapistProfileRequestDto)
            const localVarPath = `/api/v1/therapist-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTherapistProfileRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete therapist profile update
         * @param {string} therapistProfileUpdateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistUpdatesControllerDeleteProfileUpdate: async (therapistProfileUpdateId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistProfileUpdateId' is not null or undefined
            assertParamExists('therapistUpdatesControllerDeleteProfileUpdate', 'therapistProfileUpdateId', therapistProfileUpdateId)
            const localVarPath = `/api/v1/therapist-update/{therapistProfileUpdateId}`
                .replace(`{${"therapistProfileUpdateId"}}`, encodeURIComponent(String(therapistProfileUpdateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get therapist profile update (only for therapist)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistUpdatesControllerGetProfileUpdates: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/therapist-update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TherapistUpdatesApi - functional programming interface
 * @export
 */
export const TherapistUpdatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TherapistUpdatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create therapist profile update (only for therapist)
         * @param {CreateTherapistProfileRequestDto} createTherapistProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistUpdatesControllerCreateProfileUpdate(createTherapistProfileRequestDto: CreateTherapistProfileRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapistProfileUpdateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistUpdatesControllerCreateProfileUpdate(createTherapistProfileRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete therapist profile update
         * @param {string} therapistProfileUpdateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistUpdatesControllerDeleteProfileUpdate(therapistProfileUpdateId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapistProfileUpdateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistUpdatesControllerDeleteProfileUpdate(therapistProfileUpdateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get therapist profile update (only for therapist)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistUpdatesControllerGetProfileUpdates(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TherapistProfileUpdatesResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistUpdatesControllerGetProfileUpdates(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TherapistUpdatesApi - factory interface
 * @export
 */
export const TherapistUpdatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TherapistUpdatesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create therapist profile update (only for therapist)
         * @param {CreateTherapistProfileRequestDto} createTherapistProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistUpdatesControllerCreateProfileUpdate(createTherapistProfileRequestDto: CreateTherapistProfileRequestDto, options?: any): AxiosPromise<TherapistProfileUpdateResponseDto> {
            return localVarFp.therapistUpdatesControllerCreateProfileUpdate(createTherapistProfileRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete therapist profile update
         * @param {string} therapistProfileUpdateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistUpdatesControllerDeleteProfileUpdate(therapistProfileUpdateId: string, options?: any): AxiosPromise<TherapistProfileUpdateResponseDto> {
            return localVarFp.therapistUpdatesControllerDeleteProfileUpdate(therapistProfileUpdateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get therapist profile update (only for therapist)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistUpdatesControllerGetProfileUpdates(options?: any): AxiosPromise<Array<TherapistProfileUpdatesResponseDto>> {
            return localVarFp.therapistUpdatesControllerGetProfileUpdates(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TherapistUpdatesApi - object-oriented interface
 * @export
 * @class TherapistUpdatesApi
 * @extends {BaseAPI}
 */
export class TherapistUpdatesApi extends BaseAPI {
    /**
     * 
     * @summary Create therapist profile update (only for therapist)
     * @param {CreateTherapistProfileRequestDto} createTherapistProfileRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistUpdatesApi
     */
    public therapistUpdatesControllerCreateProfileUpdate(createTherapistProfileRequestDto: CreateTherapistProfileRequestDto, options?: AxiosRequestConfig) {
        return TherapistUpdatesApiFp(this.configuration).therapistUpdatesControllerCreateProfileUpdate(createTherapistProfileRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete therapist profile update
     * @param {string} therapistProfileUpdateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistUpdatesApi
     */
    public therapistUpdatesControllerDeleteProfileUpdate(therapistProfileUpdateId: string, options?: AxiosRequestConfig) {
        return TherapistUpdatesApiFp(this.configuration).therapistUpdatesControllerDeleteProfileUpdate(therapistProfileUpdateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get therapist profile update (only for therapist)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistUpdatesApi
     */
    public therapistUpdatesControllerGetProfileUpdates(options?: AxiosRequestConfig) {
        return TherapistUpdatesApiFp(this.configuration).therapistUpdatesControllerGetProfileUpdates(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TherapistsApi - axios parameter creator
 * @export
 */
export const TherapistsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add patient\'s note (only for therapist)
         * @param {string} patientId 
         * @param {TherapistPatientNoteRequestDto} therapistPatientNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistPatientNoteControllerAddNote: async (patientId: string, therapistPatientNoteRequestDto: TherapistPatientNoteRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('therapistPatientNoteControllerAddNote', 'patientId', patientId)
            // verify required parameter 'therapistPatientNoteRequestDto' is not null or undefined
            assertParamExists('therapistPatientNoteControllerAddNote', 'therapistPatientNoteRequestDto', therapistPatientNoteRequestDto)
            const localVarPath = `/api/v1/therapists/patient/{patientId}/notes`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistPatientNoteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete patient note (only for therapist)
         * @param {string} patientId 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistPatientNoteControllerDeleteNote: async (patientId: string, noteId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('therapistPatientNoteControllerDeleteNote', 'patientId', patientId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('therapistPatientNoteControllerDeleteNote', 'noteId', noteId)
            const localVarPath = `/api/v1/therapists/patient/{patientId}/notes/{noteId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update patient note (only for therapist)
         * @param {string} patientId 
         * @param {string} noteId 
         * @param {TherapistPatientNoteRequestDto} therapistPatientNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistPatientNoteControllerEditNote: async (patientId: string, noteId: string, therapistPatientNoteRequestDto: TherapistPatientNoteRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('therapistPatientNoteControllerEditNote', 'patientId', patientId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('therapistPatientNoteControllerEditNote', 'noteId', noteId)
            // verify required parameter 'therapistPatientNoteRequestDto' is not null or undefined
            assertParamExists('therapistPatientNoteControllerEditNote', 'therapistPatientNoteRequestDto', therapistPatientNoteRequestDto)
            const localVarPath = `/api/v1/therapists/patient/{patientId}/notes/{noteId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(therapistPatientNoteRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get patient\'s notes (only for therapist)
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistPatientNoteControllerGetPatientNotes: async (patientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('therapistPatientNoteControllerGetPatientNotes', 'patientId', patientId)
            const localVarPath = `/api/v1/therapists/patient/{patientId}/notes`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get active supervisions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistSupervisionsControllerGetActiveSupervisions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/therapists/supervisions/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get supervisions history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistSupervisionsControllerGetSupervisionsHistory: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/therapists/supervisions/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add therapist to favorites (only for patients)
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerAddTherapistToFavorites: async (therapistId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('therapistsControllerAddTherapistToFavorites', 'therapistId', therapistId)
            const localVarPath = `/api/v1/therapists/{therapistId}/favorite`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerAllTherapistsUrlsForSitemap: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/therapists/get-urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Archive patient and all sessions (only for therapist)
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerArchivePatient: async (patientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('therapistsControllerArchivePatient', 'patientId', patientId)
            const localVarPath = `/api/v1/therapists/patients/{patientId}/archive`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create availability (only for therapists)
         * @param {CreateAvailabilitiesRequestDto} createAvailabilitiesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerCreateAvailability: async (createAvailabilitiesRequestDto: CreateAvailabilitiesRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAvailabilitiesRequestDto' is not null or undefined
            assertParamExists('therapistsControllerCreateAvailability', 'createAvailabilitiesRequestDto', createAvailabilitiesRequestDto)
            const localVarPath = `/api/v1/therapists/availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAvailabilitiesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete availability (only for therapist)
         * @param {string} availabilityId 
         * @param {DeleteAvailabilityRequestDto} deleteAvailabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerDeleteAvailability: async (availabilityId: string, deleteAvailabilityRequestDto: DeleteAvailabilityRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityId' is not null or undefined
            assertParamExists('therapistsControllerDeleteAvailability', 'availabilityId', availabilityId)
            // verify required parameter 'deleteAvailabilityRequestDto' is not null or undefined
            assertParamExists('therapistsControllerDeleteAvailability', 'deleteAvailabilityRequestDto', deleteAvailabilityRequestDto)
            const localVarPath = `/api/v1/therapists/availability/{availabilityId}`
                .replace(`{${"availabilityId"}}`, encodeURIComponent(String(availabilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAvailabilityRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete avatar (only for therapists)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerDeleteAvatar: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/therapists/avatar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete video (only for therapists)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerDeleteVideo: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/therapists/video`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get therapist self info (only for therapists)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerFindOne: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/therapists/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get therapist url from therapist id
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerFindUrlById: async (therapistId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('therapistsControllerFindUrlById', 'therapistId', therapistId)
            const localVarPath = `/api/v1/therapists/therapist-url-from-id/{therapistId}`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get active sessions (only for therapists)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [patientName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetActiveSessions: async (limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, patientName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('therapistsControllerGetActiveSessions', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('therapistsControllerGetActiveSessions', 'page', page)
            const localVarPath = `/api/v1/therapists/sessions/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (patientName !== undefined) {
                localVarQueryParameter['patientName'] = patientName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all therapists
         * @param {boolean} [debug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetAllTherapists: async (debug?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/therapists/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (debug !== undefined) {
                localVarQueryParameter['debug'] = debug;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get availabilities of therapists
         * @param {string} therapistId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetAvailability: async (therapistId: string, from?: string, to?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('therapistsControllerGetAvailability', 'therapistId', therapistId)
            const localVarPath = `/api/v1/therapists/{therapistId}/availability`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get history sessions (only for therapists)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [patientName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetHistorySessions: async (limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, patientName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('therapistsControllerGetHistorySessions', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('therapistsControllerGetHistorySessions', 'page', page)
            const localVarPath = `/api/v1/therapists/sessions/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (patientName !== undefined) {
                localVarQueryParameter['patientName'] = patientName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create therapist create request (only for therapists)
         * @param {CreateTherapistProfileRequestDto} createTherapistProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetProfile: async (createTherapistProfileRequestDto: CreateTherapistProfileRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTherapistProfileRequestDto' is not null or undefined
            assertParamExists('therapistsControllerGetProfile', 'createTherapistProfileRequestDto', createTherapistProfileRequestDto)
            const localVarPath = `/api/v1/therapists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTherapistProfileRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get therapist schedule (only for therapists)
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetSchedule: async (from?: string, to?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/therapists/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get tiny sessions (only for therapists)
         * @param {boolean} isActive 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetSessions: async (isActive: boolean, from?: string, to?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isActive' is not null or undefined
            assertParamExists('therapistsControllerGetSessions', 'isActive', isActive)
            const localVarPath = `/api/v1/therapists/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search all supervisors
         * @param {number} limit 
         * @param {number} page 
         * @param {number} offset 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'price' | 'experience' | 'availability'} [orderTerms] 
         * @param {'male' | 'female' | 'transgender' | 'unknown'} [gender] 
         * @param {Array<string>} [therapyMethods] 
         * @param {Array<string>} [diseases] 
         * @param {string} [diseaseUrl] 
         * @param {string} [therapyMethodUrl] 
         * @param {number} [dayLimit] 
         * @param {boolean} [workWithLgbt] 
         * @param {boolean} [workWithEthnicGroups] 
         * @param {number} [workingExperience] 
         * @param {string} [firstname] 
         * @param {string} [lastname] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>} [religions] 
         * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialisations] 
         * @param {boolean} [debug] 
         * @param {boolean} [childTherapists] 
         * @param {boolean} [adultTherapists] 
         * @param {boolean} [supervisorTherapists] 
         * @param {boolean} [b2bTherapists] 
         * @param {boolean} [coaches] 
         * @param {number} [childOld] 
         * @param {string} [therapistOld] Возраст терапевта должен быть в формате \&quot;20-34\&quot; или \&quot;45+\&quot;
         * @param {boolean} [demo] 
         * @param {boolean} [family] 
         * @param {'supporting' | 'guiding'} [workApproachGuidance] 
         * @param {'soft' | 'straight'} [workApproachInteraction] 
         * @param {'serious' | 'informal'} [workApproachConnection] 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetSupervisors: async (limit: number, page: number, offset: number, order?: 'ASC' | 'DESC', orderTerms?: 'price' | 'experience' | 'availability', gender?: 'male' | 'female' | 'transgender' | 'unknown', therapyMethods?: Array<string>, diseases?: Array<string>, diseaseUrl?: string, therapyMethodUrl?: string, dayLimit?: number, workWithLgbt?: boolean, workWithEthnicGroups?: boolean, workingExperience?: number, firstname?: string, lastname?: string, priceMin?: number, priceMax?: number, religions?: Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>, specialisations?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, debug?: boolean, childTherapists?: boolean, adultTherapists?: boolean, supervisorTherapists?: boolean, b2bTherapists?: boolean, coaches?: boolean, childOld?: number, therapistOld?: string, demo?: boolean, family?: boolean, workApproachGuidance?: 'supporting' | 'guiding', workApproachInteraction?: 'soft' | 'straight', workApproachConnection?: 'serious' | 'informal', isFavorite?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('therapistsControllerGetSupervisors', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('therapistsControllerGetSupervisors', 'page', page)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('therapistsControllerGetSupervisors', 'offset', offset)
            const localVarPath = `/api/v1/therapists/supervisors/with_filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }

            if (therapyMethods) {
                localVarQueryParameter['therapyMethods'] = therapyMethods;
            }

            if (diseases) {
                localVarQueryParameter['diseases'] = diseases;
            }

            if (diseaseUrl !== undefined) {
                localVarQueryParameter['diseaseUrl'] = diseaseUrl;
            }

            if (therapyMethodUrl !== undefined) {
                localVarQueryParameter['therapyMethodUrl'] = therapyMethodUrl;
            }

            if (dayLimit !== undefined) {
                localVarQueryParameter['dayLimit'] = dayLimit;
            }

            if (workWithLgbt !== undefined) {
                localVarQueryParameter['workWithLgbt'] = workWithLgbt;
            }

            if (workWithEthnicGroups !== undefined) {
                localVarQueryParameter['workWithEthnicGroups'] = workWithEthnicGroups;
            }

            if (workingExperience !== undefined) {
                localVarQueryParameter['workingExperience'] = workingExperience;
            }

            if (firstname !== undefined) {
                localVarQueryParameter['firstname'] = firstname;
            }

            if (lastname !== undefined) {
                localVarQueryParameter['lastname'] = lastname;
            }

            if (priceMin !== undefined) {
                localVarQueryParameter['priceMin'] = priceMin;
            }

            if (priceMax !== undefined) {
                localVarQueryParameter['priceMax'] = priceMax;
            }

            if (religions) {
                localVarQueryParameter['religions'] = religions;
            }

            if (specialisations) {
                localVarQueryParameter['specialisations'] = specialisations;
            }

            if (debug !== undefined) {
                localVarQueryParameter['debug'] = debug;
            }

            if (childTherapists !== undefined) {
                localVarQueryParameter['childTherapists'] = childTherapists;
            }

            if (adultTherapists !== undefined) {
                localVarQueryParameter['adultTherapists'] = adultTherapists;
            }

            if (supervisorTherapists !== undefined) {
                localVarQueryParameter['supervisorTherapists'] = supervisorTherapists;
            }

            if (b2bTherapists !== undefined) {
                localVarQueryParameter['b2bTherapists'] = b2bTherapists;
            }

            if (coaches !== undefined) {
                localVarQueryParameter['coaches'] = coaches;
            }

            if (childOld !== undefined) {
                localVarQueryParameter['childOld'] = childOld;
            }

            if (therapistOld !== undefined) {
                localVarQueryParameter['therapistOld'] = therapistOld;
            }

            if (demo !== undefined) {
                localVarQueryParameter['demo'] = demo;
            }

            if (family !== undefined) {
                localVarQueryParameter['family'] = family;
            }

            if (workApproachGuidance !== undefined) {
                localVarQueryParameter['workApproachGuidance'] = workApproachGuidance;
            }

            if (workApproachInteraction !== undefined) {
                localVarQueryParameter['workApproachInteraction'] = workApproachInteraction;
            }

            if (workApproachConnection !== undefined) {
                localVarQueryParameter['workApproachConnection'] = workApproachConnection;
            }

            if (isFavorite !== undefined) {
                localVarQueryParameter['isFavorite'] = isFavorite;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get therapist review list
         * @param {string} therapistId 
         * @param {number} limit 
         * @param {number} page 
         * @param {'rating' | 'createdAt'} orderTerms 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetTherapistReviews: async (therapistId: string, limit: number, page: number, orderTerms: 'rating' | 'createdAt', order?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('therapistsControllerGetTherapistReviews', 'therapistId', therapistId)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('therapistsControllerGetTherapistReviews', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('therapistsControllerGetTherapistReviews', 'page', page)
            // verify required parameter 'orderTerms' is not null or undefined
            assertParamExists('therapistsControllerGetTherapistReviews', 'orderTerms', orderTerms)
            const localVarPath = `/api/v1/therapists/{therapistId}/reviews`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all therapist patients (only for therapist)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'firstname' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate'} [orderTerms] 
         * @param {boolean} [archivedByTherapist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerPatientTherapists: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'firstname' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate', archivedByTherapist?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('therapistsControllerPatientTherapists', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('therapistsControllerPatientTherapists', 'page', page)
            const localVarPath = `/api/v1/therapists/patients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (archivedByTherapist !== undefined) {
                localVarQueryParameter['archivedByTherapist'] = archivedByTherapist;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject patient and cancel all sessions (only for therapist)
         * @param {string} patientId 
         * @param {RejectPatientRequestDto} rejectPatientRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerRejectPatient: async (patientId: string, rejectPatientRequestDto: RejectPatientRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('therapistsControllerRejectPatient', 'patientId', patientId)
            // verify required parameter 'rejectPatientRequestDto' is not null or undefined
            assertParamExists('therapistsControllerRejectPatient', 'rejectPatientRequestDto', rejectPatientRequestDto)
            const localVarPath = `/api/v1/therapists/patients/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectPatientRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove therapist from favorites (only for patients)
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerRemoveTherapistFromFavorites: async (therapistId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('therapistsControllerRemoveTherapistFromFavorites', 'therapistId', therapistId)
            const localVarPath = `/api/v1/therapists/{therapistId}/favorite`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request session from therapist through admins
         * @param {string} therapistId 
         * @param {RequestSessionRequestDto} requestSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerRequestTherapistSession: async (therapistId: string, requestSessionRequestDto: RequestSessionRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistId' is not null or undefined
            assertParamExists('therapistsControllerRequestTherapistSession', 'therapistId', therapistId)
            // verify required parameter 'requestSessionRequestDto' is not null or undefined
            assertParamExists('therapistsControllerRequestTherapistSession', 'requestSessionRequestDto', requestSessionRequestDto)
            const localVarPath = `/api/v1/therapists/{therapistId}/request_session`
                .replace(`{${"therapistId"}}`, encodeURIComponent(String(therapistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestSessionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get therapist list by search filter
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'price' | 'experience' | 'availability'} [orderTerms] 
         * @param {'male' | 'female' | 'transgender' | 'unknown'} [gender] 
         * @param {Array<string>} [therapyMethods] 
         * @param {Array<string>} [diseases] 
         * @param {string} [diseaseUrl] 
         * @param {string} [therapyMethodUrl] 
         * @param {number} [dayLimit] 
         * @param {boolean} [workWithLgbt] 
         * @param {boolean} [workWithEthnicGroups] 
         * @param {number} [workingExperience] 
         * @param {boolean} [isApproved] 
         * @param {string} [firstname] 
         * @param {string} [lastname] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>} [religions] 
         * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialisations] 
         * @param {boolean} [debug] 
         * @param {boolean} [childTherapists] 
         * @param {boolean} [adultTherapists] 
         * @param {boolean} [supervisorTherapists] 
         * @param {boolean} [b2bTherapists] 
         * @param {boolean} [coaches] 
         * @param {number} [childOld] 
         * @param {string} [therapistOld] Возраст терапевта должен быть в формате \&quot;20-34\&quot; или \&quot;45+\&quot;
         * @param {boolean} [demo] 
         * @param {boolean} [family] 
         * @param {'supporting' | 'guiding'} [workApproachGuidance] 
         * @param {'soft' | 'straight'} [workApproachInteraction] 
         * @param {'serious' | 'informal'} [workApproachConnection] 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerSearch: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'price' | 'experience' | 'availability', gender?: 'male' | 'female' | 'transgender' | 'unknown', therapyMethods?: Array<string>, diseases?: Array<string>, diseaseUrl?: string, therapyMethodUrl?: string, dayLimit?: number, workWithLgbt?: boolean, workWithEthnicGroups?: boolean, workingExperience?: number, isApproved?: boolean, firstname?: string, lastname?: string, priceMin?: number, priceMax?: number, religions?: Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>, specialisations?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, debug?: boolean, childTherapists?: boolean, adultTherapists?: boolean, supervisorTherapists?: boolean, b2bTherapists?: boolean, coaches?: boolean, childOld?: number, therapistOld?: string, demo?: boolean, family?: boolean, workApproachGuidance?: 'supporting' | 'guiding', workApproachInteraction?: 'soft' | 'straight', workApproachConnection?: 'serious' | 'informal', isFavorite?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('therapistsControllerSearch', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('therapistsControllerSearch', 'page', page)
            const localVarPath = `/api/v1/therapists/search/with_filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }

            if (therapyMethods) {
                localVarQueryParameter['therapyMethods'] = therapyMethods;
            }

            if (diseases) {
                localVarQueryParameter['diseases'] = diseases;
            }

            if (diseaseUrl !== undefined) {
                localVarQueryParameter['diseaseUrl'] = diseaseUrl;
            }

            if (therapyMethodUrl !== undefined) {
                localVarQueryParameter['therapyMethodUrl'] = therapyMethodUrl;
            }

            if (dayLimit !== undefined) {
                localVarQueryParameter['dayLimit'] = dayLimit;
            }

            if (workWithLgbt !== undefined) {
                localVarQueryParameter['workWithLgbt'] = workWithLgbt;
            }

            if (workWithEthnicGroups !== undefined) {
                localVarQueryParameter['workWithEthnicGroups'] = workWithEthnicGroups;
            }

            if (workingExperience !== undefined) {
                localVarQueryParameter['workingExperience'] = workingExperience;
            }

            if (isApproved !== undefined) {
                localVarQueryParameter['isApproved'] = isApproved;
            }

            if (firstname !== undefined) {
                localVarQueryParameter['firstname'] = firstname;
            }

            if (lastname !== undefined) {
                localVarQueryParameter['lastname'] = lastname;
            }

            if (priceMin !== undefined) {
                localVarQueryParameter['priceMin'] = priceMin;
            }

            if (priceMax !== undefined) {
                localVarQueryParameter['priceMax'] = priceMax;
            }

            if (religions) {
                localVarQueryParameter['religions'] = religions;
            }

            if (specialisations) {
                localVarQueryParameter['specialisations'] = specialisations;
            }

            if (debug !== undefined) {
                localVarQueryParameter['debug'] = debug;
            }

            if (childTherapists !== undefined) {
                localVarQueryParameter['childTherapists'] = childTherapists;
            }

            if (adultTherapists !== undefined) {
                localVarQueryParameter['adultTherapists'] = adultTherapists;
            }

            if (supervisorTherapists !== undefined) {
                localVarQueryParameter['supervisorTherapists'] = supervisorTherapists;
            }

            if (b2bTherapists !== undefined) {
                localVarQueryParameter['b2bTherapists'] = b2bTherapists;
            }

            if (coaches !== undefined) {
                localVarQueryParameter['coaches'] = coaches;
            }

            if (childOld !== undefined) {
                localVarQueryParameter['childOld'] = childOld;
            }

            if (therapistOld !== undefined) {
                localVarQueryParameter['therapistOld'] = therapistOld;
            }

            if (demo !== undefined) {
                localVarQueryParameter['demo'] = demo;
            }

            if (family !== undefined) {
                localVarQueryParameter['family'] = family;
            }

            if (workApproachGuidance !== undefined) {
                localVarQueryParameter['workApproachGuidance'] = workApproachGuidance;
            }

            if (workApproachInteraction !== undefined) {
                localVarQueryParameter['workApproachInteraction'] = workApproachInteraction;
            }

            if (workApproachConnection !== undefined) {
                localVarQueryParameter['workApproachConnection'] = workApproachConnection;
            }

            if (isFavorite !== undefined) {
                localVarQueryParameter['isFavorite'] = isFavorite;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get therapist list by recommendation params (only for patients)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'price' | 'experience' | 'availability'} [orderTerms] 
         * @param {'male' | 'female' | 'transgender' | 'unknown'} [gender] 
         * @param {Array<string>} [therapyMethods] 
         * @param {Array<string>} [diseases] 
         * @param {string} [diseaseUrl] 
         * @param {string} [therapyMethodUrl] 
         * @param {number} [dayLimit] 
         * @param {boolean} [workWithLgbt] 
         * @param {boolean} [workWithEthnicGroups] 
         * @param {number} [workingExperience] 
         * @param {boolean} [isApproved] 
         * @param {string} [firstname] 
         * @param {string} [lastname] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>} [religions] 
         * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialisations] 
         * @param {boolean} [debug] 
         * @param {boolean} [childTherapists] 
         * @param {boolean} [adultTherapists] 
         * @param {boolean} [supervisorTherapists] 
         * @param {boolean} [b2bTherapists] 
         * @param {boolean} [coaches] 
         * @param {number} [childOld] 
         * @param {string} [therapistOld] Возраст терапевта должен быть в формате \&quot;20-34\&quot; или \&quot;45+\&quot;
         * @param {boolean} [demo] 
         * @param {boolean} [family] 
         * @param {'supporting' | 'guiding'} [workApproachGuidance] 
         * @param {'soft' | 'straight'} [workApproachInteraction] 
         * @param {'serious' | 'informal'} [workApproachConnection] 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerSearchRecommended: async (limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'price' | 'experience' | 'availability', gender?: 'male' | 'female' | 'transgender' | 'unknown', therapyMethods?: Array<string>, diseases?: Array<string>, diseaseUrl?: string, therapyMethodUrl?: string, dayLimit?: number, workWithLgbt?: boolean, workWithEthnicGroups?: boolean, workingExperience?: number, isApproved?: boolean, firstname?: string, lastname?: string, priceMin?: number, priceMax?: number, religions?: Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>, specialisations?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, debug?: boolean, childTherapists?: boolean, adultTherapists?: boolean, supervisorTherapists?: boolean, b2bTherapists?: boolean, coaches?: boolean, childOld?: number, therapistOld?: string, demo?: boolean, family?: boolean, workApproachGuidance?: 'supporting' | 'guiding', workApproachInteraction?: 'soft' | 'straight', workApproachConnection?: 'serious' | 'informal', isFavorite?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('therapistsControllerSearchRecommended', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('therapistsControllerSearchRecommended', 'page', page)
            const localVarPath = `/api/v1/therapists/search/recommended`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderTerms !== undefined) {
                localVarQueryParameter['orderTerms'] = orderTerms;
            }

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }

            if (therapyMethods) {
                localVarQueryParameter['therapyMethods'] = therapyMethods;
            }

            if (diseases) {
                localVarQueryParameter['diseases'] = diseases;
            }

            if (diseaseUrl !== undefined) {
                localVarQueryParameter['diseaseUrl'] = diseaseUrl;
            }

            if (therapyMethodUrl !== undefined) {
                localVarQueryParameter['therapyMethodUrl'] = therapyMethodUrl;
            }

            if (dayLimit !== undefined) {
                localVarQueryParameter['dayLimit'] = dayLimit;
            }

            if (workWithLgbt !== undefined) {
                localVarQueryParameter['workWithLgbt'] = workWithLgbt;
            }

            if (workWithEthnicGroups !== undefined) {
                localVarQueryParameter['workWithEthnicGroups'] = workWithEthnicGroups;
            }

            if (workingExperience !== undefined) {
                localVarQueryParameter['workingExperience'] = workingExperience;
            }

            if (isApproved !== undefined) {
                localVarQueryParameter['isApproved'] = isApproved;
            }

            if (firstname !== undefined) {
                localVarQueryParameter['firstname'] = firstname;
            }

            if (lastname !== undefined) {
                localVarQueryParameter['lastname'] = lastname;
            }

            if (priceMin !== undefined) {
                localVarQueryParameter['priceMin'] = priceMin;
            }

            if (priceMax !== undefined) {
                localVarQueryParameter['priceMax'] = priceMax;
            }

            if (religions) {
                localVarQueryParameter['religions'] = religions;
            }

            if (specialisations) {
                localVarQueryParameter['specialisations'] = specialisations;
            }

            if (debug !== undefined) {
                localVarQueryParameter['debug'] = debug;
            }

            if (childTherapists !== undefined) {
                localVarQueryParameter['childTherapists'] = childTherapists;
            }

            if (adultTherapists !== undefined) {
                localVarQueryParameter['adultTherapists'] = adultTherapists;
            }

            if (supervisorTherapists !== undefined) {
                localVarQueryParameter['supervisorTherapists'] = supervisorTherapists;
            }

            if (b2bTherapists !== undefined) {
                localVarQueryParameter['b2bTherapists'] = b2bTherapists;
            }

            if (coaches !== undefined) {
                localVarQueryParameter['coaches'] = coaches;
            }

            if (childOld !== undefined) {
                localVarQueryParameter['childOld'] = childOld;
            }

            if (therapistOld !== undefined) {
                localVarQueryParameter['therapistOld'] = therapistOld;
            }

            if (demo !== undefined) {
                localVarQueryParameter['demo'] = demo;
            }

            if (family !== undefined) {
                localVarQueryParameter['family'] = family;
            }

            if (workApproachGuidance !== undefined) {
                localVarQueryParameter['workApproachGuidance'] = workApproachGuidance;
            }

            if (workApproachInteraction !== undefined) {
                localVarQueryParameter['workApproachInteraction'] = workApproachInteraction;
            }

            if (workApproachConnection !== undefined) {
                localVarQueryParameter['workApproachConnection'] = workApproachConnection;
            }

            if (isFavorite !== undefined) {
                localVarQueryParameter['isFavorite'] = isFavorite;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerSetUrlForAllTherapists: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/therapists/set-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get therapist public info by URL
         * @param {string} therapistUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerTherapistPublicInfo: async (therapistUrl: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'therapistUrl' is not null or undefined
            assertParamExists('therapistsControllerTherapistPublicInfo', 'therapistUrl', therapistUrl)
            const localVarPath = `/api/v1/therapists/{therapistUrl}`
                .replace(`{${"therapistUrl"}}`, encodeURIComponent(String(therapistUrl)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unarchive patient and all sessions (only for therapist)
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerUnarchivePatient: async (patientId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('therapistsControllerUnarchivePatient', 'patientId', patientId)
            const localVarPath = `/api/v1/therapists/patients/{patientId}/unarchive`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update availability (only for therapist)
         * @param {string} availabilityId 
         * @param {UpdateAvailabilityRequestDto} updateAvailabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerUpdateAvailability: async (availabilityId: string, updateAvailabilityRequestDto: UpdateAvailabilityRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'availabilityId' is not null or undefined
            assertParamExists('therapistsControllerUpdateAvailability', 'availabilityId', availabilityId)
            // verify required parameter 'updateAvailabilityRequestDto' is not null or undefined
            assertParamExists('therapistsControllerUpdateAvailability', 'updateAvailabilityRequestDto', updateAvailabilityRequestDto)
            const localVarPath = `/api/v1/therapists/availability/{availabilityId}`
                .replace(`{${"availabilityId"}}`, encodeURIComponent(String(availabilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAvailabilityRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TherapistsApi - functional programming interface
 * @export
 */
export const TherapistsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TherapistsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add patient\'s note (only for therapist)
         * @param {string} patientId 
         * @param {TherapistPatientNoteRequestDto} therapistPatientNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistPatientNoteControllerAddNote(patientId: string, therapistPatientNoteRequestDto: TherapistPatientNoteRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapistPatientNoteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistPatientNoteControllerAddNote(patientId, therapistPatientNoteRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete patient note (only for therapist)
         * @param {string} patientId 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistPatientNoteControllerDeleteNote(patientId: string, noteId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistPatientNoteControllerDeleteNote(patientId, noteId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update patient note (only for therapist)
         * @param {string} patientId 
         * @param {string} noteId 
         * @param {TherapistPatientNoteRequestDto} therapistPatientNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistPatientNoteControllerEditNote(patientId: string, noteId: string, therapistPatientNoteRequestDto: TherapistPatientNoteRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapistPatientNoteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistPatientNoteControllerEditNote(patientId, noteId, therapistPatientNoteRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get patient\'s notes (only for therapist)
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistPatientNoteControllerGetPatientNotes(patientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TherapistPatientNoteResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistPatientNoteControllerGetPatientNotes(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get active supervisions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistSupervisionsControllerGetActiveSupervisions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisionsBaseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistSupervisionsControllerGetActiveSupervisions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get supervisions history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistSupervisionsControllerGetSupervisionsHistory(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupervisionsBaseResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistSupervisionsControllerGetSupervisionsHistory(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add therapist to favorites (only for patients)
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerAddTherapistToFavorites(therapistId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerAddTherapistToFavorites(therapistId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerAllTherapistsUrlsForSitemap(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerAllTherapistsUrlsForSitemap(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Archive patient and all sessions (only for therapist)
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerArchivePatient(patientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerArchivePatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create availability (only for therapists)
         * @param {CreateAvailabilitiesRequestDto} createAvailabilitiesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerCreateAvailability(createAvailabilitiesRequestDto: CreateAvailabilitiesRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilitiesCreateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerCreateAvailability(createAvailabilitiesRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete availability (only for therapist)
         * @param {string} availabilityId 
         * @param {DeleteAvailabilityRequestDto} deleteAvailabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerDeleteAvailability(availabilityId: string, deleteAvailabilityRequestDto: DeleteAvailabilityRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerDeleteAvailability(availabilityId, deleteAvailabilityRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete avatar (only for therapists)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerDeleteAvatar(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerDeleteAvatar(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete video (only for therapists)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerDeleteVideo(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerDeleteVideo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get therapist self info (only for therapists)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerFindOne(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicTherapistResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerFindOne(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get therapist url from therapist id
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerFindUrlById(therapistId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerFindUrlById(therapistId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get active sessions (only for therapists)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [patientName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerGetActiveSessions(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, patientName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSessionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerGetActiveSessions(limit, page, order, from, to, patientName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all therapists
         * @param {boolean} [debug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerGetAllTherapists(debug?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerGetAllTherapists(debug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get availabilities of therapists
         * @param {string} therapistId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerGetAvailability(therapistId: string, from?: string, to?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailabilitiesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerGetAvailability(therapistId, from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get history sessions (only for therapists)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [patientName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerGetHistorySessions(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, patientName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSessionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerGetHistorySessions(limit, page, order, from, to, patientName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create therapist create request (only for therapists)
         * @param {CreateTherapistProfileRequestDto} createTherapistProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerGetProfile(createTherapistProfileRequestDto: CreateTherapistProfileRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerGetProfile(createTherapistProfileRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get therapist schedule (only for therapists)
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerGetSchedule(from?: string, to?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapistScheduleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerGetSchedule(from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get tiny sessions (only for therapists)
         * @param {boolean} isActive 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerGetSessions(isActive: boolean, from?: string, to?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionsWithStartDate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerGetSessions(isActive, from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Search all supervisors
         * @param {number} limit 
         * @param {number} page 
         * @param {number} offset 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'price' | 'experience' | 'availability'} [orderTerms] 
         * @param {'male' | 'female' | 'transgender' | 'unknown'} [gender] 
         * @param {Array<string>} [therapyMethods] 
         * @param {Array<string>} [diseases] 
         * @param {string} [diseaseUrl] 
         * @param {string} [therapyMethodUrl] 
         * @param {number} [dayLimit] 
         * @param {boolean} [workWithLgbt] 
         * @param {boolean} [workWithEthnicGroups] 
         * @param {number} [workingExperience] 
         * @param {string} [firstname] 
         * @param {string} [lastname] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>} [religions] 
         * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialisations] 
         * @param {boolean} [debug] 
         * @param {boolean} [childTherapists] 
         * @param {boolean} [adultTherapists] 
         * @param {boolean} [supervisorTherapists] 
         * @param {boolean} [b2bTherapists] 
         * @param {boolean} [coaches] 
         * @param {number} [childOld] 
         * @param {string} [therapistOld] Возраст терапевта должен быть в формате \&quot;20-34\&quot; или \&quot;45+\&quot;
         * @param {boolean} [demo] 
         * @param {boolean} [family] 
         * @param {'supporting' | 'guiding'} [workApproachGuidance] 
         * @param {'soft' | 'straight'} [workApproachInteraction] 
         * @param {'serious' | 'informal'} [workApproachConnection] 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerGetSupervisors(limit: number, page: number, offset: number, order?: 'ASC' | 'DESC', orderTerms?: 'price' | 'experience' | 'availability', gender?: 'male' | 'female' | 'transgender' | 'unknown', therapyMethods?: Array<string>, diseases?: Array<string>, diseaseUrl?: string, therapyMethodUrl?: string, dayLimit?: number, workWithLgbt?: boolean, workWithEthnicGroups?: boolean, workingExperience?: number, firstname?: string, lastname?: string, priceMin?: number, priceMax?: number, religions?: Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>, specialisations?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, debug?: boolean, childTherapists?: boolean, adultTherapists?: boolean, supervisorTherapists?: boolean, b2bTherapists?: boolean, coaches?: boolean, childOld?: number, therapistOld?: string, demo?: boolean, family?: boolean, workApproachGuidance?: 'supporting' | 'guiding', workApproachInteraction?: 'soft' | 'straight', workApproachConnection?: 'serious' | 'informal', isFavorite?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicTherapistsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerGetSupervisors(limit, page, offset, order, orderTerms, gender, therapyMethods, diseases, diseaseUrl, therapyMethodUrl, dayLimit, workWithLgbt, workWithEthnicGroups, workingExperience, firstname, lastname, priceMin, priceMax, religions, specialisations, debug, childTherapists, adultTherapists, supervisorTherapists, b2bTherapists, coaches, childOld, therapistOld, demo, family, workApproachGuidance, workApproachInteraction, workApproachConnection, isFavorite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get therapist review list
         * @param {string} therapistId 
         * @param {number} limit 
         * @param {number} page 
         * @param {'rating' | 'createdAt'} orderTerms 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerGetTherapistReviews(therapistId: string, limit: number, page: number, orderTerms: 'rating' | 'createdAt', order?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapistReviewPaginationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerGetTherapistReviews(therapistId, limit, page, orderTerms, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all therapist patients (only for therapist)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'firstname' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate'} [orderTerms] 
         * @param {boolean} [archivedByTherapist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerPatientTherapists(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'firstname' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate', archivedByTherapist?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapistPatientsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerPatientTherapists(limit, page, order, orderTerms, archivedByTherapist, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject patient and cancel all sessions (only for therapist)
         * @param {string} patientId 
         * @param {RejectPatientRequestDto} rejectPatientRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerRejectPatient(patientId: string, rejectPatientRequestDto: RejectPatientRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerRejectPatient(patientId, rejectPatientRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove therapist from favorites (only for patients)
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerRemoveTherapistFromFavorites(therapistId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerRemoveTherapistFromFavorites(therapistId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request session from therapist through admins
         * @param {string} therapistId 
         * @param {RequestSessionRequestDto} requestSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerRequestTherapistSession(therapistId: string, requestSessionRequestDto: RequestSessionRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerRequestTherapistSession(therapistId, requestSessionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get therapist list by search filter
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'price' | 'experience' | 'availability'} [orderTerms] 
         * @param {'male' | 'female' | 'transgender' | 'unknown'} [gender] 
         * @param {Array<string>} [therapyMethods] 
         * @param {Array<string>} [diseases] 
         * @param {string} [diseaseUrl] 
         * @param {string} [therapyMethodUrl] 
         * @param {number} [dayLimit] 
         * @param {boolean} [workWithLgbt] 
         * @param {boolean} [workWithEthnicGroups] 
         * @param {number} [workingExperience] 
         * @param {boolean} [isApproved] 
         * @param {string} [firstname] 
         * @param {string} [lastname] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>} [religions] 
         * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialisations] 
         * @param {boolean} [debug] 
         * @param {boolean} [childTherapists] 
         * @param {boolean} [adultTherapists] 
         * @param {boolean} [supervisorTherapists] 
         * @param {boolean} [b2bTherapists] 
         * @param {boolean} [coaches] 
         * @param {number} [childOld] 
         * @param {string} [therapistOld] Возраст терапевта должен быть в формате \&quot;20-34\&quot; или \&quot;45+\&quot;
         * @param {boolean} [demo] 
         * @param {boolean} [family] 
         * @param {'supporting' | 'guiding'} [workApproachGuidance] 
         * @param {'soft' | 'straight'} [workApproachInteraction] 
         * @param {'serious' | 'informal'} [workApproachConnection] 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerSearch(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'price' | 'experience' | 'availability', gender?: 'male' | 'female' | 'transgender' | 'unknown', therapyMethods?: Array<string>, diseases?: Array<string>, diseaseUrl?: string, therapyMethodUrl?: string, dayLimit?: number, workWithLgbt?: boolean, workWithEthnicGroups?: boolean, workingExperience?: number, isApproved?: boolean, firstname?: string, lastname?: string, priceMin?: number, priceMax?: number, religions?: Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>, specialisations?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, debug?: boolean, childTherapists?: boolean, adultTherapists?: boolean, supervisorTherapists?: boolean, b2bTherapists?: boolean, coaches?: boolean, childOld?: number, therapistOld?: string, demo?: boolean, family?: boolean, workApproachGuidance?: 'supporting' | 'guiding', workApproachInteraction?: 'soft' | 'straight', workApproachConnection?: 'serious' | 'informal', isFavorite?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapistPaginationSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerSearch(limit, page, order, orderTerms, gender, therapyMethods, diseases, diseaseUrl, therapyMethodUrl, dayLimit, workWithLgbt, workWithEthnicGroups, workingExperience, isApproved, firstname, lastname, priceMin, priceMax, religions, specialisations, debug, childTherapists, adultTherapists, supervisorTherapists, b2bTherapists, coaches, childOld, therapistOld, demo, family, workApproachGuidance, workApproachInteraction, workApproachConnection, isFavorite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get therapist list by recommendation params (only for patients)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'price' | 'experience' | 'availability'} [orderTerms] 
         * @param {'male' | 'female' | 'transgender' | 'unknown'} [gender] 
         * @param {Array<string>} [therapyMethods] 
         * @param {Array<string>} [diseases] 
         * @param {string} [diseaseUrl] 
         * @param {string} [therapyMethodUrl] 
         * @param {number} [dayLimit] 
         * @param {boolean} [workWithLgbt] 
         * @param {boolean} [workWithEthnicGroups] 
         * @param {number} [workingExperience] 
         * @param {boolean} [isApproved] 
         * @param {string} [firstname] 
         * @param {string} [lastname] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>} [religions] 
         * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialisations] 
         * @param {boolean} [debug] 
         * @param {boolean} [childTherapists] 
         * @param {boolean} [adultTherapists] 
         * @param {boolean} [supervisorTherapists] 
         * @param {boolean} [b2bTherapists] 
         * @param {boolean} [coaches] 
         * @param {number} [childOld] 
         * @param {string} [therapistOld] Возраст терапевта должен быть в формате \&quot;20-34\&quot; или \&quot;45+\&quot;
         * @param {boolean} [demo] 
         * @param {boolean} [family] 
         * @param {'supporting' | 'guiding'} [workApproachGuidance] 
         * @param {'soft' | 'straight'} [workApproachInteraction] 
         * @param {'serious' | 'informal'} [workApproachConnection] 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerSearchRecommended(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'price' | 'experience' | 'availability', gender?: 'male' | 'female' | 'transgender' | 'unknown', therapyMethods?: Array<string>, diseases?: Array<string>, diseaseUrl?: string, therapyMethodUrl?: string, dayLimit?: number, workWithLgbt?: boolean, workWithEthnicGroups?: boolean, workingExperience?: number, isApproved?: boolean, firstname?: string, lastname?: string, priceMin?: number, priceMax?: number, religions?: Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>, specialisations?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, debug?: boolean, childTherapists?: boolean, adultTherapists?: boolean, supervisorTherapists?: boolean, b2bTherapists?: boolean, coaches?: boolean, childOld?: number, therapistOld?: string, demo?: boolean, family?: boolean, workApproachGuidance?: 'supporting' | 'guiding', workApproachInteraction?: 'soft' | 'straight', workApproachConnection?: 'serious' | 'informal', isFavorite?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TherapistPaginationSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerSearchRecommended(limit, page, order, orderTerms, gender, therapyMethods, diseases, diseaseUrl, therapyMethodUrl, dayLimit, workWithLgbt, workWithEthnicGroups, workingExperience, isApproved, firstname, lastname, priceMin, priceMax, religions, specialisations, debug, childTherapists, adultTherapists, supervisorTherapists, b2bTherapists, coaches, childOld, therapistOld, demo, family, workApproachGuidance, workApproachInteraction, workApproachConnection, isFavorite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerSetUrlForAllTherapists(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerSetUrlForAllTherapists(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get therapist public info by URL
         * @param {string} therapistUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerTherapistPublicInfo(therapistUrl: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicTherapistResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerTherapistPublicInfo(therapistUrl, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unarchive patient and all sessions (only for therapist)
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerUnarchivePatient(patientId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerUnarchivePatient(patientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update availability (only for therapist)
         * @param {string} availabilityId 
         * @param {UpdateAvailabilityRequestDto} updateAvailabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async therapistsControllerUpdateAvailability(availabilityId: string, updateAvailabilityRequestDto: UpdateAvailabilityRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.therapistsControllerUpdateAvailability(availabilityId, updateAvailabilityRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TherapistsApi - factory interface
 * @export
 */
export const TherapistsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TherapistsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add patient\'s note (only for therapist)
         * @param {string} patientId 
         * @param {TherapistPatientNoteRequestDto} therapistPatientNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistPatientNoteControllerAddNote(patientId: string, therapistPatientNoteRequestDto: TherapistPatientNoteRequestDto, options?: any): AxiosPromise<TherapistPatientNoteResponseDto> {
            return localVarFp.therapistPatientNoteControllerAddNote(patientId, therapistPatientNoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete patient note (only for therapist)
         * @param {string} patientId 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistPatientNoteControllerDeleteNote(patientId: string, noteId: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.therapistPatientNoteControllerDeleteNote(patientId, noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update patient note (only for therapist)
         * @param {string} patientId 
         * @param {string} noteId 
         * @param {TherapistPatientNoteRequestDto} therapistPatientNoteRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistPatientNoteControllerEditNote(patientId: string, noteId: string, therapistPatientNoteRequestDto: TherapistPatientNoteRequestDto, options?: any): AxiosPromise<TherapistPatientNoteResponseDto> {
            return localVarFp.therapistPatientNoteControllerEditNote(patientId, noteId, therapistPatientNoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get patient\'s notes (only for therapist)
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistPatientNoteControllerGetPatientNotes(patientId: string, options?: any): AxiosPromise<Array<TherapistPatientNoteResponseDto>> {
            return localVarFp.therapistPatientNoteControllerGetPatientNotes(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get active supervisions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistSupervisionsControllerGetActiveSupervisions(options?: any): AxiosPromise<SupervisionsBaseResponseDto> {
            return localVarFp.therapistSupervisionsControllerGetActiveSupervisions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get supervisions history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistSupervisionsControllerGetSupervisionsHistory(options?: any): AxiosPromise<SupervisionsBaseResponseDto> {
            return localVarFp.therapistSupervisionsControllerGetSupervisionsHistory(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add therapist to favorites (only for patients)
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerAddTherapistToFavorites(therapistId: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.therapistsControllerAddTherapistToFavorites(therapistId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerAllTherapistsUrlsForSitemap(options?: any): AxiosPromise<Array<object>> {
            return localVarFp.therapistsControllerAllTherapistsUrlsForSitemap(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Archive patient and all sessions (only for therapist)
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerArchivePatient(patientId: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.therapistsControllerArchivePatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create availability (only for therapists)
         * @param {CreateAvailabilitiesRequestDto} createAvailabilitiesRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerCreateAvailability(createAvailabilitiesRequestDto: CreateAvailabilitiesRequestDto, options?: any): AxiosPromise<AvailabilitiesCreateResponseDto> {
            return localVarFp.therapistsControllerCreateAvailability(createAvailabilitiesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete availability (only for therapist)
         * @param {string} availabilityId 
         * @param {DeleteAvailabilityRequestDto} deleteAvailabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerDeleteAvailability(availabilityId: string, deleteAvailabilityRequestDto: DeleteAvailabilityRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.therapistsControllerDeleteAvailability(availabilityId, deleteAvailabilityRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete avatar (only for therapists)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerDeleteAvatar(options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.therapistsControllerDeleteAvatar(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete video (only for therapists)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerDeleteVideo(options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.therapistsControllerDeleteVideo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get therapist self info (only for therapists)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerFindOne(options?: any): AxiosPromise<PublicTherapistResponseDto> {
            return localVarFp.therapistsControllerFindOne(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get therapist url from therapist id
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerFindUrlById(therapistId: string, options?: any): AxiosPromise<void> {
            return localVarFp.therapistsControllerFindUrlById(therapistId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get active sessions (only for therapists)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [patientName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetActiveSessions(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, patientName?: string, options?: any): AxiosPromise<PaginatedSessionResponseDto> {
            return localVarFp.therapistsControllerGetActiveSessions(limit, page, order, from, to, patientName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all therapists
         * @param {boolean} [debug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetAllTherapists(debug?: boolean, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.therapistsControllerGetAllTherapists(debug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get availabilities of therapists
         * @param {string} therapistId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetAvailability(therapistId: string, from?: string, to?: string, options?: any): AxiosPromise<AvailabilitiesResponseDto> {
            return localVarFp.therapistsControllerGetAvailability(therapistId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get history sessions (only for therapists)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {string} [patientName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetHistorySessions(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, patientName?: string, options?: any): AxiosPromise<PaginatedSessionResponseDto> {
            return localVarFp.therapistsControllerGetHistorySessions(limit, page, order, from, to, patientName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create therapist create request (only for therapists)
         * @param {CreateTherapistProfileRequestDto} createTherapistProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetProfile(createTherapistProfileRequestDto: CreateTherapistProfileRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.therapistsControllerGetProfile(createTherapistProfileRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get therapist schedule (only for therapists)
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetSchedule(from?: string, to?: string, options?: any): AxiosPromise<TherapistScheduleResponseDto> {
            return localVarFp.therapistsControllerGetSchedule(from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get tiny sessions (only for therapists)
         * @param {boolean} isActive 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetSessions(isActive: boolean, from?: string, to?: string, options?: any): AxiosPromise<SessionsWithStartDate> {
            return localVarFp.therapistsControllerGetSessions(isActive, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search all supervisors
         * @param {number} limit 
         * @param {number} page 
         * @param {number} offset 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'price' | 'experience' | 'availability'} [orderTerms] 
         * @param {'male' | 'female' | 'transgender' | 'unknown'} [gender] 
         * @param {Array<string>} [therapyMethods] 
         * @param {Array<string>} [diseases] 
         * @param {string} [diseaseUrl] 
         * @param {string} [therapyMethodUrl] 
         * @param {number} [dayLimit] 
         * @param {boolean} [workWithLgbt] 
         * @param {boolean} [workWithEthnicGroups] 
         * @param {number} [workingExperience] 
         * @param {string} [firstname] 
         * @param {string} [lastname] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>} [religions] 
         * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialisations] 
         * @param {boolean} [debug] 
         * @param {boolean} [childTherapists] 
         * @param {boolean} [adultTherapists] 
         * @param {boolean} [supervisorTherapists] 
         * @param {boolean} [b2bTherapists] 
         * @param {boolean} [coaches] 
         * @param {number} [childOld] 
         * @param {string} [therapistOld] Возраст терапевта должен быть в формате \&quot;20-34\&quot; или \&quot;45+\&quot;
         * @param {boolean} [demo] 
         * @param {boolean} [family] 
         * @param {'supporting' | 'guiding'} [workApproachGuidance] 
         * @param {'soft' | 'straight'} [workApproachInteraction] 
         * @param {'serious' | 'informal'} [workApproachConnection] 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetSupervisors(limit: number, page: number, offset: number, order?: 'ASC' | 'DESC', orderTerms?: 'price' | 'experience' | 'availability', gender?: 'male' | 'female' | 'transgender' | 'unknown', therapyMethods?: Array<string>, diseases?: Array<string>, diseaseUrl?: string, therapyMethodUrl?: string, dayLimit?: number, workWithLgbt?: boolean, workWithEthnicGroups?: boolean, workingExperience?: number, firstname?: string, lastname?: string, priceMin?: number, priceMax?: number, religions?: Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>, specialisations?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, debug?: boolean, childTherapists?: boolean, adultTherapists?: boolean, supervisorTherapists?: boolean, b2bTherapists?: boolean, coaches?: boolean, childOld?: number, therapistOld?: string, demo?: boolean, family?: boolean, workApproachGuidance?: 'supporting' | 'guiding', workApproachInteraction?: 'soft' | 'straight', workApproachConnection?: 'serious' | 'informal', isFavorite?: boolean, options?: any): AxiosPromise<PublicTherapistsResponseDto> {
            return localVarFp.therapistsControllerGetSupervisors(limit, page, offset, order, orderTerms, gender, therapyMethods, diseases, diseaseUrl, therapyMethodUrl, dayLimit, workWithLgbt, workWithEthnicGroups, workingExperience, firstname, lastname, priceMin, priceMax, religions, specialisations, debug, childTherapists, adultTherapists, supervisorTherapists, b2bTherapists, coaches, childOld, therapistOld, demo, family, workApproachGuidance, workApproachInteraction, workApproachConnection, isFavorite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get therapist review list
         * @param {string} therapistId 
         * @param {number} limit 
         * @param {number} page 
         * @param {'rating' | 'createdAt'} orderTerms 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerGetTherapistReviews(therapistId: string, limit: number, page: number, orderTerms: 'rating' | 'createdAt', order?: 'ASC' | 'DESC', options?: any): AxiosPromise<TherapistReviewPaginationResponseDto> {
            return localVarFp.therapistsControllerGetTherapistReviews(therapistId, limit, page, orderTerms, order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all therapist patients (only for therapist)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'firstname' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate'} [orderTerms] 
         * @param {boolean} [archivedByTherapist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerPatientTherapists(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'firstname' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate', archivedByTherapist?: boolean, options?: any): AxiosPromise<TherapistPatientsResponseDto> {
            return localVarFp.therapistsControllerPatientTherapists(limit, page, order, orderTerms, archivedByTherapist, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject patient and cancel all sessions (only for therapist)
         * @param {string} patientId 
         * @param {RejectPatientRequestDto} rejectPatientRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerRejectPatient(patientId: string, rejectPatientRequestDto: RejectPatientRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.therapistsControllerRejectPatient(patientId, rejectPatientRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove therapist from favorites (only for patients)
         * @param {string} therapistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerRemoveTherapistFromFavorites(therapistId: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.therapistsControllerRemoveTherapistFromFavorites(therapistId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request session from therapist through admins
         * @param {string} therapistId 
         * @param {RequestSessionRequestDto} requestSessionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerRequestTherapistSession(therapistId: string, requestSessionRequestDto: RequestSessionRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.therapistsControllerRequestTherapistSession(therapistId, requestSessionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get therapist list by search filter
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'price' | 'experience' | 'availability'} [orderTerms] 
         * @param {'male' | 'female' | 'transgender' | 'unknown'} [gender] 
         * @param {Array<string>} [therapyMethods] 
         * @param {Array<string>} [diseases] 
         * @param {string} [diseaseUrl] 
         * @param {string} [therapyMethodUrl] 
         * @param {number} [dayLimit] 
         * @param {boolean} [workWithLgbt] 
         * @param {boolean} [workWithEthnicGroups] 
         * @param {number} [workingExperience] 
         * @param {boolean} [isApproved] 
         * @param {string} [firstname] 
         * @param {string} [lastname] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>} [religions] 
         * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialisations] 
         * @param {boolean} [debug] 
         * @param {boolean} [childTherapists] 
         * @param {boolean} [adultTherapists] 
         * @param {boolean} [supervisorTherapists] 
         * @param {boolean} [b2bTherapists] 
         * @param {boolean} [coaches] 
         * @param {number} [childOld] 
         * @param {string} [therapistOld] Возраст терапевта должен быть в формате \&quot;20-34\&quot; или \&quot;45+\&quot;
         * @param {boolean} [demo] 
         * @param {boolean} [family] 
         * @param {'supporting' | 'guiding'} [workApproachGuidance] 
         * @param {'soft' | 'straight'} [workApproachInteraction] 
         * @param {'serious' | 'informal'} [workApproachConnection] 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerSearch(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'price' | 'experience' | 'availability', gender?: 'male' | 'female' | 'transgender' | 'unknown', therapyMethods?: Array<string>, diseases?: Array<string>, diseaseUrl?: string, therapyMethodUrl?: string, dayLimit?: number, workWithLgbt?: boolean, workWithEthnicGroups?: boolean, workingExperience?: number, isApproved?: boolean, firstname?: string, lastname?: string, priceMin?: number, priceMax?: number, religions?: Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>, specialisations?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, debug?: boolean, childTherapists?: boolean, adultTherapists?: boolean, supervisorTherapists?: boolean, b2bTherapists?: boolean, coaches?: boolean, childOld?: number, therapistOld?: string, demo?: boolean, family?: boolean, workApproachGuidance?: 'supporting' | 'guiding', workApproachInteraction?: 'soft' | 'straight', workApproachConnection?: 'serious' | 'informal', isFavorite?: boolean, options?: any): AxiosPromise<TherapistPaginationSearchResponseDto> {
            return localVarFp.therapistsControllerSearch(limit, page, order, orderTerms, gender, therapyMethods, diseases, diseaseUrl, therapyMethodUrl, dayLimit, workWithLgbt, workWithEthnicGroups, workingExperience, isApproved, firstname, lastname, priceMin, priceMax, religions, specialisations, debug, childTherapists, adultTherapists, supervisorTherapists, b2bTherapists, coaches, childOld, therapistOld, demo, family, workApproachGuidance, workApproachInteraction, workApproachConnection, isFavorite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get therapist list by recommendation params (only for patients)
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {'price' | 'experience' | 'availability'} [orderTerms] 
         * @param {'male' | 'female' | 'transgender' | 'unknown'} [gender] 
         * @param {Array<string>} [therapyMethods] 
         * @param {Array<string>} [diseases] 
         * @param {string} [diseaseUrl] 
         * @param {string} [therapyMethodUrl] 
         * @param {number} [dayLimit] 
         * @param {boolean} [workWithLgbt] 
         * @param {boolean} [workWithEthnicGroups] 
         * @param {number} [workingExperience] 
         * @param {boolean} [isApproved] 
         * @param {string} [firstname] 
         * @param {string} [lastname] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>} [religions] 
         * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialisations] 
         * @param {boolean} [debug] 
         * @param {boolean} [childTherapists] 
         * @param {boolean} [adultTherapists] 
         * @param {boolean} [supervisorTherapists] 
         * @param {boolean} [b2bTherapists] 
         * @param {boolean} [coaches] 
         * @param {number} [childOld] 
         * @param {string} [therapistOld] Возраст терапевта должен быть в формате \&quot;20-34\&quot; или \&quot;45+\&quot;
         * @param {boolean} [demo] 
         * @param {boolean} [family] 
         * @param {'supporting' | 'guiding'} [workApproachGuidance] 
         * @param {'soft' | 'straight'} [workApproachInteraction] 
         * @param {'serious' | 'informal'} [workApproachConnection] 
         * @param {boolean} [isFavorite] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerSearchRecommended(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'price' | 'experience' | 'availability', gender?: 'male' | 'female' | 'transgender' | 'unknown', therapyMethods?: Array<string>, diseases?: Array<string>, diseaseUrl?: string, therapyMethodUrl?: string, dayLimit?: number, workWithLgbt?: boolean, workWithEthnicGroups?: boolean, workingExperience?: number, isApproved?: boolean, firstname?: string, lastname?: string, priceMin?: number, priceMax?: number, religions?: Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>, specialisations?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, debug?: boolean, childTherapists?: boolean, adultTherapists?: boolean, supervisorTherapists?: boolean, b2bTherapists?: boolean, coaches?: boolean, childOld?: number, therapistOld?: string, demo?: boolean, family?: boolean, workApproachGuidance?: 'supporting' | 'guiding', workApproachInteraction?: 'soft' | 'straight', workApproachConnection?: 'serious' | 'informal', isFavorite?: boolean, options?: any): AxiosPromise<TherapistPaginationSearchResponseDto> {
            return localVarFp.therapistsControllerSearchRecommended(limit, page, order, orderTerms, gender, therapyMethods, diseases, diseaseUrl, therapyMethodUrl, dayLimit, workWithLgbt, workWithEthnicGroups, workingExperience, isApproved, firstname, lastname, priceMin, priceMax, religions, specialisations, debug, childTherapists, adultTherapists, supervisorTherapists, b2bTherapists, coaches, childOld, therapistOld, demo, family, workApproachGuidance, workApproachInteraction, workApproachConnection, isFavorite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerSetUrlForAllTherapists(options?: any): AxiosPromise<void> {
            return localVarFp.therapistsControllerSetUrlForAllTherapists(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get therapist public info by URL
         * @param {string} therapistUrl 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerTherapistPublicInfo(therapistUrl: string, options?: any): AxiosPromise<PublicTherapistResponseDto> {
            return localVarFp.therapistsControllerTherapistPublicInfo(therapistUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unarchive patient and all sessions (only for therapist)
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerUnarchivePatient(patientId: string, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.therapistsControllerUnarchivePatient(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update availability (only for therapist)
         * @param {string} availabilityId 
         * @param {UpdateAvailabilityRequestDto} updateAvailabilityRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        therapistsControllerUpdateAvailability(availabilityId: string, updateAvailabilityRequestDto: UpdateAvailabilityRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.therapistsControllerUpdateAvailability(availabilityId, updateAvailabilityRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TherapistsApi - object-oriented interface
 * @export
 * @class TherapistsApi
 * @extends {BaseAPI}
 */
export class TherapistsApi extends BaseAPI {
    /**
     * 
     * @summary Add patient\'s note (only for therapist)
     * @param {string} patientId 
     * @param {TherapistPatientNoteRequestDto} therapistPatientNoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistPatientNoteControllerAddNote(patientId: string, therapistPatientNoteRequestDto: TherapistPatientNoteRequestDto, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistPatientNoteControllerAddNote(patientId, therapistPatientNoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete patient note (only for therapist)
     * @param {string} patientId 
     * @param {string} noteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistPatientNoteControllerDeleteNote(patientId: string, noteId: string, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistPatientNoteControllerDeleteNote(patientId, noteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update patient note (only for therapist)
     * @param {string} patientId 
     * @param {string} noteId 
     * @param {TherapistPatientNoteRequestDto} therapistPatientNoteRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistPatientNoteControllerEditNote(patientId: string, noteId: string, therapistPatientNoteRequestDto: TherapistPatientNoteRequestDto, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistPatientNoteControllerEditNote(patientId, noteId, therapistPatientNoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get patient\'s notes (only for therapist)
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistPatientNoteControllerGetPatientNotes(patientId: string, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistPatientNoteControllerGetPatientNotes(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get active supervisions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistSupervisionsControllerGetActiveSupervisions(options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistSupervisionsControllerGetActiveSupervisions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get supervisions history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistSupervisionsControllerGetSupervisionsHistory(options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistSupervisionsControllerGetSupervisionsHistory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add therapist to favorites (only for patients)
     * @param {string} therapistId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerAddTherapistToFavorites(therapistId: string, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerAddTherapistToFavorites(therapistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerAllTherapistsUrlsForSitemap(options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerAllTherapistsUrlsForSitemap(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Archive patient and all sessions (only for therapist)
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerArchivePatient(patientId: string, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerArchivePatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create availability (only for therapists)
     * @param {CreateAvailabilitiesRequestDto} createAvailabilitiesRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerCreateAvailability(createAvailabilitiesRequestDto: CreateAvailabilitiesRequestDto, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerCreateAvailability(createAvailabilitiesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete availability (only for therapist)
     * @param {string} availabilityId 
     * @param {DeleteAvailabilityRequestDto} deleteAvailabilityRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerDeleteAvailability(availabilityId: string, deleteAvailabilityRequestDto: DeleteAvailabilityRequestDto, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerDeleteAvailability(availabilityId, deleteAvailabilityRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete avatar (only for therapists)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerDeleteAvatar(options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerDeleteAvatar(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete video (only for therapists)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerDeleteVideo(options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerDeleteVideo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get therapist self info (only for therapists)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerFindOne(options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerFindOne(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get therapist url from therapist id
     * @param {string} therapistId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerFindUrlById(therapistId: string, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerFindUrlById(therapistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get active sessions (only for therapists)
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [patientName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerGetActiveSessions(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, patientName?: string, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerGetActiveSessions(limit, page, order, from, to, patientName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all therapists
     * @param {boolean} [debug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerGetAllTherapists(debug?: boolean, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerGetAllTherapists(debug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get availabilities of therapists
     * @param {string} therapistId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerGetAvailability(therapistId: string, from?: string, to?: string, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerGetAvailability(therapistId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get history sessions (only for therapists)
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {string} [patientName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerGetHistorySessions(limit: number, page: number, order?: 'ASC' | 'DESC', from?: string, to?: string, patientName?: string, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerGetHistorySessions(limit, page, order, from, to, patientName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create therapist create request (only for therapists)
     * @param {CreateTherapistProfileRequestDto} createTherapistProfileRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerGetProfile(createTherapistProfileRequestDto: CreateTherapistProfileRequestDto, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerGetProfile(createTherapistProfileRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get therapist schedule (only for therapists)
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerGetSchedule(from?: string, to?: string, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerGetSchedule(from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get tiny sessions (only for therapists)
     * @param {boolean} isActive 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerGetSessions(isActive: boolean, from?: string, to?: string, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerGetSessions(isActive, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search all supervisors
     * @param {number} limit 
     * @param {number} page 
     * @param {number} offset 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'price' | 'experience' | 'availability'} [orderTerms] 
     * @param {'male' | 'female' | 'transgender' | 'unknown'} [gender] 
     * @param {Array<string>} [therapyMethods] 
     * @param {Array<string>} [diseases] 
     * @param {string} [diseaseUrl] 
     * @param {string} [therapyMethodUrl] 
     * @param {number} [dayLimit] 
     * @param {boolean} [workWithLgbt] 
     * @param {boolean} [workWithEthnicGroups] 
     * @param {number} [workingExperience] 
     * @param {string} [firstname] 
     * @param {string} [lastname] 
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>} [religions] 
     * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialisations] 
     * @param {boolean} [debug] 
     * @param {boolean} [childTherapists] 
     * @param {boolean} [adultTherapists] 
     * @param {boolean} [supervisorTherapists] 
     * @param {boolean} [b2bTherapists] 
     * @param {boolean} [coaches] 
     * @param {number} [childOld] 
     * @param {string} [therapistOld] Возраст терапевта должен быть в формате \&quot;20-34\&quot; или \&quot;45+\&quot;
     * @param {boolean} [demo] 
     * @param {boolean} [family] 
     * @param {'supporting' | 'guiding'} [workApproachGuidance] 
     * @param {'soft' | 'straight'} [workApproachInteraction] 
     * @param {'serious' | 'informal'} [workApproachConnection] 
     * @param {boolean} [isFavorite] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerGetSupervisors(limit: number, page: number, offset: number, order?: 'ASC' | 'DESC', orderTerms?: 'price' | 'experience' | 'availability', gender?: 'male' | 'female' | 'transgender' | 'unknown', therapyMethods?: Array<string>, diseases?: Array<string>, diseaseUrl?: string, therapyMethodUrl?: string, dayLimit?: number, workWithLgbt?: boolean, workWithEthnicGroups?: boolean, workingExperience?: number, firstname?: string, lastname?: string, priceMin?: number, priceMax?: number, religions?: Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>, specialisations?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, debug?: boolean, childTherapists?: boolean, adultTherapists?: boolean, supervisorTherapists?: boolean, b2bTherapists?: boolean, coaches?: boolean, childOld?: number, therapistOld?: string, demo?: boolean, family?: boolean, workApproachGuidance?: 'supporting' | 'guiding', workApproachInteraction?: 'soft' | 'straight', workApproachConnection?: 'serious' | 'informal', isFavorite?: boolean, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerGetSupervisors(limit, page, offset, order, orderTerms, gender, therapyMethods, diseases, diseaseUrl, therapyMethodUrl, dayLimit, workWithLgbt, workWithEthnicGroups, workingExperience, firstname, lastname, priceMin, priceMax, religions, specialisations, debug, childTherapists, adultTherapists, supervisorTherapists, b2bTherapists, coaches, childOld, therapistOld, demo, family, workApproachGuidance, workApproachInteraction, workApproachConnection, isFavorite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get therapist review list
     * @param {string} therapistId 
     * @param {number} limit 
     * @param {number} page 
     * @param {'rating' | 'createdAt'} orderTerms 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerGetTherapistReviews(therapistId: string, limit: number, page: number, orderTerms: 'rating' | 'createdAt', order?: 'ASC' | 'DESC', options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerGetTherapistReviews(therapistId, limit, page, orderTerms, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all therapist patients (only for therapist)
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'firstname' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate'} [orderTerms] 
     * @param {boolean} [archivedByTherapist] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerPatientTherapists(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'firstname' | 'totalSessions' | 'firstSessionDate' | 'lastSessionDate', archivedByTherapist?: boolean, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerPatientTherapists(limit, page, order, orderTerms, archivedByTherapist, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject patient and cancel all sessions (only for therapist)
     * @param {string} patientId 
     * @param {RejectPatientRequestDto} rejectPatientRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerRejectPatient(patientId: string, rejectPatientRequestDto: RejectPatientRequestDto, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerRejectPatient(patientId, rejectPatientRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove therapist from favorites (only for patients)
     * @param {string} therapistId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerRemoveTherapistFromFavorites(therapistId: string, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerRemoveTherapistFromFavorites(therapistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request session from therapist through admins
     * @param {string} therapistId 
     * @param {RequestSessionRequestDto} requestSessionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerRequestTherapistSession(therapistId: string, requestSessionRequestDto: RequestSessionRequestDto, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerRequestTherapistSession(therapistId, requestSessionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get therapist list by search filter
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'price' | 'experience' | 'availability'} [orderTerms] 
     * @param {'male' | 'female' | 'transgender' | 'unknown'} [gender] 
     * @param {Array<string>} [therapyMethods] 
     * @param {Array<string>} [diseases] 
     * @param {string} [diseaseUrl] 
     * @param {string} [therapyMethodUrl] 
     * @param {number} [dayLimit] 
     * @param {boolean} [workWithLgbt] 
     * @param {boolean} [workWithEthnicGroups] 
     * @param {number} [workingExperience] 
     * @param {boolean} [isApproved] 
     * @param {string} [firstname] 
     * @param {string} [lastname] 
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>} [religions] 
     * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialisations] 
     * @param {boolean} [debug] 
     * @param {boolean} [childTherapists] 
     * @param {boolean} [adultTherapists] 
     * @param {boolean} [supervisorTherapists] 
     * @param {boolean} [b2bTherapists] 
     * @param {boolean} [coaches] 
     * @param {number} [childOld] 
     * @param {string} [therapistOld] Возраст терапевта должен быть в формате \&quot;20-34\&quot; или \&quot;45+\&quot;
     * @param {boolean} [demo] 
     * @param {boolean} [family] 
     * @param {'supporting' | 'guiding'} [workApproachGuidance] 
     * @param {'soft' | 'straight'} [workApproachInteraction] 
     * @param {'serious' | 'informal'} [workApproachConnection] 
     * @param {boolean} [isFavorite] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerSearch(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'price' | 'experience' | 'availability', gender?: 'male' | 'female' | 'transgender' | 'unknown', therapyMethods?: Array<string>, diseases?: Array<string>, diseaseUrl?: string, therapyMethodUrl?: string, dayLimit?: number, workWithLgbt?: boolean, workWithEthnicGroups?: boolean, workingExperience?: number, isApproved?: boolean, firstname?: string, lastname?: string, priceMin?: number, priceMax?: number, religions?: Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>, specialisations?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, debug?: boolean, childTherapists?: boolean, adultTherapists?: boolean, supervisorTherapists?: boolean, b2bTherapists?: boolean, coaches?: boolean, childOld?: number, therapistOld?: string, demo?: boolean, family?: boolean, workApproachGuidance?: 'supporting' | 'guiding', workApproachInteraction?: 'soft' | 'straight', workApproachConnection?: 'serious' | 'informal', isFavorite?: boolean, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerSearch(limit, page, order, orderTerms, gender, therapyMethods, diseases, diseaseUrl, therapyMethodUrl, dayLimit, workWithLgbt, workWithEthnicGroups, workingExperience, isApproved, firstname, lastname, priceMin, priceMax, religions, specialisations, debug, childTherapists, adultTherapists, supervisorTherapists, b2bTherapists, coaches, childOld, therapistOld, demo, family, workApproachGuidance, workApproachInteraction, workApproachConnection, isFavorite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get therapist list by recommendation params (only for patients)
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {'price' | 'experience' | 'availability'} [orderTerms] 
     * @param {'male' | 'female' | 'transgender' | 'unknown'} [gender] 
     * @param {Array<string>} [therapyMethods] 
     * @param {Array<string>} [diseases] 
     * @param {string} [diseaseUrl] 
     * @param {string} [therapyMethodUrl] 
     * @param {number} [dayLimit] 
     * @param {boolean} [workWithLgbt] 
     * @param {boolean} [workWithEthnicGroups] 
     * @param {number} [workingExperience] 
     * @param {boolean} [isApproved] 
     * @param {string} [firstname] 
     * @param {string} [lastname] 
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>} [religions] 
     * @param {Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>} [specialisations] 
     * @param {boolean} [debug] 
     * @param {boolean} [childTherapists] 
     * @param {boolean} [adultTherapists] 
     * @param {boolean} [supervisorTherapists] 
     * @param {boolean} [b2bTherapists] 
     * @param {boolean} [coaches] 
     * @param {number} [childOld] 
     * @param {string} [therapistOld] Возраст терапевта должен быть в формате \&quot;20-34\&quot; или \&quot;45+\&quot;
     * @param {boolean} [demo] 
     * @param {boolean} [family] 
     * @param {'supporting' | 'guiding'} [workApproachGuidance] 
     * @param {'soft' | 'straight'} [workApproachInteraction] 
     * @param {'serious' | 'informal'} [workApproachConnection] 
     * @param {boolean} [isFavorite] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerSearchRecommended(limit: number, page: number, order?: 'ASC' | 'DESC', orderTerms?: 'price' | 'experience' | 'availability', gender?: 'male' | 'female' | 'transgender' | 'unknown', therapyMethods?: Array<string>, diseases?: Array<string>, diseaseUrl?: string, therapyMethodUrl?: string, dayLimit?: number, workWithLgbt?: boolean, workWithEthnicGroups?: boolean, workingExperience?: number, isApproved?: boolean, firstname?: string, lastname?: string, priceMin?: number, priceMax?: number, religions?: Array<'christianity' | 'islamism' | 'judaism' | 'buddhism'>, specialisations?: Array<'unspecified' | 'psychologist' | 'psychoanalyst' | 'coach' | 'supervisor' | 'clinical_psychologist' | 'sexologist'>, debug?: boolean, childTherapists?: boolean, adultTherapists?: boolean, supervisorTherapists?: boolean, b2bTherapists?: boolean, coaches?: boolean, childOld?: number, therapistOld?: string, demo?: boolean, family?: boolean, workApproachGuidance?: 'supporting' | 'guiding', workApproachInteraction?: 'soft' | 'straight', workApproachConnection?: 'serious' | 'informal', isFavorite?: boolean, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerSearchRecommended(limit, page, order, orderTerms, gender, therapyMethods, diseases, diseaseUrl, therapyMethodUrl, dayLimit, workWithLgbt, workWithEthnicGroups, workingExperience, isApproved, firstname, lastname, priceMin, priceMax, religions, specialisations, debug, childTherapists, adultTherapists, supervisorTherapists, b2bTherapists, coaches, childOld, therapistOld, demo, family, workApproachGuidance, workApproachInteraction, workApproachConnection, isFavorite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerSetUrlForAllTherapists(options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerSetUrlForAllTherapists(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get therapist public info by URL
     * @param {string} therapistUrl 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerTherapistPublicInfo(therapistUrl: string, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerTherapistPublicInfo(therapistUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unarchive patient and all sessions (only for therapist)
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerUnarchivePatient(patientId: string, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerUnarchivePatient(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update availability (only for therapist)
     * @param {string} availabilityId 
     * @param {UpdateAvailabilityRequestDto} updateAvailabilityRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TherapistsApi
     */
    public therapistsControllerUpdateAvailability(availabilityId: string, updateAvailabilityRequestDto: UpdateAvailabilityRequestDto, options?: AxiosRequestConfig) {
        return TherapistsApiFp(this.configuration).therapistsControllerUpdateAvailability(availabilityId, updateAvailabilityRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserNotificationsApi - axios parameter creator
 * @export
 */
export const UserNotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Clear all notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerClearAll: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Clear notification by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerClearOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('notificationsControllerClearOne', 'id', id)
            const localVarPath = `/api/v1/notifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user notifications, order by popUpDate
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerGetNotifications: async (limit: number, page: number, order?: 'ASC' | 'DESC', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('notificationsControllerGetNotifications', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('notificationsControllerGetNotifications', 'page', page)
            const localVarPath = `/api/v1/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark all user notifications as viewed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerMarkNotificationsAsViewed: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserNotificationsApi - functional programming interface
 * @export
 */
export const UserNotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserNotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Clear all notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsControllerClearAll(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsControllerClearAll(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Clear notification by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsControllerClearOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsControllerClearOne(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user notifications, order by popUpDate
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsControllerGetNotifications(limit: number, page: number, order?: 'ASC' | 'DESC', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsControllerGetNotifications(limit, page, order, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Mark all user notifications as viewed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsControllerMarkNotificationsAsViewed(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsControllerMarkNotificationsAsViewed(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserNotificationsApi - factory interface
 * @export
 */
export const UserNotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserNotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Clear all notifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerClearAll(options?: any): AxiosPromise<void> {
            return localVarFp.notificationsControllerClearAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Clear notification by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerClearOne(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.notificationsControllerClearOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user notifications, order by popUpDate
         * @param {number} limit 
         * @param {number} page 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerGetNotifications(limit: number, page: number, order?: 'ASC' | 'DESC', options?: any): AxiosPromise<NotificationsResponseDto> {
            return localVarFp.notificationsControllerGetNotifications(limit, page, order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark all user notifications as viewed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerMarkNotificationsAsViewed(options?: any): AxiosPromise<number> {
            return localVarFp.notificationsControllerMarkNotificationsAsViewed(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserNotificationsApi - object-oriented interface
 * @export
 * @class UserNotificationsApi
 * @extends {BaseAPI}
 */
export class UserNotificationsApi extends BaseAPI {
    /**
     * 
     * @summary Clear all notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationsApi
     */
    public notificationsControllerClearAll(options?: AxiosRequestConfig) {
        return UserNotificationsApiFp(this.configuration).notificationsControllerClearAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Clear notification by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationsApi
     */
    public notificationsControllerClearOne(id: string, options?: AxiosRequestConfig) {
        return UserNotificationsApiFp(this.configuration).notificationsControllerClearOne(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user notifications, order by popUpDate
     * @param {number} limit 
     * @param {number} page 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationsApi
     */
    public notificationsControllerGetNotifications(limit: number, page: number, order?: 'ASC' | 'DESC', options?: AxiosRequestConfig) {
        return UserNotificationsApiFp(this.configuration).notificationsControllerGetNotifications(limit, page, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark all user notifications as viewed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationsApi
     */
    public notificationsControllerMarkNotificationsAsViewed(options?: AxiosRequestConfig) {
        return UserNotificationsApiFp(this.configuration).notificationsControllerMarkNotificationsAsViewed(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Close modal for user
         * @param {CloseSessionModalRequestDto} closeSessionModalRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerCloseSessionModal: async (closeSessionModalRequestDto: CloseSessionModalRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'closeSessionModalRequestDto' is not null or undefined
            assertParamExists('usersControllerCloseSessionModal', 'closeSessionModalRequestDto', closeSessionModalRequestDto)
            const localVarPath = `/api/v1/users/close-session-modal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(closeSessionModalRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerDelete: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get self information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerFindOne: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get required to complete modals for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetRequiredModals: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/get-required-modals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update notification time
         * @param {UpdateNotificationTimeRequestDto} updateNotificationTimeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdateNotifications: async (updateNotificationTimeRequestDto: UpdateNotificationTimeRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateNotificationTimeRequestDto' is not null or undefined
            assertParamExists('usersControllerUpdateNotifications', 'updateNotificationTimeRequestDto', updateNotificationTimeRequestDto)
            const localVarPath = `/api/v1/users/notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationTimeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Close modal for user
         * @param {CloseSessionModalRequestDto} closeSessionModalRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerCloseSessionModal(closeSessionModalRequestDto: CloseSessionModalRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageSuccessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerCloseSessionModal(closeSessionModalRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerDelete(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerDelete(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get self information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerFindOne(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserWithMetadataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerFindOne(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get required to complete modals for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerGetRequiredModals(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RequiredModalsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerGetRequiredModals(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update notification time
         * @param {UpdateNotificationTimeRequestDto} updateNotificationTimeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerUpdateNotifications(updateNotificationTimeRequestDto: UpdateNotificationTimeRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationTimeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerUpdateNotifications(updateNotificationTimeRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Close modal for user
         * @param {CloseSessionModalRequestDto} closeSessionModalRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerCloseSessionModal(closeSessionModalRequestDto: CloseSessionModalRequestDto, options?: any): AxiosPromise<MessageSuccessResponseDto> {
            return localVarFp.usersControllerCloseSessionModal(closeSessionModalRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerDelete(options?: any): AxiosPromise<UserResponseDto> {
            return localVarFp.usersControllerDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get self information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerFindOne(options?: any): AxiosPromise<UserWithMetadataResponseDto> {
            return localVarFp.usersControllerFindOne(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get required to complete modals for user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetRequiredModals(options?: any): AxiosPromise<RequiredModalsResponseDto> {
            return localVarFp.usersControllerGetRequiredModals(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update notification time
         * @param {UpdateNotificationTimeRequestDto} updateNotificationTimeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdateNotifications(updateNotificationTimeRequestDto: UpdateNotificationTimeRequestDto, options?: any): AxiosPromise<NotificationTimeResponseDto> {
            return localVarFp.usersControllerUpdateNotifications(updateNotificationTimeRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary Close modal for user
     * @param {CloseSessionModalRequestDto} closeSessionModalRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerCloseSessionModal(closeSessionModalRequestDto: CloseSessionModalRequestDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerCloseSessionModal(closeSessionModalRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerDelete(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get self information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerFindOne(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerFindOne(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get required to complete modals for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerGetRequiredModals(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerGetRequiredModals(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update notification time
     * @param {UpdateNotificationTimeRequestDto} updateNotificationTimeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerUpdateNotifications(updateNotificationTimeRequestDto: UpdateNotificationTimeRequestDto, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerUpdateNotifications(updateNotificationTimeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1PusherApi - axios parameter creator
 * @export
 */
export const V1PusherApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Auth for presence and private pusher channels
         * @param {PusherAuthRequestDto} pusherAuthRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pusherControllerAuthenticate: async (pusherAuthRequestDto: PusherAuthRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pusherAuthRequestDto' is not null or undefined
            assertParamExists('pusherControllerAuthenticate', 'pusherAuthRequestDto', pusherAuthRequestDto)
            const localVarPath = `/api/v1/pusher/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pusherAuthRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1PusherApi - functional programming interface
 * @export
 */
export const V1PusherApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1PusherApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Auth for presence and private pusher channels
         * @param {PusherAuthRequestDto} pusherAuthRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pusherControllerAuthenticate(pusherAuthRequestDto: PusherAuthRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PusherAuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pusherControllerAuthenticate(pusherAuthRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1PusherApi - factory interface
 * @export
 */
export const V1PusherApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1PusherApiFp(configuration)
    return {
        /**
         * 
         * @summary Auth for presence and private pusher channels
         * @param {PusherAuthRequestDto} pusherAuthRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pusherControllerAuthenticate(pusherAuthRequestDto: PusherAuthRequestDto, options?: any): AxiosPromise<PusherAuthResponseDto> {
            return localVarFp.pusherControllerAuthenticate(pusherAuthRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1PusherApi - object-oriented interface
 * @export
 * @class V1PusherApi
 * @extends {BaseAPI}
 */
export class V1PusherApi extends BaseAPI {
    /**
     * 
     * @summary Auth for presence and private pusher channels
     * @param {PusherAuthRequestDto} pusherAuthRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1PusherApi
     */
    public pusherControllerAuthenticate(pusherAuthRequestDto: PusherAuthRequestDto, options?: AxiosRequestConfig) {
        return V1PusherApiFp(this.configuration).pusherControllerAuthenticate(pusherAuthRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WebhookAmoApi - axios parameter creator
 * @export
 */
export const WebhookAmoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create mail subscription
         * @param {CreateMailSubscriptionRequestDto} createMailSubscriptionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookAmoControllerCreateMailSubscription: async (createMailSubscriptionRequestDto: CreateMailSubscriptionRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMailSubscriptionRequestDto' is not null or undefined
            assertParamExists('webhookAmoControllerCreateMailSubscription', 'createMailSubscriptionRequestDto', createMailSubscriptionRequestDto)
            const localVarPath = `/api/v1/webhook-amo/subscriptions/mail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMailSubscriptionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sent consultations ticket for married couple
         * @param {CreateMarriedCoupleConsultationTicketRequestDto} createMarriedCoupleConsultationTicketRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookAmoControllerCreateMarriedCoupleConsultationTicket: async (createMarriedCoupleConsultationTicketRequestDto: CreateMarriedCoupleConsultationTicketRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMarriedCoupleConsultationTicketRequestDto' is not null or undefined
            assertParamExists('webhookAmoControllerCreateMarriedCoupleConsultationTicket', 'createMarriedCoupleConsultationTicketRequestDto', createMarriedCoupleConsultationTicketRequestDto)
            const localVarPath = `/api/v1/webhook-amo/tickets/consultations/married-couple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMarriedCoupleConsultationTicketRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User sent form in Pogovorim.MIR
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookAmoControllerMirUserSentForm: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/webhook-amo/mir-user-sent-form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send contact from main page
         * @param {SendContactRequestDto} sendContactRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookAmoControllerSendContact: async (sendContactRequestDto: SendContactRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendContactRequestDto' is not null or undefined
            assertParamExists('webhookAmoControllerSendContact', 'sendContactRequestDto', sendContactRequestDto)
            const localVarPath = `/api/v1/webhook-amo/main/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendContactRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhookAmoApi - functional programming interface
 * @export
 */
export const WebhookAmoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhookAmoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary create mail subscription
         * @param {CreateMailSubscriptionRequestDto} createMailSubscriptionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhookAmoControllerCreateMailSubscription(createMailSubscriptionRequestDto: CreateMailSubscriptionRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AmoResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhookAmoControllerCreateMailSubscription(createMailSubscriptionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sent consultations ticket for married couple
         * @param {CreateMarriedCoupleConsultationTicketRequestDto} createMarriedCoupleConsultationTicketRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhookAmoControllerCreateMarriedCoupleConsultationTicket(createMarriedCoupleConsultationTicketRequestDto: CreateMarriedCoupleConsultationTicketRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhookAmoControllerCreateMarriedCoupleConsultationTicket(createMarriedCoupleConsultationTicketRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary User sent form in Pogovorim.MIR
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhookAmoControllerMirUserSentForm(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhookAmoControllerMirUserSentForm(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary send contact from main page
         * @param {SendContactRequestDto} sendContactRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webhookAmoControllerSendContact(sendContactRequestDto: SendContactRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AmoResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webhookAmoControllerSendContact(sendContactRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WebhookAmoApi - factory interface
 * @export
 */
export const WebhookAmoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhookAmoApiFp(configuration)
    return {
        /**
         * 
         * @summary create mail subscription
         * @param {CreateMailSubscriptionRequestDto} createMailSubscriptionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookAmoControllerCreateMailSubscription(createMailSubscriptionRequestDto: CreateMailSubscriptionRequestDto, options?: any): AxiosPromise<AmoResponseDto> {
            return localVarFp.webhookAmoControllerCreateMailSubscription(createMailSubscriptionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sent consultations ticket for married couple
         * @param {CreateMarriedCoupleConsultationTicketRequestDto} createMarriedCoupleConsultationTicketRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookAmoControllerCreateMarriedCoupleConsultationTicket(createMarriedCoupleConsultationTicketRequestDto: CreateMarriedCoupleConsultationTicketRequestDto, options?: any): AxiosPromise<object> {
            return localVarFp.webhookAmoControllerCreateMarriedCoupleConsultationTicket(createMarriedCoupleConsultationTicketRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User sent form in Pogovorim.MIR
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookAmoControllerMirUserSentForm(options?: any): AxiosPromise<object> {
            return localVarFp.webhookAmoControllerMirUserSentForm(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send contact from main page
         * @param {SendContactRequestDto} sendContactRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webhookAmoControllerSendContact(sendContactRequestDto: SendContactRequestDto, options?: any): AxiosPromise<AmoResponseDto> {
            return localVarFp.webhookAmoControllerSendContact(sendContactRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebhookAmoApi - object-oriented interface
 * @export
 * @class WebhookAmoApi
 * @extends {BaseAPI}
 */
export class WebhookAmoApi extends BaseAPI {
    /**
     * 
     * @summary create mail subscription
     * @param {CreateMailSubscriptionRequestDto} createMailSubscriptionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookAmoApi
     */
    public webhookAmoControllerCreateMailSubscription(createMailSubscriptionRequestDto: CreateMailSubscriptionRequestDto, options?: AxiosRequestConfig) {
        return WebhookAmoApiFp(this.configuration).webhookAmoControllerCreateMailSubscription(createMailSubscriptionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sent consultations ticket for married couple
     * @param {CreateMarriedCoupleConsultationTicketRequestDto} createMarriedCoupleConsultationTicketRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookAmoApi
     */
    public webhookAmoControllerCreateMarriedCoupleConsultationTicket(createMarriedCoupleConsultationTicketRequestDto: CreateMarriedCoupleConsultationTicketRequestDto, options?: AxiosRequestConfig) {
        return WebhookAmoApiFp(this.configuration).webhookAmoControllerCreateMarriedCoupleConsultationTicket(createMarriedCoupleConsultationTicketRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User sent form in Pogovorim.MIR
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookAmoApi
     */
    public webhookAmoControllerMirUserSentForm(options?: AxiosRequestConfig) {
        return WebhookAmoApiFp(this.configuration).webhookAmoControllerMirUserSentForm(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send contact from main page
     * @param {SendContactRequestDto} sendContactRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookAmoApi
     */
    public webhookAmoControllerSendContact(sendContactRequestDto: SendContactRequestDto, options?: AxiosRequestConfig) {
        return WebhookAmoApiFp(this.configuration).webhookAmoControllerSendContact(sendContactRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

